window.dicoGenerated = {
    "AppelFonds": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Appel de fonds",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code appel de fonds"
                            },
                            "tranche_libelle": {
                                "type": "string",
                                "description": "Libellé tranche commerciale de l’opération"
                            },
                            "nom_tiers": {
                                "type": "string",
                                "description": "Nom du client"
                            },
                            "prenom_tiers": {
                                "type": "string",
                                "description": "Prénom du client"
                            },
                            "mail_tiers": {
                                "type": "string",
                                "description": "Courriel du client"
                            },
                            "civilite_tiers": {
                                "type": "string",
                                "description": "civilité de l'acquéreur",
                                "codif": "Civilite"
                            },
                            "lib_tiers": {
                                "type": "string",
                                "description": "civilité + prenom + nom de l'acquéreur ou raison sociale"
                            },
                            "civNom_tiers": {
                                "type": "string",
                                "description": "civilité + nom de l'acquéreur ou raison sociale"
                            },
                            "formeJuridique_tiers": {
                                "type": "string",
                                "description": "formeJuridique de l'acquéreur"
                            },
                            "adr_rue1": {
                                "type": "string",
                                "description": "adrPointRemise de l'acquéreur"
                            },
                            "adr_rue2": {
                                "type": "string",
                                "description": "adrNomVoie de l'acquéreur"
                            },
                            "adr_complement": {
                                "type": "string",
                                "description": "adrComplement de l'acquéreur"
                            },
                            "adr_pointDistrib": {
                                "type": "string",
                                "description": "adrPointDistrib de l'acquéreur"
                            },
                            "adr_cp": {
                                "type": "string",
                                "description": "code postal de l'acquéreur"
                            },
                            "adr_pays": {
                                "type": "string",
                                "description": "pays de l'acquéreur"
                            },
                            "adr_localite": {
                                "type": "string",
                                "description": "ville de l'acquéreur"
                            },
                            "destinataire_courrier": {
                                "type": "string",
                                "description": "destinataire du courrier"
                            },
                            "num_principaux": {
                                "type": "string",
                                "description": "numéros des lots principaux"
                            },
                            "num_secondaires": {
                                "type": "string",
                                "description": "numéros des lots secondaires"
                            },
                            "numCopro_principaux": {
                                "type": "string",
                                "description": "liste des numéros de copro des lots principaux séparés par des virgules"
                            },
                            "numCopro_secondaires": {
                                "type": "string",
                                "description": "liste des numéros de copro des lots secondaires séparés par des virgules"
                            },
                            "mnt_vente_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "somme de prix de vente TTC des lots correspondant à l'appel de fond"
                            },
                            "mnt_vente_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "somme de prix de vente HT des lots correspondant à l'appel de fond"
                            },
                            "mnt_vente_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "montant TVA de la vente"
                            },
                            "mnt_tmaHorsActe_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total HT des TMA signés hors acte"
                            },
                            "mnt_tmaHorsActe_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TVA des TMA signés hors acte"
                            },
                            "mnt_tmaHorsActe_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TTC des TMA signés hors acte"
                            },
                            "mnt_dossierTmaInclu_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "montant du dossier client TTC avec tous les TMA"
                            },
                            "mnt_dossierTmaInclu_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "montant du dossier client HT avec tous les TMA"
                            },
                            "mnt_dossierTmaInclu_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "montant du dossier client TVA avec tous les TMA"
                            },
                            "cumul_appel_portageTva": {
                                "type": "number",
                                "format": "money",
                                "description": "montant portage TVA appelé du dossier en cumul"
                            },
                            "acte_vente_num": {
                                "type": "string",
                                "description": "numéro de l'acte de vente"
                            },
                            "date_vente": {
                                "type": "string",
                                "format": "date",
                                "description": "date de la vente du dossier"
                            },
                            "doss_delaiReglement": {
                                "type": "integer",
                                "description": "délai règlement (jours)"
                            },
                            "appel_dateEchRegl": {
                                "type": "string",
                                "format": "date",
                                "description": "date prévue du règlement"
                            },
                            "appel_dateAppel": {
                                "type": "string",
                                "format": "date",
                                "description": "date d'appel"
                            },
                            "stade_atteint": {
                                "type": "string",
                                "description": "libellé de la dernière écheance"
                            },
                            "mnt_appel_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "montant de l'appel TTC"
                            },
                            "mnt_appel_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "montant de l'appel HT"
                            },
                            "mnt_appel_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "montant de l'appel TVA"
                            },
                            "taux_appel_tva": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de TVA de l'appel"
                            },
                            "pourcentage_appel": {
                                "type": "number",
                                "format": "rate",
                                "description": "pourcentage du dernier appel"
                            },
                            "pourcentage_appel_cumule": {
                                "type": "number",
                                "format": "rate",
                                "description": "pourcentage cumulé"
                            },
                            "pourcentage_encaisse_cumule": {
                                "type": "number",
                                "format": "rate",
                                "description": "pourcentage encaissé cumulé"
                            },
                            "pourcentage_encaisse_cumule_horsTMA": {
                                "type": "number",
                                "format": "rate",
                                "description": "pourcentage encaissé cumulé hors TMA"
                            },
                            "solde_appel": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TTC  des appels passés du dossier"
                            },
                            "solde_appelHT": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants HT des appels passés du dossier"
                            },
                            "solde_appelTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TVA des appels passés du dossier"
                            },
                            "cumul_appel_avant": {
                                "type": "number",
                                "format": "money",
                                "description": "cumul TTC des appels hors celui en cours",
                                "version": "18.1"
                            },
                            "cumul_appel_horsTma_avant": {
                                "type": "number",
                                "format": "money",
                                "description": "cumul TTC des appels hors TMA, hors celui en cours",
                                "version": "18.2"
                            },
                            "total_appelHorsTma_TTC": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TTC des appels passés du dossier hors TMA"
                            },
                            "total_appelHorsTma_HT": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants HT des appels passés du dossier hors TMA"
                            },
                            "total_appelHorsTma_TVA": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TVA des appels passés du dossier hors TMA"
                            },
                            "total_appelTma_TTC": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TTC  des appels passés du dossier uniquement TMA"
                            },
                            "total_appelTma_HT": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants HT des appels passés du dossier uniquement TMA"
                            },
                            "total_appelTma_TVA": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TVA des appels passés du dossier uniquement TMA"
                            },
                            "solde_encaisse": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des encaissements des appels passés du dossier"
                            },
                            "solde_encaisse_horsTMA": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des encaissements des appels passés du dossier hors TMA"
                            },
                            "solde_appel_horsTMA": {
                                "type": "number",
                                "format": "money",
                                "version": "17.5",
                                "description": "Solde dû pour les appels de fonds hors TMA"
                            },
                            "solde_facturation_justeTMA": {
                                "type": "number",
                                "format": "money",
                                "version": "17.5",
                                "description": "Solde dû pour la facturation des TMA seuls"
                            },
                            "total_encaisse_justeTMA": {
                                "type": "number",
                                "format": "money",
                                "version": "17.5",
                                "description": "Somme des encaissements des TMA seuls"
                            },
                            "solde_client": {
                                "type": "number",
                                "format": "money",
                                "description": "solde dû hors portage TVA"
                            },
                            "solde_client_avant": {
                                "type": "number",
                                "format": "money",
                                "description": "solde avant le nouvel appel de fonds"
                            },
                            "solde_client_horsTma_avant": {
                                "type": "number",
                                "format": "money",
                                "description": "solde hors TMA avant le nouvel appel de fonds",
                                "version": "18.2"
                            },
                            "solde_dossier": {
                                "type": "number",
                                "format": "money",
                                "description": "solde dossier client (inclus portage TVA)"
                            },
                            "solde_dossier_HT": {
                                "type": "number",
                                "format": "money",
                                "description": "solde dossier client HT "
                            },
                            "solde_dossier_TVA": {
                                "type": "number",
                                "format": "money",
                                "description": "solde dossier client TVA"
                            },
                            "solde_tropPercu": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde Trop perçu"
                            },
                            "date_livraison": {
                                "type": "string",
                                "format": "date",
                                "description": "date livraison du dossier"
                            },
                            "facture_num": {
                                "type": "string",
                                "description": "numéro de la facture"
                            },
                            "origineContactClient": {
                                "type": "string",
                                "description": "origine contact client",
                                "codif": "OrigContactCli"
                            },
                            "qualiteClient": {
                                "type": "string",
                                "description": "qualité client",
                                "codif": "QualiteCli"
                            },
                            "perso_doss_flag1": {
                                "type": "boolean",
                                "description": "Valeur dossier flag1"
                            },
                            "perso_doss_flag2": {
                                "type": "boolean",
                                "description": "Valeur dossier flag2"
                            },
                            "perso_doss_flag3": {
                                "type": "boolean",
                                "description": "Valeur dossier flag3"
                            },
                            "perso_doss_flag4": {
                                "type": "boolean",
                                "description": "Valeur dossier flag4"
                            },
                            "perso_doss_flag5": {
                                "type": "boolean",
                                "description": "Valeur dossier flag5"
                            },
                            "perso_doss_flag6": {
                                "type": "boolean",
                                "description": "Valeur dossier flag6",
                                "version": "18.0"
                            },
                            "perso_doss_flag7": {
                                "type": "boolean",
                                "description": "Valeur dossier flag7",
                                "version": "18.0"
                            },
                            "perso_doss_flag8": {
                                "type": "boolean",
                                "description": "Valeur dossier flag8",
                                "version": "18.0"
                            },
                            "perso_doss_flag9": {
                                "type": "boolean",
                                "description": "Valeur dossier flag9",
                                "version": "18.0"
                            },
                            "perso_doss_flag10": {
                                "type": "boolean",
                                "description": "Valeur dossier flag10",
                                "version": "18.0"
                            },
                            "perso_doss_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date1"
                            },
                            "perso_doss_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date2"
                            },
                            "perso_doss_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date3"
                            },
                            "perso_doss_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date4"
                            },
                            "perso_doss_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date5"
                            },
                            "perso_doss_date6": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date6"
                            },
                            "perso_doss_date7": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date7",
                                "version": "18.0"
                            },
                            "perso_doss_date8": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date8",
                                "version": "18.0"
                            },
                            "perso_doss_date9": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date9",
                                "version": "18.0"
                            },
                            "perso_doss_date10": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date10",
                                "version": "18.0"
                            },
                            "perso_doss_texte1": {
                                "type": "string",
                                "description": "Valeur dossier texte1"
                            },
                            "perso_doss_texte2": {
                                "type": "string",
                                "description": "Valeur dossier texte2"
                            },
                            "perso_doss_texte3": {
                                "type": "string",
                                "description": "Valeur dossier texte3"
                            },
                            "perso_doss_texte4": {
                                "type": "string",
                                "description": "Valeur dossier texte4"
                            },
                            "perso_doss_texte5": {
                                "type": "string",
                                "description": "Valeur dossier texte5"
                            },
                            "perso_doss_texte6": {
                                "type": "string",
                                "description": "Valeur dossier texte6",
                                "version": "18.0"
                            },
                            "perso_doss_texte7": {
                                "type": "string",
                                "description": "Valeur dossier texte7",
                                "version": "18.0"
                            },
                            "perso_doss_texte8": {
                                "type": "string",
                                "description": "Valeur dossier texte8",
                                "version": "18.0"
                            },
                            "perso_doss_texte9": {
                                "type": "string",
                                "description": "Valeur dossier texte9",
                                "version": "18.0"
                            },
                            "perso_doss_texte10": {
                                "type": "string",
                                "description": "Valeur dossier texte10",
                                "version": "18.0"
                            },
                            "perso_doss_codif1": {
                                "type": "string",
                                "description": "Valeur dossier codif1",
                                "codif": "RVDossier_codif1"
                            },
                            "perso_doss_codif2": {
                                "type": "string",
                                "description": "Valeur dossier codif2",
                                "codif": "RVDossier_codif2"
                            },
                            "perso_doss_codif3": {
                                "type": "string",
                                "description": "Valeur dossier codif3",
                                "codif": "RVDossier_codif3"
                            },
                            "perso_doss_codif4": {
                                "type": "string",
                                "description": "Valeur dossier codif4",
                                "codif": "RVDossier_codif4"
                            },
                            "perso_doss_codif5": {
                                "type": "string",
                                "description": "Valeur dossier codif5",
                                "codif": "RVDossier_codif5"
                            },
                            "perso_doss_codif6": {
                                "type": "string",
                                "description": "Valeur dossier codif6",
                                "codif": "RVDossier_codif6",
                                "version": "18.0"
                            },
                            "perso_doss_codif7": {
                                "type": "string",
                                "description": "Valeur dossier codif7",
                                "codif": "RVDossier_codif7",
                                "version": "18.0"
                            },
                            "perso_doss_codif8": {
                                "type": "string",
                                "description": "Valeur dossier codif8",
                                "codif": "RVDossier_codif8",
                                "version": "18.0"
                            },
                            "perso_doss_codif9": {
                                "type": "string",
                                "description": "Valeur dossier codif9",
                                "codif": "RVDossier_codif9",
                                "version": "18.0"
                            },
                            "perso_doss_codif10": {
                                "type": "string",
                                "description": "Valeur dossier codif10",
                                "codif": "RVDossier_codif10",
                                "version": "18.0"
                            },
                            "perso_psla_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date1"
                            },
                            "perso_psla_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date2"
                            },
                            "perso_psla_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date3"
                            },
                            "perso_psla_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date4"
                            },
                            "perso_psla_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date5"
                            },
                            "perso_psla_date6": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date6"
                            },
                            "perso_tiers_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant1"
                            },
                            "perso_tiers_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant2"
                            },
                            "perso_tiers_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant3"
                            },
                            "perso_tiers_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant4"
                            },
                            "perso_tiers_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant5"
                            },
                            "perso_tiers_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal1"
                            },
                            "perso_tiers_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal2"
                            },
                            "perso_tiers_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal3"
                            },
                            "perso_tiers_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal4"
                            },
                            "perso_tiers_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal5"
                            },
                            "perso_tiers_entier1": {
                                "type": "number",
                                "description": "Valeur tiers entier1"
                            },
                            "perso_tiers_entier2": {
                                "type": "number",
                                "description": "Valeur tiers entier2"
                            },
                            "perso_tiers_entier3": {
                                "type": "number",
                                "description": "Valeur tiers entier3"
                            },
                            "perso_tiers_entier4": {
                                "type": "number",
                                "description": "Valeur tiers entier4"
                            },
                            "perso_tiers_entier5": {
                                "type": "number",
                                "description": "Valeur tiers entier5"
                            },
                            "perso_tiers_flag1": {
                                "type": "boolean",
                                "description": "Valeur tiers flag1"
                            },
                            "perso_tiers_flag2": {
                                "type": "boolean",
                                "description": "Valeur tiers flag2"
                            },
                            "perso_tiers_flag3": {
                                "type": "boolean",
                                "description": "Valeur tiers flag3"
                            },
                            "perso_tiers_flag4": {
                                "type": "boolean",
                                "description": "Valeur tiers flag4"
                            },
                            "perso_tiers_flag5": {
                                "type": "boolean",
                                "description": "Valeur tiers flag5"
                            },
                            "perso_tiers_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date1"
                            },
                            "perso_tiers_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date2"
                            },
                            "perso_tiers_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date3"
                            },
                            "perso_tiers_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date4"
                            },
                            "perso_tiers_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date5"
                            },
                            "perso_tiers_texte1": {
                                "type": "string",
                                "description": "Valeur tiers texte1"
                            },
                            "perso_tiers_texte2": {
                                "type": "string",
                                "description": "Valeur tiers texte2"
                            },
                            "perso_tiers_texte3": {
                                "type": "string",
                                "description": "Valeur tiers texte3"
                            },
                            "perso_tiers_texte4": {
                                "type": "string",
                                "description": "Valeur tiers texte4"
                            },
                            "perso_tiers_texte5": {
                                "type": "string",
                                "description": "Valeur tiers texte5"
                            },
                            "perso_tiers_codif1": {
                                "type": "string",
                                "description": "Valeur tiers codif1",
                                "codif": "SpoTiers_codif1"
                            },
                            "perso_tiers_codif2": {
                                "type": "string",
                                "description": "Valeur tiers codif2",
                                "codif": "SpoTiers_codif2"
                            },
                            "perso_tiers_codif3": {
                                "type": "string",
                                "description": "Valeur tiers codif3",
                                "codif": "SpoTiers_codif3"
                            },
                            "perso_tiers_codif4": {
                                "type": "string",
                                "description": "Valeur tiers codif4",
                                "codif": "SpoTiers_codif4"
                            },
                            "perso_tiers_codif5": {
                                "type": "string",
                                "description": "Valeur tiers codif5",
                                "codif": "SpoTiers_codif5"
                            },
                            "echeances": {
                                "type": "array",
                                "description": "échéances du dossier",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ech_evt": {
                                            "type": "string",
                                            "description": "Evènement de l'échéance"
                                        },
                                        "ech_lib": {
                                            "type": "string",
                                            "description": "Le libellé de chaque échéance"
                                        },
                                        "ech_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Le pourcentage de l'échéance"
                                        },
                                        "ech_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant HT de l'échéance"
                                        },
                                        "ech_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant TTC de l'échéance"
                                        },
                                        "ech_tauxTVA": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de l'échéance"
                                        },
                                        "ech_statut": {
                                            "type": "string",
                                            "description": "Prévue / réalisée",
                                            "enumId": "RVDossierEcheance.statut"
                                        },
                                        "ech_datePrev": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date prévue de l'écheance"
                                        }
                                    }
                                }
                            },
                            "historique_appels": {
                                "type": "array",
                                "description": "historique des appels de fonds",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "lib_appel": {
                                            "type": "string",
                                            "description": "libellé de l'appel + libellé de la dernière écheance de l'appel"
                                        },
                                        "date_appel": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date de l'appel"
                                        },
                                        "mnt_appel": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'appel"
                                        },
                                        "mnt_appel_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'appel TVA"
                                        },
                                        "histoAppel_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'appel HT",
                                            "version": "18.2"
                                        },
                                        "mnt_encaisse": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "somme de montants des encaissements de l'appel"
                                        },
                                        "taux_appel": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage de l'appel"
                                        }
                                    }
                                }
                            },
                            "historique_appels_horsTMA": {
                                "type": "array",
                                "description": "historique des appels de fonds hors TMA du dossier",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ha_libAppel": {
                                            "type": "string",
                                            "description": "libellé de l'appel"
                                        },
                                        "ha_dateAppel": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date de l'appel"
                                        },
                                        "ha_mntAppel": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'appel"
                                        },
                                        "ha_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'appel HT",
                                            "version": "18.2"
                                        },
                                        "ha_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'appel TVA",
                                            "version": "18.2"
                                        },
                                        "ha_mntEncaisse": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant encaissé pour l’appel hors TMA"
                                        },
                                        "ha_tauxAppel": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage de l'appel"
                                        }
                                    }
                                }
                            },
                            "historique_appels_TMA": {
                                "type": "array",
                                "description": "historique des appels des TMA du dossier",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ht_refTma": {
                                            "type": "string",
                                            "description": "référence TMA"
                                        },
                                        "ht_libTma": {
                                            "type": "string",
                                            "description": "libellé TMA"
                                        },
                                        "ht_libAppel": {
                                            "type": "string",
                                            "description": "libellé de l'appel"
                                        },
                                        "ht_libTma_libEch": {
                                            "type": "string",
                                            "description": "libellé du TMA / libellé de l’échéance"
                                        },
                                        "ht_dateAppel": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date de l'appel"
                                        },
                                        "ht_mntAppel": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'appel"
                                        },
                                        "ht_mntEncaisse": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant encaissé pour le TMA"
                                        },
                                        "ht_tauxAppel": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage de l'appel"
                                        }
                                    }
                                }
                            },
                            "suivi_compte": {
                                "type": "array",
                                "description": "suivi de compte",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "num_lot": {
                                            "type": "string",
                                            "description": "Numéro du lot"
                                        },
                                        "lib_appel": {
                                            "type": "string",
                                            "description": "libellé de l'écheance ou libellé de l'encaissement"
                                        },
                                        "date_appel": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date de l'appel ou date l'encaissement"
                                        },
                                        "mnt_appel": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'échéance appellée"
                                        },
                                        "mnt_encaisse": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant de l'encaissement"
                                        }
                                    }
                                }
                            },
                            "echeances_tma": {
                                "type": "array",
                                "description": "échéances tma du dossier",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tma_evt": {
                                            "type": "string",
                                            "description": "Evènement de l'échéance",
                                            "enumId": "RVDossierTmaEcheance.codeEvent"
                                        },
                                        "tma_lib": {
                                            "type": "string",
                                            "description": "Le libellé de chaque échéance"
                                        },
                                        "tma_libTma": {
                                            "type": "string",
                                            "description": "libellé du TMA"
                                        },
                                        "tma_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Le pourcentage de l'échéance"
                                        },
                                        "tma_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant HT de l'échéance"
                                        },
                                        "tma_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant TTC de l'échéance"
                                        },
                                        "tma_tauxTVA": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de l'échéance"
                                        },
                                        "tma_statut": {
                                            "type": "string",
                                            "description": "Prévue / réalisée",
                                            "enumId": "RVDossierTmaEcheance.statut"
                                        },
                                        "tma_dateEch": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date prévue de l'écheance"
                                        }
                                    }
                                }
                            },
                            "dgs": {
                                "type": "array",
                                "description": "dépots garantie",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "dg_evt": {
                                            "type": "string",
                                            "description": "évènement",
                                            "enumId": "RVDossierDepotGarantie.codeEvt"
                                        },
                                        "dg_modePaiement": {
                                            "type": "string",
                                            "description": "mode de paiement",
                                            "enumId": "RVDossierDepotGarantie.modePaiement"
                                        },
                                        "dg_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant du dg"
                                        },
                                        "dg_dateRemise": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date remise"
                                        },
                                        "dg_banque": {
                                            "type": "string",
                                            "description": "Banque émettrice"
                                        },
                                        "dg_tiersLib": {
                                            "type": "string",
                                            "description": "Libellé tiers émetteur"
                                        },
                                        "dg_compteLib": {
                                            "type": "string",
                                            "description": "Libellé compte bancaire"
                                        },
                                        "dg_iban": {
                                            "type": "string",
                                            "description": "IBAN"
                                        },
                                        "dg_comm": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        }
                                    }
                                }
                            },
                            "lots": {
                                "type": "array",
                                "description": "liste des lots",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "lot_numero": {
                                            "type": "string",
                                            "description": "n° de lot"
                                        },
                                        "lot_typeLot": {
                                            "type": "string",
                                            "codif": "TYPELOT",
                                            "description": "type de lot"
                                        },
                                        "lot_nature": {
                                            "type": "string",
                                            "description": "nature de lot"
                                        },
                                        "lot_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "tauxTva du lot"
                                        },
                                        "perso_lot_flag1": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag1"
                                        },
                                        "perso_lot_flag2": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag2"
                                        },
                                        "perso_lot_flag3": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag3"
                                        },
                                        "perso_lot_flag4": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag4"
                                        },
                                        "perso_lot_flag5": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag5"
                                        },
                                        "perso_lot_flag6": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag6",
                                            "version": "18.0"
                                        },
                                        "perso_lot_flag7": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag7",
                                            "version": "18.0"
                                        },
                                        "perso_lot_flag8": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag8",
                                            "version": "18.0"
                                        },
                                        "perso_lot_flag9": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag9",
                                            "version": "18.0"
                                        },
                                        "perso_lot_flag10": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag10",
                                            "version": "18.0"
                                        },
                                        "perso_lot_date1": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date1"
                                        },
                                        "perso_lot_date2": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date2"
                                        },
                                        "perso_lot_date3": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date3"
                                        },
                                        "perso_lot_date4": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date4"
                                        },
                                        "perso_lot_date5": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date5"
                                        },
                                        "perso_lot_date6": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date6"
                                        },
                                        "perso_lot_date7": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date7"
                                        },
                                        "perso_lot_date8": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date 8"
                                        },
                                        "perso_lot_date9": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date 9"
                                        },
                                        "perso_lot_date10": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date 10"
                                        },
                                        "perso_lot_montant1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant1"
                                        },
                                        "perso_lot_montant2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 2"
                                        },
                                        "perso_lot_montant3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 3"
                                        },
                                        "perso_lot_montant4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 4"
                                        },
                                        "perso_lot_montant5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 5"
                                        },
                                        "perso_lot_montant6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 6"
                                        },
                                        "perso_lot_montant7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 7"
                                        },
                                        "perso_lot_montant8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 8"
                                        },
                                        "perso_lot_montant9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 9"
                                        },
                                        "perso_lot_montant10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 10"
                                        },
                                        "perso_lot_surface1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface1"
                                        },
                                        "perso_lot_surface2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 2"
                                        },
                                        "perso_lot_surface3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 3"
                                        },
                                        "perso_lot_surface4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 4"
                                        },
                                        "perso_lot_surface5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 5"
                                        },
                                        "perso_lot_surface6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 6"
                                        },
                                        "perso_lot_surface7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 7"
                                        },
                                        "perso_lot_surface8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 8"
                                        },
                                        "perso_lot_surface9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 9"
                                        },
                                        "perso_lot_surface10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 10"
                                        },
                                        "perso_lot_surfAnnexe1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe1"
                                        },
                                        "perso_lot_surfAnnexe2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 2"
                                        },
                                        "perso_lot_surfAnnexe3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 3"
                                        },
                                        "perso_lot_surfAnnexe4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 4"
                                        },
                                        "perso_lot_surfAnnexe5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 5"
                                        },
                                        "perso_lot_surfAnnexe6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 6"
                                        },
                                        "perso_lot_surfAnnexe7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 7"
                                        },
                                        "perso_lot_surfAnnexe8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 8"
                                        },
                                        "perso_lot_surfAnnexe9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 9"
                                        },
                                        "perso_lot_surfAnnexe10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 10"
                                        },
                                        "perso_lot_texte1": {
                                            "type": "string",
                                            "description": "Valeur lot texte1"
                                        },
                                        "perso_lot_texte2": {
                                            "type": "string",
                                            "description": "Valeur lot texte2"
                                        },
                                        "perso_lot_texte3": {
                                            "type": "string",
                                            "description": "Valeur lot texte3"
                                        },
                                        "perso_lot_texte4": {
                                            "type": "string",
                                            "description": "Valeur lot texte4"
                                        },
                                        "perso_lot_texte5": {
                                            "type": "string",
                                            "description": "Valeur lot texte5"
                                        },
                                        "perso_lot_texte6": {
                                            "type": "string",
                                            "description": "Valeur lot texte6",
                                            "version": "18.0"
                                        },
                                        "perso_lot_texte7": {
                                            "type": "string",
                                            "description": "Valeur lot texte7",
                                            "version": "18.0"
                                        },
                                        "perso_lot_texte8": {
                                            "type": "string",
                                            "description": "Valeur lot texte8",
                                            "version": "18.0"
                                        },
                                        "perso_lot_texte9": {
                                            "type": "string",
                                            "description": "Valeur lot texte9",
                                            "version": "18.0"
                                        },
                                        "perso_lot_texte10": {
                                            "type": "string",
                                            "description": "Valeur lot texte10",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif1": {
                                            "type": "string",
                                            "description": "Valeur lot codif1",
                                            "codif": "RVLotImmo_codif1"
                                        },
                                        "perso_lot_codif2": {
                                            "type": "string",
                                            "description": "Valeur lot codif2",
                                            "codif": "RVLotImmo_codif2"
                                        },
                                        "perso_lot_codif3": {
                                            "type": "string",
                                            "description": "Valeur lot codif3",
                                            "codif": "RVLotImmo_codif3"
                                        },
                                        "perso_lot_codif4": {
                                            "type": "string",
                                            "description": "Valeur lot codif4",
                                            "codif": "RVLotImmo_codif4"
                                        },
                                        "perso_lot_codif5": {
                                            "type": "string",
                                            "description": "Valeur lot codif5",
                                            "codif": "RVLotImmo_codif5"
                                        },
                                        "perso_lot_codif6": {
                                            "type": "string",
                                            "description": "Valeur lot codif6",
                                            "codif": "RVLotImmo_codif6",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif7": {
                                            "type": "string",
                                            "description": "Valeur lot codif7",
                                            "codif": "RVLotImmo_codif7",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif8": {
                                            "type": "string",
                                            "description": "Valeur lot codif8",
                                            "codif": "RVLotImmo_codif8",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif9": {
                                            "type": "string",
                                            "description": "Valeur lot codif9",
                                            "codif": "RVLotImmo_codif9",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif10": {
                                            "type": "string",
                                            "description": "Valeur lot codif10",
                                            "codif": "RVLotImmo_codif10",
                                            "version": "18.0"
                                        }
                                    }
                                }
                            },
                            "clients": {
                                "type": "array",
                                "description": "clients",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "cli_civilite": {
                                            "type": "string",
                                            "description": "civilité du client",
                                            "codif": "Civilite"
                                        },
                                        "cli_libelle": {
                                            "type": "string",
                                            "description": "nom + prenom du client ou raison sociale"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "AppelTMA": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "TMA Appel/Facture",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code appel de fonds"
                            },
                            "tma_code": {
                                "type": "string",
                                "description": "Code TMA"
                            },
                            "appel_lib": {
                                "type": "string",
                                "description": "Libellé appel"
                            },
                            "appel_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date appel"
                            },
                            "appel_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant HT appel"
                            },
                            "appel_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant TTC appel"
                            },
                            "appel_mntTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant TVA appel"
                            },
                            "appel_prct": {
                                "type": "number",
                                "format": "rate",
                                "description": "Pourcentage appel sur échéancier TMA"
                            },
                            "tranche_libelle": {
                                "type": "string",
                                "description": "Libellé tranche commerciale de l’opération"
                            },
                            "tma_ref": {
                                "type": "string",
                                "description": "Numéro référence"
                            },
                            "tma_dateFinDevis": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de fin de validité du devis"
                            },
                            "tma_lib": {
                                "type": "string",
                                "description": "Libellé du TMA"
                            },
                            "tma_mntEncaisse": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant encaissé du TMA"
                            },
                            "tma_solde": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde du TMA"
                            },
                            "solde_tropPercu": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde Trop perçu du dossier",
                                "version": "18.1"
                            },
                            "tma_lots": {
                                "type": "string",
                                "description": "Liste des lots concernés par le TMA"
                            },
                            "tma_description": {
                                "type": "string",
                                "description": "Description du TMA"
                            },
                            "tma_commentaire": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "client_civPreNom": {
                                "type": "string",
                                "description": "civilité + prenom + nom du client"
                            },
                            "client_civNom": {
                                "type": "string",
                                "description": "civilité + nom du client"
                            },
                            "client_civ": {
                                "type": "string",
                                "description": "civilité du client",
                                "codif": "Civilite"
                            },
                            "client_lib": {
                                "type": "string",
                                "description": "Nom du client"
                            },
                            "client_adr1": {
                                "type": "string",
                                "description": "adrPointRemise du client"
                            },
                            "client_adr2": {
                                "type": "string",
                                "description": "adrNomVoie du client"
                            },
                            "client_adrComplement": {
                                "type": "string",
                                "description": "adrComplement de l'acquéreur"
                            },
                            "client_adrPointDistrib": {
                                "type": "string",
                                "description": "adrPointDistrib de l'acquéreur"
                            },
                            "client_cp": {
                                "type": "string",
                                "description": "adrCP du client"
                            },
                            "client_localite": {
                                "type": "string",
                                "description": "adrLocalite du client"
                            },
                            "client_pays": {
                                "type": "string",
                                "description": "adrPays du client"
                            },
                            "client_mail": {
                                "type": "string",
                                "description": "Courriel du client"
                            },
                            "destinataire_courrier": {
                                "type": "string",
                                "description": "destinataire du courrier"
                            },
                            "devis_ref": {
                                "type": "string",
                                "description": "RefDevis du TMA"
                            },
                            "devis_date": {
                                "type": "string",
                                "format": "date",
                                "description": "dateDevis du TMA"
                            },
                            "signe_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de la signature du devis"
                            },
                            "vente_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de la vente"
                            },
                            "reglement_mode": {
                                "type": "string",
                                "description": "Mode de règlement",
                                "enumId": "RVDossierTma.modeRegle"
                            },
                            "details_solde_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants HT du details"
                            },
                            "details_solde_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TTC du details"
                            },
                            "details_solde_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TVA du details"
                            },
                            "taux_tva": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de TVA du TMA"
                            },
                            "facture_num": {
                                "type": "string",
                                "description": "numéro de la facture"
                            },
                            "dossier_numLot_principal": {
                                "type": "string",
                                "description": "numéro de lot principal du dossier de vente"
                            },
                            "perso_flag1": {
                                "type": "boolean",
                                "description": "flag1"
                            },
                            "perso_flag2": {
                                "type": "boolean",
                                "description": "flag2"
                            },
                            "perso_flag3": {
                                "type": "boolean",
                                "description": "flag3"
                            },
                            "perso_flag4": {
                                "type": "boolean",
                                "description": "flag4"
                            },
                            "perso_flag5": {
                                "type": "boolean",
                                "description": "flag5"
                            },
                            "perso_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant1"
                            },
                            "perso_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant2"
                            },
                            "perso_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant3"
                            },
                            "perso_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant4"
                            },
                            "perso_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant5"
                            },
                            "perso_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal1"
                            },
                            "perso_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal2"
                            },
                            "perso_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal3"
                            },
                            "perso_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal4"
                            },
                            "perso_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal5"
                            },
                            "perso_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date1"
                            },
                            "perso_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date2"
                            },
                            "perso_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date3"
                            },
                            "perso_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date4"
                            },
                            "perso_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date5"
                            },
                            "perso_texte1": {
                                "type": "string",
                                "description": "Valeur texte1"
                            },
                            "perso_texte2": {
                                "type": "string",
                                "description": "Valeur texte2"
                            },
                            "perso_texte3": {
                                "type": "string",
                                "description": "Valeur texte3"
                            },
                            "perso_texte4": {
                                "type": "string",
                                "description": "Valeur texte4"
                            },
                            "perso_texte5": {
                                "type": "string",
                                "description": "Valeur texte5"
                            },
                            "perso_codif1": {
                                "type": "string",
                                "description": "Valeur codif1",
                                "codif": "RVDossierTma_codif1"
                            },
                            "perso_codif2": {
                                "type": "string",
                                "description": "Valeur codif2",
                                "codif": "RVDossierTma_codif2"
                            },
                            "perso_codif3": {
                                "type": "string",
                                "description": "Valeur codif3",
                                "codif": "RVDossierTma_codif3"
                            },
                            "perso_codif4": {
                                "type": "string",
                                "description": "Valeur codif4",
                                "codif": "RVDossierTma_codif4"
                            },
                            "perso_codif5": {
                                "type": "string",
                                "description": "Valeur codif5",
                                "codif": "RVDossierTma_codif5"
                            },
                            "perso_psla_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date1"
                            },
                            "perso_psla_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date2"
                            },
                            "perso_psla_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date3"
                            },
                            "perso_psla_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date4"
                            },
                            "perso_psla_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date5"
                            },
                            "perso_psla_date6": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date6"
                            },
                            "details": {
                                "type": "array",
                                "description": "Détails du TMA",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "lib": {
                                            "type": "string",
                                            "description": "Libellé du détail"
                                        },
                                        "piece": {
                                            "type": "string",
                                            "description": "emplacement du détail du TMA"
                                        },
                                        "quantite": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "quantité du détail du TMA"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT du détail du TMA"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC du détail du TMA"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA du détail du TMA"
                                        },
                                        "unite": {
                                            "type": "string",
                                            "description": "Unité",
                                            "enumId": "RVDossierTmaDetail.unite"
                                        },
                                        "prix_vente_unit_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de vente unitaire HT"
                                        },
                                        "prix_vente_unit_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de vente unitaire TTC"
                                        },
                                        "prix_vente_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de vente HT (avant remise)"
                                        },
                                        "prix_vente_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de vente TTC (avant remise)"
                                        },
                                        "prix_revient_unit_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de revient unitaire HT"
                                        },
                                        "prix_revient_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de revient HT"
                                        },
                                        "prix_revient_unit_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de revient unitaire TTC"
                                        },
                                        "prix_revient_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de revient TTC"
                                        },
                                        "coef": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Coef"
                                        },
                                        "offert": {
                                            "type": "boolean",
                                            "description": "Offert"
                                        },
                                        "desc_detail": {
                                            "type": "string",
                                            "description": "Descriptif détaillé"
                                        }
                                    }
                                }
                            },
                            "echeances": {
                                "type": "array",
                                "description": "Échéances du TMA",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "lib": {
                                            "type": "string",
                                            "description": "Libellé de l'échéance"
                                        },
                                        "date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de l'échéance"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de l'échéance"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de l'échéance"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de l'échéance"
                                        },
                                        "ech_prctAppel": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage d'appel sur l'échéancier TMA"
                                        }
                                    }
                                }
                            },
                            "clients": {
                                "type": "array",
                                "description": "Clients",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "libelle": {
                                            "type": "string",
                                            "description": "Libelle du client"
                                        },
                                        "civilite": {
                                            "type": "string",
                                            "description": "civilité du client",
                                            "codif": "Civilite"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "AvenantCommande": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "AvenantCommande",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code avenant",
                                "version": "18.1"
                            },
                            "avenant_lib": {
                                "type": "string",
                                "description": "Libellé de avenant"
                            },
                            "avenant_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de avenant"
                            },
                            "avenant_dateEngage": {
                                "type": "string",
                                "format": "date",
                                "description": "Date engagement avenant"
                            },
                            "prestataire_lib": {
                                "type": "string",
                                "description": "Nom du prestataire"
                            },
                            "prestataire_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé prestataire"
                            },
                            "prestataire_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie prestataire"
                            },
                            "prestataire_adr_complement": {
                                "type": "string",
                                "description": "adresse complement prestataire"
                            },
                            "prestataire_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal prestataire"
                            },
                            "prestataire_adr_localite": {
                                "type": "string",
                                "description": "adresse localité prestataire"
                            },
                            "prestataire_formeJuridique": {
                                "type": "string",
                                "description": "forme Juridique du prestataire"
                            },
                            "prestataire_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "capital social du prestataire"
                            },
                            "prestataire_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers prestataire"
                            },
                            "prestataire_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers prestataire"
                            },
                            "prestataire_civilite": {
                                "type": "string",
                                "codif": "Civilite",
                                "description": "civilité du représentant principal du prestataire"
                            },
                            "prestataire_prenom": {
                                "type": "string",
                                "description": "prénom du représentant principal du prestataire"
                            },
                            "prestataire_nom": {
                                "type": "string",
                                "description": "nom du représentant principal du prestataire"
                            },
                            "prestataire_email": {
                                "type": "string",
                                "description": "email du représentant principal du prestataire"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du représentant principal prestataire"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du représentant principal prestataire"
                            },
                            "bc_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date du bon de commande"
                            },
                            "bc_lib": {
                                "type": "string",
                                "description": "Libellé du bon de commande"
                            },
                            "bc_ref": {
                                "type": "string",
                                "description": "Numéro du bon de commande"
                            },
                            "bc_createur": {
                                "type": "string",
                                "description": "Créateur du bon de commande"
                            },
                            "bc_code": {
                                "type": "string",
                                "description": "Code du bon de commande"
                            },
                            "bc_adrFE": {
                                "type": "string",
                                "description": "Adresse de réception facture électronique",
                                "version": "18.3"
                            },
                            "bc_cmnt": {
                                "type": "string",
                                "description": "Commentaire commande",
                                "version": "18.0"
                            },
                            "bc_totalMntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total HT bon de commande"
                            },
                            "bc_totalMntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TTC bon de commande"
                            },
                            "bc_totalMntTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TVA bon de commande"
                            },
                            "bc_dateDebut": {
                                "type": "string",
                                "format": "date",
                                "description": "Bon de commande date début d'exécution"
                            },
                            "bc_dateFin": {
                                "type": "string",
                                "format": "date",
                                "description": "Bon de commande date fin d'exécution"
                            },
                            "bc_delai": {
                                "type": "number",
                                "description": "Bon de commande delai d'exécution"
                            },
                            "bc_dateEngage": {
                                "type": "string",
                                "format": "date",
                                "description": "Date engagement commande"
                            },
                            "bc_initialHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial HT du bon de commande"
                            },
                            "bc_initialTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TTC du bon de commande"
                            },
                            "bc_initialTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TVA du bon de commande"
                            },
                            "perso_tiers_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant1"
                            },
                            "perso_tiers_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant2"
                            },
                            "perso_tiers_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant3"
                            },
                            "perso_tiers_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant4"
                            },
                            "perso_tiers_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant5"
                            },
                            "perso_tiers_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal1"
                            },
                            "perso_tiers_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal2"
                            },
                            "perso_tiers_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal3"
                            },
                            "perso_tiers_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal4"
                            },
                            "perso_tiers_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal5"
                            },
                            "perso_tiers_entier1": {
                                "type": "number",
                                "description": "Valeur tiers entier1"
                            },
                            "perso_tiers_entier2": {
                                "type": "number",
                                "description": "Valeur tiers entier2"
                            },
                            "perso_tiers_entier3": {
                                "type": "number",
                                "description": "Valeur tiers entier3"
                            },
                            "perso_tiers_entier4": {
                                "type": "number",
                                "description": "Valeur tiers entier4"
                            },
                            "perso_tiers_entier5": {
                                "type": "number",
                                "description": "Valeur tiers entier5"
                            },
                            "perso_tiers_flag1": {
                                "type": "boolean",
                                "description": "Valeur tiers flag1"
                            },
                            "perso_tiers_flag2": {
                                "type": "boolean",
                                "description": "Valeur tiers flag2"
                            },
                            "perso_tiers_flag3": {
                                "type": "boolean",
                                "description": "Valeur tiers flag3"
                            },
                            "perso_tiers_flag4": {
                                "type": "boolean",
                                "description": "Valeur tiers flag4"
                            },
                            "perso_tiers_flag5": {
                                "type": "boolean",
                                "description": "Valeur tiers flag5"
                            },
                            "perso_tiers_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date1"
                            },
                            "perso_tiers_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date2"
                            },
                            "perso_tiers_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date3"
                            },
                            "perso_tiers_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date4"
                            },
                            "perso_tiers_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date5"
                            },
                            "perso_tiers_texte1": {
                                "type": "string",
                                "description": "Valeur tiers texte1"
                            },
                            "perso_tiers_texte2": {
                                "type": "string",
                                "description": "Valeur tiers texte2"
                            },
                            "perso_tiers_texte3": {
                                "type": "string",
                                "description": "Valeur tiers texte3"
                            },
                            "perso_tiers_texte4": {
                                "type": "string",
                                "description": "Valeur tiers texte4"
                            },
                            "perso_tiers_texte5": {
                                "type": "string",
                                "description": "Valeur tiers texte5"
                            },
                            "perso_tiers_codif1": {
                                "type": "string",
                                "description": "Valeur tiers codif1"
                            },
                            "perso_tiers_codif2": {
                                "type": "string",
                                "description": "Valeur tiers codif2"
                            },
                            "perso_tiers_codif3": {
                                "type": "string",
                                "description": "Valeur tiers codif3"
                            },
                            "perso_tiers_codif4": {
                                "type": "string",
                                "description": "Valeur tiers codif4"
                            },
                            "perso_tiers_codif5": {
                                "type": "string",
                                "description": "Valeur tiers codif5"
                            },
                            "cde_montants": {
                                "type": "array",
                                "description": "Liste des montants de la commande",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "mnt_lib": {
                                            "type": "string",
                                            "description": "Libellé de la ligne de commande",
                                            "version": "18.0"
                                        },
                                        "mnt_codeExt": {
                                            "type": "string",
                                            "description": "Code externe",
                                            "version": "18.0"
                                        },
                                        "mnt_qte": {
                                            "type": "integer",
                                            "description": "Quantité ligne commande",
                                            "version": "18.0"
                                        },
                                        "mnt_prixUnit": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix unitaire HT ligne commande",
                                            "version": "18.0"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de commande"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de commande"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de commande"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de commande"
                                        }
                                    }
                                }
                            },
                            "avenant_montants": {
                                "type": "array",
                                "description": "Liste des montants de l'avenant",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "amnt_lib": {
                                            "type": "string",
                                            "description": "Libellé de la ligne avenant",
                                            "version": "18.0"
                                        },
                                        "amnt_codeExt": {
                                            "type": "string",
                                            "description": "Code externe",
                                            "version": "18.0"
                                        },
                                        "amnt_qte": {
                                            "type": "integer",
                                            "description": "Quantité ligne avenant",
                                            "version": "18.0"
                                        },
                                        "amnt_prixUnit": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix unitaire HT ligne avenant",
                                            "version": "18.0"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de avenant"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de avenant"
                                        },
                                        "mnt_ht_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant HT de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "mnt_ttc_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant TTC de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de avenant"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de avenant"
                                        }
                                    }
                                }
                            },
                            "avenants": {
                                "type": "array",
                                "description": "Liste des avenants du bon de commande",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ref": {
                                            "type": "string",
                                            "description": "Numéro de avevant"
                                        },
                                        "lib": {
                                            "type": "string",
                                            "description": "libellé de avenant"
                                        },
                                        "cmnt": {
                                            "type": "string",
                                            "description": "commentaire de l'avenant"
                                        },
                                        "date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de avenant"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de avenant"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de avenant"
                                        },
                                        "mnt_ht_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant HT de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "mnt_ttc_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant TTC de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de avenant"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de avenant"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "AvenantMarche": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "AvenantMarche",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code avenant",
                                "version": "18.1"
                            },
                            "titulaire_lib": {
                                "type": "string",
                                "description": "Nom du prestataire"
                            },
                            "titulaire_siret": {
                                "type": "string",
                                "description": "SIRET du tiers titulaire",
                                "version": "18.0"
                            },
                            "titulaire_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé titulaire"
                            },
                            "titulaire_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie titulaire"
                            },
                            "titulaire_adr_complement": {
                                "type": "string",
                                "description": "adresse complement titulaire"
                            },
                            "titulaire_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal titulaire"
                            },
                            "titulaire_adr_localite": {
                                "type": "string",
                                "description": "adresse localité titulaire"
                            },
                            "prestataire_formeJuridique": {
                                "type": "string",
                                "description": "forme Juridique du titulaire du marché"
                            },
                            "prestataire_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "capital social du titulaire du marché"
                            },
                            "prestataire_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers prestataire"
                            },
                            "prestataire_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers prestataire"
                            },
                            "prestataire_civilite": {
                                "type": "string",
                                "codif": "Civilite",
                                "description": "civilité du représentant principal du titulaire du marché"
                            },
                            "prestataire_prenom": {
                                "type": "string",
                                "description": "prénom du représentant principal du titulaire du marché"
                            },
                            "prestataire_nom": {
                                "type": "string",
                                "description": "nom du représentant principal du titulaire du marché"
                            },
                            "tiers_rep_mail": {
                                "type": "string",
                                "description": "email du représentant principal titulaire",
                                "version": "18.0"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du représentant principal prestataire",
                                "version": "18.0"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du représentant principal prestataire",
                                "version": "18.0"
                            },
                            "marche_code": {
                                "type": "string",
                                "description": "Code du marché"
                            },
                            "marche_adrFE": {
                                "type": "string",
                                "description": "Adresse de réception facture électronique",
                                "version": "18.3"
                            },
                            "marche_ref": {
                                "type": "string",
                                "description": "Numéro du marché"
                            },
                            "marche_lib": {
                                "type": "string",
                                "description": "Libellé du marché"
                            },
                            "marche_lotNum": {
                                "type": "string",
                                "description": "Numéro du lot"
                            },
                            "marche_lotType": {
                                "type": "string",
                                "description": "Type de lot"
                            },
                            "marche_mntInitialHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial HT"
                            },
                            "marche_mntInitialTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TVA"
                            },
                            "marche_mntInitialTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TTC"
                            },
                            "marche_dateSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du marché"
                            },
                            "marche_dateNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification du marché",
                                "version": "18.0"
                            },
                            "marche_mntTotalHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total HT"
                            },
                            "marche_mntTotalTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TVA"
                            },
                            "marche_mntTotalTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TTC"
                            },
                            "marche_tauxRG": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de retenue de garantie",
                                "version": "18.0"
                            },
                            "marche_tauxProrata": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de prorata",
                                "version": "18.0"
                            },
                            "avenant_lib": {
                                "type": "string",
                                "description": "Libellé de l'avenant"
                            },
                            "avenant_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de l'avenant"
                            },
                            "avenant_notif": {
                                "type": "string",
                                "format": "date",
                                "description": "Notification de l'avenant"
                            },
                            "avenant_dateEngage": {
                                "type": "string",
                                "format": "date",
                                "description": "Date engage de l'avenant"
                            },
                            "avenant_numero": {
                                "type": "string",
                                "description": "Numéro de l'avenant"
                            },
                            "avenant_dtOS": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'OS de l'avenant",
                                "version": "18.0"
                            },
                            "avenant_dtFinExec": {
                                "type": "string",
                                "format": "date",
                                "description": "NDate fin d'exécution de l'avenant",
                                "version": "18.0"
                            },
                            "perso_tiers_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant1"
                            },
                            "perso_tiers_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant2"
                            },
                            "perso_tiers_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant3"
                            },
                            "perso_tiers_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant4"
                            },
                            "perso_tiers_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant5"
                            },
                            "perso_tiers_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal1"
                            },
                            "perso_tiers_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal2"
                            },
                            "perso_tiers_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal3"
                            },
                            "perso_tiers_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal4"
                            },
                            "perso_tiers_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal5"
                            },
                            "perso_tiers_entier1": {
                                "type": "number",
                                "description": "Valeur tiers entier1"
                            },
                            "perso_tiers_entier2": {
                                "type": "number",
                                "description": "Valeur tiers entier2"
                            },
                            "perso_tiers_entier3": {
                                "type": "number",
                                "description": "Valeur tiers entier3"
                            },
                            "perso_tiers_entier4": {
                                "type": "number",
                                "description": "Valeur tiers entier4"
                            },
                            "perso_tiers_entier5": {
                                "type": "number",
                                "description": "Valeur tiers entier5"
                            },
                            "perso_tiers_flag1": {
                                "type": "boolean",
                                "description": "Valeur tiers flag1"
                            },
                            "perso_tiers_flag2": {
                                "type": "boolean",
                                "description": "Valeur tiers flag2"
                            },
                            "perso_tiers_flag3": {
                                "type": "boolean",
                                "description": "Valeur tiers flag3"
                            },
                            "perso_tiers_flag4": {
                                "type": "boolean",
                                "description": "Valeur tiers flag4"
                            },
                            "perso_tiers_flag5": {
                                "type": "boolean",
                                "description": "Valeur tiers flag5"
                            },
                            "perso_tiers_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date1"
                            },
                            "perso_tiers_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date2"
                            },
                            "perso_tiers_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date3"
                            },
                            "perso_tiers_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date4"
                            },
                            "perso_tiers_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date5"
                            },
                            "perso_tiers_texte1": {
                                "type": "string",
                                "description": "Valeur tiers texte1"
                            },
                            "perso_tiers_texte2": {
                                "type": "string",
                                "description": "Valeur tiers texte2"
                            },
                            "perso_tiers_texte3": {
                                "type": "string",
                                "description": "Valeur tiers texte3"
                            },
                            "perso_tiers_texte4": {
                                "type": "string",
                                "description": "Valeur tiers texte4"
                            },
                            "perso_tiers_texte5": {
                                "type": "string",
                                "description": "Valeur tiers texte5"
                            },
                            "perso_tiers_codif1": {
                                "type": "string",
                                "description": "Valeur tiers codif1"
                            },
                            "perso_tiers_codif2": {
                                "type": "string",
                                "description": "Valeur tiers codif2"
                            },
                            "perso_tiers_codif3": {
                                "type": "string",
                                "description": "Valeur tiers codif3"
                            },
                            "perso_tiers_codif4": {
                                "type": "string",
                                "description": "Valeur tiers codif4"
                            },
                            "perso_tiers_codif5": {
                                "type": "string",
                                "description": "Valeur tiers codif5"
                            },
                            "marche_montants": {
                                "type": "array",
                                "description": "Liste des montants du marché",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT marché"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC marché"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA marché"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA marché"
                                        }
                                    }
                                }
                            },
                            "avenant_montants": {
                                "type": "array",
                                "description": "Liste des montants de l'avenant",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de avenant"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de avenant"
                                        },
                                        "mnt_ht_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant HT de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "mnt_ttc_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant TTC de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de avenant"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de avenant"
                                        },
                                        "av_cmnt": {
                                            "type": "string",
                                            "description": "commentaire de l'avenant"
                                        }
                                    }
                                }
                            },
                            "avenants": {
                                "type": "array",
                                "description": "Liste des avenants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "av_lib": {
                                            "type": "string",
                                            "description": "Libellé de l'avenant"
                                        },
                                        "av_numero": {
                                            "type": "string",
                                            "description": "Numéro de l'avenant",
                                            "version": "18.0"
                                        },
                                        "av_statut": {
                                            "type": "string",
                                            "description": "Statut de l'avenant",
                                            "enumId": "DPStatutContrat",
                                            "version": "18.0"
                                        },
                                        "av_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de l'avenant"
                                        },
                                        "av_notif": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Notification de l'avenant"
                                        },
                                        "av_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de avenant"
                                        },
                                        "av_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de avenant"
                                        },
                                        "av_mntHT_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant HT de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "av_mntTTC_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant TTC de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "av_tauxTVA": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de avenant"
                                        },
                                        "av_mntTVA": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de avenant"
                                        },
                                        "av_cmnt": {
                                            "type": "string",
                                            "description": "commentaire de l'avenant",
                                            "version": "18.0"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "Caution": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Caution",
                    "items": {
                        "type": "object",
                        "properties": {
                            "marche_lib": {
                                "type": "string",
                                "description": "Libellé du marché"
                            },
                            "marche_code": {
                                "type": "string",
                                "description": "Code du marché"
                            },
                            "marche_num": {
                                "type": "string",
                                "description": "Numéro du marché"
                            },
                            "marche_mntInitialHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial HT du marché"
                            },
                            "marche_mntInitialTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TVA du marché"
                            },
                            "marche_mntInitialTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TTC du marché"
                            },
                            "marche_dtSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du marché"
                            },
                            "marche_dtNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification du marché"
                            },
                            "marche_dtOS": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réelle d'OS1 du marché"
                            },
                            "tiers_lib": {
                                "type": "string",
                                "description": "Nom titulaire"
                            },
                            "tiers_formeJuridique": {
                                "type": "string",
                                "description": "Forme juridique titulaire",
                                "codif": "FormeJuridique"
                            },
                            "tiers_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "Capital social titulaire"
                            },
                            "tiers_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers titulaire"
                            },
                            "tiers_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers titulaire"
                            },
                            "tiers_rep_civilite": {
                                "type": "string",
                                "description": "Civilité du Représentant principal titulaire",
                                "codif": "Civilite"
                            },
                            "tiers_rep_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal titulaire"
                            },
                            "tiers_rep_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal titulaire"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du représentant principal titulaire"
                            },
                            "tiers_rep_mail": {
                                "type": "string",
                                "description": "Courriel du représentant principal titulaire"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du représentant principal titulaire"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "Adresse nom remisé titulaire"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "Adresse nom voie titulaire"
                            },
                            "tiers_adr_complement": {
                                "type": "string",
                                "description": "Adresse complement titulaire"
                            },
                            "tiers_adr_codePostal": {
                                "type": "string",
                                "description": "Adresse code postal titulaire"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "Adresse localité titulaire"
                            },
                            "tiers_siret": {
                                "type": "string",
                                "description": "SIRET du tiers titulaire"
                            },
                            "tiers_ape": {
                                "type": "string",
                                "description": "APE du tiers titulaire"
                            },
                            "tiers_libRib": {
                                "type": "string",
                                "description": "Nom titulaire RIB"
                            },
                            "tiers_iban": {
                                "type": "string",
                                "description": "Numero de compte RIB titulaire"
                            },
                            "tiers_banque": {
                                "type": "string",
                                "description": "Banque titulaire du RIB"
                            },
                            "tiers_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant1"
                            },
                            "tiers_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant2"
                            },
                            "tiers_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant3"
                            },
                            "tiers_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant4"
                            },
                            "tiers_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant5"
                            },
                            "tiers_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal1"
                            },
                            "tiers_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal2"
                            },
                            "tiers_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal3"
                            },
                            "tiers_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal4"
                            },
                            "tiers_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal5"
                            },
                            "tiers_entier1": {
                                "type": "number",
                                "description": "Valeur tiers entier1"
                            },
                            "tiers_entier2": {
                                "type": "number",
                                "description": "Valeur tiers entier2"
                            },
                            "tiers_entier3": {
                                "type": "number",
                                "description": "Valeur tiers entier3"
                            },
                            "tiers_entier4": {
                                "type": "number",
                                "description": "Valeur tiers entier4"
                            },
                            "tiers_entier5": {
                                "type": "number",
                                "description": "Valeur tiers entier5"
                            },
                            "tiers_flag1": {
                                "type": "boolean",
                                "description": "Valeur tiers flag1"
                            },
                            "tiers_flag2": {
                                "type": "boolean",
                                "description": "Valeur tiers flag2"
                            },
                            "tiers_flag3": {
                                "type": "boolean",
                                "description": "Valeur tiers flag3"
                            },
                            "tiers_flag4": {
                                "type": "boolean",
                                "description": "Valeur tiers flag4"
                            },
                            "tiers_flag5": {
                                "type": "boolean",
                                "description": "Valeur tiers flag5"
                            },
                            "tiers_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date1"
                            },
                            "tiers_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date2"
                            },
                            "tiers_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date3"
                            },
                            "tiers_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date4"
                            },
                            "tiers_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date5"
                            },
                            "tiers_texte1": {
                                "type": "string",
                                "description": "Valeur tiers texte1"
                            },
                            "tiers_texte2": {
                                "type": "string",
                                "description": "Valeur tiers texte2"
                            },
                            "tiers_texte3": {
                                "type": "string",
                                "description": "Valeur tiers texte3"
                            },
                            "tiers_texte4": {
                                "type": "string",
                                "description": "Valeur tiers texte4"
                            },
                            "tiers_texte5": {
                                "type": "string",
                                "description": "Valeur tiers texte5"
                            },
                            "tiers_codif1": {
                                "type": "string",
                                "description": "Valeur tiers codif1",
                                "codif": "SpoTiers_codif1"
                            },
                            "tiers_codif2": {
                                "type": "string",
                                "description": "Valeur tiers codif2",
                                "codif": "SpoTiers_codif2"
                            },
                            "tiers_codif3": {
                                "type": "string",
                                "description": "Valeur tiers codif3",
                                "codif": "SpoTiers_codif3"
                            },
                            "tiers_codif4": {
                                "type": "string",
                                "description": "Valeur tiers codif4",
                                "codif": "SpoTiers_codif4"
                            },
                            "tiers_codif5": {
                                "type": "string",
                                "description": "Valeur tiers codif5",
                                "codif": "SpoTiers_codif5"
                            },
                            "tc_lib": {
                                "type": "string",
                                "description": "Nom Tiers cautionneur"
                            },
                            "tc_formeJuridique": {
                                "type": "string",
                                "description": "Forme juridique cautionneur",
                                "codif": "FormeJuridique"
                            },
                            "tc_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "Capital social cautionneur"
                            },
                            "tc_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers cautionneur"
                            },
                            "tc_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers cautionneur"
                            },
                            "tc_rep_civilite": {
                                "type": "string",
                                "description": "Civilité du Représentant principal cautionneur",
                                "codif": "Civilite"
                            },
                            "tc_rep_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal cautionneur"
                            },
                            "tc_rep_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal cautionneur"
                            },
                            "tc_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du Représentant principal cautionneur"
                            },
                            "tc_rep_mail": {
                                "type": "string",
                                "description": "Courriel du Représentant principal cautionneur"
                            },
                            "tc_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du Représentant principal cautionneur"
                            },
                            "tc_adr_remise": {
                                "type": "string",
                                "description": "Adresse nom remisé cautionneur"
                            },
                            "tc_adr_voie": {
                                "type": "string",
                                "description": "Adresse nom voie cautionneur"
                            },
                            "tc_adr_complement": {
                                "type": "string",
                                "description": "Adresse complement cautionneur"
                            },
                            "tc_adr_codePostal": {
                                "type": "string",
                                "description": "Adresse code postal cautionneur"
                            },
                            "tc_adr_localite": {
                                "type": "string",
                                "description": "Adresse localité cautionneur"
                            },
                            "tc_siret": {
                                "type": "string",
                                "description": "SIRET du tiers cautionneur"
                            },
                            "tc_ape": {
                                "type": "string",
                                "description": "APE du tiers cautionneur"
                            },
                            "tc_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur montant1"
                            },
                            "tc_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur montant2"
                            },
                            "tc_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur montant3"
                            },
                            "tc_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur montant4"
                            },
                            "tc_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur montant5"
                            },
                            "tc_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur decimal1"
                            },
                            "tc_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur decimal2"
                            },
                            "tc_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur decimal3"
                            },
                            "tc_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur decimal4"
                            },
                            "tc_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur cautionneur decimal5"
                            },
                            "tc_entier1": {
                                "type": "number",
                                "description": "Valeur cautionneur entier1"
                            },
                            "tc_entier2": {
                                "type": "number",
                                "description": "Valeur cautionneur entier2"
                            },
                            "tc_entier3": {
                                "type": "number",
                                "description": "Valeur cautionneur entier3"
                            },
                            "tc_entier4": {
                                "type": "number",
                                "description": "Valeur cautionneur entier4"
                            },
                            "tc_entier5": {
                                "type": "number",
                                "description": "Valeur cautionneur entier5"
                            },
                            "tc_flag1": {
                                "type": "boolean",
                                "description": "Valeur cautionneur flag1"
                            },
                            "tc_flag2": {
                                "type": "boolean",
                                "description": "Valeur cautionneur flag2"
                            },
                            "tc_flag3": {
                                "type": "boolean",
                                "description": "Valeur cautionneur flag3"
                            },
                            "tc_flag4": {
                                "type": "boolean",
                                "description": "Valeur cautionneur flag4"
                            },
                            "tc_flag5": {
                                "type": "boolean",
                                "description": "Valeur cautionneur flag5"
                            },
                            "tc_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur cautionneur date1"
                            },
                            "tc_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur cautionneur date2"
                            },
                            "tc_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur cautionneur date3"
                            },
                            "tc_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur cautionneur date4"
                            },
                            "tc_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur cautionneur date5"
                            },
                            "tc_texte1": {
                                "type": "string",
                                "description": "Valeur cautionneur texte1"
                            },
                            "tc_texte2": {
                                "type": "string",
                                "description": "Valeur cautionneur texte2"
                            },
                            "tc_texte3": {
                                "type": "string",
                                "description": "Valeur cautionneur texte3"
                            },
                            "tc_texte4": {
                                "type": "string",
                                "description": "Valeur cautionneur texte4"
                            },
                            "tc_texte5": {
                                "type": "string",
                                "description": "Valeur cautionneur texte5"
                            },
                            "tc_codif1": {
                                "type": "string",
                                "description": "Valeur cautionneur codif1",
                                "codif": "SpoTiers_codif1"
                            },
                            "tc_codif2": {
                                "type": "string",
                                "description": "Valeur cautionneur codif2",
                                "codif": "SpoTiers_codif2"
                            },
                            "tc_codif3": {
                                "type": "string",
                                "description": "Valeur cautionneur codif3",
                                "codif": "SpoTiers_codif3"
                            },
                            "tc_codif4": {
                                "type": "string",
                                "description": "Valeur cautionneur codif4",
                                "codif": "SpoTiers_codif4"
                            },
                            "tc_codif5": {
                                "type": "string",
                                "description": "Valeur cautionneur codif5",
                                "codif": "SpoTiers_codif5"
                            },
                            "caution_type": {
                                "type": "string",
                                "description": "Type de caution",
                                "enumId": "DPTypeCaution"
                            },
                            "caution_retenue": {
                                "type": "string",
                                "description": "Retenue"
                            },
                            "caution_nature": {
                                "type": "string",
                                "description": "Nature de caution",
                                "enumId": "DPContratCaution.portee"
                            },
                            "caution_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de la caution"
                            },
                            "caution_dtFinValid": {
                                "type": "string",
                                "format": "date",
                                "description": "Fin de validité de la caution"
                            },
                            "caution_prc": {
                                "type": "number",
                                "format": "rate",
                                "description": "Pourcentage"
                            },
                            "caution_mntEngageTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant de l'engagement TTC"
                            },
                            "caution_mntCalcule": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant calculé TTC"
                            },
                            "caution_mnt": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant TTC de la caution"
                            },
                            "caution_statut": {
                                "type": "string",
                                "description": "Statut de la caution",
                                "enumId": "DPContratCaution.statut"
                            },
                            "caution_dtRecep": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de réception de la caution"
                            },
                            "caution_modeRecep": {
                                "type": "string",
                                "description": "Mode de réception de la caution",
                                "codif": "DPDelegModeRcpt"
                            },
                            "caution_dtAccep": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'acceptation de la caution"
                            },
                            "caution_dtRefus": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de refus de la caution"
                            },
                            "caution_motifRefus": {
                                "type": "string",
                                "description": "Motif de refus de la caution",
                                "codif": "DPCautionMotifRefus"
                            },
                            "caution_dtMainLeveeTot": {
                                "type": "string",
                                "format": "date",
                                "description": "Date main levée totale"
                            },
                            "caution_cmnt": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "mainLevees": {
                                "type": "array",
                                "description": "Liste des mains levées",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ml_lib": {
                                            "type": "string",
                                            "description": "Libellé de la main de levée"
                                        },
                                        "ml_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de la main levée"
                                        },
                                        "ml_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant de la main levée"
                                        },
                                        "ml_prc": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage de la main levée"
                                        }
                                    }
                                }
                            },
                            "avenants": {
                                "type": "array",
                                "description": "Liste des avenants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ave_numAvenant": {
                                            "type": "string",
                                            "description": "N° de l'avenant"
                                        },
                                        "ave_lib": {
                                            "type": "string",
                                            "description": "Libellé de l'avenant"
                                        },
                                        "ave_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de l'avenant"
                                        },
                                        "ave_mntTVA": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de l'avenant"
                                        },
                                        "ave_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de l'avenant"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "Commande": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "NotificationCommande",
                    "items": {
                        "type": "object",
                        "properties": {
                            "prestataire_lib": {
                                "type": "string",
                                "description": "Nom du prestataire"
                            },
                            "prestataire_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé prestataire"
                            },
                            "prestataire_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie prestataire"
                            },
                            "prestataire_adr_complement": {
                                "type": "string",
                                "description": "adresse complement prestataire"
                            },
                            "prestataire_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal prestataire"
                            },
                            "prestataire_adr_localite": {
                                "type": "string",
                                "description": "adresse localité prestataire"
                            },
                            "prestataire_formeJuridique": {
                                "type": "string",
                                "description": "forme Juridique du prestataire"
                            },
                            "prestataire_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "capital social du prestataire"
                            },
                            "prestataire_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers prestataire"
                            },
                            "prestataire_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers prestataire"
                            },
                            "prestataire_civilite": {
                                "type": "string",
                                "codif": "Civilite",
                                "description": "civilité du représentant principal du prestataire"
                            },
                            "prestataire_prenom": {
                                "type": "string",
                                "description": "prénom du représentant principal du prestataire"
                            },
                            "prestataire_nom": {
                                "type": "string",
                                "description": "nom du représentant principal du prestataire"
                            },
                            "prestataire_email": {
                                "type": "string",
                                "description": "email du représentant principal du prestataire"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du représentant principal prestataire",
                                "version": "18.0"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du représentant principal prestataire",
                                "version": "18.0"
                            },
                            "prestataire_siret": {
                                "type": "string",
                                "description": "SIRET du tiers prestataire"
                            },
                            "prestataire_APE": {
                                "type": "string",
                                "description": "APE du tiers prestataire"
                            },
                            "prestataire_libRib": {
                                "type": "string",
                                "description": "RIB du tiers prestataire"
                            },
                            "prestataire_iban": {
                                "type": "string",
                                "description": "IBAN du tiers prestataire"
                            },
                            "prestataire_banque": {
                                "type": "string",
                                "description": "Banque du tiers prestataire"
                            },
                            "bc_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date du bon de commande"
                            },
                            "bc_lib": {
                                "type": "string",
                                "description": "Libellé du bon de commande"
                            },
                            "bc_ref": {
                                "type": "string",
                                "description": "Numéro du bon de commande"
                            },
                            "bc_createur": {
                                "type": "string",
                                "description": "Créateur du bon de commande"
                            },
                            "bc_createurMail": {
                                "type": "string",
                                "description": "Adresse email du créateur"
                            },
                            "bc_code": {
                                "type": "string",
                                "description": "Code du bon de commande"
                            },
                            "bc_adrFE": {
                                "type": "string",
                                "description": "Adresse de réception facture électronique",
                                "version": "18.3"
                            },
                            "bc_cmnt": {
                                "type": "string",
                                "description": "Commentaire commande",
                                "version": "18.0"
                            },
                            "bc_dateDevis": {
                                "type": "string",
                                "format": "date",
                                "description": "date du devis du bon de commande"
                            },
                            "bc_refDevis": {
                                "type": "string",
                                "description": "reférérence du devis du bon de commande"
                            },
                            "bc_mntHTDevis": {
                                "type": "number",
                                "format": "money",
                                "description": "montant HT du devis du bon de commande"
                            },
                            "bc_totalMntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total HT bon de commande"
                            },
                            "bc_totalMntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TTC bon de commande"
                            },
                            "bc_totalMntHT_lettres": {
                                "type": "string",
                                "format": "number-letters",
                                "description": "Montant Total HT bon de commande en toutes lettres",
                                "version": "18.0"
                            },
                            "bc_totalMntTTC_lettres": {
                                "type": "string",
                                "format": "number-letters",
                                "description": "Montant Total TTC bon de commande en toutes lettres",
                                "version": "18.0"
                            },
                            "bc_totalMntTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TVA bon de commande"
                            },
                            "bc_dateDebut": {
                                "type": "string",
                                "format": "date",
                                "description": "Bon de commande date début d'exécution"
                            },
                            "bc_dateFin": {
                                "type": "string",
                                "format": "date",
                                "description": "Bon de commande date fin d'exécution"
                            },
                            "bc_delai": {
                                "type": "number",
                                "description": "Bon de commande delai d'exécution"
                            },
                            "bc_dateEngage": {
                                "type": "string",
                                "format": "date",
                                "description": "Date engage du bon de commande"
                            },
                            "bc_initialHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial HT du bon de commande"
                            },
                            "bc_initialTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TTC du bon de commande"
                            },
                            "bc_initialTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant inital TVA du bon de commande"
                            },
                            "bc_delaiReg": {
                                "type": "integer",
                                "description": "Délai",
                                "version": "18.0"
                            },
                            "bc_condReg": {
                                "type": "string",
                                "description": "Base",
                                "enumId": "FacBaseRegle",
                                "version": "18.0"
                            },
                            "bc_exigible": {
                                "type": "integer",
                                "description": "Exigible",
                                "version": "18.0"
                            },
                            "bc_modeReg": {
                                "type": "string",
                                "description": "Mode de paiement",
                                "enumId": "DPModeReglement",
                                "version": "18.0"
                            },
                            "accordCadre_code": {
                                "type": "string",
                                "description": "Code accord cadre",
                                "version": "18.1"
                            },
                            "accordCadre_lib": {
                                "type": "string",
                                "description": "Libellé accord cadre",
                                "version": "18.1"
                            },
                            "accordCadre_num": {
                                "type": "string",
                                "description": "N° accord cadre",
                                "version": "18.1"
                            },
                            "bc_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant1 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant2 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant3 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant4 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant5 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal1 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal2 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal3 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal4 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal5 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_entier1": {
                                "type": "integer",
                                "description": "Entier1 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_entier2": {
                                "type": "integer",
                                "description": "Entier2 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_entier3": {
                                "type": "integer",
                                "description": "Entier3 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_entier4": {
                                "type": "integer",
                                "description": "Entier4 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_entier5": {
                                "type": "integer",
                                "description": "Entier5 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_flag1": {
                                "type": "boolean",
                                "description": "Flag1 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_flag2": {
                                "type": "boolean",
                                "description": "Flag2 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_flag3": {
                                "type": "boolean",
                                "description": "Flag3 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_flag4": {
                                "type": "boolean",
                                "description": "Flag4 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_flag5": {
                                "type": "boolean",
                                "description": "Flag5 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Date1 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Date2 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Date3 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Date4 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Date5 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_texte1": {
                                "type": "string",
                                "description": "Texte1 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_texte2": {
                                "type": "string",
                                "description": "Texte2 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_texte3": {
                                "type": "string",
                                "description": "Texte3 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_texte4": {
                                "type": "string",
                                "description": "Texte4 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_texte5": {
                                "type": "string",
                                "description": "Texte5 du bon de commande",
                                "version": "18.3"
                            },
                            "bc_codif1": {
                                "type": "string",
                                "description": "Codif1 du bon de commande",
                                "codif": "DPContrat_codif1",
                                "version": "18.3"
                            },
                            "bc_codif2": {
                                "type": "string",
                                "description": "Codif2 du bon de commande",
                                "codif": "DPContrat_codif2",
                                "version": "18.3"
                            },
                            "bc_codif3": {
                                "type": "string",
                                "description": "Codif3 du bon de commande",
                                "codif": "DPContrat_codif3",
                                "version": "18.3"
                            },
                            "bc_codif4": {
                                "type": "string",
                                "description": "Codif4 du bon de commande",
                                "codif": "DPContrat_codif4",
                                "version": "18.3"
                            },
                            "bc_codif5": {
                                "type": "string",
                                "description": "Codif5 du bon de commande",
                                "codif": "DPContrat_codif5",
                                "version": "18.3"
                            },
                            "perso_tiers_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant1"
                            },
                            "perso_tiers_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant2"
                            },
                            "perso_tiers_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant3"
                            },
                            "perso_tiers_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant4"
                            },
                            "perso_tiers_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant5"
                            },
                            "perso_tiers_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal1"
                            },
                            "perso_tiers_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal2"
                            },
                            "perso_tiers_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal3"
                            },
                            "perso_tiers_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal4"
                            },
                            "perso_tiers_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal5"
                            },
                            "perso_tiers_entier1": {
                                "type": "number",
                                "description": "Valeur tiers entier1"
                            },
                            "perso_tiers_entier2": {
                                "type": "number",
                                "description": "Valeur tiers entier2"
                            },
                            "perso_tiers_entier3": {
                                "type": "number",
                                "description": "Valeur tiers entier3"
                            },
                            "perso_tiers_entier4": {
                                "type": "number",
                                "description": "Valeur tiers entier4"
                            },
                            "perso_tiers_entier5": {
                                "type": "number",
                                "description": "Valeur tiers entier5"
                            },
                            "perso_tiers_flag1": {
                                "type": "boolean",
                                "description": "Valeur tiers flag1"
                            },
                            "perso_tiers_flag2": {
                                "type": "boolean",
                                "description": "Valeur tiers flag2"
                            },
                            "perso_tiers_flag3": {
                                "type": "boolean",
                                "description": "Valeur tiers flag3"
                            },
                            "perso_tiers_flag4": {
                                "type": "boolean",
                                "description": "Valeur tiers flag4"
                            },
                            "perso_tiers_flag5": {
                                "type": "boolean",
                                "description": "Valeur tiers flag5"
                            },
                            "perso_tiers_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date1"
                            },
                            "perso_tiers_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date2"
                            },
                            "perso_tiers_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date3"
                            },
                            "perso_tiers_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date4"
                            },
                            "perso_tiers_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date5"
                            },
                            "perso_tiers_texte1": {
                                "type": "string",
                                "description": "Valeur tiers texte1"
                            },
                            "perso_tiers_texte2": {
                                "type": "string",
                                "description": "Valeur tiers texte2"
                            },
                            "perso_tiers_texte3": {
                                "type": "string",
                                "description": "Valeur tiers texte3"
                            },
                            "perso_tiers_texte4": {
                                "type": "string",
                                "description": "Valeur tiers texte4"
                            },
                            "perso_tiers_texte5": {
                                "type": "string",
                                "description": "Valeur tiers texte5"
                            },
                            "perso_tiers_codif1": {
                                "type": "string",
                                "description": "Valeur tiers codif1"
                            },
                            "perso_tiers_codif2": {
                                "type": "string",
                                "description": "Valeur tiers codif2"
                            },
                            "perso_tiers_codif3": {
                                "type": "string",
                                "description": "Valeur tiers codif3"
                            },
                            "perso_tiers_codif4": {
                                "type": "string",
                                "description": "Valeur tiers codif4"
                            },
                            "perso_tiers_codif5": {
                                "type": "string",
                                "description": "Valeur tiers codif5"
                            },
                            "cde_montants": {
                                "type": "array",
                                "description": "Liste des montants de la commande",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "mnt_lib": {
                                            "type": "string",
                                            "description": "Libellé de la ligne de commande",
                                            "version": "18.0"
                                        },
                                        "mnt_codeExt": {
                                            "type": "string",
                                            "description": "Code externe",
                                            "version": "18.0"
                                        },
                                        "mnt_qte": {
                                            "type": "integer",
                                            "description": "Quantité ligne commande",
                                            "version": "18.0"
                                        },
                                        "mnt_prixUnit": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix unitaire HT ligne commande",
                                            "version": "18.0"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de commande"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de commande"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de commande"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de commande"
                                        },
                                        "cm_libpostes": {
                                            "type": "string",
                                            "description": "Libellé du/des postes budgétaires afffectés au bon de commande par ligne de montant"
                                        }
                                    }
                                }
                            },
                            "cmdMntParTva": {
                                "type": "array",
                                "description": "Liste des montants du bon de commande par taux de TVA",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "cmdTva_lib": {
                                            "type": "string",
                                            "description": "Libellé du taux de TVA",
                                            "version": "18.2"
                                        },
                                        "cmdTva_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA",
                                            "version": "18.2"
                                        },
                                        "cmdTva_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT",
                                            "version": "18.2"
                                        },
                                        "cmdTva_mntTVA": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA",
                                            "version": "18.2"
                                        },
                                        "cmdTva_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC",
                                            "version": "18.2"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "CommandeClient": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Commande Client",
                    "items": {
                        "type": "object",
                        "properties": {
                            "client_civilite": {
                                "type": "string",
                                "description": "civilité du client",
                                "codif": "Civilite"
                            },
                            "client_lib": {
                                "type": "string",
                                "description": "Nom du client"
                            },
                            "client_nom": {
                                "type": "string",
                                "description": "Nom du client"
                            },
                            "client_adr_remise": {
                                "type": "string",
                                "description": "adrPointRemise du client"
                            },
                            "client_adr_voie": {
                                "type": "string",
                                "description": "adrNomVoie du client"
                            },
                            "client_cp": {
                                "type": "string",
                                "description": "adrCP du client"
                            },
                            "client_adr_localite": {
                                "type": "string",
                                "description": "adrLocalite du client"
                            },
                            "client_adr_complement": {
                                "type": "string",
                                "description": "adrComplement du client"
                            },
                            "cmd_ref": {
                                "type": "string",
                                "description": "Référence de la commande"
                            },
                            "cmd_num": {
                                "type": "string",
                                "description": "numéro de la commande"
                            },
                            "cmd_libelle": {
                                "type": "string",
                                "description": "libellé de la commande"
                            },
                            "cmd_date": {
                                "type": "string",
                                "format": "date",
                                "description": "date de la commande"
                            },
                            "cmd_comm": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "cmd_total_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants HT des commandes"
                            },
                            "cmd_total_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TTC des commandes"
                            },
                            "cmd_total_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TVA des commandes"
                            },
                            "cmd_modeRegle": {
                                "type": "string",
                                "description": "mode de règlement de la commande",
                                "enumId": "FRCmdCli.modeReg"
                            },
                            "cmd_baseRegle": {
                                "type": "string",
                                "description": "base de règlement de la commande",
                                "enumId": "FRCmdCli.condReg"
                            },
                            "cmd_delaiRegle": {
                                "type": "integer",
                                "description": "délai de règlement de la commande"
                            },
                            "cmd_exigible": {
                                "type": "integer",
                                "description": "exigibilité de la commande"
                            },
                            "tc_typeOuvrage": {
                                "type": "string",
                                "description": "type ouvrage"
                            },
                            "cmdMontants": {
                                "type": "array",
                                "description": "Détails des montants de la commande",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "libelle": {
                                            "type": "string",
                                            "description": "Libellé"
                                        },
                                        "quantite": {
                                            "type": "integer",
                                            "description": "Quantité"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux tva"
                                        },
                                        "prix_unit": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix unitaire"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        },
                                        "commentaire": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        }
                                    }
                                }
                            },
                            "echeancier": {
                                "type": "array",
                                "description": "Détails des échéances",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "libelle": {
                                            "type": "string",
                                            "description": "Libellé"
                                        },
                                        "type": {
                                            "type": "string",
                                            "description": "Type"
                                        },
                                        "evt": {
                                            "type": "string",
                                            "description": "Evénement"
                                        },
                                        "delai": {
                                            "type": "integer",
                                            "description": "Délai"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "date_ech": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date échéance"
                                        },
                                        "pourcentage": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage"
                                        },
                                        "ech_statut": {
                                            "type": "string",
                                            "description": "statut",
                                            "enumId": "FRCmdCliEch.statut"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "ContratCadre": {
        "schemas": {
            "type": "object",
            "properties": {
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Contrat Cadre",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "code accord cadre"
                            },
                            "tiers_lib": {
                                "type": "string",
                                "description": "nom titulaire"
                            },
                            "tiers_formeJuridique": {
                                "type": "string",
                                "description": "forme juridique titulaire"
                            },
                            "tiers_capital": {
                                "type": "money",
                                "description": "capital social titulaire"
                            },
                            "tiers_tribunalComm": {
                                "type": "string",
                                "description": "tribunal de commerce titulaire"
                            },
                            "tiers_rcs": {
                                "type": "string",
                                "description": "RCS titulaire"
                            },
                            "tiers_civilite": {
                                "type": "string",
                                "description": "civilité du représentant principal titulaire"
                            },
                            "tiers_prenom": {
                                "type": "string",
                                "description": "prénom du représentant principal titulaire"
                            },
                            "tiers_nom": {
                                "type": "string",
                                "description": "nom du représentant principal titulaire"
                            },
                            "tiers_rep_mail": {
                                "type": "string",
                                "description": "email du représentant principal titulaire"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "téléphone du représentant principal titulaire"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "fonction du représentant principal titulaire"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "remise adresse titulaire"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "nom voie adresse titulaire"
                            },
                            "tiers_adr_complement": {
                                "type": "string",
                                "description": "complément adresse titulaire"
                            },
                            "tiers_adr_cp": {
                                "type": "string",
                                "description": "code postal titulaire"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "localité titulaire"
                            },
                            "tiers_siret": {
                                "type": "string",
                                "description": "SIRET du titulaire"
                            },
                            "tiers_ape": {
                                "type": "string",
                                "description": "APE du titulaire"
                            },
                            "cadre_lib": {
                                "type": "string",
                                "description": "libellé du contrat cadre"
                            },
                            "cadre_num": {
                                "type": "string",
                                "description": "n° contrat cadre"
                            },
                            "cadre_code": {
                                "type": "string",
                                "description": "code contrat cadre"
                            },
                            "cadre_dtSign": {
                                "type": "date",
                                "description": "date de signature"
                            },
                            "cadre_dtNotif": {
                                "type": "date",
                                "description": "date de notification"
                            },
                            "cadre_dtDebut": {
                                "type": "integer",
                                "description": "départ"
                            },
                            "cadre_duree": {
                                "type": "string",
                                "description": "nombre d'année"
                            },
                            "cadre_dtFin": {
                                "type": "date",
                                "description": "fin"
                            },
                            "cadre_clos": {
                                "type": "boolean",
                                "description": "contrat cloturé"
                            },
                            "cadre_cmnt": {
                                "type": "string",
                                "description": "commentaire"
                            },
                            "cadre_mntMin": {
                                "type": "money",
                                "description": "montant minimum HT"
                            },
                            "cadre_mntMax": {
                                "type": "money",
                                "description": "montant maximum HT"
                            },
                            "cadre_mntCmd": {
                                "type": "money",
                                "description": "montant commandé HT"
                            },
                            "cadre_soldeMin": {
                                "type": "money",
                                "description": "solde sur minimum HT"
                            },
                            "cadre_soldeMax": {
                                "type": "money",
                                "description": "solde sur maximum HT"
                            },
                            "cadre_totalAvenantMin": {
                                "type": "money",
                                "description": "total des avenants montant minimum HT"
                            },
                            "cadre_totalAvenantMax": {
                                "type": "money",
                                "description": "total des avenants Montant maximum HT"
                            },
                            "fournisseurs": {
                                "type": "array",
                                "description": "liste des tiers du contrat",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "t_lib": {
                                            "type": "string",
                                            "description": "nom titulaire"
                                        },
                                        "t_formeJuridique": {
                                            "type": "string",
                                            "description": "forme juridique titulaire"
                                        },
                                        "t_capital": {
                                            "type": "money",
                                            "description": "capital social titulaire"
                                        },
                                        "t_tribunalComm": {
                                            "type": "string",
                                            "description": "tribunal de commerce titulaire"
                                        },
                                        "t_rcs": {
                                            "type": "string",
                                            "description": "RCS titulaire"
                                        },
                                        "t_rep_civilite": {
                                            "type": "string",
                                            "description": "civilité du représentant principal titulaire"
                                        },
                                        "t_rep_prenom": {
                                            "type": "string",
                                            "description": "prénom du représentant principal titulaire"
                                        },
                                        "t_rep_nom": {
                                            "type": "string",
                                            "description": "nom du représentant principal titulaire"
                                        },
                                        "t_rep_fonction": {
                                            "type": "string",
                                            "description": "fonction du représentant principal titulaire"
                                        },
                                        "t_rep_mail": {
                                            "type": "string",
                                            "description": "email du représentant principal titulaire"
                                        },
                                        "t_rep_phone": {
                                            "type": "string",
                                            "description": "téléphone du représentant principal titulaire"
                                        },
                                        "t_adr_remise": {
                                            "type": "string",
                                            "description": "remise adresse titulaire"
                                        },
                                        "t_adr_voie": {
                                            "type": "string",
                                            "description": "nom voie adresse titulaire"
                                        },
                                        "t_adr_complement": {
                                            "type": "string",
                                            "description": "complément adresse titulaire"
                                        },
                                        "t_adr_codePostal": {
                                            "type": "string",
                                            "description": "code postal titulaire"
                                        },
                                        "t_adr_localite": {
                                            "type": "string",
                                            "description": "localité titulaire"
                                        },
                                        "t_siret": {
                                            "type": "string",
                                            "description": "SIRET du titulaire"
                                        },
                                        "t_ape": {
                                            "type": "string",
                                            "description": "APE du titulaire"
                                        }
                                    }
                                }
                            },
                            "sous_traitants": {
                                "type": "array",
                                "description": "liste des sous-traitants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "st_sousTraitant": {
                                            "type": "string",
                                            "description": "nom sous-traitant"
                                        },
                                        "st_formeJuridique": {
                                            "type": "string",
                                            "description": "forme juridique sous-traitant"
                                        },
                                        "st_capital": {
                                            "type": "money",
                                            "description": "capital social sous-traitant"
                                        },
                                        "st_tribunalComm": {
                                            "type": "string",
                                            "description": "tribunal de commerce sous-traitant"
                                        },
                                        "st_rcs": {
                                            "type": "string",
                                            "description": "RCS sous-traitant"
                                        },
                                        "st_rep_civilite": {
                                            "type": "string",
                                            "description": "civilité du représentant principal sous-traitant"
                                        },
                                        "st_rep_prenom": {
                                            "type": "string",
                                            "description": "prénom du représentant principal sous-traitant"
                                        },
                                        "st_rep_nom": {
                                            "type": "string",
                                            "description": "nom du représentant principal sous-traitant"
                                        },
                                        "st_rep_fonction": {
                                            "type": "string",
                                            "description": "fonction du représentant principal sous-traitant"
                                        },
                                        "st_rep_mail": {
                                            "type": "string",
                                            "description": "email du représentant principal sous-traitant"
                                        },
                                        "st_rep_phone": {
                                            "type": "string",
                                            "description": "téléphone du représentant principal sous-traitant"
                                        },
                                        "st_adr_remise": {
                                            "type": "string",
                                            "description": "remise adresse sous-traitant"
                                        },
                                        "st_adr_voie": {
                                            "type": "string",
                                            "description": "nom voie adresse sous-traitant"
                                        },
                                        "st_adr_complement": {
                                            "type": "string",
                                            "description": "complément adresse sous-traitant"
                                        },
                                        "st_adr_codePostal": {
                                            "type": "string",
                                            "description": "code postal sous-traitant"
                                        },
                                        "st_adr_localite": {
                                            "type": "string",
                                            "description": "localité sous-traitant"
                                        },
                                        "st_siret": {
                                            "type": "string",
                                            "description": "SIRET sous-traitant"
                                        },
                                        "st_ape": {
                                            "type": "string",
                                            "description": "APE sous-traitant"
                                        },
                                        "st_dtActe": {
                                            "type": "date",
                                            "description": "date acte"
                                        }
                                    }
                                }
                            },
                            "montants": {
                                "type": "array",
                                "description": "liste des montants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "m_annee": {
                                            "type": "integer",
                                            "description": "année"
                                        },
                                        "m_mntMin": {
                                            "type": "money",
                                            "description": "montant minimum HT"
                                        },
                                        "m_mntMax": {
                                            "type": "money",
                                            "description": "montant maximum HT"
                                        },
                                        "m_mntCmd": {
                                            "type": "money",
                                            "description": "montant commandé HT"
                                        },
                                        "m_soldeMin": {
                                            "type": "money",
                                            "description": "solde sur minimum HT"
                                        },
                                        "m_soldeMax": {
                                            "type": "money",
                                            "description": "solde sur maximum HT"
                                        }
                                    }
                                }
                            },
                            "avenants": {
                                "type": "array",
                                "description": "liste des avenants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "a_tiers": {
                                            "type": "string",
                                            "description": "tiers titulaire"
                                        },
                                        "a_lib": {
                                            "type": "string",
                                            "description": "libellé de l'avenant"
                                        },
                                        "a_num": {
                                            "type": "string",
                                            "description": "n° de l'avenant"
                                        },
                                        "a_code": {
                                            "type": "string",
                                            "description": "code de l'avenant"
                                        },
                                        "a_dtSign": {
                                            "type": "date",
                                            "description": "date de signature"
                                        },
                                        "a_dtNotif": {
                                            "type": "date",
                                            "description": "date de notification"
                                        },
                                        "a_dtDebut": {
                                            "type": "date",
                                            "description": "date de début"
                                        },
                                        "a_duree": {
                                            "type": "integer",
                                            "description": "nombre d'année"
                                        },
                                        "a_dtFin": {
                                            "type": "date",
                                            "description": "date de fin"
                                        },
                                        "a_cmnt": {
                                            "type": "string",
                                            "description": "commentaire"
                                        },
                                        "a_mntMin": {
                                            "type": "money",
                                            "description": "montant minimum HT"
                                        },
                                        "a_mntMax": {
                                            "type": "money",
                                            "description": "montant maximum HT"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "ContratCadreAve": {
        "schemas": {
            "type": "object",
            "properties": {
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Contrat Cadre  avenant",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "code accord cadre"
                            },
                            "tiers_lib": {
                                "type": "string",
                                "description": "nom titulaire"
                            },
                            "tiers_formeJuridique": {
                                "type": "string",
                                "description": "forme juridique titulaire"
                            },
                            "tiers_capital": {
                                "type": "money",
                                "description": "capital social titulaire"
                            },
                            "tiers_tribunalComm": {
                                "type": "string",
                                "description": "tribunal de commerce titulaire"
                            },
                            "tiers_rcs": {
                                "type": "string",
                                "description": "RCS titulaire"
                            },
                            "tiers_civilite": {
                                "type": "string",
                                "description": "civilité du représentant principal titulaire"
                            },
                            "tiers_prenom": {
                                "type": "string",
                                "description": "prénom du représentant principal titulaire"
                            },
                            "tiers_nom": {
                                "type": "string",
                                "description": "nom du représentant principal titulaire"
                            },
                            "tiers_rep_mail": {
                                "type": "string",
                                "description": "email du représentant principal titulaire"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "téléphone du représentant principal titulaire"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "fonction du représentant principal titulaire"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "remise adresse titulaire"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "nom voie adresse titulaire"
                            },
                            "tiers_adr_complement": {
                                "type": "string",
                                "description": "complément adresse titulaire"
                            },
                            "tiers_adr_cp": {
                                "type": "string",
                                "description": "code postal titulaire"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "localité titulaire"
                            },
                            "tiers_siret": {
                                "type": "string",
                                "description": "SIRET du titulaire"
                            },
                            "tiers_ape": {
                                "type": "string",
                                "description": "APE du titulaire"
                            },
                            "cadre_lib": {
                                "type": "string",
                                "description": "libellé du contrat cadre"
                            },
                            "cadre_num": {
                                "type": "string",
                                "description": "n° contrat cadre"
                            },
                            "cadre_code": {
                                "type": "string",
                                "description": "code contrat cadre"
                            },
                            "cadre_dtSign": {
                                "type": "date",
                                "description": "date de signature"
                            },
                            "cadre_dtNotif": {
                                "type": "date",
                                "description": "date de notification"
                            },
                            "cadre_dtDebut": {
                                "type": "integer",
                                "description": "départ"
                            },
                            "cadre_duree": {
                                "type": "string",
                                "description": "nombre d'année"
                            },
                            "cadre_dtFin": {
                                "type": "date",
                                "description": "fin"
                            },
                            "cadre_clos": {
                                "type": "boolean",
                                "description": "contrat cloturé"
                            },
                            "cadre_cmnt": {
                                "type": "string",
                                "description": "commentaire"
                            },
                            "cadre_mntMin": {
                                "type": "money",
                                "description": "montant minimum HT"
                            },
                            "cadre_mntMax": {
                                "type": "money",
                                "description": "montant maximum HT"
                            },
                            "cadre_mntCmd": {
                                "type": "money",
                                "description": "montant commandé HT"
                            },
                            "cadre_soldeMin": {
                                "type": "money",
                                "description": "solde sur minimum HT"
                            },
                            "cadre_soldeMax": {
                                "type": "money",
                                "description": "solde sur maximum HT"
                            },
                            "cadre_totalAvenantMin": {
                                "type": "money",
                                "description": "total des avenants montant minimum HT"
                            },
                            "cadre_totalAvenantMax": {
                                "type": "money",
                                "description": "total des avenants Montant maximum HT"
                            },
                            "ave_lib": {
                                "type": "string",
                                "description": "libellé avenant"
                            },
                            "ave_num": {
                                "type": "string",
                                "description": "n° avenant"
                            },
                            "ave_code": {
                                "type": "string",
                                "description": "code avenant"
                            },
                            "ave_dtSign": {
                                "type": "date",
                                "description": "date signature avenant"
                            },
                            "ave_dtNotif": {
                                "type": "date",
                                "description": "date de notification avenant"
                            },
                            "ave_dtDebut": {
                                "type": "date",
                                "description": "départ avenant"
                            },
                            "ave_duree": {
                                "type": "integer",
                                "description": "nombre d'année avenant"
                            },
                            "ave_dtFin": {
                                "type": "date",
                                "description": "fin avenant"
                            },
                            "ave_cmnt": {
                                "type": "string",
                                "description": "commentaire avenant"
                            },
                            "ave_mntMin": {
                                "type": "money",
                                "description": "montant minimum HT avenant"
                            },
                            "ave_mntMax": {
                                "type": "money",
                                "description": "montant maximum HT avenant"
                            },
                            "fournisseurs": {
                                "type": "array",
                                "description": "liste des tiers du contrat",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "t_lib": {
                                            "type": "string",
                                            "description": "nom titulaire"
                                        },
                                        "t_formeJuridique": {
                                            "type": "string",
                                            "description": "forme juridique titulaire"
                                        },
                                        "t_capital": {
                                            "type": "money",
                                            "description": "capital social titulaire"
                                        },
                                        "t_tribunalComm": {
                                            "type": "string",
                                            "description": "tribunal de commerce titulaire"
                                        },
                                        "t_rcs": {
                                            "type": "string",
                                            "description": "RCS titulaire"
                                        },
                                        "t_rep_civilite": {
                                            "type": "string",
                                            "description": "civilité du représentant principal titulaire"
                                        },
                                        "t_rep_prenom": {
                                            "type": "string",
                                            "description": "prénom du représentant principal titulaire"
                                        },
                                        "t_rep_nom": {
                                            "type": "string",
                                            "description": "nom du représentant principal titulaire"
                                        },
                                        "t_rep_fonction": {
                                            "type": "string",
                                            "description": "fonction du représentant principal titulaire"
                                        },
                                        "t_rep_mail": {
                                            "type": "string",
                                            "description": "email du représentant principal titulaire"
                                        },
                                        "t_rep_phone": {
                                            "type": "string",
                                            "description": "téléphone du représentant principal titulaire"
                                        },
                                        "t_adr_remise": {
                                            "type": "string",
                                            "description": "remise adresse titulaire"
                                        },
                                        "t_adr_voie": {
                                            "type": "string",
                                            "description": "nom voie adresse titulaire"
                                        },
                                        "t_adr_complement": {
                                            "type": "string",
                                            "description": "complément adresse titulaire"
                                        },
                                        "t_adr_codePostal": {
                                            "type": "string",
                                            "description": "code postal titulaire"
                                        },
                                        "t_adr_localite": {
                                            "type": "string",
                                            "description": "localité titulaire"
                                        },
                                        "t_siret": {
                                            "type": "string",
                                            "description": "SIRET du titulaire"
                                        },
                                        "t_ape": {
                                            "type": "string",
                                            "description": "APE du titulaire"
                                        }
                                    }
                                }
                            },
                            "sous_traitants": {
                                "type": "array",
                                "description": "liste des sous-traitants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "st_sousTraitant": {
                                            "type": "string",
                                            "description": "nom sous-traitant"
                                        },
                                        "st_formeJuridique": {
                                            "type": "string",
                                            "description": "forme juridique sous-traitant"
                                        },
                                        "st_capital": {
                                            "type": "money",
                                            "description": "capital social sous-traitant"
                                        },
                                        "st_tribunalComm": {
                                            "type": "string",
                                            "description": "tribunal de commerce sous-traitant"
                                        },
                                        "st_rcs": {
                                            "type": "string",
                                            "description": "RCS sous-traitant"
                                        },
                                        "st_rep_civilite": {
                                            "type": "string",
                                            "description": "civilité du représentant principal sous-traitant"
                                        },
                                        "st_rep_prenom": {
                                            "type": "string",
                                            "description": "prénom du représentant principal sous-traitant"
                                        },
                                        "st_rep_nom": {
                                            "type": "string",
                                            "description": "nom du représentant principal sous-traitant"
                                        },
                                        "st_rep_fonction": {
                                            "type": "string",
                                            "description": "fonction du représentant principal sous-traitant"
                                        },
                                        "st_rep_mail": {
                                            "type": "string",
                                            "description": "email du représentant principal sous-traitant"
                                        },
                                        "st_rep_phone": {
                                            "type": "string",
                                            "description": "téléphone du représentant principal sous-traitant"
                                        },
                                        "st_adr_remise": {
                                            "type": "string",
                                            "description": "remise adresse sous-traitant"
                                        },
                                        "st_adr_voie": {
                                            "type": "string",
                                            "description": "nom voie adresse sous-traitant"
                                        },
                                        "st_adr_complement": {
                                            "type": "string",
                                            "description": "complément adresse sous-traitant"
                                        },
                                        "st_adr_codePostal": {
                                            "type": "string",
                                            "description": "code postal sous-traitant"
                                        },
                                        "st_adr_localite": {
                                            "type": "string",
                                            "description": "localité sous-traitant"
                                        },
                                        "st_siret": {
                                            "type": "string",
                                            "description": "SIRET sous-traitant"
                                        },
                                        "st_ape": {
                                            "type": "string",
                                            "description": "APE sous-traitant"
                                        },
                                        "st_dtActe": {
                                            "type": "date",
                                            "description": "date acte"
                                        }
                                    }
                                }
                            },
                            "montants": {
                                "type": "array",
                                "description": "liste des montants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "m_annee": {
                                            "type": "integer",
                                            "description": "année"
                                        },
                                        "m_mntMin": {
                                            "type": "money",
                                            "description": "montant minimum HT"
                                        },
                                        "m_mntMax": {
                                            "type": "money",
                                            "description": "montant maximum HT"
                                        },
                                        "m_mntCmd": {
                                            "type": "money",
                                            "description": "montant commandé HT"
                                        },
                                        "m_soldeMin": {
                                            "type": "money",
                                            "description": "solde sur minimum HT"
                                        },
                                        "m_soldeMax": {
                                            "type": "money",
                                            "description": "solde sur maximum HT"
                                        }
                                    }
                                }
                            },
                            "avenants": {
                                "type": "array",
                                "description": "liste des avenants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "a_tiers": {
                                            "type": "string",
                                            "description": "tiers titulaire"
                                        },
                                        "a_lib": {
                                            "type": "string",
                                            "description": "libellé de l'avenant"
                                        },
                                        "a_num": {
                                            "type": "string",
                                            "description": "n° de l'avenant"
                                        },
                                        "a_code": {
                                            "type": "string",
                                            "description": "code de l'avenant"
                                        },
                                        "a_dtSign": {
                                            "type": "date",
                                            "description": "date de signature"
                                        },
                                        "a_dtNotif": {
                                            "type": "date",
                                            "description": "date de notification"
                                        },
                                        "a_dtDebut": {
                                            "type": "date",
                                            "description": "date de début"
                                        },
                                        "a_duree": {
                                            "type": "integer",
                                            "description": "nombre d'année"
                                        },
                                        "a_dtFin": {
                                            "type": "date",
                                            "description": "date de fin"
                                        },
                                        "a_cmnt": {
                                            "type": "string",
                                            "description": "commentaire"
                                        },
                                        "a_mntMin": {
                                            "type": "money",
                                            "description": "montant minimum HT"
                                        },
                                        "a_mntMax": {
                                            "type": "money",
                                            "description": "montant maximum HT"
                                        }
                                    }
                                }
                            },
                            "avenant_mnts": {
                                "type": "array",
                                "description": "liste des montants de l'avenant",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "am_annee": {
                                            "type": "integer",
                                            "description": "année"
                                        },
                                        "am_mntMin": {
                                            "type": "money",
                                            "description": "montant minimum HT"
                                        },
                                        "am_mntMax": {
                                            "type": "money",
                                            "description": "montant maximum HT"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "Delegation": {
        "schemas": {
            "type": "object",
            "properties": {
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Délégation",
                    "items": {
                        "type": "object",
                        "properties": {
                            "type": {
                                "type": "string",
                                "description": "Type de délégation",
                                "enumId": "DPDelegPaie.typeDeleg"
                            },
                            "date_deleg": {
                                "type": "string",
                                "format": "date",
                                "description": "date de la délégation"
                            },
                            "date_butoir": {
                                "type": "string",
                                "format": "date",
                                "description": "date butoir"
                            },
                            "mnt_deleg": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant TTC"
                            },
                            "portee": {
                                "type": "string",
                                "description": "Portée de la délégation",
                                "enumId": "DPDelegPaie.portee"
                            },
                            "statut": {
                                "type": "string",
                                "description": "Statut",
                                "enumId": "DPDelegPaie.statut"
                            },
                            "date_recep": {
                                "type": "string",
                                "format": "date",
                                "description": "date de réception"
                            },
                            "mode_recep": {
                                "type": "string",
                                "description": "Mode de réception",
                                "codif": "DPDelegModeRcpt"
                            },
                            "date_accept": {
                                "type": "string",
                                "format": "date",
                                "description": "date d'acceptation"
                            },
                            "mnt_accept": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant TTC accepté"
                            },
                            "date_refus": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de refus"
                            },
                            "motif_refus": {
                                "type": "string",
                                "description": "Motif de refus"
                            },
                            "commentaire": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "four_nom": {
                                "type": "string",
                                "description": "Nom tiers fournisseur"
                            },
                            "four_formeJuridique": {
                                "type": "string",
                                "description": "forme juridique tiers fournisseur",
                                "codif": "FormeJuridique"
                            },
                            "four_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "capital social tiers fournisseur"
                            },
                            "four_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers fournisseur"
                            },
                            "four_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers fournisseur"
                            },
                            "four_repres_civ": {
                                "type": "string",
                                "description": "Civilité du Représentant principal tiers fournisseur",
                                "codif": "Civilite"
                            },
                            "four_repres_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal tiers fournisseur"
                            },
                            "four_repres_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal tiers fournisseur"
                            },
                            "four_adrNomRemise": {
                                "type": "string",
                                "description": "adresse nom remis tiers fournisseur"
                            },
                            "four_adrNomVoie": {
                                "type": "string",
                                "description": "adresse nom voie tiers fournisseur"
                            },
                            "four_adrComplement": {
                                "type": "string",
                                "description": "adresse complement tiers fournisseur"
                            },
                            "four_adrCP": {
                                "type": "string",
                                "description": "adresse code postal tiers fournisseur"
                            },
                            "four_adrLocalite": {
                                "type": "string",
                                "description": "adresse localité tiers fournisseur"
                            },
                            "four_iban": {
                                "type": "string",
                                "description": "IBAN du tiers fournisseur"
                            },
                            "four_bic": {
                                "type": "string",
                                "description": "BIC du tiers fournisseur"
                            },
                            "deleg_nom": {
                                "type": "string",
                                "description": "Nom délégataire"
                            },
                            "deleg_formeJuridique": {
                                "type": "string",
                                "description": "forme juridique délégataire",
                                "codif": "FormeJuridique"
                            },
                            "deleg_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "capital social délégataire"
                            },
                            "deleg_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du délégataire"
                            },
                            "deleg_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du délégataire"
                            },
                            "deleg_repres_civ": {
                                "type": "string",
                                "description": "Civilité du Représentant principal délégataire",
                                "codif": "Civilite"
                            },
                            "deleg_repres_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal délégataire"
                            },
                            "deleg_repres_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal délégataire"
                            },
                            "deleg_adrNomRemise": {
                                "type": "string",
                                "description": "adresse nom remise délégataire"
                            },
                            "deleg_adrNomVoie": {
                                "type": "string",
                                "description": "adresse nom voie délégataire"
                            },
                            "deleg_adrComplement": {
                                "type": "string",
                                "description": "adresse complement délégataire"
                            },
                            "deleg_adrCP": {
                                "type": "string",
                                "description": "adresse code postal délégataire"
                            },
                            "deleg_adrLocalite": {
                                "type": "string",
                                "description": "adresse localité délégataire"
                            },
                            "deleg_iban": {
                                "type": "string",
                                "description": "IBAN du tiers délégataire"
                            },
                            "deleg_bic": {
                                "type": "string",
                                "description": "BIC du tiers délégataire"
                            },
                            "op_code": {
                                "type": "string",
                                "description": "code opération"
                            },
                            "op_lib": {
                                "type": "string",
                                "description": "libellé opération"
                            },
                            "op_nomcomm": {
                                "type": "string",
                                "description": "nom commercial opération"
                            },
                            "op_adrNomRemise": {
                                "type": "string",
                                "description": "adresse nom remise opération"
                            },
                            "op_adrNomVoie": {
                                "type": "string",
                                "description": "adresse nom voie opération"
                            },
                            "op_adrComplement": {
                                "type": "string",
                                "description": "adresse complement opération"
                            },
                            "op_adrCP": {
                                "type": "string",
                                "description": "adresse code postal opération"
                            },
                            "op_adrLocalite": {
                                "type": "string",
                                "description": "adresse localité opération"
                            },
                            "op_adrPays": {
                                "type": "string",
                                "description": "adresse pays opération"
                            },
                            "marche_lib": {
                                "type": "string",
                                "description": "Libellé du marché"
                            },
                            "marche_code": {
                                "type": "string",
                                "description": "Code du marché"
                            },
                            "marche_numero": {
                                "type": "string",
                                "description": "Numéro du marché"
                            },
                            "marche_numLot": {
                                "type": "string",
                                "description": "Numéro de lot du marché"
                            },
                            "marche_typeLot": {
                                "type": "string",
                                "description": "Type de lot du marché"
                            },
                            "marche_mntInitHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial HT du marché"
                            },
                            "marche_mntInitTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TVA du marché"
                            },
                            "marche_mntInitTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TTC du marché"
                            },
                            "marche_dateSig": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du marché"
                            },
                            "marche_dateNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification du marché"
                            },
                            "marche_dateOS": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réelle d'OS1 du marché"
                            },
                            "situ_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de la situation"
                            },
                            "situ_lib": {
                                "type": "string",
                                "description": "Libellé de la situation"
                            },
                            "situ_code": {
                                "type": "string",
                                "description": "Code de la situation"
                            },
                            "situ_compteur": {
                                "type": "string",
                                "description": "Compteur de la situation"
                            },
                            "situ_mntTotalHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total HT de la situation"
                            },
                            "situ_mntTotalTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TTC de la situation"
                            },
                            "situ_mntTotalTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TVA de la situation"
                            },
                            "bdc_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date du bon de commande"
                            },
                            "bdc_lib": {
                                "type": "string",
                                "description": "Libellé du bon de commande"
                            },
                            "bdc_numero": {
                                "type": "string",
                                "description": "Numéro du bon de commande"
                            },
                            "bdc_code": {
                                "type": "string",
                                "description": "Code du bon de commande"
                            },
                            "bdc_mntTotalHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total HT bon de commande"
                            },
                            "bdc_mntTotalTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TTC bon de commande"
                            },
                            "bdc_mntTotalTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TVA bon de commande"
                            },
                            "fac_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de la facture"
                            },
                            "fac_lib": {
                                "type": "string",
                                "description": "Libellé de la facture"
                            },
                            "fac_compteur": {
                                "type": "string",
                                "description": "Compteur de la facture"
                            },
                            "fac_ref": {
                                "type": "string",
                                "description": "Référence de la facture"
                            },
                            "fac_code": {
                                "type": "string",
                                "description": "Code de la facture"
                            },
                            "fac_mntTotalHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total HT de la facture"
                            },
                            "fac_mntTotalTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TTC de la facture"
                            },
                            "fac_mntTotalTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant Total TVA de la facture"
                            }
                        }
                    }
                }
            }
        }
    },
    "DossierClient": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Resa Courrier Et Contrat",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code"
                            },
                            "tranche_libelle": {
                                "type": "string",
                                "description": "Libellé tranche commerciale de l’opération"
                            },
                            "num_recommande": {
                                "type": "string",
                                "description": "numRecommande du dossier"
                            },
                            "contrat_date_envoie": {
                                "type": "string",
                                "format": "date",
                                "description": "dateEnvoiContrat du dossier"
                            },
                            "client_lib": {
                                "type": "string",
                                "description": "Nom du client"
                            },
                            "destinataire_courrier": {
                                "type": "string",
                                "description": "destinataire du courrier"
                            },
                            "acquereur_nom": {
                                "type": "string",
                                "description": "nomFamille de l'acquéreur"
                            },
                            "acquereur_prenom": {
                                "type": "string",
                                "description": "prénom de l'acquéreur"
                            },
                            "acquereur_civ": {
                                "type": "string",
                                "description": "Civilité de l'acquéreur",
                                "codif": "Civilite"
                            },
                            "acquereur_adr1": {
                                "type": "string",
                                "description": "adrPointRemise de l'acquéreur"
                            },
                            "acquereur_adr2": {
                                "type": "string",
                                "description": "adrNomVoie de l'acquéreur"
                            },
                            "acquereur_adrComplement": {
                                "type": "string",
                                "description": "adrComplement de l'acquéreur"
                            },
                            "acquereur_adrPointDistrib": {
                                "type": "string",
                                "description": "adrPointDistrib de l'acquéreur"
                            },
                            "acquereur_cp": {
                                "type": "string",
                                "description": "code postal de l'acquéreur"
                            },
                            "acquereur_localite": {
                                "type": "string",
                                "description": "ville de l'acquéreur"
                            },
                            "acquereur_pays": {
                                "type": "string",
                                "description": "adrPays de l'acquéreur"
                            },
                            "num_principaux": {
                                "type": "string",
                                "description": "numéros des lots principaux"
                            },
                            "num_secondaires": {
                                "type": "string",
                                "description": "numéros des lots secondaires"
                            },
                            "numCopro_principaux": {
                                "type": "string",
                                "description": "liste des numéros de copro des lots principaux séparés par des virgules"
                            },
                            "numCopro_secondaires": {
                                "type": "string",
                                "description": "liste des numéros de copro des lots secondaires séparés par des virgules"
                            },
                            "mnt_vente_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "somme de prix de vente HT des lots de la réservation"
                            },
                            "mnt_vente_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "somme de prix de vente TTC des lots de la réservation"
                            },
                            "mnt_vente_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "montant TVA de la vente"
                            },
                            "mnt_tmaHorsActe_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total HT des TMA signés hors acte"
                            },
                            "mnt_tmaHorsActe_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TVA des TMA signés hors acte"
                            },
                            "mnt_tmaHorsActe_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TTC des TMA signés hors acte"
                            },
                            "mnt_dossierTmaInclu_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "montant du dossier client TTC avec tous les TMA"
                            },
                            "mnt_dossierTmaInclu_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "montant du dossier client HT avec tous les TMA"
                            },
                            "mnt_dossierTmaInclu_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "montant du dossier client TVA avec tous les TMA"
                            },
                            "cumul_appel_portageTva": {
                                "type": "number",
                                "format": "money",
                                "description": "montant portage TVA appelé du dossier en cumul"
                            },
                            "acte_vente_num": {
                                "type": "string",
                                "description": "numéro de l'acte de vente"
                            },
                            "date_vente": {
                                "type": "string",
                                "format": "date",
                                "description": "date de la vente du dossier"
                            },
                            "solde_appel": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TTC  des appels passés du dossier"
                            },
                            "solde_appelHT": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants HT des appels passés du dossier"
                            },
                            "solde_appelTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TVA des appels passés du dossier"
                            },
                            "solde_encaisse": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des encaissements des appels passés du dossier"
                            },
                            "solde_client": {
                                "type": "number",
                                "format": "money",
                                "description": "solde dû hors portage TVA"
                            },
                            "solde_dossier": {
                                "type": "number",
                                "format": "money",
                                "description": "solde dossier client (inclus portage TVA)"
                            },
                            "solde_tropPercu": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde Trop perçu"
                            },
                            "date_reservation": {
                                "type": "string",
                                "format": "date",
                                "description": "dateReservation du dossier"
                            },
                            "date_livraison": {
                                "type": "string",
                                "format": "date",
                                "description": "dateLivraison du dossier"
                            },
                            "date_livraison_long": {
                                "type": "string",
                                "description": "date longue de livraison du dossier",
                                "format": "date-long"
                            },
                            "heure_livraison": {
                                "type": "string",
                                "format": "time",
                                "description": "heureLivraison du dossier"
                            },
                            "lot_shab": {
                                "type": "number",
                                "format": "money",
                                "description": "Shab lot"
                            },
                            "psla_dateEntree": {
                                "type": "string",
                                "format": "date",
                                "description": "date entrée location"
                            },
                            "psla_partLoc": {
                                "type": "number",
                                "format": "money",
                                "description": "part locative mensuelle"
                            },
                            "psla_partAcq": {
                                "type": "number",
                                "format": "money",
                                "description": "part acquisitive mensuelle"
                            },
                            "psla_redevance": {
                                "type": "number",
                                "format": "money",
                                "description": "redevance mensuelle"
                            },
                            "origineContactClient": {
                                "type": "string",
                                "description": "origine contact client",
                                "codif": "OrigContactCli"
                            },
                            "qualiteClient": {
                                "type": "string",
                                "description": "qualité client",
                                "codif": "QualiteCli"
                            },
                            "perso_doss_flag1": {
                                "type": "boolean",
                                "description": "Valeur dossier flag1"
                            },
                            "perso_doss_flag2": {
                                "type": "boolean",
                                "description": "Valeur dossier flag2"
                            },
                            "perso_doss_flag3": {
                                "type": "boolean",
                                "description": "Valeur dossier flag3"
                            },
                            "perso_doss_flag4": {
                                "type": "boolean",
                                "description": "Valeur dossier flag4"
                            },
                            "perso_doss_flag5": {
                                "type": "boolean",
                                "description": "Valeur dossier flag5"
                            },
                            "perso_doss_flag6": {
                                "type": "boolean",
                                "description": "Valeur dossier flag6",
                                "version": "18.0"
                            },
                            "perso_doss_flag7": {
                                "type": "boolean",
                                "description": "Valeur dossier flag7",
                                "version": "18.0"
                            },
                            "perso_doss_flag8": {
                                "type": "boolean",
                                "description": "Valeur dossier flag8",
                                "version": "18.0"
                            },
                            "perso_doss_flag9": {
                                "type": "boolean",
                                "description": "Valeur dossier flag9",
                                "version": "18.0"
                            },
                            "perso_doss_flag10": {
                                "type": "boolean",
                                "description": "Valeur dossier flag10",
                                "version": "18.0"
                            },
                            "perso_doss_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date1"
                            },
                            "perso_doss_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date2"
                            },
                            "perso_doss_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date3"
                            },
                            "perso_doss_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date4"
                            },
                            "perso_doss_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date5"
                            },
                            "perso_doss_date6": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date6"
                            },
                            "perso_doss_date7": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date7",
                                "version": "18.0"
                            },
                            "perso_doss_date8": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date8",
                                "version": "18.0"
                            },
                            "perso_doss_date9": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date9",
                                "version": "18.0"
                            },
                            "perso_doss_date10": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur dossier date10",
                                "version": "18.0"
                            },
                            "perso_doss_texte1": {
                                "type": "string",
                                "description": "Valeur dossier texte1"
                            },
                            "perso_doss_texte2": {
                                "type": "string",
                                "description": "Valeur dossier texte2"
                            },
                            "perso_doss_texte3": {
                                "type": "string",
                                "description": "Valeur dossier texte3"
                            },
                            "perso_doss_texte4": {
                                "type": "string",
                                "description": "Valeur dossier texte4"
                            },
                            "perso_doss_texte5": {
                                "type": "string",
                                "description": "Valeur dossier texte5"
                            },
                            "perso_doss_texte6": {
                                "type": "string",
                                "description": "Valeur dossier texte6",
                                "version": "18.0"
                            },
                            "perso_doss_texte7": {
                                "type": "string",
                                "description": "Valeur dossier texte7",
                                "version": "18.0"
                            },
                            "perso_doss_texte8": {
                                "type": "string",
                                "description": "Valeur dossier texte8",
                                "version": "18.0"
                            },
                            "perso_doss_texte9": {
                                "type": "string",
                                "description": "Valeur dossier texte9",
                                "version": "18.0"
                            },
                            "perso_doss_texte10": {
                                "type": "string",
                                "description": "Valeur dossier texte10",
                                "version": "18.0"
                            },
                            "perso_doss_codif1": {
                                "type": "string",
                                "description": "Valeur dossier codif1",
                                "codif": "RVDossier_codif1"
                            },
                            "perso_doss_codif2": {
                                "type": "string",
                                "description": "Valeur dossier codif2",
                                "codif": "RVDossier_codif2"
                            },
                            "perso_doss_codif3": {
                                "type": "string",
                                "description": "Valeur dossier codif3",
                                "codif": "RVDossier_codif3"
                            },
                            "perso_doss_codif4": {
                                "type": "string",
                                "description": "Valeur dossier codif4",
                                "codif": "RVDossier_codif4"
                            },
                            "perso_doss_codif5": {
                                "type": "string",
                                "description": "Valeur dossier codif5",
                                "codif": "RVDossier_codif5"
                            },
                            "perso_doss_codif6": {
                                "type": "string",
                                "description": "Valeur dossier codif6",
                                "codif": "RVDossier_codif6",
                                "version": "18.0"
                            },
                            "perso_doss_codif7": {
                                "type": "string",
                                "description": "Valeur dossier codif7",
                                "codif": "RVDossier_codif7",
                                "version": "18.0"
                            },
                            "perso_doss_codif8": {
                                "type": "string",
                                "description": "Valeur dossier codif8",
                                "codif": "RVDossier_codif8",
                                "version": "18.0"
                            },
                            "perso_doss_codif9": {
                                "type": "string",
                                "description": "Valeur dossier codif9",
                                "codif": "RVDossier_codif9",
                                "version": "18.0"
                            },
                            "perso_doss_codif10": {
                                "type": "string",
                                "description": "Valeur dossier codif10",
                                "codif": "RVDossier_codif10",
                                "version": "18.0"
                            },
                            "perso_psla_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date1"
                            },
                            "perso_psla_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date2"
                            },
                            "perso_psla_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date3"
                            },
                            "perso_psla_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date4"
                            },
                            "perso_psla_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date5"
                            },
                            "perso_psla_date6": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date6"
                            },
                            "lots": {
                                "type": "array",
                                "description": "Liste des lots du dossier",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "numero": {
                                            "type": "string",
                                            "description": "numéro de lot"
                                        },
                                        "type": {
                                            "type": "string",
                                            "description": "type de lot",
                                            "codif": "TYPELOT"
                                        },
                                        "num_copro": {
                                            "type": "string",
                                            "description": "numéro de copro du lot"
                                        },
                                        "lot_shab": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Shab lot"
                                        },
                                        "perso_lot_flag1": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag1"
                                        },
                                        "perso_lot_flag2": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag2"
                                        },
                                        "perso_lot_flag3": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag3"
                                        },
                                        "perso_lot_flag4": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag4"
                                        },
                                        "perso_lot_flag5": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag5"
                                        },
                                        "perso_lot_flag6": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag6",
                                            "version": "18.0"
                                        },
                                        "perso_lot_flag7": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag7",
                                            "version": "18.0"
                                        },
                                        "perso_lot_flag8": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag8",
                                            "version": "18.0"
                                        },
                                        "perso_lot_flag9": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag9",
                                            "version": "18.0"
                                        },
                                        "perso_lot_flag10": {
                                            "type": "boolean",
                                            "description": "Valeur lot flag10",
                                            "version": "18.0"
                                        },
                                        "perso_lot_date1": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date1"
                                        },
                                        "perso_lot_date2": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date2"
                                        },
                                        "perso_lot_date3": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date3"
                                        },
                                        "perso_lot_date4": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date4"
                                        },
                                        "perso_lot_date5": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date5"
                                        },
                                        "perso_lot_date6": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date6"
                                        },
                                        "perso_lot_date7": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date7"
                                        },
                                        "perso_lot_date8": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date 8"
                                        },
                                        "perso_lot_date9": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date 9"
                                        },
                                        "perso_lot_date10": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur lot date 10"
                                        },
                                        "perso_lot_montant1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant1"
                                        },
                                        "perso_lot_montant2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 2"
                                        },
                                        "perso_lot_montant3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 3"
                                        },
                                        "perso_lot_montant4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 4"
                                        },
                                        "perso_lot_montant5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 5"
                                        },
                                        "perso_lot_montant6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 6"
                                        },
                                        "perso_lot_montant7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 7"
                                        },
                                        "perso_lot_montant8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 8"
                                        },
                                        "perso_lot_montant9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 9"
                                        },
                                        "perso_lot_montant10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot montant 10"
                                        },
                                        "perso_lot_surface1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface1"
                                        },
                                        "perso_lot_surface2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 2"
                                        },
                                        "perso_lot_surface3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 3"
                                        },
                                        "perso_lot_surface4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 4"
                                        },
                                        "perso_lot_surface5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 5"
                                        },
                                        "perso_lot_surface6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 6"
                                        },
                                        "perso_lot_surface7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 7"
                                        },
                                        "perso_lot_surface8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 8"
                                        },
                                        "perso_lot_surface9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 9"
                                        },
                                        "perso_lot_surface10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surface 10"
                                        },
                                        "perso_lot_surfAnnexe1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe1"
                                        },
                                        "perso_lot_surfAnnexe2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 2"
                                        },
                                        "perso_lot_surfAnnexe3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 3"
                                        },
                                        "perso_lot_surfAnnexe4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 4"
                                        },
                                        "perso_lot_surfAnnexe5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 5"
                                        },
                                        "perso_lot_surfAnnexe6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 6"
                                        },
                                        "perso_lot_surfAnnexe7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 7"
                                        },
                                        "perso_lot_surfAnnexe8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 8"
                                        },
                                        "perso_lot_surfAnnexe9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 9"
                                        },
                                        "perso_lot_surfAnnexe10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur lot surfAnnexe 10"
                                        },
                                        "perso_lot_texte1": {
                                            "type": "string",
                                            "description": "Valeur lot texte1"
                                        },
                                        "perso_lot_texte2": {
                                            "type": "string",
                                            "description": "Valeur lot texte2"
                                        },
                                        "perso_lot_texte3": {
                                            "type": "string",
                                            "description": "Valeur lot texte3"
                                        },
                                        "perso_lot_texte4": {
                                            "type": "string",
                                            "description": "Valeur lot texte4"
                                        },
                                        "perso_lot_texte5": {
                                            "type": "string",
                                            "description": "Valeur lot texte5"
                                        },
                                        "perso_lot_texte6": {
                                            "type": "string",
                                            "description": "Valeur lot texte6",
                                            "version": "18.0"
                                        },
                                        "perso_lot_texte7": {
                                            "type": "string",
                                            "description": "Valeur lot texte7",
                                            "version": "18.0"
                                        },
                                        "perso_lot_texte8": {
                                            "type": "string",
                                            "description": "Valeur lot texte8",
                                            "version": "18.0"
                                        },
                                        "perso_lot_texte9": {
                                            "type": "string",
                                            "description": "Valeur lot texte9",
                                            "version": "18.0"
                                        },
                                        "perso_lot_texte10": {
                                            "type": "string",
                                            "description": "Valeur lot texte10",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif1": {
                                            "type": "string",
                                            "description": "Valeur lot codif1",
                                            "codif": "RVLotImmo_codif1"
                                        },
                                        "perso_lot_codif2": {
                                            "type": "string",
                                            "description": "Valeur lot codif2",
                                            "codif": "RVLotImmo_codif2"
                                        },
                                        "perso_lot_codif3": {
                                            "type": "string",
                                            "description": "Valeur lot codif3",
                                            "codif": "RVLotImmo_codif3"
                                        },
                                        "perso_lot_codif4": {
                                            "type": "string",
                                            "description": "Valeur lot codif4",
                                            "codif": "RVLotImmo_codif4"
                                        },
                                        "perso_lot_codif5": {
                                            "type": "string",
                                            "description": "Valeur lot codif5",
                                            "codif": "RVLotImmo_codif5"
                                        },
                                        "perso_lot_codif6": {
                                            "type": "string",
                                            "description": "Valeur lot codif6",
                                            "codif": "RVLotImmo_codif6",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif7": {
                                            "type": "string",
                                            "description": "Valeur lot codif7",
                                            "codif": "RVLotImmo_codif7",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif8": {
                                            "type": "string",
                                            "description": "Valeur lot codif8",
                                            "codif": "RVLotImmo_codif8",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif9": {
                                            "type": "string",
                                            "description": "Valeur lot codif9",
                                            "codif": "RVLotImmo_codif9",
                                            "version": "18.0"
                                        },
                                        "perso_lot_codif10": {
                                            "type": "string",
                                            "description": "Valeur lot codif10",
                                            "codif": "RVLotImmo_codif10",
                                            "version": "18.0"
                                        }
                                    }
                                }
                            },
                            "echeances": {
                                "type": "array",
                                "description": "échéances du dossier",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ech_evt": {
                                            "type": "string",
                                            "description": "Evènement de l'échéance"
                                        },
                                        "ech_lib": {
                                            "type": "string",
                                            "description": "Le libellé de chaque échéance"
                                        },
                                        "ech_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Le pourcentage de l'échéance"
                                        },
                                        "ech_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant HT de l'échéance"
                                        },
                                        "ech_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant TTC de l'échéance"
                                        },
                                        "ech_statut": {
                                            "type": "string",
                                            "description": "Prévue / réalisée"
                                        },
                                        "ech_datePrev": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date prévue de l'écheance"
                                        }
                                    }
                                }
                            },
                            "vendeurs": {
                                "type": "array",
                                "description": "Liste des vendeurs",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "vendeur_nom": {
                                            "type": "string",
                                            "description": "Nom du vendeur"
                                        },
                                        "vendeur_repres": {
                                            "type": "string",
                                            "description": "Représentant"
                                        }
                                    }
                                }
                            },
                            "echeances_tma": {
                                "type": "array",
                                "description": "échéances tma du dossier",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tma_evt": {
                                            "type": "string",
                                            "description": "Evènement de l'échéance",
                                            "enumId": "RVDossierTmaEcheance.codeEvent"
                                        },
                                        "tma_lib": {
                                            "type": "string",
                                            "description": "Le libellé de chaque échéance"
                                        },
                                        "tma_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Le pourcentage de l'échéance"
                                        },
                                        "tma_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant HT de l'échéance"
                                        },
                                        "tma_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant TTC de l'échéance"
                                        },
                                        "tma_tauxTVA": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de l'échéance"
                                        },
                                        "tma_statut": {
                                            "type": "string",
                                            "description": "Prévue / réalisée",
                                            "enumId": "RVDossierTmaEcheance.statut"
                                        },
                                        "tma_dateEch": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date prévue de l'écheance"
                                        }
                                    }
                                }
                            },
                            "dgs": {
                                "type": "array",
                                "description": "dépots garantie",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "dg_evt": {
                                            "type": "string",
                                            "description": "évènement",
                                            "enumId": "RVDossierDepotGarantie.codeEvt"
                                        },
                                        "dg_modePaiement": {
                                            "type": "string",
                                            "description": "mode de paiement",
                                            "enumId": "RVDossierDepotGarantie.modePaiement"
                                        },
                                        "dg_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Le montant du dg"
                                        },
                                        "dg_dateRemise": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date remise"
                                        },
                                        "dg_banque": {
                                            "type": "string",
                                            "description": "Banque émettrice"
                                        },
                                        "dg_tiersLib": {
                                            "type": "string",
                                            "description": "Libellé tiers émetteur"
                                        },
                                        "dg_compteLib": {
                                            "type": "string",
                                            "description": "Libellé compte bancaire"
                                        },
                                        "dg_iban": {
                                            "type": "string",
                                            "description": "IBAN"
                                        },
                                        "dg_comm": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        }
                                    }
                                }
                            },
                            "suivi_compte": {
                                "type": "array",
                                "description": "suivi de compte",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "sc_lib": {
                                            "type": "string",
                                            "description": "libellé appel ou encaissement"
                                        },
                                        "sc_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date de l'appel ou encaissement"
                                        },
                                        "sc_mnt_appel": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant appelé"
                                        },
                                        "sc_mnt_encaisse": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant encaissé"
                                        }
                                    }
                                }
                            },
                            "clients": {
                                "type": "array",
                                "description": "acquéreurs",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "cli_civilite": {
                                            "type": "string",
                                            "description": "civilité",
                                            "codif": "Civilite"
                                        },
                                        "cli_libelle": {
                                            "type": "string",
                                            "description": "nom + prenom ou raison sociale"
                                        },
                                        "cli_quotite": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "quotité"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "DossierFoncier": {
        "schemas": {
            "type": "object",
            "properties": {
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Dossier foncier",
                    "items": {
                        "type": "object",
                        "properties": {
                            "foncier_code": {
                                "type": "string",
                                "description": "Code foncier"
                            },
                            "foncier_lib": {
                                "type": "string",
                                "description": "Libellé foncier"
                            },
                            "foncier_responsable": {
                                "type": "string",
                                "description": "responsable foncier"
                            },
                            "foncier_uo": {
                                "type": "string",
                                "description": "unite d'organisation"
                            },
                            "foncier_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé foncier"
                            },
                            "foncier_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie foncier"
                            },
                            "foncier_adr_complement": {
                                "type": "string",
                                "description": "adresse complement foncier"
                            },
                            "foncier_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal foncier"
                            },
                            "foncier_adr_localite": {
                                "type": "string",
                                "description": "adresse localité foncier"
                            },
                            "foncier_adr_pays": {
                                "type": "string",
                                "description": "adresse pays foncier"
                            },
                            "foncier_statut": {
                                "type": "string",
                                "description": "statut du foncier",
                                "enumId": "Foncier.statut"
                            },
                            "foncier_surfParcelles": {
                                "type": "integer",
                                "description": "surface totale des parcelles"
                            },
                            "foncier_SDP": {
                                "type": "integer",
                                "description": "surface totale de plancher"
                            },
                            "doss_statut": {
                                "type": "string",
                                "description": "statut du dossier propriétaire",
                                "enumId": "FonDossier.statut"
                            },
                            "doss_natPromesse": {
                                "type": "string",
                                "description": "nature promesse",
                                "codif": "FonNatOffre"
                            },
                            "doss_dtOffre": {
                                "type": "string",
                                "format": "date",
                                "description": "date offre envoyée"
                            },
                            "doss_dtOffreSjgn": {
                                "type": "string",
                                "format": "date",
                                "description": "date offre contesignée"
                            },
                            "doss_dtEnregist": {
                                "type": "string",
                                "format": "date",
                                "description": "date enregistrement"
                            },
                            "doss_dtLeveeOption": {
                                "type": "string",
                                "format": "date",
                                "description": "date levée d'option"
                            },
                            "doss_dtEchActe": {
                                "type": "string",
                                "format": "date",
                                "description": "date échéance signature acte"
                            },
                            "doss_dtActe": {
                                "type": "string",
                                "format": "date",
                                "description": "date signature acte"
                            },
                            "doss_tauxTva": {
                                "type": "number",
                                "format": "rate",
                                "description": "taux tva"
                            },
                            "doss_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "montant HT"
                            },
                            "doss_mntTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "montant TVA"
                            },
                            "doss_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "montant TTC"
                            },
                            "doss_mntDation": {
                                "type": "number",
                                "format": "money",
                                "description": "montant dation TTC"
                            },
                            "doss_soulte": {
                                "type": "number",
                                "format": "money",
                                "description": "montant soulte TTC"
                            },
                            "foncier_texte1": {
                                "type": "string",
                                "description": "Valeur foncier texte1"
                            },
                            "foncier_texte2": {
                                "type": "string",
                                "description": "Valeur foncier texte2"
                            },
                            "foncier_texte3": {
                                "type": "string",
                                "description": "Valeur foncier texte3"
                            },
                            "foncier_texte4": {
                                "type": "string",
                                "description": "Valeur foncier texte4"
                            },
                            "foncier_texte5": {
                                "type": "string",
                                "description": "Valeur foncier texte5"
                            },
                            "foncier_codif1": {
                                "type": "string",
                                "description": "Valeur foncier codif1",
                                "codif": "Foncier_codif1"
                            },
                            "foncier_codif2": {
                                "type": "string",
                                "description": "Valeur foncier codif2",
                                "codif": "Foncier_codif2"
                            },
                            "foncier_codif3": {
                                "type": "string",
                                "description": "Valeur foncier codif3",
                                "codif": "Foncier_codif3"
                            },
                            "foncier_codif4": {
                                "type": "string",
                                "description": "Valeur foncier codif4",
                                "codif": "Foncier_codif4"
                            },
                            "foncier_codif5": {
                                "type": "string",
                                "description": "Valeur foncier codif5",
                                "codif": "Foncier_codif5"
                            },
                            "foncier_flag1": {
                                "type": "boolean",
                                "description": "Valeur foncier flag1"
                            },
                            "foncier_flag2": {
                                "type": "boolean",
                                "description": "Valeur foncier flag2"
                            },
                            "foncier_flag3": {
                                "type": "boolean",
                                "description": "Valeur foncier flag3"
                            },
                            "foncier_flag4": {
                                "type": "boolean",
                                "description": "Valeur foncier flag4"
                            },
                            "foncier_flag5": {
                                "type": "boolean",
                                "description": "Valeur foncier flag5"
                            },
                            "foncier_flag6": {
                                "type": "boolean",
                                "description": "Valeur foncier flag6"
                            },
                            "foncier_flag7": {
                                "type": "boolean",
                                "description": "Valeur foncier flag7"
                            },
                            "foncier_flag8": {
                                "type": "boolean",
                                "description": "Valeur foncier flag8"
                            },
                            "foncier_flag9": {
                                "type": "boolean",
                                "description": "Valeur foncier flag9"
                            },
                            "foncier_flag10": {
                                "type": "boolean",
                                "description": "Valeur foncier flag10"
                            },
                            "foncier_flag11": {
                                "type": "boolean",
                                "description": "Valeur foncier flag11"
                            },
                            "foncier_flag12": {
                                "type": "boolean",
                                "description": "Valeur foncier flag12"
                            },
                            "foncier_flag13": {
                                "type": "boolean",
                                "description": "Valeur foncier flag13"
                            },
                            "foncier_flag14": {
                                "type": "boolean",
                                "description": "Valeur foncier flag14"
                            },
                            "foncier_flag15": {
                                "type": "boolean",
                                "description": "Valeur foncier flag15"
                            },
                            "foncier_flag16": {
                                "type": "boolean",
                                "description": "Valeur foncier flag16"
                            },
                            "foncier_flag17": {
                                "type": "boolean",
                                "description": "Valeur foncier flag17"
                            },
                            "foncier_flag18": {
                                "type": "boolean",
                                "description": "Valeur foncier flag18"
                            },
                            "foncier_flag19": {
                                "type": "boolean",
                                "description": "Valeur foncier flag19"
                            },
                            "foncier_flag20": {
                                "type": "boolean",
                                "description": "Valeur foncier flag20"
                            },
                            "foncier_flag21": {
                                "type": "boolean",
                                "description": "Valeur foncier flag21"
                            },
                            "foncier_flag22": {
                                "type": "boolean",
                                "description": "Valeur foncier flag22"
                            },
                            "foncier_flag23": {
                                "type": "boolean",
                                "description": "Valeur foncier flag23"
                            },
                            "foncier_flag24": {
                                "type": "boolean",
                                "description": "Valeur foncier flag24"
                            },
                            "foncier_flag25": {
                                "type": "boolean",
                                "description": "Valeur foncier flag25"
                            },
                            "doss_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire montant1"
                            },
                            "doss_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire montant2"
                            },
                            "doss_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire montant3"
                            },
                            "doss_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire montant4"
                            },
                            "doss_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire montant5"
                            },
                            "doss_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire decimal1"
                            },
                            "doss_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire decimal2"
                            },
                            "doss_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire decimal3"
                            },
                            "doss_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire decimal4"
                            },
                            "doss_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur proprietaire decimal5"
                            },
                            "doss_entier1": {
                                "type": "number",
                                "description": "Valeur proprietaire entier1"
                            },
                            "doss_entier2": {
                                "type": "number",
                                "description": "Valeur proprietaire entier2"
                            },
                            "doss_entier3": {
                                "type": "number",
                                "description": "Valeur proprietaire entier3"
                            },
                            "doss_entier4": {
                                "type": "number",
                                "description": "Valeur proprietaire entier4"
                            },
                            "doss_entier5": {
                                "type": "number",
                                "description": "Valeur proprietaire entier5"
                            },
                            "doss_flag1": {
                                "type": "boolean",
                                "description": "Valeur proprietaire flag1"
                            },
                            "doss_flag2": {
                                "type": "boolean",
                                "description": "Valeur proprietaire flag2"
                            },
                            "doss_flag3": {
                                "type": "boolean",
                                "description": "Valeur proprietaire flag3"
                            },
                            "doss_flag4": {
                                "type": "boolean",
                                "description": "Valeur proprietaire flag4"
                            },
                            "doss_flag5": {
                                "type": "boolean",
                                "description": "Valeur proprietaire flag5"
                            },
                            "doss_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur proprietaire date1"
                            },
                            "doss_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur proprietaire date2"
                            },
                            "doss_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur proprietaire date3"
                            },
                            "doss_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur proprietaire date4"
                            },
                            "doss_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur proprietaire date5"
                            },
                            "doss_texte1": {
                                "type": "string",
                                "description": "Valeur proprietaire texte1"
                            },
                            "doss_texte2": {
                                "type": "string",
                                "description": "Valeur proprietaire texte2"
                            },
                            "doss_texte3": {
                                "type": "string",
                                "description": "Valeur proprietaire texte3"
                            },
                            "doss_texte4": {
                                "type": "string",
                                "description": "Valeur proprietaire texte4"
                            },
                            "doss_texte5": {
                                "type": "string",
                                "description": "Valeur proprietaire texte5"
                            },
                            "doss_codif1": {
                                "type": "string",
                                "description": "Valeur proprietaire codif1",
                                "codif": "FonDossier_codif1"
                            },
                            "doss_codif2": {
                                "type": "string",
                                "description": "Valeur proprietaire codif2",
                                "codif": "FonDossier_codif2"
                            },
                            "doss_codif3": {
                                "type": "string",
                                "description": "Valeur proprietaire codif3",
                                "codif": "FonDossier_codif3"
                            },
                            "doss_codif4": {
                                "type": "string",
                                "description": "Valeur proprietaire codif4",
                                "codif": "FonDossier_codif4"
                            },
                            "doss_codif5": {
                                "type": "string",
                                "description": "Valeur proprietaire codif5",
                                "codif": "FonDossier_codif5"
                            },
                            "parcelles": {
                                "type": "array",
                                "description": "",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "parc_code": {
                                            "type": "string",
                                            "description": "code parcelle"
                                        },
                                        "parc_lib": {
                                            "type": "string",
                                            "description": "libellé parcelle"
                                        },
                                        "parc_adr_remise": {
                                            "type": "string",
                                            "description": "adresse nom remisé parcelle"
                                        },
                                        "parc_adr_voie": {
                                            "type": "string",
                                            "description": "adresse nom voie parcelle"
                                        },
                                        "parc_adr_complement": {
                                            "type": "string",
                                            "description": "adresse complement parcelle"
                                        },
                                        "parc_adr_cp": {
                                            "type": "string",
                                            "description": "adresse code postal parcelle"
                                        },
                                        "parc_adr_localite": {
                                            "type": "string",
                                            "description": "adresse localité parcelle"
                                        },
                                        "parc_adr_pays": {
                                            "type": "string",
                                            "description": "adresse pays parcelle"
                                        },
                                        "parc_num": {
                                            "type": "string",
                                            "description": "numéro"
                                        },
                                        "parc_prefixe": {
                                            "type": "string",
                                            "description": "préfixe"
                                        },
                                        "parc_section": {
                                            "type": "string",
                                            "description": "section"
                                        },
                                        "parc_zonage": {
                                            "type": "string",
                                            "description": "zonage"
                                        },
                                        "parc_surf": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "surface"
                                        },
                                        "parc_surfDemol": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "surface à démolir"
                                        },
                                        "parc_surfBati": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "surface bâtie"
                                        },
                                        "parc_hauteur": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "hauteur des constructions"
                                        },
                                        "parc_empSol": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "emprise au sol du bâti"
                                        },
                                        "parc_surface1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface1"
                                        },
                                        "parc_surface2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface2"
                                        },
                                        "parc_surface3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface3"
                                        },
                                        "parc_surface4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface4"
                                        },
                                        "parc_surface5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface5"
                                        },
                                        "parc_surface6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface6"
                                        },
                                        "parc_surface7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface7"
                                        },
                                        "parc_surface8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface8"
                                        },
                                        "parc_surface9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface9"
                                        },
                                        "parc_surface10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface10"
                                        },
                                        "parc_date1": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date1"
                                        },
                                        "parc_date2": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date2"
                                        },
                                        "parc_date3": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date3"
                                        },
                                        "parc_date4": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date4"
                                        },
                                        "parc_date5": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date5"
                                        },
                                        "parc_texte1": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte1"
                                        },
                                        "parc_texte2": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte2"
                                        },
                                        "parc_texte3": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte3"
                                        },
                                        "parc_texte4": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte4"
                                        },
                                        "parc_texte5": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte5"
                                        },
                                        "parc_codif1": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif1",
                                            "codif": "FonParcelle_codif1"
                                        },
                                        "parc_codif2": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif2",
                                            "codif": "FonParcelle_codif2"
                                        },
                                        "parc_codif3": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif3",
                                            "codif": "FonParcelle_codif3"
                                        },
                                        "parc_codif4": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif4",
                                            "codif": "FonParcelle_codif4"
                                        },
                                        "parc_codif5": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif5",
                                            "codif": "FonParcelle_codif5"
                                        }
                                    }
                                }
                            },
                            "proprietaires": {
                                "type": "array",
                                "description": "",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "prop_code": {
                                            "type": "string",
                                            "description": "code propriétaire"
                                        },
                                        "prop_nom": {
                                            "type": "string",
                                            "description": "Nom du propriétaire"
                                        },
                                        "prop_prenom": {
                                            "type": "string",
                                            "description": "Prénom du propriétaire"
                                        },
                                        "prop_civilite": {
                                            "type": "string",
                                            "description": "civilité du propriétaire",
                                            "codif": "Civilite"
                                        },
                                        "prop_lib": {
                                            "type": "string",
                                            "description": "civilité + prenom + nom du propriétaire ou raison sociale"
                                        },
                                        "prop_adr_remise": {
                                            "type": "string",
                                            "description": "adrPointRemise propriétaire"
                                        },
                                        "prop_adr_voie": {
                                            "type": "string",
                                            "description": "adrNomVoie propriétaire"
                                        },
                                        "prop_adr_complement": {
                                            "type": "string",
                                            "description": "adrComplement propriétaire"
                                        },
                                        "prop_adr_pointDistrib": {
                                            "type": "string",
                                            "description": "adrPointDistrib propriétaire"
                                        },
                                        "prop_adr_cp": {
                                            "type": "string",
                                            "description": "code postal propriétaire"
                                        },
                                        "prop_adr_localite": {
                                            "type": "string",
                                            "description": "ville propriétaire"
                                        },
                                        "prop_adr_pays": {
                                            "type": "string",
                                            "description": "pays propriétaire"
                                        },
                                        "prop_courriel": {
                                            "type": "string",
                                            "description": "courriel propriétaire1"
                                        },
                                        "prop_phone": {
                                            "type": "string",
                                            "description": "téléphone propriétaire1"
                                        },
                                        "prop_mobile": {
                                            "type": "string",
                                            "description": "portable propriétaire1"
                                        },
                                        "prop_siret": {
                                            "type": "string",
                                            "description": "siret propriétaire"
                                        },
                                        "prop_tvaIntraUE": {
                                            "type": "string",
                                            "description": "n° TVA intracom propriétaire"
                                        },
                                        "prop_ape": {
                                            "type": "string",
                                            "description": "code NAF/APE propriétaire"
                                        }
                                    }
                                }
                            },
                            "conditions": {
                                "type": "array",
                                "description": "",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "cond_type": {
                                            "type": "string",
                                            "description": "type condition",
                                            "codif": "FonCondition"
                                        },
                                        "cond_dtEch": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date échéance"
                                        },
                                        "cond_dtLevee": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date levée"
                                        }
                                    }
                                }
                            },
                            "paiements": {
                                "type": "array",
                                "description": "",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "paie_type": {
                                            "type": "string",
                                            "description": "type de paiement",
                                            "codif": "FonTypeEch"
                                        },
                                        "paie_lib": {
                                            "type": "string",
                                            "description": "libellé paiement"
                                        },
                                        "paie_dtEch": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date échéance paiement"
                                        },
                                        "paie_prct": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "pourcentage paiement"
                                        },
                                        "paie_montant": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant TTC paiement"
                                        },
                                        "paie_dtReal": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date réalisée paiement"
                                        }
                                    }
                                }
                            },
                            "indemnites": {
                                "type": "array",
                                "description": "",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ind_type": {
                                            "type": "string",
                                            "description": "type indemnité",
                                            "codif": "FonIndemnite"
                                        },
                                        "ind_lib": {
                                            "type": "string",
                                            "description": "libellé indemnité"
                                        },
                                        "ind_montant": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant TTC indemnité"
                                        },
                                        "ind_modeRegle": {
                                            "type": "string",
                                            "description": "mode règlement indemnité",
                                            "enumId": "FonDossIndem.modeReg"
                                        },
                                        "ind_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date reglement indemnité"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "FactFournisseur": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Facture Fournisseur",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code"
                            },
                            "tiers_lib": {
                                "type": "string",
                                "description": "Nom fournisseur"
                            },
                            "tiers_formeJuridique": {
                                "type": "string",
                                "description": "Forme juridique fournisseur"
                            },
                            "tiers_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "Capital social fournisseur"
                            },
                            "tiers_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du fournisseur"
                            },
                            "tiers_refCompta": {
                                "type": "string",
                                "description": "Référence comptable du fournisseur"
                            },
                            "tiers_code": {
                                "type": "string",
                                "description": "Code fournisseur"
                            },
                            "tiers_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du fournisseur"
                            },
                            "tiers_rep_civilite": {
                                "type": "string",
                                "description": "Civilité du Représentant principal fournisseur"
                            },
                            "tiers_rep_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal fournisseur"
                            },
                            "tiers_rep_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal fournisseur"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du représentant principal fournisseur"
                            },
                            "tiers_rep_mail": {
                                "type": "string",
                                "description": "Courriel du représentant principal fournisseur"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "TTéléphone du représentant principal fournisseurr"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "Adresse nom remisé fournisseur"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "Adresse nom voie fournisseur"
                            },
                            "tiers_adr_complement": {
                                "type": "string",
                                "description": "Adresse complement fournisseur"
                            },
                            "tiers_adr_codePostal": {
                                "type": "string",
                                "description": "Adresse code postal fournisseur"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "Adresse localité fournisseur"
                            },
                            "tiers_siret": {
                                "type": "string",
                                "description": "SIRET du fournisseur"
                            },
                            "tiers_ape": {
                                "type": "string",
                                "description": "APE du fournisseur"
                            },
                            "tiers_libRib": {
                                "type": "string",
                                "description": "Nom titulaire RIB fournisseur"
                            },
                            "tiers_iban": {
                                "type": "string",
                                "description": "Numero de compte RIB fournisseur"
                            },
                            "tiers_banque": {
                                "type": "string",
                                "description": "Banque du RIB fournisseur"
                            },
                            "tiers_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers montant1"
                            },
                            "tiers_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers montant2"
                            },
                            "tiers_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers montant3"
                            },
                            "tiers_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers montant4"
                            },
                            "tiers_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers montant5"
                            },
                            "tiers_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers decimal1"
                            },
                            "tiers_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers decimal2"
                            },
                            "tiers_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers decimal3"
                            },
                            "tiers_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers decimal4"
                            },
                            "tiers_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "tiers decimal5"
                            },
                            "tiers_entier1": {
                                "type": "integer",
                                "description": "tiers entier1"
                            },
                            "tiers_entier2": {
                                "type": "integer",
                                "description": "tiers entier2"
                            },
                            "tiers_entier3": {
                                "type": "integer",
                                "description": "tiers entier3"
                            },
                            "tiers_entier4": {
                                "type": "integer",
                                "description": "tiers entier4"
                            },
                            "tiers_entier5": {
                                "type": "integer",
                                "description": "tiers entier5"
                            },
                            "tiers_flag1": {
                                "type": "boolean",
                                "description": "tiers flag1"
                            },
                            "tiers_flag2": {
                                "type": "boolean",
                                "description": "tiers flag2"
                            },
                            "tiers_flag3": {
                                "type": "boolean",
                                "description": "tiers flag3"
                            },
                            "tiers_flag4": {
                                "type": "boolean",
                                "description": "tiers flag4"
                            },
                            "tiers_flag5": {
                                "type": "boolean",
                                "description": "tiers flag5"
                            },
                            "tiers_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "tiers date1"
                            },
                            "tiers_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "tiers date2"
                            },
                            "tiers_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "tiers date3"
                            },
                            "tiers_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "tiers date4"
                            },
                            "tiers_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "tiers date5"
                            },
                            "tiers_texte1": {
                                "type": "string",
                                "description": "tiers texte1"
                            },
                            "tiers_texte2": {
                                "type": "string",
                                "description": "tiers texte2"
                            },
                            "tiers_texte3": {
                                "type": "string",
                                "description": "tiers texte3"
                            },
                            "tiers_texte4": {
                                "type": "string",
                                "description": "tiers texte4"
                            },
                            "tiers_texte5": {
                                "type": "string",
                                "description": "tiers texte5"
                            },
                            "tiers_codif1": {
                                "type": "string",
                                "description": "tiers codif1"
                            },
                            "tiers_codif2": {
                                "type": "string",
                                "description": "tiers codif2"
                            },
                            "tiers_codif3": {
                                "type": "string",
                                "description": "tiers codif3"
                            },
                            "tiers_codif4": {
                                "type": "string",
                                "description": "tiers codif4"
                            },
                            "tiers_codif5": {
                                "type": "string",
                                "description": "tiers codif5"
                            },
                            "cmd_num": {
                                "type": "string",
                                "description": "N° du bon de commande"
                            },
                            "cmd_lib": {
                                "type": "string",
                                "description": "Libellé du bon de commande"
                            },
                            "cmd_code": {
                                "type": "string",
                                "description": "Code commande"
                            },
                            "cmd_totalHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Total HT commande"
                            },
                            "cmd_totalTva": {
                                "type": "number",
                                "format": "money",
                                "description": "Total TVA commande"
                            },
                            "cmd_totalTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Total TTC commande"
                            },
                            "cmd_resteFactHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Reste à facturer commande HT"
                            },
                            "fact_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de situation"
                            },
                            "fact_dtRecep": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de réception"
                            },
                            "fact_dtEch": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'échéance"
                            },
                            "fact_typeAffec": {
                                "type": "string",
                                "description": "Type d'affectation"
                            },
                            "fact_typePresta": {
                                "type": "string",
                                "description": "Type de prestation"
                            },
                            "fact_num": {
                                "type": "string",
                                "description": "N° de la facture"
                            },
                            "fact_idFactEl": {
                                "type": "string",
                                "description": "Id.Fact Electronique"
                            },
                            "fact_code": {
                                "type": "string",
                                "description": "Code situation"
                            },
                            "fact_compteur": {
                                "type": "string",
                                "description": "Compteur"
                            },
                            "fact_lib": {
                                "type": "string",
                                "description": "Libellé"
                            },
                            "fact_totalHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Total HT de la facture"
                            },
                            "fact_totalTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Total TTC de la facture"
                            },
                            "fact_totalTva": {
                                "type": "number",
                                "format": "money",
                                "description": "Total TVA de la facture"
                            },
                            "fact_mntPaye": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant payé TTC"
                            },
                            "fact_soldePayer": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde à payer"
                            },
                            "fact_dtPaie": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de dernier paiement"
                            },
                            "fact_delaiReg": {
                                "type": "integer",
                                "description": "Délai"
                            },
                            "fact_condReg": {
                                "type": "string",
                                "description": "Base"
                            },
                            "fact_exigible": {
                                "type": "integer",
                                "description": "Exigible"
                            },
                            "fact_modeReg": {
                                "type": "string",
                                "description": "Mode de paiement"
                            },
                            "fact_cmnt": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "fact_montant1": {
                                "type": "string",
                                "description": "facture montant1"
                            },
                            "fact_montant2": {
                                "type": "string",
                                "description": "facture montant2"
                            },
                            "fact_montant3": {
                                "type": "string",
                                "description": "facture montant3"
                            },
                            "fact_montant4": {
                                "type": "string",
                                "description": "facture montant4"
                            },
                            "fact_montant5": {
                                "type": "string",
                                "description": "facture montant5"
                            },
                            "fact_decimal1": {
                                "type": "string",
                                "description": "facture decimal1"
                            },
                            "fact_decimal2": {
                                "type": "string",
                                "description": "facture decimal2"
                            },
                            "fact_decimal3": {
                                "type": "string",
                                "description": "facture decimal3"
                            },
                            "fact_decimal4": {
                                "type": "string",
                                "description": "facture decimal4"
                            },
                            "fact_decimal5": {
                                "type": "string",
                                "description": "facture decimal5"
                            },
                            "fact_entier1": {
                                "type": "string",
                                "description": "facture entier1"
                            },
                            "fact_entier2": {
                                "type": "string",
                                "description": "facture entier2"
                            },
                            "fact_entier3": {
                                "type": "string",
                                "description": "facture entier3"
                            },
                            "fact_entier4": {
                                "type": "string",
                                "description": "facture entier4"
                            },
                            "fact_entier5": {
                                "type": "string",
                                "description": "facture entier5"
                            },
                            "fact_flag1": {
                                "type": "string",
                                "description": "facture flag1"
                            },
                            "fact_flag2": {
                                "type": "string",
                                "description": "facture flag2"
                            },
                            "fact_flag3": {
                                "type": "string",
                                "description": "facture flag3"
                            },
                            "fact_flag4": {
                                "type": "string",
                                "description": "facture flag4"
                            },
                            "fact_flag5": {
                                "type": "string",
                                "description": "facture flag5"
                            },
                            "fact_date1": {
                                "type": "string",
                                "description": "facture date1"
                            },
                            "fact_date2": {
                                "type": "string",
                                "description": "facture date2"
                            },
                            "fact_date3": {
                                "type": "string",
                                "description": "facture date3"
                            },
                            "fact_date4": {
                                "type": "string",
                                "description": "facture date4"
                            },
                            "fact_date5": {
                                "type": "string",
                                "description": "facture date5"
                            },
                            "fact_texte1": {
                                "type": "string",
                                "description": "facture texte1"
                            },
                            "fact_texte2": {
                                "type": "string",
                                "description": "facture texte2"
                            },
                            "fact_texte3": {
                                "type": "string",
                                "description": "facture texte3"
                            },
                            "fact_texte4": {
                                "type": "string",
                                "description": "facture texte4"
                            },
                            "fact_texte5": {
                                "type": "string",
                                "description": "facture texte5"
                            },
                            "fact_codif1": {
                                "type": "string",
                                "description": "facture codif1"
                            },
                            "fact_codif2": {
                                "type": "string",
                                "description": "facture codif2"
                            },
                            "fact_codif3": {
                                "type": "string",
                                "description": "facture codif3"
                            },
                            "fact_codif4": {
                                "type": "string",
                                "description": "facture codif4"
                            },
                            "fact_codif5": {
                                "type": "string",
                                "description": "facture codif5"
                            },
                            "montants": {
                                "type": "array",
                                "description": "Liste des montants facture",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "m_lib": {
                                            "type": "string",
                                            "description": "Libellé de la ligne"
                                        },
                                        "m_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "m_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "m_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        },
                                        "m_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        },
                                        "m_qte": {
                                            "type": "integer",
                                            "description": "Quantité"
                                        },
                                        "m_prixUnit": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix unitaire"
                                        },
                                        "m_mntCmdHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant Cmd. HT"
                                        },
                                        "m_resteFactHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Reste à facturer HT"
                                        }
                                    }
                                }
                            },
                            "facMntParTva": {
                                "type": "array",
                                "description": "Liste des montants de la facture par taux de TVA",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "facTva_lib": {
                                            "type": "string",
                                            "description": "Libellé du taux de TVA",
                                            "version": "18.2"
                                        },
                                        "facTva_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA",
                                            "version": "18.2"
                                        },
                                        "facTva_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT",
                                            "version": "18.2"
                                        },
                                        "facTva_mntTVA": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA",
                                            "version": "18.2"
                                        },
                                        "facTva_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC",
                                            "version": "18.2"
                                        }
                                    }
                                }
                            },
                            "affectations": {
                                "type": "array",
                                "description": "Liste affectation budgétaire",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "af_libPoste": {
                                            "type": "string",
                                            "description": "Poste budgétaire"
                                        },
                                        "af_codePoste": {
                                            "type": "string",
                                            "description": "Code poste budgétaire"
                                        },
                                        "af_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        },
                                        "af_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "af_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "af_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        }
                                    }
                                }
                            },
                            "cmdMontants": {
                                "type": "array",
                                "description": "Liste détails des montants du BDC avenant compris",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "cm_libEngage": {
                                            "type": "string",
                                            "description": "Libellé de l'engagement"
                                        },
                                        "cm_code": {
                                            "type": "string",
                                            "description": "Code ligne"
                                        },
                                        "cm_lib": {
                                            "type": "string",
                                            "description": "Libellé de la ligne"
                                        },
                                        "cm_qte": {
                                            "type": "integer",
                                            "description": "Quantité"
                                        },
                                        "cmp_prixUnit": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix unitaire"
                                        },
                                        "cm_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "cm_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        },
                                        "cm_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        },
                                        "cm_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        }
                                    }
                                }
                            },
                            "cmdMntParTva": {
                                "type": "array",
                                "description": "Liste des montants du bon de commande par taux de TVA",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "cmdTva_lib": {
                                            "type": "string",
                                            "description": "Libellé du taux de TVA",
                                            "version": "18.2"
                                        },
                                        "cmdTva_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA",
                                            "version": "18.2"
                                        },
                                        "cmdTva_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT",
                                            "version": "18.2"
                                        },
                                        "cmdTva_mntTVA": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA",
                                            "version": "18.2"
                                        },
                                        "cmdTva_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC",
                                            "version": "18.2"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "FactSituation": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Situation",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code situation"
                            },
                            "tiers_lib": {
                                "type": "string",
                                "description": "Nom titulaire"
                            },
                            "tiers_formeJuridique": {
                                "type": "string",
                                "description": "Forme juridique titulaire",
                                "codif": "FormeJuridique"
                            },
                            "tiers_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "Capital social titulaire"
                            },
                            "tiers_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers titulaire"
                            },
                            "tiers_refCompta": {
                                "type": "string",
                                "description": "Référence comptable du tiers titulaire"
                            },
                            "tiers_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers titulaire"
                            },
                            "tiers_rep_civilite": {
                                "type": "string",
                                "description": "Civilité du Représentant principal titulaire",
                                "codif": "Civilite"
                            },
                            "tiers_rep_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal titulaire"
                            },
                            "tiers_rep_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal titulaire"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du représentant principal titulaire"
                            },
                            "tiers_rep_mail": {
                                "type": "string",
                                "description": "Courriel du représentant principal titulaire"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du représentant principal titulaire"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "Adresse nom remisé titulaire"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "Adresse nom remisé titulaire"
                            },
                            "tiers_adr_complement": {
                                "type": "string",
                                "description": "Adresse complement titulaire"
                            },
                            "tiers_adr_codePostal": {
                                "type": "string",
                                "description": "Adresse code postal titulaire"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "Adresse localité titulaire"
                            },
                            "tiers_siret": {
                                "type": "string",
                                "description": "SIRET du tiers titulaire"
                            },
                            "tiers_ape": {
                                "type": "string",
                                "description": "APE du tiers titulaire"
                            },
                            "tiers_libRib": {
                                "type": "string",
                                "description": "Nom titulaire RIB"
                            },
                            "tiers_iban": {
                                "type": "string",
                                "description": "Numero de compte RIB titulaire"
                            },
                            "tiers_banque": {
                                "type": "string",
                                "description": "Banque titulaire du RIB"
                            },
                            "marche_lib": {
                                "type": "string",
                                "description": "Libellé du marché"
                            },
                            "marche_code": {
                                "type": "string",
                                "description": "Code du marché"
                            },
                            "marche_ref": {
                                "type": "string",
                                "description": "Numéro du marché"
                            },
                            "marche_mntInitialHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial HT du marché"
                            },
                            "marche_mntInitialTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TVA du marché"
                            },
                            "marche_mntInitialTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TTC du marché"
                            },
                            "marche_dateSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du marché"
                            },
                            "marche_dateNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification du marché"
                            },
                            "marche_dateOS": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réelle d'OS du marché"
                            },
                            "marche_dateRecept": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réelle de réception"
                            },
                            "marche_cmnt": {
                                "type": "string",
                                "description": "Commentaire du marché"
                            },
                            "tiers_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant1"
                            },
                            "tiers_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant2"
                            },
                            "tiers_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant3"
                            },
                            "tiers_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant4"
                            },
                            "tiers_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant5"
                            },
                            "tiers_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal1"
                            },
                            "tiers_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal2"
                            },
                            "tiers_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal3"
                            },
                            "tiers_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal4"
                            },
                            "tiers_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal5"
                            },
                            "tiers_entier1": {
                                "type": "number",
                                "description": "Valeur tiers entier1"
                            },
                            "tiers_entier2": {
                                "type": "number",
                                "description": "Valeur tiers entier2"
                            },
                            "tiers_entier3": {
                                "type": "number",
                                "description": "Valeur tiers entier3"
                            },
                            "tiers_entier4": {
                                "type": "number",
                                "description": "Valeur tiers entier4"
                            },
                            "tiers_entier5": {
                                "type": "number",
                                "description": "Valeur tiers entier5"
                            },
                            "tiers_flag1": {
                                "type": "boolean",
                                "description": "Valeur tiers flag1"
                            },
                            "tiers_flag2": {
                                "type": "boolean",
                                "description": "Valeur tiers flag2"
                            },
                            "tiers_flag3": {
                                "type": "boolean",
                                "description": "Valeur tiers flag3"
                            },
                            "tiers_flag4": {
                                "type": "boolean",
                                "description": "Valeur tiers flag4"
                            },
                            "tiers_flag5": {
                                "type": "boolean",
                                "description": "Valeur tiers flag5"
                            },
                            "tiers_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date1"
                            },
                            "tiers_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date2"
                            },
                            "tiers_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date3"
                            },
                            "tiers_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date4"
                            },
                            "tiers_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date5"
                            },
                            "tiers_texte1": {
                                "type": "string",
                                "description": "Valeur tiers texte1"
                            },
                            "tiers_texte2": {
                                "type": "string",
                                "description": "Valeur tiers texte2"
                            },
                            "tiers_texte3": {
                                "type": "string",
                                "description": "Valeur tiers texte3"
                            },
                            "tiers_texte4": {
                                "type": "string",
                                "description": "Valeur tiers texte4"
                            },
                            "tiers_texte5": {
                                "type": "string",
                                "description": "Valeur tiers texte5"
                            },
                            "tiers_codif1": {
                                "type": "string",
                                "description": "Valeur tiers codif1",
                                "codif": "SpoTiers_codif1"
                            },
                            "tiers_codif2": {
                                "type": "string",
                                "description": "Valeur tiers codif2",
                                "codif": "SpoTiers_codif2"
                            },
                            "tiers_codif3": {
                                "type": "string",
                                "description": "Valeur tiers codif3",
                                "codif": "SpoTiers_codif3"
                            },
                            "tiers_codif4": {
                                "type": "string",
                                "description": "Valeur tiers codif4",
                                "codif": "SpoTiers_codif4"
                            },
                            "tiers_codif5": {
                                "type": "string",
                                "description": "Valeur tiers codif5",
                                "codif": "SpoTiers_codif5"
                            },
                            "sit_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de situation"
                            },
                            "sit_dtRecep": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de réception"
                            },
                            "sit_dtExec": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'exécution"
                            },
                            "sit_dtRecepMOE": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réception MOE"
                            },
                            "sit_dtAccordMOE": {
                                "type": "string",
                                "format": "date",
                                "description": "Date accord MOE"
                            },
                            "sit_dtEch": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'échéance"
                            },
                            "sit_type": {
                                "type": "string",
                                "description": "Type de situation"
                            },
                            "sit_num": {
                                "type": "string",
                                "description": "N° de situation"
                            },
                            "sit_idFactEl": {
                                "type": "string",
                                "description": "Id.Fact Electronique"
                            },
                            "sit_code": {
                                "type": "string",
                                "description": "Code situation"
                            },
                            "sit_compteur": {
                                "type": "string",
                                "description": "Compteur"
                            },
                            "sit_lib": {
                                "type": "string",
                                "description": "Libellé"
                            },
                            "sit_engageHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Engagé HT"
                            },
                            "sit_cumulPreHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Ancien cumul HT"
                            },
                            "sit_prcCumulPreHT": {
                                "type": "number",
                                "format": "rate",
                                "description": "Final - % ancien cumul HT"
                            },
                            "sit_cumulHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Nouveau cumul HT"
                            },
                            "sit_prcCumulHT": {
                                "type": "number",
                                "format": "rate",
                                "description": "Final - % nouveau cumul HT"
                            },
                            "sit_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Période HT"
                            },
                            "sit_prcHT": {
                                "type": "number",
                                "format": "rate",
                                "description": "Final - % Période HT"
                            },
                            "sit_dispoHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Solde disponible HT"
                            },
                            "sit_engageTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Engagé TTC"
                            },
                            "sit_cumulPreTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Ancien cumul TTC"
                            },
                            "sit_prcCumulPreTTC": {
                                "type": "number",
                                "format": "rate",
                                "description": "Final - % ancien cumul TTC"
                            },
                            "sit_cumulTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Nouveau cumul TTC"
                            },
                            "sit_prcCumulTTC": {
                                "type": "number",
                                "format": "rate",
                                "description": "Final - % nouveau cumul TTC"
                            },
                            "sit_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Période TTC"
                            },
                            "sit_prcTTC": {
                                "type": "number",
                                "format": "rate",
                                "description": "Final - % Période TTC"
                            },
                            "sit_dispoTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Final - Solde disponible TTC"
                            },
                            "sit_ret_engageHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Engagé HT"
                            },
                            "sit_ret_cumulPreHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Ancien cumul HT"
                            },
                            "sit_ret_cumulHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Nouveau cumul HT"
                            },
                            "sit_ret_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Période HT"
                            },
                            "sit_ret_dispoHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Solde disponible HT"
                            },
                            "sit_ret_engageTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Engagé TTC"
                            },
                            "sit_ret_cumulPreTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Ancien cumul TTC"
                            },
                            "sit_ret_cumulTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Nouveau cumul TTC"
                            },
                            "sit_ret_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Période TTC"
                            },
                            "sit_ret_dispoTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Solde disponible TTC"
                            },
                            "sit_ret_mntTva": {
                                "type": "number",
                                "format": "money",
                                "description": "Retenue - Période TVA"
                            },
                            "sit_av_engageHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Engagé HT"
                            },
                            "sit_av_cumulPreHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Ancien cumul HT"
                            },
                            "sit_av_cumulHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Nouveau cumul HT"
                            },
                            "sit_av_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Période HT"
                            },
                            "sit_av_dispoHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Solde disponible HT"
                            },
                            "sit_av_engageTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Engagé TTC"
                            },
                            "sit_av_cumulPreTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Ancien cumul TTC"
                            },
                            "sit_av_cumulTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Nouveau cumul TTC"
                            },
                            "sit_av_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Période TTC"
                            },
                            "sit_av_dispoTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Solde disponible TTC"
                            },
                            "sit_av_mntTva": {
                                "type": "number",
                                "format": "money",
                                "description": "Avance - Période TVA"
                            },
                            "sit_dp_mntDeleg": {
                                "type": "number",
                                "format": "money",
                                "description": "Délégation - Montant accepté"
                            },
                            "sit_dp_cumulPre": {
                                "type": "number",
                                "format": "money",
                                "description": "Délégation - Ancien cumul"
                            },
                            "sit_dp_mnt": {
                                "type": "number",
                                "format": "money",
                                "description": "Délégation - Période"
                            },
                            "sit_dp_solde": {
                                "type": "number",
                                "format": "money",
                                "description": "Délégation - Solde"
                            },
                            "sit_dpst_mntDeleg": {
                                "type": "number",
                                "format": "money",
                                "description": "DélégationST - Montant accepté"
                            },
                            "sit_dpst_cumulPre": {
                                "type": "number",
                                "format": "money",
                                "description": "DélégationST - Ancien cumul"
                            },
                            "sit_dpst_mnt": {
                                "type": "number",
                                "format": "money",
                                "description": "DélégationST - Période"
                            },
                            "sit_dpst_solde": {
                                "type": "number",
                                "format": "money",
                                "description": "DélégationST - Solde"
                            },
                            "sit_tpc_engageHT": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Engagé HT"
                            },
                            "sit_tpc_cumulPreHT": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Ancien cumul HT"
                            },
                            "sit_tpc_cumulHT": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Nouveau cumul HT"
                            },
                            "sit_tpc_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Période HT"
                            },
                            "sit_tpc_dispoHT": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Solde disponible HT"
                            },
                            "sit_tpc_engageTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Engagé TTC"
                            },
                            "sit_tpc_cumulPreTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Ancien cumul TTC"
                            },
                            "sit_tpc_cumulTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Nouveau cumul TTC"
                            },
                            "sit_tpc_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Période TTC"
                            },
                            "sit_tpc_mntTTC_lettre": {
                                "type": "string",
                                "description": "A payer - Période TTC écrit en toutes lettres"
                            },
                            "sit_tpc_dispoTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Solde disponible TTC"
                            },
                            "sit_tpc_mntTva": {
                                "type": "number",
                                "format": "money",
                                "description": "A payer - Période TVA"
                            },
                            "sit_delaiReg": {
                                "type": "integer",
                                "description": "Délai"
                            },
                            "sit_condReg": {
                                "type": "string",
                                "description": "Base"
                            },
                            "sit_exigible": {
                                "type": "integer",
                                "description": "Exigible"
                            },
                            "sit_modeReg": {
                                "type": "string",
                                "description": "Mode de paiement",
                                "enumId": "DPModeReglement"
                            },
                            "sit_cmnt": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "montants": {
                                "type": "array",
                                "description": "Liste des Montants brut de la situation (détail)",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "m_libEngage": {
                                            "type": "string",
                                            "description": "Détail - Libellé engagement"
                                        },
                                        "m_lib": {
                                            "type": "string",
                                            "description": "Détail - Libellé de la ligne"
                                        },
                                        "m_typeLot": {
                                            "type": "string",
                                            "description": "Détail - Type de lot"
                                        },
                                        "m_numLot": {
                                            "type": "string",
                                            "description": "Détail - N° de lot"
                                        },
                                        "m_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Détail - Taux de TVA"
                                        },
                                        "m_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Engagé HT"
                                        },
                                        "m_cumulPreHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Ancien cumul HT"
                                        },
                                        "m_prcCumulPreHT": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Détail - % ancien cumul HT"
                                        },
                                        "m_cumulHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Nouveau cumul HT"
                                        },
                                        "m_prcCumulHT": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Détail - % nouveau cumul HT"
                                        },
                                        "m_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Période HT"
                                        },
                                        "m_prcHT": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Détail - % Période HT"
                                        },
                                        "m_dispoHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Solde disponible HT"
                                        },
                                        "m_engageTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Engagé TTC"
                                        },
                                        "m_cumulPreTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Ancien cumul TTC"
                                        },
                                        "m_prcCumulPreTTC": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Détail - % ancien cumul TTC"
                                        },
                                        "m_cumulTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Nouveau cumul TTC"
                                        },
                                        "m_prcCumulTTC": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Détail - % nouveau cumul TTC"
                                        },
                                        "m_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Période TTC"
                                        },
                                        "m_prcTTC": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Détail - % Période TTC"
                                        },
                                        "m_dispoTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Détail - Solde disponible TTC"
                                        }
                                    }
                                }
                            },
                            "totaux": {
                                "type": "array",
                                "description": "Liste des Montants brut de la situation regroupé (initial + cumul avenant)",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "mt_lib": {
                                            "type": "string",
                                            "description": "Initial + cumul avenant - Libellé de la ligne"
                                        },
                                        "mt_typeLot": {
                                            "type": "string",
                                            "description": "Initial + cumul avenant - Type de lot"
                                        },
                                        "mt_numLot": {
                                            "type": "string",
                                            "description": "Initial + cumul avenant - N° de lot"
                                        },
                                        "mt_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Initial + cumul avenant - Taux de TVA"
                                        },
                                        "mt_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Engagé HT"
                                        },
                                        "mt_cumulPreHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Ancien cumul HT"
                                        },
                                        "mt_prcCumulPreHT": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Initial + cumul avenant - % ancien cumul HT"
                                        },
                                        "mt_cumulHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Nouveau cumul HT"
                                        },
                                        "mt_prcCumulHT": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Initial + cumul avenant - % nouveau cumul HT"
                                        },
                                        "mt_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Période HT"
                                        },
                                        "mt_prcHT": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Initial + cumul avenant - % Période HT"
                                        },
                                        "mt_dispoHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Solde disponible HT"
                                        },
                                        "mt_engageTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Engagé TTC"
                                        },
                                        "mt_cumulPreTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Ancien cumul TTC"
                                        },
                                        "mt_prcCumulPreTTC": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Initial + cumul avenant - % ancien cumul TTC"
                                        },
                                        "mt_cumulTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Nouveau cumul TTC"
                                        },
                                        "mt_prcCumulTTC": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Initial + cumul avenant - % nouveau cumul TTC"
                                        },
                                        "mt_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Période TTC"
                                        },
                                        "mt_prcTTC": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Initial + cumul avenant - % Période TTC"
                                        },
                                        "mt_dispoTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Initial + cumul avenant - Solde disponible TTC"
                                        }
                                    }
                                }
                            },
                            "retenu_penalite": {
                                "type": "array",
                                "description": "Détails (liste retenues et pénalités)",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ret_lib": {
                                            "type": "string",
                                            "description": "Libellé retenue ou pénalité"
                                        },
                                        "ret_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux"
                                        },
                                        "ret_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé HT"
                                        },
                                        "ret_cumulPreHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul HT"
                                        },
                                        "ret_cumulHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul HT"
                                        },
                                        "ret_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période HT"
                                        },
                                        "ret_dispoHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible HT"
                                        },
                                        "ret_engageTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé TTC"
                                        },
                                        "ret_cumulPreTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul TTC"
                                        },
                                        "ret_cumulTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul TTC"
                                        },
                                        "ret_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TTC"
                                        },
                                        "ret_dispoTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible TTC"
                                        },
                                        "ret_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA"
                                        }
                                    }
                                }
                            },
                            "net_a_payer": {
                                "type": "array",
                                "description": "Total NET à payer",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "net_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé HT"
                                        },
                                        "net_cumulPreHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul HT"
                                        },
                                        "net_cumulHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul HT"
                                        },
                                        "net_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période HT"
                                        },
                                        "net_dispoHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible HT"
                                        },
                                        "net_engageTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé TTC"
                                        },
                                        "net_cumulPreTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul TTC"
                                        },
                                        "net_cumulTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul TTC"
                                        },
                                        "net_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TTC"
                                        },
                                        "net_dispoTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible TTC"
                                        },
                                        "net_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA"
                                        },
                                        "net_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        }
                                    }
                                }
                            },
                            "sous_trait_direct": {
                                "type": "array",
                                "description": "Sous-traitants paiement direct",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "std_libTiers": {
                                            "type": "string",
                                            "description": "Tiers sous-traitant"
                                        },
                                        "std_refCompta": {
                                            "type": "string",
                                            "description": "Référence comptable du tiers sous-traitant"
                                        },
                                        "std_cmnt": {
                                            "type": "string",
                                            "description": "Commentaire de la ligne"
                                        },
                                        "std_dtActe": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date acte"
                                        },
                                        "std_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        },
                                        "std_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé HT"
                                        },
                                        "std_cumulPreHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul HT"
                                        },
                                        "std_cumulHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul HT"
                                        },
                                        "std_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période HT"
                                        },
                                        "std_dispoHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible HT"
                                        },
                                        "std_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA"
                                        },
                                        "std_mntTvaAuto": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA Autoliquidée"
                                        },
                                        "std_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TTC"
                                        },
                                        "std_dispoTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible TTC"
                                        }
                                    }
                                }
                            },
                            "totaux_sous_trait_direct": {
                                "type": "array",
                                "description": "Total Sous-traitants paiement direct",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tstd_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        },
                                        "tstd_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé HT"
                                        },
                                        "tstd_cumulPreHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul HT"
                                        },
                                        "tstd_cumulHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul HT"
                                        },
                                        "tstd_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période HT"
                                        },
                                        "tstd_dispoHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible HT"
                                        },
                                        "tstd_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA"
                                        },
                                        "tstd_mntTvaAuto": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA Autoliquidée"
                                        },
                                        "tstd_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TTC"
                                        },
                                        "tstd_dispoTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible TTC"
                                        }
                                    }
                                }
                            },
                            "sous_trait_indirect": {
                                "type": "array",
                                "description": "Sous-traitants paiement indirect",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "sti_libTiers": {
                                            "type": "string",
                                            "description": "Tiers sous-traitant"
                                        },
                                        "sti_refCompta": {
                                            "type": "string",
                                            "description": "Référence comptable du tiers sous-traitant"
                                        },
                                        "sti_cmnt": {
                                            "type": "string",
                                            "description": "Commentaire de la ligne"
                                        },
                                        "sti_dtActe": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date acte"
                                        },
                                        "sti_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        },
                                        "sti_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé HT"
                                        },
                                        "sti_cumulPreHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul HT"
                                        },
                                        "sti_cumulHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul HT"
                                        },
                                        "sti_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période HT"
                                        },
                                        "sti_dispoHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible HT"
                                        },
                                        "sti_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA"
                                        },
                                        "sti_mntTvaAuto": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA Autoliquidée"
                                        },
                                        "sti_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TTC"
                                        },
                                        "sti_dispoTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible TTC"
                                        }
                                    }
                                }
                            },
                            "totaux_sous_trait_indirect": {
                                "type": "array",
                                "description": "Total Sous-traitants paiement indirect",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tsti_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        },
                                        "tsti_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé HT"
                                        },
                                        "tsti_cumulPreHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul HT"
                                        },
                                        "tsti_cumulHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul HT"
                                        },
                                        "tsti_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période HT"
                                        },
                                        "tsti_dispoHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible HT"
                                        },
                                        "tsti_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA"
                                        },
                                        "tsti_mntTvaAuto": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TVA Autoliquidée"
                                        },
                                        "tsti_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période TTC"
                                        },
                                        "tsti_dispoTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde disponible TTC"
                                        }
                                    }
                                }
                            },
                            "delegations": {
                                "type": "array",
                                "description": "Délégations sur titulaire",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "dp_tiersDeleg": {
                                            "type": "string",
                                            "description": "Tiers délégataire"
                                        },
                                        "dp_refCompta": {
                                            "type": "string",
                                            "description": "Référence comptable du tiers délégataire"
                                        },
                                        "dp_dtDeleg": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de la délégation"
                                        },
                                        "dp_typeDeleg": {
                                            "type": "string",
                                            "enumId": "DPDelegPaie.typeDeleg",
                                            "description": "Type de délégation"
                                        },
                                        "dp_mntDeleg": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant accepté"
                                        },
                                        "dp_cumulPre": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul"
                                        },
                                        "dp_cumul": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul"
                                        },
                                        "dp_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période"
                                        },
                                        "dp_solde": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde délégation"
                                        }
                                    }
                                }
                            },
                            "delegations_st": {
                                "type": "array",
                                "description": "Délégations sur sous-traitants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "dpst_tiersDeleg": {
                                            "type": "string",
                                            "description": "Tiers délégataire"
                                        },
                                        "dpst_refCompta": {
                                            "type": "string",
                                            "description": "Référence comptable du tiers délégataire"
                                        },
                                        "dpst_sousTraitant": {
                                            "type": "string",
                                            "description": "Tiers sous-traitant"
                                        },
                                        "dpst_dtDeleg": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de la délégation"
                                        },
                                        "dpst_typeDeleg": {
                                            "type": "string",
                                            "enumId": "DPDelegPaie.typeDeleg",
                                            "description": "Type de délégation"
                                        },
                                        "dpst_mntDeleg": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant accepté"
                                        },
                                        "dpst_cumulPre": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Ancien cumul"
                                        },
                                        "dpst_cumul": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Nouveau cumul"
                                        },
                                        "dpst_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Période"
                                        },
                                        "dpst_solde": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde délégation"
                                        }
                                    }
                                }
                            },
                            "cautions": {
                                "type": "array",
                                "description": "Cautions",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "caut_cautionneur": {
                                            "type": "string",
                                            "description": "Nom Tiers cautionneur"
                                        },
                                        "caut_numero": {
                                            "type": "string",
                                            "description": "Numéro de la caution"
                                        },
                                        "caut_type": {
                                            "type": "string",
                                            "description": "Type de caution",
                                            "enumId": "DPTypeCaution"
                                        },
                                        "caut_retenu": {
                                            "type": "string",
                                            "description": "Retenue"
                                        },
                                        "caut_portee": {
                                            "type": "string",
                                            "description": "Nature de caution",
                                            "enumId": "DPContratCaution.portee"
                                        },
                                        "caut_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de la caution"
                                        },
                                        "caut_dtFinValid": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Fin de validité de la caution"
                                        },
                                        "caut_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de la caution"
                                        }
                                    }
                                }
                            },
                            "situations": {
                                "type": "array",
                                "description": "Situations précédentes",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "lisit_lib": {
                                            "type": "string",
                                            "description": "Libellé situation"
                                        },
                                        "lisit_statut": {
                                            "type": "string",
                                            "enumId": "DPStatutFact",
                                            "description": "Statut situation"
                                        },
                                        "lisit_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de la situation"
                                        },
                                        "lisit_num": {
                                            "type": "string",
                                            "description": "N° de situation"
                                        },
                                        "lisit_idFactEl": {
                                            "type": "string",
                                            "description": "Id.Fact Electronique"
                                        },
                                        "lisit_netHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Total Net à payer HT"
                                        },
                                        "lisit_netTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Total Net à payer TTC"
                                        },
                                        "lisit_mntPaye": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant payé TTC"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "Facture": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Facture recette",
                    "items": {
                        "type": "object",
                        "properties": {
                            "client_civilite": {
                                "type": "string",
                                "description": "civilité du client",
                                "codif": "Civilite"
                            },
                            "client_lib": {
                                "type": "string",
                                "description": "Nom du client"
                            },
                            "client_adr1": {
                                "type": "string",
                                "description": "adrPointRemise du client"
                            },
                            "client_adr2": {
                                "type": "string",
                                "description": "adrNomVoie du client"
                            },
                            "client_complement": {
                                "type": "string",
                                "description": "adrComplement du client"
                            },
                            "client_cp": {
                                "type": "string",
                                "description": "adrCP du client"
                            },
                            "client_localite": {
                                "type": "string",
                                "description": "adrLocalite du client"
                            },
                            "client_tvaIntraUE": {
                                "type": "string",
                                "description": "Numéro TVA intracommunautaire  du client (personne morale)"
                            },
                            "client_pays": {
                                "type": "string",
                                "description": "adrPays du client"
                            },
                            "facture_num": {
                                "type": "string",
                                "description": "numéro de la facture"
                            },
                            "facture_numOrdre": {
                                "type": "string",
                                "description": "N° ordre de facturation sur contrat client"
                            },
                            "facture_lib": {
                                "type": "string",
                                "description": "libellé de la facture"
                            },
                            "facture_date": {
                                "type": "string",
                                "format": "date",
                                "description": "date de la facturation"
                            },
                            "facture_dateEcheance": {
                                "type": "string",
                                "format": "date",
                                "description": "date échéance"
                            },
                            "facture_type": {
                                "type": "string",
                                "description": "type de facture"
                            },
                            "facture_modeRegle": {
                                "type": "string",
                                "description": "mode de règlement de la facture",
                                "enumId": "FRFacture.modeReg"
                            },
                            "facture_baseRegle": {
                                "type": "string",
                                "description": "base de règlement de la facture",
                                "enumId": "FRFacture.condReg"
                            },
                            "facture_delaiRegle": {
                                "type": "integer",
                                "description": "délai de règlement de la facture"
                            },
                            "facture_exigible": {
                                "type": "integer",
                                "description": "exigibilité de la facture"
                            },
                            "postes_total_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants HT des postes budgétaires"
                            },
                            "postes_total_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TTC des postes budgétaires"
                            },
                            "postes_total_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TVA des postes budgetaires"
                            },
                            "cmd_ref": {
                                "type": "string",
                                "description": "Référence de la commande"
                            },
                            "cmd_num": {
                                "type": "string",
                                "description": "numéro de la commande"
                            },
                            "cmd_libelle": {
                                "type": "string",
                                "description": "libellé de la commande"
                            },
                            "cmd_date": {
                                "type": "string",
                                "format": "date",
                                "description": "date de la commande"
                            },
                            "cmd_total_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "total HT de la commande"
                            },
                            "cmd_total_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "total TTC de la commande"
                            },
                            "cmd_total_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "total TVA de la commande"
                            },
                            "cmd_cumulFac_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "cumul facturé HT de la commande"
                            },
                            "cmd_cumulFac_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "cumul facturé TTC de la commande"
                            },
                            "cmd_cumulEnc_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "cumul encaissé HT de la commande"
                            },
                            "cmd_cumulEnc_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "cumul encaissé TTC de la commande"
                            },
                            "cmd_resteFac_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "reste à facturer HT de la commande"
                            },
                            "cmd_resteFac_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "reste à facturer TTC de la commande"
                            },
                            "cmd_resteEnc_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "reste à encaisser HT de la commande"
                            },
                            "cmd_resteEnc_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "reste à encaisser TTC de la commande"
                            },
                            "cmd_cumulFacAvant_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "cumul facturé HT de la commande avant la dernière facture"
                            },
                            "cmd_cumulFacAvant_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "cumul facturé TTC de la commande avant la dernière facture"
                            },
                            "avenants_total_HT": {
                                "type": "number",
                                "format": "money",
                                "description": "total avenants HT"
                            },
                            "avenants_total_TTC": {
                                "type": "number",
                                "format": "money",
                                "description": "total avenants TTC"
                            },
                            "avenants_total_TVA": {
                                "type": "number",
                                "format": "money",
                                "description": "total avenants TVA"
                            },
                            "cmd_avecAvenants_total_HT": {
                                "type": "number",
                                "format": "money",
                                "description": "total commande + avenants HT"
                            },
                            "cmd_avecAvenants_total_TTC": {
                                "type": "number",
                                "format": "money",
                                "description": "total commande + avenants TTC"
                            },
                            "cmd_avecAvenants_total_TVA": {
                                "type": "number",
                                "format": "money",
                                "description": "total commande + avenants TVA"
                            },
                            "fac_total_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "total HT de la facture"
                            },
                            "fac_total_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "total TTC de la facture"
                            },
                            "fac_total_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "total TVA de la facture"
                            },
                            "tc_typeOuvrage": {
                                "type": "string",
                                "description": "type ouvrage"
                            },
                            "fac_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture montant1"
                            },
                            "fac_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture montant2"
                            },
                            "fac_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture montant3"
                            },
                            "fac_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture montant4"
                            },
                            "fac_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture montant5"
                            },
                            "fac_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture decimal1"
                            },
                            "fac_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture decimal2"
                            },
                            "fac_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture decimal3"
                            },
                            "fac_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture decimal4"
                            },
                            "fac_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur facture decimal5"
                            },
                            "fac_entier1": {
                                "type": "number",
                                "description": "Valeur facture entier1"
                            },
                            "fac_entier2": {
                                "type": "number",
                                "description": "Valeur facture entier2"
                            },
                            "fac_entier3": {
                                "type": "number",
                                "description": "Valeur facture entier3"
                            },
                            "fac_entier4": {
                                "type": "number",
                                "description": "Valeur facture entier4"
                            },
                            "fac_entier5": {
                                "type": "number",
                                "description": "Valeur facture entier5"
                            },
                            "fac_flag1": {
                                "type": "boolean",
                                "description": "Valeur facture flag1"
                            },
                            "fac_flag2": {
                                "type": "boolean",
                                "description": "Valeur facture flag2"
                            },
                            "fac_flag3": {
                                "type": "boolean",
                                "description": "Valeur facture flag3"
                            },
                            "fac_flag4": {
                                "type": "boolean",
                                "description": "Valeur facture flag4"
                            },
                            "fac_flag5": {
                                "type": "boolean",
                                "description": "Valeur facture flag5"
                            },
                            "fac_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur facture date1"
                            },
                            "fac_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur facture date2"
                            },
                            "fac_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur facture date3"
                            },
                            "fac_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur facture date4"
                            },
                            "fac_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur facture date5"
                            },
                            "fac_texte1": {
                                "type": "string",
                                "description": "Valeur facture texte1"
                            },
                            "fac_texte2": {
                                "type": "string",
                                "description": "Valeur facture texte2"
                            },
                            "fac_texte3": {
                                "type": "string",
                                "description": "Valeur facture texte3"
                            },
                            "fac_texte4": {
                                "type": "string",
                                "description": "Valeur facture texte4"
                            },
                            "fac_texte5": {
                                "type": "string",
                                "description": "Valeur facture texte5"
                            },
                            "fac_codif1": {
                                "type": "string",
                                "description": "Valeur facture codif1",
                                "codif": "FRFacture_codif1"
                            },
                            "fac_codif2": {
                                "type": "string",
                                "description": "Valeur facture codif2",
                                "codif": "FRFacture_codif2"
                            },
                            "fac_codif3": {
                                "type": "string",
                                "description": "Valeur facture codif3",
                                "codif": "FRFacture_codif3"
                            },
                            "fac_codif4": {
                                "type": "string",
                                "description": "Valeur facture codif4",
                                "codif": "FRFacture_codif4"
                            },
                            "fac_codif5": {
                                "type": "string",
                                "description": "Valeur facture codif5",
                                "codif": "FRFacture_codif5"
                            },
                            "postes_budgetaires": {
                                "type": "array",
                                "description": "Postes budgétaires",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "poste": {
                                            "type": "string",
                                            "description": "poste budgétaire"
                                        },
                                        "tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "taux tva"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant HT"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant TTC"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant TVA"
                                        }
                                    }
                                }
                            },
                            "cmdMontants": {
                                "type": "array",
                                "description": "Détails des montants de la commande",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "libelle": {
                                            "type": "string",
                                            "description": "Libéllé"
                                        },
                                        "quantite": {
                                            "type": "integer",
                                            "description": "Quantité"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux tva"
                                        },
                                        "prix_unit": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix unitaire"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        },
                                        "commentaire": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        }
                                    }
                                }
                            },
                            "facMontants": {
                                "type": "array",
                                "description": "Détails des montants de la facture",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "libelle": {
                                            "type": "string",
                                            "description": "Libéllé"
                                        },
                                        "fm_libEch": {
                                            "type": "string",
                                            "description": "libellé de l'échéance"
                                        },
                                        "quantite": {
                                            "type": "integer",
                                            "description": "Quantité"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux tva"
                                        },
                                        "prix_unit": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix unitaire"
                                        },
                                        "fm_prixUnit_3": {
                                            "type": "number",
                                            "decimals": 3,
                                            "description": "Prix unitaire * 100, avec 3 décimales (centimes €)"
                                        },
                                        "fm_mnt_3": {
                                            "type": "number",
                                            "decimals": 3,
                                            "description": "[Prix unitaire * 100] * quantité, avec 3 décimales (centimes €)"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        },
                                        "mnt_cmd_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant de la commande HT"
                                        }
                                    }
                                }
                            },
                            "echeancier": {
                                "type": "array",
                                "description": "Détails des échéances",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "libelle": {
                                            "type": "string",
                                            "description": "Libellé"
                                        },
                                        "type": {
                                            "type": "string",
                                            "description": "Type"
                                        },
                                        "evt": {
                                            "type": "string",
                                            "description": "Evénement"
                                        },
                                        "delai": {
                                            "type": "integer",
                                            "description": "Délai"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "date_ech": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date échéance"
                                        },
                                        "pourcentage": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage"
                                        },
                                        "ech_statut": {
                                            "type": "string",
                                            "description": "statut",
                                            "enumId": "FRCmdCliEch.statut"
                                        },
                                        "ech_mntFacture_HT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant facturé HT"
                                        }
                                    }
                                }
                            },
                            "echeancier_conso": {
                                "type": "array",
                                "description": "Echéancier consolidé",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ec_dateEch": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date échéance"
                                        },
                                        "ec_evt": {
                                            "type": "string",
                                            "description": "Evénement"
                                        },
                                        "ec_delai": {
                                            "type": "integer",
                                            "description": "Délai"
                                        },
                                        "ec_libelle": {
                                            "type": "string",
                                            "description": "Libellé"
                                        },
                                        "ec_mnt_TTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "ec_mnt_HT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "ec_prct": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage"
                                        },
                                        "ec_mntFacture_HT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant facturé HT"
                                        }
                                    }
                                }
                            },
                            "avenants": {
                                "type": "array",
                                "description": "Liste des avenants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "av_ref": {
                                            "type": "string",
                                            "description": "Référence avenant"
                                        },
                                        "av_num": {
                                            "type": "string",
                                            "description": "Numéro avenant"
                                        },
                                        "av_libelle": {
                                            "type": "string",
                                            "description": "Libellé"
                                        },
                                        "av_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date avenant"
                                        },
                                        "av_typeAvenant": {
                                            "type": "string",
                                            "description": "Type avenant"
                                        },
                                        "av_statut": {
                                            "type": "string",
                                            "description": "Statut avenant",
                                            "enumId": "FRCmdCli.statut"
                                        },
                                        "av_total_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Total HT avenant"
                                        },
                                        "av_total_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Total TTC avenant"
                                        },
                                        "av_total_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Total TVA avenant"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "Financement": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Dossier financement",
                    "items": {
                        "type": "object",
                        "properties": {
                            "lib": {
                                "type": "string",
                                "description": "Libellé dossier"
                            },
                            "nature": {
                                "type": "string",
                                "description": "Nature du financement"
                            },
                            "posteBudgetaire": {
                                "type": "string",
                                "description": "Poste budgétaire"
                            },
                            "financement": {
                                "type": "string",
                                "description": "Financement",
                                "codif": "OpTypeFin"
                            },
                            "mntDemande": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant demandé"
                            },
                            "dateDemande": {
                                "type": "string",
                                "format": "date",
                                "description": "Date demande de financement"
                            },
                            "datelimiteDem": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de demande de prêt"
                            },
                            "ref": {
                                "type": "string",
                                "description": "Référence"
                            },
                            "refExterne": {
                                "type": "string",
                                "description": "Référence externe"
                            },
                            "commentaire": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "decision": {
                                "type": "string",
                                "description": "Décision du financeur",
                                "enumId": "FiDossier.decision"
                            },
                            "dateDecision": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de décision"
                            },
                            "mntAttribue": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant  attribué"
                            },
                            "dateNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification"
                            },
                            "dateSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date signature du prêt"
                            },
                            "numContrat": {
                                "type": "string",
                                "description": "Numéro contrat de prêt"
                            },
                            "dateArrete": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'arrêté attributif"
                            },
                            "refArrete": {
                                "type": "string",
                                "description": "Référence arrêté"
                            },
                            "contratCadre": {
                                "type": "string",
                                "description": "Contrat cadre"
                            },
                            "dateLimiteValidite_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de début validité"
                            },
                            "dateLimiteValidite_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de fin validité"
                            },
                            "dateDemPro_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de demande prorogation début"
                            },
                            "datePro_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de prorogation début"
                            },
                            "dateDemPro_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de demande prorogation fin"
                            },
                            "datePro_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de propagation fin"
                            },
                            "dateEngage": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'engagement"
                            },
                            "op_nbLotPrinc": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux de l'opération"
                            },
                            "op_nbLotPrincPLUS": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLUS de l'opération"
                            },
                            "op_nbLotPrincPLAI": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLAI de l'opération"
                            },
                            "op_nbLotPrincPLS": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLS de l'opération"
                            },
                            "tiers_lib": {
                                "type": "string",
                                "description": "Tiers financeur"
                            },
                            "tiers_repres": {
                                "type": "string",
                                "description": "Tiers financeur representant"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "Tiers financeur adresse nom remisé"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "Tiers financeur adresse nom voie"
                            },
                            "tiers_adr_complement": {
                                "type": "string",
                                "description": "Tiers financeur adresse complément"
                            },
                            "tiers_adr_cp": {
                                "type": "string",
                                "description": "Tiers financeur adresse code postal"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "Tiers financeur adresse localité"
                            },
                            "tiers_adr_pays": {
                                "type": "string",
                                "description": "Tiers financeur adresse pays"
                            },
                            "tiers_email": {
                                "type": "string",
                                "description": "Tiers financeur e-mail"
                            },
                            "charge_lib": {
                                "type": "string",
                                "description": "Chargé de financement"
                            },
                            "charge_adr_remise": {
                                "type": "string",
                                "description": "Chargé de financement adresse nom remisé"
                            },
                            "charge_adr_voie": {
                                "type": "string",
                                "description": "Chargé de financement adresse nom voie"
                            },
                            "charge_adr_complement": {
                                "type": "string",
                                "description": "Chargé de financement adresse complément"
                            },
                            "charge_adr_cp": {
                                "type": "string",
                                "description": "Chargé de financement adresse code postal"
                            },
                            "charge_adr_localite": {
                                "type": "string",
                                "description": "Chargé de financement adresse localité"
                            },
                            "charge_adr_pays": {
                                "type": "string",
                                "description": "Chargé de financement adresse pays"
                            },
                            "charge_email": {
                                "type": "string",
                                "description": "Chargé de financement e-mail"
                            },
                            "charge_phone": {
                                "type": "string",
                                "description": "Chargé de financement téléphone"
                            }
                        }
                    }
                }
            }
        }
    },
    "FinancementAF": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Dossier financement Appel de Fonds",
                    "items": {
                        "type": "object",
                        "properties": {
                            "lib": {
                                "type": "string",
                                "description": "Libellé dossier"
                            },
                            "nature": {
                                "type": "string",
                                "description": "Nature du financement"
                            },
                            "posteBudgetaire": {
                                "type": "string",
                                "description": "Poste budgétaire"
                            },
                            "financement": {
                                "type": "string",
                                "description": "Financement",
                                "codif": "OpTypeFin"
                            },
                            "mntDemande": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant demandé"
                            },
                            "dateDemande": {
                                "type": "string",
                                "format": "date",
                                "description": "Date demande de financement"
                            },
                            "datelimiteDem": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de demande de prêt"
                            },
                            "ref": {
                                "type": "string",
                                "description": "Référence"
                            },
                            "refExterne": {
                                "type": "string",
                                "description": "Référence externe"
                            },
                            "commentaire": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "decision": {
                                "type": "string",
                                "description": "Décision du financeur",
                                "enumId": "FiDossier.decision"
                            },
                            "dateDecision": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de décision"
                            },
                            "mntAttribue": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant  attribué"
                            },
                            "dateNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification"
                            },
                            "dateSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date signature du prêt"
                            },
                            "numContrat": {
                                "type": "string",
                                "description": "Numéro contrat de prêt"
                            },
                            "dateArrete": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'arrêté attributif"
                            },
                            "refArrete": {
                                "type": "string",
                                "description": "Référence arrêté"
                            },
                            "contratCadre": {
                                "type": "string",
                                "description": "Contrat cadre"
                            },
                            "dateLimiteValidite_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de début validité"
                            },
                            "dateLimiteValidite_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de fin validité"
                            },
                            "dateDemPro_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de demande prorogation début"
                            },
                            "datePro_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de prorogation début"
                            },
                            "dateDemPro_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de demande prorogation fin"
                            },
                            "datePro_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de propagation fin"
                            },
                            "dateEngage": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'engagement"
                            },
                            "op_nbLotPrinc": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux de l'opération"
                            },
                            "op_nbLotPrincPLUS": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLUS de l'opération"
                            },
                            "op_nbLotPrincPLAI": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLAI de l'opération"
                            },
                            "op_nbLotPrincPLS": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLS de l'opération"
                            },
                            "tiers_lib": {
                                "type": "string",
                                "description": "Tiers financeur"
                            },
                            "tiers_repres": {
                                "type": "string",
                                "description": "Tiers financeur representant"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "Tiers financeur adresse nom remisé"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "Tiers financeur adresse nom voie"
                            },
                            "tiers_adr_complement": {
                                "type": "string",
                                "description": "Tiers financeur adresse complément"
                            },
                            "tiers_adr_cp": {
                                "type": "string",
                                "description": "Tiers financeur adresse code postal"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "Tiers financeur adresse localité"
                            },
                            "tiers_adr_pays": {
                                "type": "string",
                                "description": "Tiers financeur adresse pays"
                            },
                            "tiers_email": {
                                "type": "string",
                                "description": "Tiers financeur e-mail"
                            },
                            "charge_lib": {
                                "type": "string",
                                "description": "Chargé de financement"
                            },
                            "charge_adr_remise": {
                                "type": "string",
                                "description": "Chargé de financement adresse nom remisé"
                            },
                            "charge_adr_voie": {
                                "type": "string",
                                "description": "Chargé de financement adresse nom voie"
                            },
                            "charge_adr_complement": {
                                "type": "string",
                                "description": "Chargé de financement adresse complément"
                            },
                            "charge_adr_cp": {
                                "type": "string",
                                "description": "Chargé de financement adresse code postal"
                            },
                            "charge_adr_localite": {
                                "type": "string",
                                "description": "Chargé de financement adresse localité"
                            },
                            "charge_adr_pays": {
                                "type": "string",
                                "description": "Chargé de financement adresse pays"
                            },
                            "charge_email": {
                                "type": "string",
                                "description": "Chargé de financement e-mail"
                            },
                            "charge_phone": {
                                "type": "string",
                                "description": "Chargé de financement téléphone"
                            },
                            "appel_lib": {
                                "type": "string",
                                "description": "Libellé appel de fond"
                            },
                            "appel_datePrevu": {
                                "type": "string",
                                "format": "date",
                                "description": "Date appel de fond prévu"
                            },
                            "appel_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date appel de fond"
                            },
                            "appel_taux": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux appel de fond"
                            },
                            "appel_mntPrevu": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant appel de fond prévu"
                            },
                            "appel_mnt": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant appel de fond"
                            },
                            "appel_mntEncaisse": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant encaissé"
                            },
                            "appel_resteEncaisse": {
                                "type": "number",
                                "format": "money",
                                "description": "Reste à encaisser"
                            },
                            "appels": {
                                "type": "array",
                                "description": "Liste des appels de fonds",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ap_lib": {
                                            "type": "string",
                                            "description": "Libellé appel de fond"
                                        },
                                        "ap_datePrevu": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date appel de fond prévu"
                                        },
                                        "ap_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date appel de fond"
                                        },
                                        "ap_taux": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux appel de fond"
                                        },
                                        "ap_mntPrevu": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant appel de fond prévu"
                                        },
                                        "ap_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant appel de fond"
                                        },
                                        "ap_mntEncaisse": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant encaissé"
                                        },
                                        "ap_resteEncaisse": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Reste à encaisser"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "FinancementGarant": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Dossier financement Garant",
                    "items": {
                        "type": "object",
                        "properties": {
                            "lib": {
                                "type": "string",
                                "description": "Libellé dossier"
                            },
                            "nature": {
                                "type": "string",
                                "description": "Nature du financement"
                            },
                            "posteBudgetaire": {
                                "type": "string",
                                "description": "Poste budgétaire"
                            },
                            "financement": {
                                "type": "string",
                                "description": "Financement",
                                "codif": "OpTypeFin"
                            },
                            "mntDemande": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant demandé"
                            },
                            "dateDemande": {
                                "type": "string",
                                "format": "date",
                                "description": "Date demande de financement"
                            },
                            "datelimiteDem": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de demande de prêt"
                            },
                            "ref": {
                                "type": "string",
                                "description": "Référence"
                            },
                            "refExterne": {
                                "type": "string",
                                "description": "Référence externe"
                            },
                            "commentaire": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "decision": {
                                "type": "string",
                                "description": "Décision du financeur",
                                "enumId": "FiDossier.decision"
                            },
                            "dateDecision": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de décision"
                            },
                            "mntAttribue": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant  attribué"
                            },
                            "dateNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification"
                            },
                            "dateSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date signature du prêt"
                            },
                            "numContrat": {
                                "type": "string",
                                "description": "Numéro contrat de prêt"
                            },
                            "dateArrete": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'arrêté attributif"
                            },
                            "refArrete": {
                                "type": "string",
                                "description": "Référence arrêté"
                            },
                            "contratCadre": {
                                "type": "string",
                                "description": "Contrat cadre"
                            },
                            "dateLimiteValidite_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de début validité"
                            },
                            "dateLimiteValidite_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de fin validité"
                            },
                            "dateDemPro_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de demande prorogation début"
                            },
                            "datePro_debut": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de prorogation début"
                            },
                            "dateDemPro_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de demande prorogation fin"
                            },
                            "datePro_fin": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de propagation fin"
                            },
                            "dateEngage": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'engagement"
                            },
                            "op_nbLotPrinc": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux de l'opération"
                            },
                            "op_nbLotPrincPLUS": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLUS de l'opération"
                            },
                            "op_nbLotPrincPLAI": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLAI de l'opération"
                            },
                            "op_nbLotPrincPLS": {
                                "type": "integer",
                                "description": "Nombre de Lots principaux PLS de l'opération"
                            },
                            "tiers_lib": {
                                "type": "string",
                                "description": "Tiers financeur"
                            },
                            "tiers_repres": {
                                "type": "string",
                                "description": "Tiers financeur representant"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "Tiers financeur adresse nom remisé"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "Tiers financeur adresse nom voie"
                            },
                            "tiers_adr_complement": {
                                "type": "string",
                                "description": "Tiers financeur adresse complément"
                            },
                            "tiers_adr_cp": {
                                "type": "string",
                                "description": "Tiers financeur adresse code postal"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "Tiers financeur adresse localité"
                            },
                            "tiers_adr_pays": {
                                "type": "string",
                                "description": "Tiers financeur adresse pays"
                            },
                            "tiers_email": {
                                "type": "string",
                                "description": "Tiers financeur e-mail"
                            },
                            "charge_lib": {
                                "type": "string",
                                "description": "Chargé de financement"
                            },
                            "charge_adr_remise": {
                                "type": "string",
                                "description": "Chargé de financement adresse nom remisé"
                            },
                            "charge_adr_voie": {
                                "type": "string",
                                "description": "Chargé de financement adresse nom voie"
                            },
                            "charge_adr_complement": {
                                "type": "string",
                                "description": "Chargé de financement adresse complément"
                            },
                            "charge_adr_cp": {
                                "type": "string",
                                "description": "Chargé de financement adresse code postal"
                            },
                            "charge_adr_localite": {
                                "type": "string",
                                "description": "Chargé de financement adresse localité"
                            },
                            "charge_adr_pays": {
                                "type": "string",
                                "description": "Chargé de financement adresse pays"
                            },
                            "charge_email": {
                                "type": "string",
                                "description": "Chargé de financement e-mail"
                            },
                            "charge_phone": {
                                "type": "string",
                                "description": "Chargé de financement téléphone"
                            },
                            "garant_lib": {
                                "type": "string",
                                "description": "Garant"
                            },
                            "garant_dateDelib": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de délibération du garant"
                            },
                            "garant_dateSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du garant"
                            },
                            "garant_tauxGaranti": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de garantie"
                            },
                            "garant_mntGaranti": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant de garantie"
                            },
                            "garants": {
                                "type": "array",
                                "description": "Liste des garants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ga_lib": {
                                            "type": "string",
                                            "description": "Garant"
                                        },
                                        "ga_dateDelib": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de délibération du garant"
                                        },
                                        "ga_dateSign": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de signature du garant"
                                        },
                                        "ga_tauxGaranti": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de garantie"
                                        },
                                        "ga_mntGaranti": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant de garantie"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "LotPaiement": {
        "schemas": {
            "type": "object",
            "properties": {
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Lot de paiement",
                    "items": {
                        "type": "object",
                        "properties": {
                            "operation_code": {
                                "type": "string",
                                "description": "Code de l'opération"
                            },
                            "operation_lib": {
                                "type": "string",
                                "description": "Libellé de l'opération"
                            },
                            "operation_refCompta": {
                                "type": "string",
                                "description": "Référence comptable de l'opération",
                                "version": "18.3"
                            },
                            "lotPaie_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date du lot de paiement"
                            },
                            "lotPaie_statut": {
                                "type": "string",
                                "description": "Statut",
                                "enumId": "DPLotPaie.statut"
                            },
                            "lotPaie_code": {
                                "type": "string",
                                "description": "N° du lot"
                            },
                            "lotPaie_lib": {
                                "type": "string",
                                "description": "Libellé du lot"
                            },
                            "lotPaie_cmnt": {
                                "type": "string",
                                "description": "Commentaire du lot"
                            },
                            "lotPaie_datePaie": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de paiement"
                            },
                            "lotPaie_libCB": {
                                "type": "string",
                                "description": "Compte bancaire"
                            },
                            "lotPaie_typeCB": {
                                "type": "string",
                                "description": "Type de compte",
                                "enumId": "OPCompteBancaire.typeCB"
                            },
                            "lotPaie_iban": {
                                "type": "string",
                                "description": "IBAN du compte bancaire"
                            },
                            "lotPaie_bic": {
                                "type": "string",
                                "description": "BIC du compte bancaire"
                            },
                            "lotPaie_etablisCB": {
                                "type": "string",
                                "description": "Etablissement bancaire"
                            },
                            "lotPaie_modePaie": {
                                "type": "string",
                                "description": "Mode de paiement",
                                "enumId": "DPLotPaie.modPaie"
                            },
                            "lotPaie_group": {
                                "type": "boolean",
                                "description": "Paiement groupé par fournisseur"
                            },
                            "lotPaie_nbPaiements": {
                                "type": "integer",
                                "description": "Nombre de paiement"
                            },
                            "lotPaie_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants HT des factures"
                            },
                            "lotPaie_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants TTC des factures"
                            },
                            "lotPaie_mntTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants TVA des factures"
                            },
                            "lotPaie_mntAutoriseTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants autorisés TTC des factures"
                            },
                            "lotPaie_mntPaieTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants paiement TTC des factures"
                            },
                            "lotPaie_soldeAPayerTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde à payer TTC des factures"
                            },
                            "factures": {
                                "type": "array",
                                "description": "Liste des factures et des situations",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "fact_op_code": {
                                            "type": "string",
                                            "description": "Code l'opération"
                                        },
                                        "fact_op_lib": {
                                            "type": "string",
                                            "description": "Libellé de l'opération"
                                        },
                                        "fact_op_codeAnalytique": {
                                            "type": "string",
                                            "description": "Code analytique de l'opération"
                                        },
                                        "fact_typeDepenses": {
                                            "type": "string",
                                            "description": "Type de dépenses"
                                        },
                                        "fact_four_code": {
                                            "type": "string",
                                            "description": "Code fournisseur"
                                        },
                                        "fact_four_lib": {
                                            "type": "string",
                                            "description": "Tiers Fournisseur"
                                        },
                                        "fact_four_iban": {
                                            "type": "string",
                                            "description": "IBAN du Tiers"
                                        },
                                        "fact_four_bic": {
                                            "type": "string",
                                            "description": "BIC du Tiers"
                                        },
                                        "fact_four_siret": {
                                            "type": "string",
                                            "description": "Siret du Tiers",
                                            "version": "18.0"
                                        },
                                        "fact_four_etablis": {
                                            "type": "string",
                                            "description": "Etablissement bancaire du Tiers"
                                        },
                                        "fact_eng_ref": {
                                            "type": "string",
                                            "description": "Ref. engagement"
                                        },
                                        "fact_eng_lib": {
                                            "type": "string",
                                            "description": "Engagement"
                                        },
                                        "fact_lib": {
                                            "type": "string",
                                            "description": "Facture / situation"
                                        },
                                        "fact_num": {
                                            "type": "string",
                                            "description": "Numéro Facture / Situation"
                                        },
                                        "fact_code": {
                                            "type": "string",
                                            "description": "Code Facture / Situation"
                                        },
                                        "fact_roleTiers": {
                                            "type": "string",
                                            "description": "Rôle tiers Facture",
                                            "enumId": "DPLotPaieFact.roleTiers"
                                        },
                                        "fact_numRefRegle": {
                                            "type": "string",
                                            "description": "Référence du règlement"
                                        },
                                        "fact_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date pièce"
                                        },
                                        "fact_dateEch": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date échéance"
                                        },
                                        "fact_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "fact_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "fact_mntTVA": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        },
                                        "fact_mntAutoriseTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant autorisé TTC"
                                        },
                                        "fact_soldeAPayerTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde à payer TTC"
                                        },
                                        "fact_mntPaieTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant paiement TTC"
                                        },
                                        "fact_bonAPayer_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date du bon à payer"
                                        },
                                        "fact_bonAPayer_cmnt": {
                                            "type": "string",
                                            "description": "Commentaire du bon à payer"
                                        },
                                        "fact_postes_lib": {
                                            "type": "string",
                                            "description": "Postes budgétaires"
                                        },
                                        "fact_postes_code_compta": {
                                            "type": "string",
                                            "description": "Codes postes budgétaires"
                                        },
                                        "fact_docExterne": {
                                            "type": "string",
                                            "description": "Document externe"
                                        },
                                        "fact_lienDocExterne": {
                                            "type": "string",
                                            "description": "Lien vers document externe"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "MandatPrelev": {
        "schemas": {
            "type": "object",
            "properties": {
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Mandat de prélèvement",
                    "items": {
                        "type": "object",
                        "properties": {
                            "tiers_lib": {
                                "type": "string",
                                "description": "Nom et prénom du tiers"
                            },
                            "tiers_adr_pays": {
                                "type": "string",
                                "description": "Pays du tiers"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "Point de remise du tiers"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "Nom de voie du tiers"
                            },
                            "tiers_adr_compl": {
                                "type": "string",
                                "description": "Comlément adresse du tiers"
                            },
                            "tiers_adr_distrib": {
                                "type": "string",
                                "description": "Boite postale du tiers"
                            },
                            "tiers_adr_codePostal": {
                                "type": "string",
                                "description": "Code postal du tiers"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "Localité du tiers"
                            },
                            "rib_rum": {
                                "type": "string",
                                "description": "Référence Unique du mandat"
                            },
                            "rib_dtSignMandat": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du mandat"
                            },
                            "rib_titulaire": {
                                "type": "string",
                                "description": "Titulaire du compte"
                            },
                            "rib_iban": {
                                "type": "string",
                                "description": "IBAN"
                            },
                            "rib_bic": {
                                "type": "string",
                                "description": "BIC"
                            },
                            "rib_libelle": {
                                "type": "string",
                                "description": "libelle"
                            },
                            "rib_banque": {
                                "type": "string",
                                "description": "banque"
                            },
                            "soc_lib": {
                                "type": "string",
                                "description": "Nom de la société"
                            },
                            "soc_ics": {
                                "type": "string",
                                "description": "Identifiant créancier SEPA"
                            },
                            "soc_adr_pays": {
                                "type": "string",
                                "description": "Pays de la société"
                            },
                            "soc_adr_voie": {
                                "type": "string",
                                "description": "Nom de voie de la société"
                            },
                            "soc_adr_compl": {
                                "type": "string",
                                "description": "Comlément adresse de la société"
                            },
                            "soc_adr_distrib": {
                                "type": "string",
                                "description": "Boite postale de la société"
                            },
                            "soc_adr_codePostal": {
                                "type": "string",
                                "description": "Code postal de la société"
                            },
                            "soc_adr_localite": {
                                "type": "string",
                                "description": "Localité de la société"
                            }
                        }
                    }
                }
            }
        }
    },
    "Marche": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "NotificationMarche",
                    "items": {
                        "type": "object",
                        "properties": {
                            "titulaire_lib": {
                                "type": "string",
                                "description": "Nom titulaire"
                            },
                            "titulaire_formeJuridique": {
                                "type": "string",
                                "description": "forme juridique titulaire",
                                "codif": "FormeJuridique"
                            },
                            "titulaire_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "capital social titulaire"
                            },
                            "titulaire_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers titulaire"
                            },
                            "titulaire_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers titulaire"
                            },
                            "titulaire_civilite": {
                                "type": "string",
                                "description": "Civilité du Représentant principal titulaire",
                                "codif": "Civilite"
                            },
                            "titulaire_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal titulaire"
                            },
                            "titulaire_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal titulaire"
                            },
                            "tiers_rep_mail": {
                                "type": "string",
                                "description": "email du représentant principal titulaire"
                            },
                            "tiers_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du représentant principal prestataire"
                            },
                            "tiers_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du représentant principal prestataire"
                            },
                            "titulaire_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé titulaire"
                            },
                            "titulaire_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie titulaire"
                            },
                            "titulaire_adr_complement": {
                                "type": "string",
                                "description": "adresse complement titulaire"
                            },
                            "titulaire_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal titulaire"
                            },
                            "titulaire_adr_localite": {
                                "type": "string",
                                "description": "adresse localité titulaire"
                            },
                            "titulaire_siret": {
                                "type": "string",
                                "description": "SIRET du tiers titulaire"
                            },
                            "titulaire_APE": {
                                "type": "string",
                                "description": "APE du tiers titulaire"
                            },
                            "titulaire_libRib": {
                                "type": "string",
                                "description": "RIB du tiers prestataire"
                            },
                            "titulaire_iban": {
                                "type": "string",
                                "description": "IBAN du tiers titulaire"
                            },
                            "titulaire_banque": {
                                "type": "string",
                                "description": "Banque du tiers titulaire"
                            },
                            "marche_lib": {
                                "type": "string",
                                "description": "Libellé du marché"
                            },
                            "marche_code": {
                                "type": "string",
                                "description": "Code du marché"
                            },
                            "marche_adrFE": {
                                "type": "string",
                                "description": "Adresse de réception facture électronique",
                                "version": "18.3"
                            },
                            "marche_ref": {
                                "type": "string",
                                "description": "Numéro du marché"
                            },
                            "marche_lotNum": {
                                "type": "string",
                                "description": "Numéro de lot du marché"
                            },
                            "marche_lotType": {
                                "type": "string",
                                "description": "Type de lot du marché"
                            },
                            "marche_mntInitialHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial HT du marché"
                            },
                            "marche_mntInitialTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TVA du marché"
                            },
                            "marche_mntInitialTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TTC du marché"
                            },
                            "marche_mntInitialHT_lettres": {
                                "type": "string",
                                "format": "number-letters",
                                "description": "Montant initial HT du marché en toutes lettres"
                            },
                            "marche_mntInitialTTC_lettres": {
                                "type": "string",
                                "format": "number-letters",
                                "description": "Montant initial TTC du marché en toutes lettres"
                            },
                            "marche_dateSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du marché"
                            },
                            "marche_dateNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification du marché"
                            },
                            "marche_dateOs": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réelle d'OS1 du marché"
                            },
                            "marche_dtRecep": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réelle de réception"
                            },
                            "marche_dtFinExec": {
                                "type": "string",
                                "format": "date",
                                "description": "Date fin d'exécution"
                            },
                            "marche_cmnt": {
                                "type": "string",
                                "description": "Commentaire du marché"
                            },
                            "marche_tauxRG": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de retenue de garantie"
                            },
                            "marche_tauxProrata": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de prorata"
                            },
                            "marche_delaiReg": {
                                "type": "integer",
                                "description": "Délai"
                            },
                            "marche_typeMarche": {
                                "type": "string",
                                "description": "Type de marché",
                                "enumId": "DPContrat.typeMarche"
                            },
                            "marche_typeContractant": {
                                "type": "string",
                                "description": "Type de contractant",
                                "enumId": "DPGrpFour"
                            },
                            "marche_typeGroupement": {
                                "type": "string",
                                "description": "Type de groupement",
                                "enumId": "DPTypeGrpFour"
                            },
                            "marche_delaiExec": {
                                "type": "integer",
                                "description": "Délai d'exécution"
                            },
                            "marche_condReg": {
                                "type": "string",
                                "description": "Base",
                                "enumId": "FacBaseRegle"
                            },
                            "marche_exigible": {
                                "type": "integer",
                                "description": "Exigible"
                            },
                            "marche_modeReg": {
                                "type": "string",
                                "description": "Mode de paiement",
                                "enumId": "DPModeReglement"
                            },
                            "marche_modeReval": {
                                "type": "string",
                                "description": "Prix",
                                "enumId": "DPModeReval"
                            },
                            "marche_dtPrixInit": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'établissement du prix (mois = M0)"
                            },
                            "marche_mntAvance": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant de l'avance sur la 1ère situation"
                            },
                            "marche_debutRembAvance": {
                                "type": "number",
                                "format": "rate",
                                "description": "Remboursement début"
                            },
                            "marche_finRembAvance": {
                                "type": "number",
                                "format": "rate",
                                "description": "Remboursement fin"
                            },
                            "accordCadre_code": {
                                "type": "string",
                                "description": "Code accord cadre",
                                "version": "18.1"
                            },
                            "accordCadre_lib": {
                                "type": "string",
                                "description": "Libellé accord cadre",
                                "version": "18.1"
                            },
                            "accordCadre_num": {
                                "type": "string",
                                "description": "N° accord cadre",
                                "version": "18.1"
                            },
                            "marche_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant1 du marché",
                                "version": "18.3"
                            },
                            "marche_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant2 du marché",
                                "version": "18.3"
                            },
                            "marche_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant3 du marché",
                                "version": "18.3"
                            },
                            "marche_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant4 du marché",
                                "version": "18.3"
                            },
                            "marche_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant5 du marché",
                                "version": "18.3"
                            },
                            "marche_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal1 du marché",
                                "version": "18.3"
                            },
                            "marche_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal2 du marché",
                                "version": "18.3"
                            },
                            "marche_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal3 du marché",
                                "version": "18.3"
                            },
                            "marche_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal4 du marché",
                                "version": "18.3"
                            },
                            "marche_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Decimal5 du marché",
                                "version": "18.3"
                            },
                            "marche_entier1": {
                                "type": "integer",
                                "description": "Entier1 du marché",
                                "version": "18.3"
                            },
                            "marche_entier2": {
                                "type": "integer",
                                "description": "Entier2 du marché",
                                "version": "18.3"
                            },
                            "marche_entier3": {
                                "type": "integer",
                                "description": "Entier3 du marché",
                                "version": "18.3"
                            },
                            "marche_entier4": {
                                "type": "integer",
                                "description": "Entier4 du marché",
                                "version": "18.3"
                            },
                            "marche_entier5": {
                                "type": "integer",
                                "description": "Entier5 du marché",
                                "version": "18.3"
                            },
                            "marche_flag1": {
                                "type": "boolean",
                                "description": "Flag1 du marché",
                                "version": "18.3"
                            },
                            "marche_flag2": {
                                "type": "boolean",
                                "description": "Flag2 du marché",
                                "version": "18.3"
                            },
                            "marche_flag3": {
                                "type": "boolean",
                                "description": "Flag3 du marché",
                                "version": "18.3"
                            },
                            "marche_flag4": {
                                "type": "boolean",
                                "description": "Flag4 du marché",
                                "version": "18.3"
                            },
                            "marche_flag5": {
                                "type": "boolean",
                                "description": "Flag5 du marché",
                                "version": "18.3"
                            },
                            "marche_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Date1 du marché",
                                "version": "18.3"
                            },
                            "marche_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Date2 du marché",
                                "version": "18.3"
                            },
                            "marche_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Date3 du marché",
                                "version": "18.3"
                            },
                            "marche_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Date4 du marché",
                                "version": "18.3"
                            },
                            "marche_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Date5 du marché",
                                "version": "18.3"
                            },
                            "marche_texte1": {
                                "type": "string",
                                "description": "Texte1 du marché",
                                "version": "18.3"
                            },
                            "marche_texte2": {
                                "type": "string",
                                "description": "Texte2 du marché",
                                "version": "18.3"
                            },
                            "marche_texte3": {
                                "type": "string",
                                "description": "Texte3 du marché",
                                "version": "18.3"
                            },
                            "marche_texte4": {
                                "type": "string",
                                "description": "Texte4 du marché",
                                "version": "18.3"
                            },
                            "marche_texte5": {
                                "type": "string",
                                "description": "Texte5 du marché",
                                "version": "18.3"
                            },
                            "marche_codif1": {
                                "type": "string",
                                "description": "Codif1 du marché",
                                "codif": "DPContrat_codif1",
                                "version": "18.3"
                            },
                            "marche_codif2": {
                                "type": "string",
                                "description": "Codif2 du marché",
                                "codif": "DPContrat_codif2",
                                "version": "18.3"
                            },
                            "marche_codif3": {
                                "type": "string",
                                "description": "Codif3 du marché",
                                "codif": "DPContrat_codif3",
                                "version": "18.3"
                            },
                            "marche_codif4": {
                                "type": "string",
                                "description": "Codif4 du marché",
                                "codif": "DPContrat_codif4",
                                "version": "18.3"
                            },
                            "marche_codif5": {
                                "type": "string",
                                "description": "Codif5 du marché",
                                "codif": "DPContrat_codif5",
                                "version": "18.3"
                            },
                            "perso_tiers_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant1"
                            },
                            "perso_tiers_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant2"
                            },
                            "perso_tiers_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant3"
                            },
                            "perso_tiers_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant4"
                            },
                            "perso_tiers_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant5"
                            },
                            "perso_tiers_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal1"
                            },
                            "perso_tiers_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal2"
                            },
                            "perso_tiers_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal3"
                            },
                            "perso_tiers_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal4"
                            },
                            "perso_tiers_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal5"
                            },
                            "perso_tiers_entier1": {
                                "type": "number",
                                "description": "Valeur tiers entier1"
                            },
                            "perso_tiers_entier2": {
                                "type": "number",
                                "description": "Valeur tiers entier2"
                            },
                            "perso_tiers_entier3": {
                                "type": "number",
                                "description": "Valeur tiers entier3"
                            },
                            "perso_tiers_entier4": {
                                "type": "number",
                                "description": "Valeur tiers entier4"
                            },
                            "perso_tiers_entier5": {
                                "type": "number",
                                "description": "Valeur tiers entier5"
                            },
                            "perso_tiers_flag1": {
                                "type": "boolean",
                                "description": "Valeur tiers flag1"
                            },
                            "perso_tiers_flag2": {
                                "type": "boolean",
                                "description": "Valeur tiers flag2"
                            },
                            "perso_tiers_flag3": {
                                "type": "boolean",
                                "description": "Valeur tiers flag3"
                            },
                            "perso_tiers_flag4": {
                                "type": "boolean",
                                "description": "Valeur tiers flag4"
                            },
                            "perso_tiers_flag5": {
                                "type": "boolean",
                                "description": "Valeur tiers flag5"
                            },
                            "perso_tiers_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date1"
                            },
                            "perso_tiers_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date2"
                            },
                            "perso_tiers_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date3"
                            },
                            "perso_tiers_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date4"
                            },
                            "perso_tiers_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date5"
                            },
                            "perso_tiers_texte1": {
                                "type": "string",
                                "description": "Valeur tiers texte1"
                            },
                            "perso_tiers_texte2": {
                                "type": "string",
                                "description": "Valeur tiers texte2"
                            },
                            "perso_tiers_texte3": {
                                "type": "string",
                                "description": "Valeur tiers texte3"
                            },
                            "perso_tiers_texte4": {
                                "type": "string",
                                "description": "Valeur tiers texte4"
                            },
                            "perso_tiers_texte5": {
                                "type": "string",
                                "description": "Valeur tiers texte5"
                            },
                            "perso_tiers_codif1": {
                                "type": "string",
                                "description": "Valeur tiers codif1"
                            },
                            "perso_tiers_codif2": {
                                "type": "string",
                                "description": "Valeur tiers codif2"
                            },
                            "perso_tiers_codif3": {
                                "type": "string",
                                "description": "Valeur tiers codif3"
                            },
                            "perso_tiers_codif4": {
                                "type": "string",
                                "description": "Valeur tiers codif4"
                            },
                            "perso_tiers_codif5": {
                                "type": "string",
                                "description": "Valeur tiers codif5"
                            },
                            "marche_montants": {
                                "type": "array",
                                "description": "Liste des montants du marché",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "mnt_lib": {
                                            "type": "string",
                                            "description": "Libellé engagement"
                                        },
                                        "mnt_type": {
                                            "type": "string",
                                            "description": "Marché / Avenant"
                                        },
                                        "mnt_numLot": {
                                            "type": "string",
                                            "description": "N° de lot"
                                        },
                                        "mnt_typeLot": {
                                            "type": "string",
                                            "description": "Type de lot"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT marché"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC marché"
                                        },
                                        "taux_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA marché"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA marché"
                                        },
                                        "mnt_tiers": {
                                            "type": "string",
                                            "description": "Tiers"
                                        }
                                    }
                                }
                            },
                            "marche_montantsAvecAvenants": {
                                "type": "array",
                                "description": "Liste des montants du marché incluant les avenants",
                                "version": "18.3",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "mntaa_numAvenant": {
                                            "type": "string",
                                            "description": "N° de l'avenant (vide pour le marché initial)",
                                            "version": "18.3"
                                        },
                                        "mntaa_libAvenant": {
                                            "type": "string",
                                            "description": "Libellé de l'avenant (initial pour le marché)",
                                            "version": "18.3"
                                        },
                                        "mntaa_lib": {
                                            "type": "string",
                                            "description": "Libellé engagement",
                                            "version": "18.3"
                                        },
                                        "mntaa_type": {
                                            "type": "string",
                                            "description": "Marché / Avenant",
                                            "version": "18.3"
                                        },
                                        "mntaa_numLot": {
                                            "type": "string",
                                            "description": "N° de lot",
                                            "version": "18.3"
                                        },
                                        "mntaa_typeLot": {
                                            "type": "string",
                                            "description": "Type de lot",
                                            "version": "18.3"
                                        },
                                        "mntaa_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT",
                                            "version": "18.3"
                                        },
                                        "mntaa_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC",
                                            "version": "18.3"
                                        },
                                        "mntaa_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA",
                                            "version": "18.3"
                                        },
                                        "mntaa_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA",
                                            "version": "18.3"
                                        },
                                        "mntaa_tiers": {
                                            "type": "string",
                                            "description": "Tiers",
                                            "version": "18.3"
                                        }
                                    }
                                }
                            },
                            "fournisseurs": {
                                "type": "array",
                                "description": "Liste des tiers du marché",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "t_lib": {
                                            "type": "string",
                                            "description": "Nom titulaire"
                                        },
                                        "t_formeJuridique": {
                                            "type": "string",
                                            "description": "Forme juridique titulaire",
                                            "codif": "FormeJuridique"
                                        },
                                        "t_capital": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Capital social titulaire"
                                        },
                                        "t_tribunalComm": {
                                            "type": "string",
                                            "description": "Tribunal de commerce du tiers titulaire"
                                        },
                                        "t_rcs": {
                                            "type": "string",
                                            "description": "Numéro RCS du tiers titulaire"
                                        },
                                        "t_rep_civilite": {
                                            "type": "string",
                                            "description": "Civilité du Représentant principal titulaire",
                                            "codif": "Civilite"
                                        },
                                        "t_rep_prenom": {
                                            "type": "string",
                                            "description": "Prénom du Représentant principal titulaire"
                                        },
                                        "t_rep_nom": {
                                            "type": "string",
                                            "description": "Nom du Représentant principal titulaire"
                                        },
                                        "t_rep_fonction": {
                                            "type": "string",
                                            "description": "Fonction du représentant principal titulaire"
                                        },
                                        "t_rep_mail": {
                                            "type": "string",
                                            "description": "Courriel du représentant principal titulaire"
                                        },
                                        "t_rep_phone": {
                                            "type": "string",
                                            "description": "Téléphone du représentant principal titulaire"
                                        },
                                        "t_adr_remise": {
                                            "type": "string",
                                            "description": "Adresse nom remisé titulaire"
                                        },
                                        "t_adr_voie": {
                                            "type": "string",
                                            "description": "Adresse nom voie titulaire"
                                        },
                                        "t_adr_complement": {
                                            "type": "string",
                                            "description": "Adresse complement titulaire"
                                        },
                                        "t_adr_codePostal": {
                                            "type": "string",
                                            "description": "Adresse code postal titulaire"
                                        },
                                        "t_adr_localite": {
                                            "type": "string",
                                            "description": "Adresse localité titulaire"
                                        },
                                        "t_siret": {
                                            "type": "string",
                                            "description": "SIRET du tiers titulaire"
                                        },
                                        "t_ape": {
                                            "type": "string",
                                            "description": "APE du tiers titulaire"
                                        },
                                        "t_libRib": {
                                            "type": "string",
                                            "description": "Nom titulaire RIB"
                                        },
                                        "t_iban": {
                                            "type": "string",
                                            "description": "Numero de compte RIB titulaire"
                                        },
                                        "t_banque": {
                                            "type": "string",
                                            "description": "Banque titulaire du RIB"
                                        },
                                        "t_modeReg": {
                                            "type": "string",
                                            "description": "Mode de paiement",
                                            "enumId": "DPModeReglement"
                                        }
                                    }
                                }
                            },
                            "retenues": {
                                "type": "array",
                                "description": "Liste des Retenues contractuelles (type de montant = %)",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "ret_lib": {
                                            "type": "string",
                                            "description": "Libellé"
                                        },
                                        "ret_taux": {
                                            "type": "string",
                                            "description": "Valeur"
                                        },
                                        "ret_baseCalcul": {
                                            "type": "string",
                                            "description": "Base de calcul",
                                            "enumId": "DPRetBaseCalcul"
                                        }
                                    }
                                }
                            },
                            "cautions": {
                                "type": "array",
                                "description": "Liste des cautions",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "caut_cautionneur": {
                                            "type": "string",
                                            "description": "Nom Tiers cautionneur"
                                        },
                                        "caut_titulaire": {
                                            "type": "string",
                                            "description": "Nom du tiers titulaire"
                                        },
                                        "caut_type": {
                                            "type": "string",
                                            "description": "Type de caution",
                                            "enumId": "DPTypeCaution"
                                        },
                                        "caut_retenue": {
                                            "type": "string",
                                            "description": "Retenue"
                                        },
                                        "caut_nature": {
                                            "type": "string",
                                            "description": "Nature de caution",
                                            "enumId": "DPContratCaution.portee"
                                        },
                                        "caut_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de la caution"
                                        },
                                        "caut_dtFinValid": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Fin de validité de la caution"
                                        },
                                        "caut_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant de la caution TTC"
                                        },
                                        "caut_statut": {
                                            "type": "string",
                                            "description": "Statut de la caution",
                                            "enumId": "DPContratCaution.statut"
                                        },
                                        "caut_dtRecep": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de réception"
                                        },
                                        "caut_dtAccep": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date d'acceptation"
                                        },
                                        "caut_dtRefus": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de refus"
                                        },
                                        "caut_dtMainLeveeTot": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de main levée totale"
                                        },
                                        "caut_prcMainLevee": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "% main levée"
                                        },
                                        "caut_cmnt": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        }
                                    }
                                }
                            },
                            "sous_traitants": {
                                "type": "array",
                                "description": "Liste des sous-traitants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "st_sousTraitant": {
                                            "type": "string",
                                            "description": "Nom Tiers sous-traitant"
                                        },
                                        "st_titulaire": {
                                            "type": "string",
                                            "description": "Nom du tiers titulaire"
                                        },
                                        "st_formeJuridique": {
                                            "type": "string",
                                            "description": "Forme juridique sous-traitant",
                                            "codif": "FormeJuridique"
                                        },
                                        "st_capital": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Capital social sous-traitant"
                                        },
                                        "st_tribunalComm": {
                                            "type": "string",
                                            "description": "Tribunal de commerce du tiers sous-traitant"
                                        },
                                        "st_rcs": {
                                            "type": "string",
                                            "description": "Numéro RCS du tiers sous-traitant"
                                        },
                                        "st_rep_civilite": {
                                            "type": "string",
                                            "description": "Civilité du Représentant principal sous-traitant",
                                            "codif": "Civilite"
                                        },
                                        "st_rep_prenom": {
                                            "type": "string",
                                            "description": "Prénom du Représentant principal sous-traitant"
                                        },
                                        "st_rep_nom": {
                                            "type": "string",
                                            "description": "Nom du Représentant principal sous-traitant"
                                        },
                                        "st_rep_fonction": {
                                            "type": "string",
                                            "description": "Fonction du Représentant principal sous-traitant"
                                        },
                                        "st_rep_mail": {
                                            "type": "string",
                                            "description": "Courriel du Représentant principal sous-traitant"
                                        },
                                        "st_rep_phone": {
                                            "type": "string",
                                            "description": "Téléphone du Représentant principal sous-traitant"
                                        },
                                        "st_adr_remise": {
                                            "type": "string",
                                            "description": "Adresse nom remisé sous-traitant"
                                        },
                                        "st_adr_voie": {
                                            "type": "string",
                                            "description": "Adresse nom voie sous-traitant"
                                        },
                                        "st_adr_complement": {
                                            "type": "string",
                                            "description": "Adresse complement sous-traitant"
                                        },
                                        "st_adr_codePostal": {
                                            "type": "string",
                                            "description": "Adresse code postal sous-traitant"
                                        },
                                        "st_adr_localite": {
                                            "type": "string",
                                            "description": "Adresse localité sous-traitant"
                                        },
                                        "st_siret": {
                                            "type": "string",
                                            "description": "SIRET du tiers sous-traitant"
                                        },
                                        "st_ape": {
                                            "type": "string",
                                            "description": "APE du tiers sous-traitant"
                                        },
                                        "st_dtSign": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de signature"
                                        },
                                        "st_libActe": {
                                            "type": "string",
                                            "description": "Libellé de l'acte"
                                        },
                                        "st_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT (acte + avenant)"
                                        },
                                        "st_tauxTva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA"
                                        },
                                        "st_tvaAuto": {
                                            "type": "boolean",
                                            "description": "TVA autoliquidée"
                                        },
                                        "st_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA (acte + avenant)"
                                        },
                                        "st_mntTvaAuto": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA autoliquidée (acte + avenant)"
                                        },
                                        "st_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC (acte + avenant)"
                                        },
                                        "st_condPaie": {
                                            "type": "string",
                                            "description": "Conditions de paiement : direct / indirect",
                                            "enumId": "DPContratST.condPaie"
                                        },
                                        "st_modeReg": {
                                            "type": "string",
                                            "description": "Mode de paiement",
                                            "enumId": "DPModeReglement"
                                        },
                                        "st_libRib": {
                                            "type": "string",
                                            "description": "Nom sous-traitant RIB"
                                        },
                                        "st_iban": {
                                            "type": "string",
                                            "description": "Numero de compte RIB sous-traitant"
                                        },
                                        "st_banque": {
                                            "type": "string",
                                            "description": "Banque sous-traitant du RIB"
                                        },
                                        "st_statut": {
                                            "type": "string",
                                            "description": "Statut de l'acte",
                                            "enumId": "DPContratST.statut"
                                        },
                                        "st_dtRecep": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de réception"
                                        },
                                        "st_modeRecep": {
                                            "type": "string",
                                            "description": "Mode de réception",
                                            "codif": "DPDelegModeRcpt"
                                        },
                                        "st_dtAccep": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date d'acceptation"
                                        },
                                        "st_dtRefus": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de refus"
                                        },
                                        "st_dtQuitus": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de quitus"
                                        },
                                        "st_cmnt": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        }
                                    }
                                }
                            },
                            "delegations": {
                                "type": "array",
                                "description": "Liste des délégations",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "deleg_delegataire": {
                                            "type": "string",
                                            "description": "Nom délégataire"
                                        },
                                        "deleg_fournisseur": {
                                            "type": "string",
                                            "description": "Nom du tiers fournisseur"
                                        },
                                        "deleg_formeJuridique": {
                                            "type": "string",
                                            "description": "Forme juridique délégataire",
                                            "codif": "FormeJuridique"
                                        },
                                        "deleg_capital": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Capital social délégataire"
                                        },
                                        "deleg_tribunalComm": {
                                            "type": "string",
                                            "description": "Tribunal de commerce du délégataire"
                                        },
                                        "deleg_rcs": {
                                            "type": "string",
                                            "description": "Numéro RCS du délégataire "
                                        },
                                        "deleg_rep_civilite": {
                                            "type": "string",
                                            "description": "Civilité du Représentant principal délégataire",
                                            "codif": "Civilite"
                                        },
                                        "deleg_rep_prenom": {
                                            "type": "string",
                                            "description": "Prénom du Représentant principal délégataire"
                                        },
                                        "deleg_rep_nom": {
                                            "type": "string",
                                            "description": "Nom du Représentant principal délégataire"
                                        },
                                        "deleg_adr_remise": {
                                            "type": "string",
                                            "description": "Adresse nom remise délégataire"
                                        },
                                        "deleg_adr_voie": {
                                            "type": "string",
                                            "description": "Adresse nom voie délégataire"
                                        },
                                        "deleg_adr_complement": {
                                            "type": "string",
                                            "description": "Adresse complement délégataire"
                                        },
                                        "deleg_adr_codePostal": {
                                            "type": "string",
                                            "description": "Adresse code postal délégataire"
                                        },
                                        "deleg_adr_localite": {
                                            "type": "string",
                                            "description": "Adresse localité délégataire"
                                        },
                                        "deleg_iban": {
                                            "type": "string",
                                            "description": "IBAN du tiers délégataire"
                                        },
                                        "deleg_bic": {
                                            "type": "string",
                                            "description": "BIC du tiers délégataire"
                                        },
                                        "deleg_type": {
                                            "type": "string",
                                            "description": "Type de délégation",
                                            "enumId": "DPDelegPaie.typeDeleg"
                                        },
                                        "deleg_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de la délégation"
                                        },
                                        "deleg_dateButoir": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date butoir"
                                        },
                                        "deleg_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "deleg_portee": {
                                            "type": "string",
                                            "description": "Portée de la délégation",
                                            "enumId": "DPDelegPaie.portee"
                                        },
                                        "deleg_statut": {
                                            "type": "string",
                                            "description": "Statut",
                                            "enumId": "DPDelegPaie.statut"
                                        },
                                        "deleg_dtRecep": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de réception"
                                        },
                                        "deleg_modeRecep": {
                                            "type": "string",
                                            "description": "Mode de réception",
                                            "codif": "DPDelegModeRcpt"
                                        },
                                        "deleg_dtAccep": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date d'acceptation"
                                        },
                                        "deleg_mntAccep": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC accepté"
                                        },
                                        "deleg_dtRefus": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de refus"
                                        },
                                        "deleg_motifRefus": {
                                            "type": "string",
                                            "description": "Motif de refus"
                                        },
                                        "deleg_cmnt": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        }
                                    }
                                }
                            },
                            "avenants": {
                                "type": "array",
                                "description": "Liste des avenants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "av_lib": {
                                            "type": "string",
                                            "description": "Libellé de l'avenant",
                                            "version": "18.0"
                                        },
                                        "av_numero": {
                                            "type": "string",
                                            "description": "Numéro de l'avenant",
                                            "version": "18.0"
                                        },
                                        "av_statut": {
                                            "type": "string",
                                            "description": "Statut de l'avenant",
                                            "enumId": "DPStatutContrat",
                                            "version": "18.0"
                                        },
                                        "av_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de l'avenant",
                                            "version": "18.0"
                                        },
                                        "av_notif": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Notification de l'avenant",
                                            "version": "18.0"
                                        },
                                        "av_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de avenant",
                                            "version": "18.0"
                                        },
                                        "av_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de avenant",
                                            "version": "18.0"
                                        },
                                        "av_mntHT_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant HT de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "av_mntTTC_lettres": {
                                            "type": "string",
                                            "format": "number-letters",
                                            "description": "Montant TTC de avenant en toutes lettres",
                                            "version": "18.0"
                                        },
                                        "av_tauxTVA": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Taux de TVA de avenant",
                                            "version": "18.0"
                                        },
                                        "av_mntTVA": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de avenant",
                                            "version": "18.0"
                                        },
                                        "av_cmnt": {
                                            "type": "string",
                                            "description": "commentaire de l'avenant",
                                            "version": "18.0"
                                        }
                                    }
                                }
                            },
                            "tranchesCond": {
                                "type": "array",
                                "description": "Liste des tranches conditionnelles",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tco_lib": {
                                            "type": "string",
                                            "description": "Libellé TC"
                                        },
                                        "tco_affermie": {
                                            "type": "boolean",
                                            "description": "TC Affermie"
                                        },
                                        "tco_dateOS": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date OS TC"
                                        },
                                        "tco_dateNotif": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date notification TC"
                                        },
                                        "tco_delaiExec": {
                                            "type": "integer",
                                            "description": "Délai exécution TC"
                                        }
                                    }
                                }
                            },
                            "affectations": {
                                "type": "array",
                                "description": "Liste des affectations budgétaires du marché",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "af_libPoste": {
                                            "type": "string",
                                            "description": "Poste"
                                        },
                                        "af_codePoste": {
                                            "type": "string",
                                            "description": "Code poste"
                                        },
                                        "af_tiers": {
                                            "type": "string",
                                            "description": "Tiers"
                                        },
                                        "af_engageHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé HT"
                                        },
                                        "af_engageTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Engagé TTC"
                                        },
                                        "af_factureHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Facturé HT"
                                        },
                                        "af_factureTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Facturé TTC"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "PaieFournisseur": {
        "schemas": {
            "type": "object",
            "properties": {
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Paie Fournisseur",
                    "items": {
                        "type": "object",
                        "properties": {
                            "operation_code": {
                                "type": "string",
                                "description": "code opération"
                            },
                            "operation_lib": {
                                "type": "string",
                                "description": "libellé opération"
                            },
                            "operation_nomCom": {
                                "type": "string",
                                "description": "nom commercial opération"
                            },
                            "operation_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé opération"
                            },
                            "operation_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie opération"
                            },
                            "operation_adr_complement": {
                                "type": "string",
                                "description": "adresse complement opération"
                            },
                            "operation_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal opération"
                            },
                            "operation_adr_localite": {
                                "type": "string",
                                "description": "adresse localité opération"
                            },
                            "operation_adr_pays": {
                                "type": "string",
                                "description": "adresse pays opération"
                            },
                            "lotPaie_etablisCB": {
                                "type": "string",
                                "description": "Etablissement bancaire de la société"
                            },
                            "lotPaie_iban": {
                                "type": "string",
                                "description": "IBAN du compte bancaire associé au lot de paiement"
                            },
                            "cb_banque": {
                                "type": "string",
                                "description": "Libellé du Tiers Banque"
                            },
                            "cb_banque_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie du Tiers Banque"
                            },
                            "cb_banque_adr_complement": {
                                "type": "string",
                                "description": "adresse complément du Tiers Banque"
                            },
                            "cb_banque_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal du Tiers Banque"
                            },
                            "cb_banque_adr_localite": {
                                "type": "string",
                                "description": "adresse localité du Tiers Banque"
                            },
                            "lotPaie_datePaie": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de paiement"
                            },
                            "lotPaie_modePaie": {
                                "type": "string",
                                "description": "Mode de paiement",
                                "enumId": "DPLotPaie.modPaie"
                            },
                            "lotPaie_four_lib": {
                                "type": "string",
                                "description": "Tiers Fournisseur"
                            },
                            "lotPaie_four_civilite": {
                                "type": "string",
                                "description": "civilité du représentant principal du tiers fournisseur",
                                "codif": "Civilite"
                            },
                            "lotPaie_four_nom": {
                                "type": "string",
                                "description": "nom du représentant principal du tiers fournisseur"
                            },
                            "lotPaie_four_prenom": {
                                "type": "string",
                                "description": "prénom du représentant principal du tiers fournisseur"
                            },
                            "lotPaie_four_iban": {
                                "type": "string",
                                "description": "IBAN du tiers"
                            },
                            "lotPaie_four_bic": {
                                "type": "string",
                                "description": "BIC du Tiers"
                            },
                            "lotPaie_four_etablis": {
                                "type": "string",
                                "description": "Etablissement bancaire du Tiers"
                            },
                            "lotPaie_four_formeJuri": {
                                "type": "string",
                                "description": "forme Juridique du tiers fournisseur"
                            },
                            "lotPaie_four_refCompta": {
                                "type": "string",
                                "description": "Référence comptable Fournisseur"
                            },
                            "lotPaie_four_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé tiers fournisseur"
                            },
                            "lotPaie_four_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie tiers fournisseur"
                            },
                            "lotPaie_four_adr_complement": {
                                "type": "string",
                                "description": "adresse complement tiers fournisseur"
                            },
                            "lotPaie_four_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal tiers fournisseur"
                            },
                            "lotPaie_four_adr_localite": {
                                "type": "string",
                                "description": "adresse localité tiers fournisseur"
                            },
                            "lotPaie_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants HT des factures"
                            },
                            "lotPaie_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants TTC des factures"
                            },
                            "lotPaie_mntTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants TVA des factures"
                            },
                            "lotPaie_mntAutoriseTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants autorisés TTC des factures"
                            },
                            "lotPaie_mntPaieTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Total des montants paiement TTC des factures"
                            },
                            "lotPaie_soldeAPayerTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde à payer TTC des factures"
                            },
                            "factures": {
                                "type": "array",
                                "description": "Liste des factures et des situations",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "fact_eng_ref": {
                                            "type": "string",
                                            "description": "Ref. engagement"
                                        },
                                        "fact_eng_lib": {
                                            "type": "string",
                                            "description": "Engagement"
                                        },
                                        "fact_op_lib": {
                                            "type": "string",
                                            "description": "Libellé opération"
                                        },
                                        "fact_op_code": {
                                            "type": "string",
                                            "description": "Code opération"
                                        },
                                        "fact_lib": {
                                            "type": "string",
                                            "description": "Facture / situation"
                                        },
                                        "fact_num": {
                                            "type": "string",
                                            "description": "Numéro Facture / Situation"
                                        },
                                        "fact_code": {
                                            "type": "string",
                                            "description": "Code Facture / Situation"
                                        },
                                        "fact_roleTiers": {
                                            "type": "string",
                                            "description": "Rôle tiers Facture",
                                            "enumId": "DPLotPaieFact.roleTiers"
                                        },
                                        "fact_numRefRegle": {
                                            "type": "string",
                                            "description": "Référence du règlement"
                                        },
                                        "fact_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date facture ou de la situation"
                                        },
                                        "fact_dateEch": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date échéance"
                                        },
                                        "fact_dtEchLCR": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date d'échéance LCR"
                                        },
                                        "fact_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de la facture"
                                        },
                                        "fact_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de la facture"
                                        },
                                        "fact_mntTVA": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de la facture"
                                        },
                                        "fact_mntAutoriseTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant autorisé TTC de facture ou situation"
                                        },
                                        "fact_soldeAPayerTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Solde à payer TTC"
                                        },
                                        "fact_mntPaieTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant paiement TTC"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "Prelevement": {
        "schemas": {
            "type": "object",
            "properties": {
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Prélèvement",
                    "items": {
                        "type": "object",
                        "properties": {
                            "dtPrelev": {
                                "type": "string",
                                "format": "date",
                                "description": "Date prélèvement"
                            },
                            "lib": {
                                "type": "string",
                                "description": "Libellé du prélèvement"
                            },
                            "typeOperation": {
                                "type": "string",
                                "description": "Virement ou Prélèvement",
                                "enumId": "RVPrelev.typeOperat"
                            },
                            "iban": {
                                "type": "string",
                                "description": "IBAN de la société"
                            },
                            "bic": {
                                "type": "string",
                                "description": "BIC de la société"
                            },
                            "banque": {
                                "type": "string",
                                "description": "Etablissement bancaire de la société"
                            },
                            "nb": {
                                "type": "integer",
                                "description": "Nombre de prélèvement"
                            },
                            "mntTotal": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total prélevé"
                            },
                            "details": {
                                "type": "array",
                                "description": "détails",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "pd_refComptaOp": {
                                            "type": "string",
                                            "description": "Référence comptable opération"
                                        },
                                        "pd_libOp": {
                                            "type": "string",
                                            "description": "Libellé opération"
                                        },
                                        "pd_codeDossier": {
                                            "type": "string",
                                            "description": "Code dossier client"
                                        },
                                        "pd_libDossier": {
                                            "type": "string",
                                            "description": "Libellé dossier client"
                                        },
                                        "pd_ibanTiers": {
                                            "type": "string",
                                            "description": "IBAN du tiers"
                                        },
                                        "pd_bicTiers": {
                                            "type": "string",
                                            "description": "BIC du tiers"
                                        },
                                        "pd_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant prélevé"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "Quittancement": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Quittancement",
                    "items": {
                        "type": "object",
                        "properties": {
                            "tiers_lib": {
                                "type": "string",
                                "description": "civilité + prenom + nom du tiers"
                            },
                            "tiers_civilite": {
                                "type": "string",
                                "description": "civilité du tiers",
                                "codif": "Civilite"
                            },
                            "tiers_refCompta": {
                                "type": "string",
                                "description": "Référence comptable du tiers"
                            },
                            "tiers_adr_remise": {
                                "type": "string",
                                "description": "Point de remise du tiers"
                            },
                            "tiers_adr_voie": {
                                "type": "string",
                                "description": "Nom de voie du tiers"
                            },
                            "tiers_adr_compl": {
                                "type": "string",
                                "description": "Complément adresse du tiers"
                            },
                            "tiers_adr_distrib": {
                                "type": "string",
                                "description": "Boite postale ou point de distribution du tiers"
                            },
                            "tiers_adr_codePostal": {
                                "type": "string",
                                "description": "Code postal du tiers"
                            },
                            "tiers_adr_localite": {
                                "type": "string",
                                "description": "Localité du tiers"
                            },
                            "tiers_libRib": {
                                "type": "string",
                                "description": "Titulaire du compte bancaire du tiers"
                            },
                            "tiers_iban": {
                                "type": "string",
                                "description": "IBAN du tiers"
                            },
                            "tiers_bic": {
                                "type": "string",
                                "description": "BIC du tiers"
                            },
                            "mandat_ics": {
                                "type": "string",
                                "description": "ICS du mandat de prélèvement"
                            },
                            "mandat_rum": {
                                "type": "string",
                                "description": "RUM du mandat de prélèvement"
                            },
                            "psla_dtAgremDef": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de l'agrément définitif"
                            },
                            "psla_dtAgremProv": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'obtention de l'agrément provisoire"
                            },
                            "dc_numContrat": {
                                "type": "string",
                                "description": "Numéro de contrat"
                            },
                            "dc_dtSignLocation": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du contrat de location"
                            },
                            "dc_dtEntree": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'entrée dans les lieux"
                            },
                            "dc_dtLimiteLevOpt": {
                                "type": "string",
                                "format": "date",
                                "description": "Date limite de levée d'option"
                            },
                            "dc_dtMinLevOpt": {
                                "type": "string",
                                "format": "date",
                                "description": "Date minimum de levée d'option"
                            },
                            "dc_dtDemandeLevOpt": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de demande de levée d'option"
                            },
                            "dc_loyerMens": {
                                "type": "number",
                                "format": "money",
                                "description": "Part locative"
                            },
                            "dc_partAcquiMens": {
                                "type": "number",
                                "format": "money",
                                "description": "Part acquisitive"
                            },
                            "dc_redevance": {
                                "type": "number",
                                "format": "money",
                                "description": "Redevance"
                            },
                            "dc_modeRegle": {
                                "type": "string",
                                "description": "Mode de règlement",
                                "enumId": "ModeReglement"
                            },
                            "dc_lib": {
                                "type": "string",
                                "description": "Libellé du dossier client"
                            },
                            "dc_numLot": {
                                "type": "string",
                                "description": "N° du lot"
                            },
                            "dc_cumulPartAcquiRegle": {
                                "type": "number",
                                "format": "money",
                                "description": "Part acquisitive réglée cumulée"
                            },
                            "ech_numQuittance": {
                                "type": "string",
                                "description": "Numéro de quittance"
                            },
                            "ech_dtQuittance": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de la quittance"
                            },
                            "ech_dtEch": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de l'échéance"
                            },
                            "ech_dtPrelev": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de prélèvement"
                            },
                            "ech_statut": {
                                "type": "string",
                                "description": "Statut de l'échéance",
                                "enumId": "RVDossierLoyer.statut"
                            },
                            "ech_loyer": {
                                "type": "number",
                                "format": "money",
                                "description": "Part locative de l'échéance"
                            },
                            "ech_partAcqui": {
                                "type": "number",
                                "format": "money",
                                "description": "Part acquisitive  de l'échéance"
                            },
                            "ech_redevance": {
                                "type": "number",
                                "format": "money",
                                "description": "Redevance de l'échéance"
                            },
                            "ech_charges": {
                                "type": "number",
                                "format": "money",
                                "description": "Autres charges de l'échéance"
                            },
                            "ech_frais": {
                                "type": "number",
                                "format": "money",
                                "description": "Frais de l'échéance"
                            },
                            "ech_dg": {
                                "type": "number",
                                "format": "money",
                                "description": "Dépôt de garantie à déduire de l'échéance"
                            },
                            "ech_mntEch": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant de l'échéance"
                            },
                            "ech_soldeAnte": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde arrêté échéance"
                            },
                            "ech_aPayer": {
                                "type": "number",
                                "format": "money",
                                "description": "Total à payer de l'échéance"
                            },
                            "ech_dtReglePrevu": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de règlement prévu de l'échéance"
                            },
                            "ech_debutPeriode": {
                                "type": "string",
                                "format": "date",
                                "description": "Date début de période"
                            },
                            "ech_finPeriode": {
                                "type": "string",
                                "format": "date",
                                "description": "Date fin de période"
                            },
                            "echp_soldeAnte": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde arrêté échéance précédente",
                                "version": "18.3"
                            },
                            "echp_dtQuittance": {
                                "type": "string",
                                "format": "date",
                                "description": "Date échéance précédente",
                                "version": "18.3"
                            },
                            "echp_loyer": {
                                "type": "number",
                                "format": "money",
                                "description": "Part locative échéance précédente",
                                "version": "18.3"
                            },
                            "echp_partAcqui": {
                                "type": "number",
                                "format": "money",
                                "description": "Part acquisitive échéance précédente",
                                "version": "18.3"
                            },
                            "echp_redevance": {
                                "type": "number",
                                "format": "money",
                                "description": "Redevance échéance précédente",
                                "version": "18.3"
                            },
                            "echp_dg": {
                                "type": "number",
                                "format": "money",
                                "description": "Dépôt de garantie à déduire échéance précédente",
                                "version": "18.3"
                            },
                            "dg_initial": {
                                "type": "number",
                                "format": "money",
                                "description": "Dépôt de garantie initial"
                            },
                            "dg_deduit": {
                                "type": "number",
                                "format": "money",
                                "description": "Dépôt de garantie déduit"
                            },
                            "dg_restant": {
                                "type": "number",
                                "format": "money",
                                "description": "Dépôt de garantie restant"
                            },
                            "enc_dtRejet": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de rejet"
                            },
                            "enc_motifRejet": {
                                "type": "string",
                                "description": "Motif de rejet",
                                "codif": "MotifRejetEncaisse"
                            },
                            "encaissements": {
                                "type": "array",
                                "description": "Encaissements depuis l'avis précédent",
                                "version": "18.3",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "e_date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de l'encaissement",
                                            "version": "18.3"
                                        },
                                        "e_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant de l'encaissement",
                                            "version": "18.3"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "SchemaComptable": {
        "schemas": {
            "type": "object",
            "properties": {
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Schema Comptable",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code_schema": {
                                "type": "string",
                                "description": "Code du schema"
                            },
                            "evt": {
                                "type": "string",
                                "description": "Evènement"
                            },
                            "typeComm": {
                                "type": "string",
                                "description": "Type de commercialisation",
                                "codif": "TypeComm"
                            },
                            "methode": {
                                "type": "string",
                                "description": "Méthode comptable",
                                "codif": "ECMCompta"
                            },
                            "regFisc": {
                                "type": "string",
                                "description": "Régime fiscal",
                                "codif": "ECRegFisc"
                            },
                            "avancement": {
                                "type": "string",
                                "description": "Avancement travaux",
                                "codif": "BudEtape2"
                            },
                            "journal": {
                                "type": "string",
                                "description": "Code journal"
                            },
                            "journalReaff": {
                                "type": "string",
                                "description": "Code journalReaff"
                            },
                            "libType": {
                                "type": "string",
                                "description": "Libellé Type"
                            },
                            "lignes": {
                                "type": "array",
                                "description": "Liste des montants du marché",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "num": {
                                            "type": "string",
                                            "description": "Numéro"
                                        },
                                        "temoinSP": {
                                            "type": "string",
                                            "description": "Témoin sous pièce"
                                        },
                                        "compte": {
                                            "type": "string",
                                            "description": "Compte général",
                                            "enumId": "Tools.typeCompte"
                                        },
                                        "ana": {
                                            "type": "string",
                                            "description": "Compte analytique",
                                            "codif": "ECAnalytiqueP"
                                        },
                                        "eclatement": {
                                            "type": "string",
                                            "description": "eclatement"
                                        },
                                        "aux": {
                                            "type": "string",
                                            "description": "Compte auxiliaire",
                                            "codif": "ECAuxiliaire"
                                        },
                                        "debit": {
                                            "type": "string",
                                            "description": "Montant débit",
                                            "enumId": "Tools.SCMntEcrit"
                                        },
                                        "credit": {
                                            "type": "string",
                                            "description": "Montant crédit",
                                            "enumId": "Tools.SCMntEcrit"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "SousTraitance": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Sous Traitance",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code sous traitant"
                            },
                            "marche_lib": {
                                "type": "string",
                                "description": "Libellé du marché"
                            },
                            "marche_code": {
                                "type": "string",
                                "description": "Code du marché"
                            },
                            "marche_num": {
                                "type": "string",
                                "description": "Numéro du marché"
                            },
                            "marche_mntInitialHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial HT du marché"
                            },
                            "marche_mntInitialTVA": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TVA du marché"
                            },
                            "marche_mntInitialTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant initial TTC du marché"
                            },
                            "marche_dtSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature du marché"
                            },
                            "marche_dtNotif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de notification du marché"
                            },
                            "marche_dtOS": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réelle d'OS1 du marché"
                            },
                            "titulaire_lib": {
                                "type": "string",
                                "description": "Nom titulaire"
                            },
                            "titulaire_formeJuridique": {
                                "type": "string",
                                "description": "Forme juridique titulaire",
                                "codif": "FormeJuridique"
                            },
                            "titulaire_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "Capital social titulaire"
                            },
                            "titulaire_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers titulaire"
                            },
                            "titulaire_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers titulaire"
                            },
                            "titulaire_rep_civilite": {
                                "type": "string",
                                "description": "Civilité du Représentant principal titulaire",
                                "codif": "Civilite"
                            },
                            "titulaire_rep_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal titulaire"
                            },
                            "titulaire_rep_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal titulaire"
                            },
                            "titulaire_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du représentant principal titulaire"
                            },
                            "titulaire_rep_mail": {
                                "type": "string",
                                "description": "Courriel du représentant principal titulaire"
                            },
                            "titulaire_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du représentant principal titulaire"
                            },
                            "titulaire_adr_remise": {
                                "type": "string",
                                "description": "Adresse nom remisé titulaire"
                            },
                            "titulaire_adr_voie": {
                                "type": "string",
                                "description": "Adresse nom voie titulaire"
                            },
                            "titulaire_adr_complement": {
                                "type": "string",
                                "description": "Adresse complement titulaire"
                            },
                            "titulaire_adr_codePostal": {
                                "type": "string",
                                "description": "Adresse code postal titulaire"
                            },
                            "titulaire_adr_localite": {
                                "type": "string",
                                "description": "Adresse localité titulaire"
                            },
                            "titulaire_siret": {
                                "type": "string",
                                "description": "SIRET du tiers titulaire"
                            },
                            "titulaire_ape": {
                                "type": "string",
                                "description": "APE du tiers titulaire"
                            },
                            "titulaire_libRib": {
                                "type": "string",
                                "description": "Nom titulaire RIB"
                            },
                            "titulaire_iban": {
                                "type": "string",
                                "description": "Numero de compte RIB titulaire"
                            },
                            "titulaire_banque": {
                                "type": "string",
                                "description": "Banque titulaire du RIB"
                            },
                            "titulaire_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant1"
                            },
                            "titulaire_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant2"
                            },
                            "titulaire_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant3"
                            },
                            "titulaire_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant4"
                            },
                            "titulaire_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers montant5"
                            },
                            "titulaire_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal1"
                            },
                            "titulaire_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal2"
                            },
                            "titulaire_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal3"
                            },
                            "titulaire_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal4"
                            },
                            "titulaire_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur tiers decimal5"
                            },
                            "titulaire_entier1": {
                                "type": "number",
                                "description": "Valeur tiers entier1"
                            },
                            "titulaire_entier2": {
                                "type": "number",
                                "description": "Valeur tiers entier2"
                            },
                            "titulaire_entier3": {
                                "type": "number",
                                "description": "Valeur tiers entier3"
                            },
                            "titulaire_entier4": {
                                "type": "number",
                                "description": "Valeur tiers entier4"
                            },
                            "titulaire_entier5": {
                                "type": "number",
                                "description": "Valeur tiers entier5"
                            },
                            "titulaire_flag1": {
                                "type": "boolean",
                                "description": "Valeur tiers flag1"
                            },
                            "titulaire_flag2": {
                                "type": "boolean",
                                "description": "Valeur tiers flag2"
                            },
                            "titulaire_flag3": {
                                "type": "boolean",
                                "description": "Valeur tiers flag3"
                            },
                            "titulaire_flag4": {
                                "type": "boolean",
                                "description": "Valeur tiers flag4"
                            },
                            "titulaire_flag5": {
                                "type": "boolean",
                                "description": "Valeur tiers flag5"
                            },
                            "titulaire_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date1"
                            },
                            "titulaire_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date2"
                            },
                            "titulaire_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date3"
                            },
                            "titulaire_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date4"
                            },
                            "titulaire_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur tiers date5"
                            },
                            "titulaire_texte1": {
                                "type": "string",
                                "description": "Valeur tiers texte1"
                            },
                            "titulaire_texte2": {
                                "type": "string",
                                "description": "Valeur tiers texte2"
                            },
                            "titulaire_texte3": {
                                "type": "string",
                                "description": "Valeur tiers texte3"
                            },
                            "titulaire_texte4": {
                                "type": "string",
                                "description": "Valeur tiers texte4"
                            },
                            "titulaire_texte5": {
                                "type": "string",
                                "description": "Valeur tiers texte5"
                            },
                            "titulaire_codif1": {
                                "type": "string",
                                "description": "Valeur tiers codif1",
                                "codif": "SpoTiers_codif1"
                            },
                            "titulaire_codif2": {
                                "type": "string",
                                "description": "Valeur tiers codif2",
                                "codif": "SpoTiers_codif2"
                            },
                            "titulaire_codif3": {
                                "type": "string",
                                "description": "Valeur tiers codif3",
                                "codif": "SpoTiers_codif3"
                            },
                            "titulaire_codif4": {
                                "type": "string",
                                "description": "Valeur tiers codif4",
                                "codif": "SpoTiers_codif4"
                            },
                            "titulaire_codif5": {
                                "type": "string",
                                "description": "Valeur tiers codif5",
                                "codif": "SpoTiers_codif5"
                            },
                            "sousTrait_lib": {
                                "type": "string",
                                "description": "Nom Tiers sous-traitant"
                            },
                            "sousTrait_formeJuridique": {
                                "type": "string",
                                "description": "Forme juridique sous-traitant",
                                "codif": "FormeJuridique"
                            },
                            "sousTrait_capital": {
                                "type": "number",
                                "format": "money",
                                "description": "Capital social sous-traitant"
                            },
                            "sousTrait_tribunalComm": {
                                "type": "string",
                                "description": "Tribunal de commerce du tiers sous-traitant"
                            },
                            "sousTrait_rcs": {
                                "type": "string",
                                "description": "Numéro RCS du tiers sous-traitant"
                            },
                            "sousTrait_rep_civilite": {
                                "type": "string",
                                "description": "Civilité du Représentant principal sous-traitant",
                                "codif": "Civilite"
                            },
                            "sousTrait_rep_prenom": {
                                "type": "string",
                                "description": "Prénom du Représentant principal sous-traitant"
                            },
                            "sousTrait_rep_nom": {
                                "type": "string",
                                "description": "Nom du Représentant principal sous-traitant"
                            },
                            "sousTrait_rep_fonction": {
                                "type": "string",
                                "description": "Fonction du Représentant principal sous-traitant"
                            },
                            "sousTrait_rep_mail": {
                                "type": "string",
                                "description": "Courriel du Représentant principal sous-traitant"
                            },
                            "sousTrait_rep_phone": {
                                "type": "string",
                                "description": "Téléphone du Représentant principal sous-traitant"
                            },
                            "sousTrait_adr_remise": {
                                "type": "string",
                                "description": "Adresse nom remisé sous-traitant"
                            },
                            "sousTrait_adr_voie": {
                                "type": "string",
                                "description": "Adresse nom voie sous-traitant"
                            },
                            "sousTrait_adr_complement": {
                                "type": "string",
                                "description": "Adresse complement sous-traitant"
                            },
                            "sousTrait_adr_codePostal": {
                                "type": "string",
                                "description": "Adresse code postal sous-traitant"
                            },
                            "sousTrait_adr_localite": {
                                "type": "string",
                                "description": "Adresse localité sous-traitant"
                            },
                            "sousTrait_siret": {
                                "type": "string",
                                "description": "SIRET du tiers sous-traitant"
                            },
                            "sousTrait_ape": {
                                "type": "string",
                                "description": "APE du tiers sous-traitant"
                            },
                            "acte_dtSign": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de signature"
                            },
                            "acte_lib": {
                                "type": "string",
                                "description": "Libellé"
                            },
                            "acte_mntHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant HT"
                            },
                            "acte_tauxTva": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de TVA"
                            },
                            "acte_tvaAuto": {
                                "type": "boolean",
                                "description": "TVA autoliquidée"
                            },
                            "acte_mntTva": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant TVA"
                            },
                            "acte_mntTvaAuto": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant TVA autoliquidée"
                            },
                            "acte_mntTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant TTC"
                            },
                            "acte_condPaie": {
                                "type": "string",
                                "description": "Conditions de paiement : direct / indirect",
                                "enumId": "DPContratST.condPaie"
                            },
                            "acte_modeReg": {
                                "type": "string",
                                "description": "Mode de paiement",
                                "enumId": "DPModeReglement"
                            },
                            "sousTrait_libRib": {
                                "type": "string",
                                "description": "Nom sous-traitant RIB"
                            },
                            "sousTrait_iban": {
                                "type": "string",
                                "description": "Numero de compte RIB sous-traitant"
                            },
                            "sousTrait_banque": {
                                "type": "string",
                                "description": "Banque sous-traitant du RIB"
                            },
                            "acte_statut": {
                                "type": "string",
                                "description": "Statut de l'acte",
                                "enumId": "DPContratST.statut"
                            },
                            "acte_dtRecep": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de réception"
                            },
                            "acte_modeRecep": {
                                "type": "string",
                                "description": "Mode de réception",
                                "codif": "DPDelegModeRcpt"
                            },
                            "acte_dtAccep": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'acceptation"
                            },
                            "acte_dtRefus": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de refus"
                            },
                            "acte_dtQuitus": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de quitus"
                            },
                            "acte_cmnt": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "acte_totalHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total HT"
                            },
                            "acte_totalTva": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TVA"
                            },
                            "acte_totalTvaAuto": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TVA autoliquidée"
                            },
                            "acte_totalTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant total TTC"
                            },
                            "lots": {
                                "type": "array",
                                "description": "Liste des montants affectés par lot (initial + avenants)",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "lot_typeLot": {
                                            "type": "string",
                                            "description": "Type de lot"
                                        },
                                        "lot_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "lot_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        },
                                        "lot_mntTvaAuto": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA autoliquidée"
                                        },
                                        "lot_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        }
                                    }
                                }
                            },
                            "avenants": {
                                "type": "array",
                                "description": "Avenant sur sous-traitant",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "av_dtSign": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de signature de l'avenant"
                                        },
                                        "av_lib": {
                                            "type": "string",
                                            "description": "Libellé de l'avenant"
                                        },
                                        "av_mntHT": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT"
                                        },
                                        "av_mntTva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA"
                                        },
                                        "av_mntTvaAuto": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA autoliquidée"
                                        },
                                        "av_mntTTC": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC"
                                        },
                                        "av_cmnt": {
                                            "type": "string",
                                            "description": "Commentaire de l'avenant"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "SuiviDossier": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Facture recette",
                    "items": {
                        "type": "object",
                        "properties": {
                            "operation_procedure": {
                                "type": "string",
                                "description": "procédure opération"
                            },
                            "operation_uniteOrga": {
                                "type": "string",
                                "description": "unité organisation opération"
                            },
                            "operation_refInterne": {
                                "type": "string",
                                "description": "référence interne opération"
                            },
                            "operation_type": {
                                "type": "string",
                                "description": "type opération"
                            },
                            "operation_objet": {
                                "type": "string",
                                "description": "objet opération"
                            },
                            "operation_refCompta": {
                                "type": "string",
                                "description": "référence comptable opération"
                            },
                            "operation_refGed": {
                                "type": "string",
                                "description": "référence GED opération"
                            },
                            "operation_note": {
                                "type": "string",
                                "description": "note opération"
                            },
                            "operation_dtCreation": {
                                "type": "string",
                                "format": "date",
                                "description": "date création opération"
                            },
                            "operation_dtModification": {
                                "type": "string",
                                "format": "date",
                                "description": "date de dernière modification opération"
                            },
                            "lotP_nb": {
                                "type": "integer",
                                "description": "nombre total de lots principaux"
                            },
                            "nb_t1": {
                                "type": "integer",
                                "description": "nombre de T1"
                            },
                            "nb_t1bis": {
                                "type": "integer",
                                "description": "nombre de T1bis"
                            },
                            "nb_t2": {
                                "type": "integer",
                                "description": "nombre de T2"
                            },
                            "nb_t3": {
                                "type": "integer",
                                "description": "nombre de T3"
                            },
                            "nb_t4": {
                                "type": "integer",
                                "description": "nombre de T4"
                            },
                            "nb_t5": {
                                "type": "integer",
                                "description": "nombre de T5"
                            },
                            "nb_t6": {
                                "type": "integer",
                                "description": "nombre de T6"
                            },
                            "lotP_caHT": {
                                "type": "number",
                                "format": "money",
                                "description": "Chiffre d'affaire des lots principaux HT"
                            },
                            "lotP_caTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "Chiffre d'affaire des lots principaux TTC"
                            },
                            "shab": {
                                "type": "number",
                                "format": "money",
                                "description": "SHAB"
                            },
                            "su": {
                                "type": "number",
                                "format": "money",
                                "description": "SU"
                            },
                            "sdp": {
                                "type": "number",
                                "format": "money",
                                "description": "SDP"
                            },
                            "surfTerrain": {
                                "type": "number",
                                "format": "money",
                                "description": "surface terrain"
                            },
                            "surfParcelle": {
                                "type": "number",
                                "format": "money",
                                "description": "surface parcelle"
                            },
                            "surfAnnexe": {
                                "type": "number",
                                "format": "money",
                                "description": "surface annexes"
                            },
                            "lotS_nb": {
                                "type": "integer",
                                "description": "nombre total de lots secondaires"
                            },
                            "lotS_caHT": {
                                "type": "number",
                                "format": "money",
                                "description": "chiffre d'affaire des lots secondaires HT"
                            },
                            "lotS_caTTC": {
                                "type": "number",
                                "format": "money",
                                "description": "chiffre d'affaire des lots secondaires TTC"
                            },
                            "lotS_su": {
                                "type": "number",
                                "format": "money",
                                "description": "SU de lots secondaires"
                            },
                            "locatif_nbLoge": {
                                "type": "integer",
                                "description": "Nombre de logements total"
                            },
                            "locatif_logeParTypeOuvrage": {
                                "type": "string",
                                "description": "Synthèse logement par type d'ouvrage"
                            },
                            "locatif_logeParTypo": {
                                "type": "string",
                                "description": "Synthèse logement par typologie"
                            },
                            "locatif_shon": {
                                "type": "number",
                                "format": "money",
                                "description": "SHON de logement locatif"
                            },
                            "locatif_shob": {
                                "type": "number",
                                "format": "money",
                                "description": "SHOB de logement locatif"
                            },
                            "locatif_shab": {
                                "type": "number",
                                "format": "money",
                                "description": "SHAB de logement locatif"
                            },
                            "locatif_su": {
                                "type": "number",
                                "format": "money",
                                "description": "Surface utile de logement locatif"
                            },
                            "tt_code": {
                                "type": "string",
                                "description": "Code tranche travaux"
                            },
                            "tt_lib": {
                                "type": "string",
                                "description": "libellé tranche travaux"
                            },
                            "tt_analytique": {
                                "type": "string",
                                "description": "code analytique tranche travaux"
                            },
                            "tt_avancement": {
                                "type": "string",
                                "description": "avancement tranche travaux",
                                "codif": "BudEtape2"
                            },
                            "tt_active": {
                                "type": "string",
                                "description": "oui/non tranche travaux"
                            },
                            "tt_natureTravaux": {
                                "type": "string",
                                "description": "nature de travaux de tranche travaux"
                            },
                            "tt_surfTerrain": {
                                "type": "number",
                                "format": "money",
                                "description": "surface de terrain en m2 de tranche travaux"
                            },
                            "tc_code": {
                                "type": "string",
                                "description": "code tranche commerciale"
                            },
                            "tc_lib": {
                                "type": "string",
                                "description": "libellé tranche commerciale"
                            },
                            "tc_nomCom": {
                                "type": "string",
                                "description": "nom commercial tranche commerciale"
                            },
                            "tc_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé tranche commerciale"
                            },
                            "tc_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie tranche commerciale"
                            },
                            "tc_adr_complement": {
                                "type": "string",
                                "description": "adresse complement tranche commerciale"
                            },
                            "tc_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal tranche commerciale"
                            },
                            "tc_adr_localite": {
                                "type": "string",
                                "description": "adresse localité tranche commerciale"
                            },
                            "tc_analytique": {
                                "type": "string",
                                "description": "code analytique tranche commerciale"
                            },
                            "tc_typeOuvrage": {
                                "type": "string",
                                "description": "type ouvrage tranche commerciale"
                            },
                            "tc_typeCom": {
                                "type": "string",
                                "description": "type commercialisation tranche commerciale",
                                "codif": "TypeComm"
                            },
                            "tc_regimeFiscal": {
                                "type": "string",
                                "description": "régime fiscal tranche commerciale"
                            },
                            "tc_tva": {
                                "type": "number",
                                "format": "rate",
                                "description": "taux de TVA tranche commerciale"
                            },
                            "tc_avancementCom": {
                                "type": "string",
                                "description": "avancement commercial tranche commerciale",
                                "codif": "StatutTrancheC"
                            },
                            "tc_posteBudgVente": {
                                "type": "string",
                                "description": "poste budgétaire vente tranche commerciale"
                            },
                            "tc_tvaMarge": {
                                "type": "boolean",
                                "description": "TVA sur marge tranche commerciale (oui/non)"
                            },
                            "tc_typeSurfBase": {
                                "type": "string",
                                "description": "type surface de base tranche commerciale",
                                "enumId": "OPNatureTravaux.typeSurfBase"
                            },
                            "tc_valSurfBase": {
                                "type": "number",
                                "format": "money",
                                "description": "valeur de la surface de base tranche commerciale"
                            },
                            "tc_typeSurfVendre": {
                                "type": "string",
                                "description": "type surface à vendre",
                                "codif": "TypeSurf"
                            },
                            "expediteur_lib": {
                                "type": "string",
                                "description": "expéditeur du courrier"
                            },
                            "destinataire_lib": {
                                "type": "string",
                                "description": "destinataire du courrier"
                            },
                            "destinataire_adr_remise": {
                                "type": "string",
                                "description": "adresse nom remisé destinaire du courrier"
                            },
                            "destinataire_adr_voie": {
                                "type": "string",
                                "description": "adresse nom voie destinaire du courrier"
                            },
                            "destinataire_adr_complement": {
                                "type": "string",
                                "description": "adresse complément destinaire du courrier"
                            },
                            "destinataire_adr_cp": {
                                "type": "string",
                                "description": "adresse code postal destinaire du courrier"
                            },
                            "destinataire_adr_localite": {
                                "type": "string",
                                "description": "adresse localité destinaire du courrier"
                            },
                            "destinataire_repres_civilite": {
                                "type": "string",
                                "description": "civilité du représentant du destinataire du courrier"
                            },
                            "destinataire_repres_nom": {
                                "type": "string",
                                "description": "nom du représentant du destinataire du courrier"
                            },
                            "destinataire_repres_prenom": {
                                "type": "string",
                                "description": "prenom du représentant du destinataire du courrier"
                            },
                            "lib_action": {
                                "type": "string",
                                "description": "libellé de l'action"
                            },
                            "referAdm": {
                                "type": "string",
                                "description": "référence administrative"
                            },
                            "signataire1_lib": {
                                "type": "string",
                                "description": "signataire 1 du courrier"
                            },
                            "signataire2_lib": {
                                "type": "string",
                                "description": "signataire 2 du courrier"
                            }
                        }
                    }
                }
            }
        }
    },
    "Synthese": {
        "schemas": {
            "type": "object",
            "properties": {
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Synthèse Opération",
                    "items": {
                        "type": "object",
                        "properties": {
                            "%societe_image_270x180": {
                                "type": "string",
                                "description": "Logo société"
                            },
                            "tiers_code": {
                                "type": "string",
                                "description": "Code du tiers lié à la société comptable de l'opération"
                            },
                            "societe_lib": {
                                "type": "string",
                                "description": "libellé de la société"
                            },
                            "societe_modefin": {
                                "type": "string",
                                "description": "Mode de financement société"
                            },
                            "operation_code": {
                                "type": "string",
                                "description": "Code de l'operation"
                            },
                            "operation_statut": {
                                "type": "string",
                                "description": "Statut de l'operation",
                                "enumId": "OPOperation.statut"
                            },
                            "operation_lib": {
                                "type": "string",
                                "description": "Libellé de l'operation"
                            },
                            "operation_nomCom": {
                                "type": "string",
                                "description": "Nom commerciale de l’opération"
                            },
                            "operation_adr_voie": {
                                "type": "string",
                                "description": "adrNomVoie de l'opération"
                            },
                            "operation_adr_remise": {
                                "type": "string",
                                "description": "adrNomRemise de l'opération"
                            },
                            "operation_adr_complement": {
                                "type": "string",
                                "description": "adrComplement de l'opération"
                            },
                            "operation_adr_cp": {
                                "type": "string",
                                "description": "adrCP de l'opération"
                            },
                            "operation_adr_localite": {
                                "type": "string",
                                "description": "adrLocalite de l'opération"
                            },
                            "operation_adr_pays": {
                                "type": "string",
                                "description": "adrPays de l'opération"
                            },
                            "operation_modeFin": {
                                "type": "string",
                                "description": "Mode de financement"
                            },
                            "operation_procedure": {
                                "type": "string",
                                "description": "procédure opération"
                            },
                            "operation_uniteOrga": {
                                "type": "string",
                                "description": "unité organisation opération"
                            },
                            "operation_refInterne": {
                                "type": "string",
                                "description": "référence interne opération"
                            },
                            "operation_type": {
                                "type": "string",
                                "description": "type opération",
                                "codif": "TYPEOPE"
                            },
                            "operation_activite": {
                                "type": "string",
                                "description": "Activité",
                                "enumId": "OPOperation.activite"
                            },
                            "operation_objet": {
                                "type": "string",
                                "description": "objet opération"
                            },
                            "operation_refCompta": {
                                "type": "string",
                                "description": "référence comptable opération"
                            },
                            "operation_refGed": {
                                "type": "string",
                                "description": "référence GED opération"
                            },
                            "operation_note": {
                                "type": "string",
                                "description": "note opération"
                            },
                            "operation_dtCreation": {
                                "type": "string",
                                "format": "date",
                                "description": "date création opération"
                            },
                            "operation_dtModification": {
                                "type": "string",
                                "format": "date",
                                "description": "date de dernière modification opération"
                            },
                            "%operation_image_270x180": {
                                "type": "string",
                                "description": "Image opération (dimension 270x180 personalisable)"
                            },
                            "operation_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant1"
                            },
                            "operation_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant2"
                            },
                            "operation_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant3"
                            },
                            "operation_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant4"
                            },
                            "operation_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant5"
                            },
                            "operation_montant6": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant6",
                                "version": "18.0"
                            },
                            "operation_montant7": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant7",
                                "version": "18.0"
                            },
                            "operation_montant8": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant8",
                                "version": "18.0"
                            },
                            "operation_montant9": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant9",
                                "version": "18.0"
                            },
                            "operation_montant10": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération montant10",
                                "version": "18.0"
                            },
                            "operation_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal1"
                            },
                            "operation_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal2"
                            },
                            "operation_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal3"
                            },
                            "operation_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal4"
                            },
                            "operation_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal5"
                            },
                            "operation_decimal6": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal6",
                                "version": "18.0"
                            },
                            "operation_decimal7": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal7",
                                "version": "18.0"
                            },
                            "operation_decimal8": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal8",
                                "version": "18.0"
                            },
                            "operation_decimal9": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal9",
                                "version": "18.0"
                            },
                            "operation_decimal10": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur opération decimal10",
                                "version": "18.0"
                            },
                            "operation_entier1": {
                                "type": "number",
                                "description": "Valeur opération entier1"
                            },
                            "operation_entier2": {
                                "type": "number",
                                "description": "Valeur opération entier2"
                            },
                            "operation_entier3": {
                                "type": "number",
                                "description": "Valeur opération entier3"
                            },
                            "operation_entier4": {
                                "type": "number",
                                "description": "Valeur opération entier4"
                            },
                            "operation_entier5": {
                                "type": "number",
                                "description": "Valeur opération entier5"
                            },
                            "operation_entier6": {
                                "type": "number",
                                "description": "Valeur opération entier6",
                                "version": "18.0"
                            },
                            "operation_entier7": {
                                "type": "number",
                                "description": "Valeur opération entier7",
                                "version": "18.0"
                            },
                            "operation_entier8": {
                                "type": "number",
                                "description": "Valeur opération entier8",
                                "version": "18.0"
                            },
                            "operation_entier9": {
                                "type": "number",
                                "description": "Valeur opération entier9",
                                "version": "18.0"
                            },
                            "operation_entier10": {
                                "type": "number",
                                "description": "Valeur opération entier10",
                                "version": "18.0"
                            },
                            "operation_flag1": {
                                "type": "boolean",
                                "description": "Valeur opération flag1"
                            },
                            "operation_flag2": {
                                "type": "boolean",
                                "description": "Valeur opération flag2"
                            },
                            "operation_flag3": {
                                "type": "boolean",
                                "description": "Valeur opération flag3"
                            },
                            "operation_flag4": {
                                "type": "boolean",
                                "description": "Valeur opération flag4"
                            },
                            "operation_flag5": {
                                "type": "boolean",
                                "description": "Valeur opération flag5"
                            },
                            "operation_flag6": {
                                "type": "boolean",
                                "description": "Valeur opération flag6",
                                "version": "18.0"
                            },
                            "operation_flag7": {
                                "type": "boolean",
                                "description": "Valeur opération flag7",
                                "version": "18.0"
                            },
                            "operation_flag8": {
                                "type": "boolean",
                                "description": "Valeur opération flag8",
                                "version": "18.0"
                            },
                            "operation_flag9": {
                                "type": "boolean",
                                "description": "Valeur opération flag9",
                                "version": "18.0"
                            },
                            "operation_flag10": {
                                "type": "boolean",
                                "description": "Valeur opération flag10",
                                "version": "18.0"
                            },
                            "operation_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date1"
                            },
                            "operation_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date2"
                            },
                            "operation_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date3"
                            },
                            "operation_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date4"
                            },
                            "operation_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date5"
                            },
                            "operation_date6": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date6",
                                "version": "18.0"
                            },
                            "operation_date7": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date7",
                                "version": "18.0"
                            },
                            "operation_date8": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date8",
                                "version": "18.0"
                            },
                            "operation_date9": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date9",
                                "version": "18.0"
                            },
                            "operation_date10": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur opération date10",
                                "version": "18.0"
                            },
                            "operation_texte1": {
                                "type": "string",
                                "description": "Valeur opération texte1"
                            },
                            "operation_texte2": {
                                "type": "string",
                                "description": "Valeur opération texte2"
                            },
                            "operation_texte3": {
                                "type": "string",
                                "description": "Valeur opération texte3"
                            },
                            "operation_texte4": {
                                "type": "string",
                                "description": "Valeur opération texte4"
                            },
                            "operation_texte5": {
                                "type": "string",
                                "description": "Valeur opération texte5"
                            },
                            "operation_texte6": {
                                "type": "string",
                                "description": "Valeur opération texte6",
                                "version": "18.0"
                            },
                            "operation_texte7": {
                                "type": "string",
                                "description": "Valeur opération texte7",
                                "version": "18.0"
                            },
                            "operation_texte8": {
                                "type": "string",
                                "description": "Valeur opération texte8",
                                "version": "18.0"
                            },
                            "operation_texte9": {
                                "type": "string",
                                "description": "Valeur opération texte9",
                                "version": "18.0"
                            },
                            "operation_texte10": {
                                "type": "string",
                                "description": "Valeur opération texte10",
                                "version": "18.0"
                            },
                            "operation_codif1": {
                                "type": "string",
                                "description": "Valeur opération codif1",
                                "codif": "OpExt_codif1"
                            },
                            "operation_codif2": {
                                "type": "string",
                                "description": "Valeur opération codif2",
                                "codif": "OpExt_codif2"
                            },
                            "operation_codif3": {
                                "type": "string",
                                "description": "Valeur opération codif3",
                                "codif": "OpExt_codif3"
                            },
                            "operation_codif4": {
                                "type": "string",
                                "description": "Valeur opération codif4",
                                "codif": "OpExt_codif4"
                            },
                            "operation_codif5": {
                                "type": "string",
                                "description": "Valeur opération codif5",
                                "codif": "OpExt_codif5"
                            },
                            "operation_codif6": {
                                "type": "string",
                                "description": "Valeur opération codif6",
                                "codif": "OpExt_codif6"
                            },
                            "operation_codif7": {
                                "type": "string",
                                "description": "Valeur opération codif7",
                                "codif": "OpExt_codif7"
                            },
                            "operation_codif8": {
                                "type": "string",
                                "description": "Valeur opération codif8",
                                "codif": "OpExt_codif8"
                            },
                            "operation_codif9": {
                                "type": "string",
                                "description": "Valeur opération codif9",
                                "codif": "OpExt_codif9"
                            },
                            "operation_codif10": {
                                "type": "string",
                                "description": "Valeur opération codif10",
                                "codif": "OpExt_codif10"
                            },
                            "version_code": {
                                "type": "string",
                                "description": "Numéro de version"
                            },
                            "version_lib": {
                                "type": "string",
                                "description": "Libellé de version"
                            },
                            "version_statut": {
                                "type": "string",
                                "description": "Statut de version",
                                "enumId": "SpoVersion.statut"
                            },
                            "version_type": {
                                "type": "string",
                                "description": "Type de version",
                                "codif": "TypeVerOp"
                            },
                            "version_dateArchive": {
                                "type": "string",
                                "format": "date",
                                "description": "Date d'archive de version"
                            },
                            "version_dateModif": {
                                "type": "string",
                                "format": "date",
                                "description": "Date dernière modification de version"
                            },
                            "dateArrete": {
                                "type": "string",
                                "format": "date",
                                "description": "date d'arrêté version"
                            },
                            "nb_t1": {
                                "type": "integer",
                                "description": "nombre de T1"
                            },
                            "nb_t1bis": {
                                "type": "integer",
                                "description": "nombre de T1bis"
                            },
                            "nb_t2": {
                                "type": "integer",
                                "description": "nombre de T2"
                            },
                            "nb_t3": {
                                "type": "integer",
                                "description": "nombre de T3"
                            },
                            "nb_t4": {
                                "type": "integer",
                                "description": "nombre de T4"
                            },
                            "nb_t5": {
                                "type": "integer",
                                "description": "nombre de T5"
                            },
                            "nb_t6": {
                                "type": "integer",
                                "description": "nombre de T6"
                            },
                            "locatif_nbLoge": {
                                "type": "integer",
                                "description": "Nombre de logements total"
                            },
                            "locatif_logeParTypeOuvrage": {
                                "type": "string",
                                "description": "Synthèse logement par type d'ouvrage"
                            },
                            "locatif_logeParTypo": {
                                "type": "string",
                                "description": "Synthèse logement par typologie"
                            },
                            "locatif_shon": {
                                "type": "integer",
                                "description": "SHON de logement locatif"
                            },
                            "locatif_shob": {
                                "type": "integer",
                                "description": "SHOB de logement locatif"
                            },
                            "locatif_shab": {
                                "type": "integer",
                                "description": "SHAB de logement locatif"
                            },
                            "locatif_su": {
                                "type": "integer",
                                "description": "Surface utile de logement locatif"
                            },
                            "responsable": {
                                "type": "string",
                                "description": "Responsable programme"
                            },
                            "dateComiteEng": {
                                "type": "string",
                                "format": "date",
                                "description": "Date comité d'engagement"
                            },
                            "dateAcquisition": {
                                "type": "string",
                                "format": "date",
                                "description": "Date acquisition terrain/immeuble"
                            },
                            "dateOS": {
                                "type": "string",
                                "format": "date",
                                "description": "Date OS"
                            },
                            "dateReception": {
                                "type": "string",
                                "format": "date",
                                "description": "Date réception"
                            },
                            "dateLivraison": {
                                "type": "string",
                                "format": "date",
                                "description": "Date livraison et remise des clés"
                            },
                            "financement_mntDemande": {
                                "type": "integer",
                                "description": "Montant des financements demandés"
                            },
                            "financement_mntAccorde": {
                                "type": "integer",
                                "description": "Montant des financements accordés"
                            },
                            "financement_mntAppele": {
                                "type": "integer",
                                "description": "Montant des financements appelés"
                            },
                            "financement_mntEncaisse": {
                                "type": "integer",
                                "description": "Montant des financements encaissés"
                            },
                            "tt_nb": {
                                "type": "integer",
                                "description": "Nombre de tranches travaux"
                            },
                            "tc_nb": {
                                "type": "integer",
                                "description": "Nombre de tranches commerciales"
                            },
                            "versionComp_code": {
                                "type": "string",
                                "description": "Numéro de version comparée"
                            },
                            "versionComp_lib": {
                                "type": "string",
                                "description": "Libellé de version omparée"
                            },
                            "versionComp_statut": {
                                "type": "string",
                                "description": "Statut de version comparée",
                                "enumId": "SpoVersion.statut"
                            },
                            "versionComp_type": {
                                "type": "string",
                                "description": "Type de version comparée",
                                "codif": "TypeVerOp"
                            },
                            "versionComp_dateArrete": {
                                "type": "string",
                                "format": "date",
                                "description": "date d'arrêté version comparée"
                            },
                            "loyerHTAnn": {
                                "type": "integer",
                                "description": "Loyer HT annuel / m²"
                            },
                            "loyerHTMens": {
                                "type": "integer",
                                "description": "Loyer HT mensuel / m²"
                            },
                            "loyerTTCAnn": {
                                "type": "integer",
                                "description": "Loyer TTC annuel / m²"
                            },
                            "loyerTTCMens": {
                                "type": "integer",
                                "description": "Loyer TTC mensuel / m²"
                            },
                            "loyerHTAnnTotal": {
                                "type": "integer",
                                "description": "Loyer total HT annuel"
                            },
                            "loyerHTMensTotal": {
                                "type": "integer",
                                "description": "Loyer total HT mensuel"
                            },
                            "loyerTTCAnnTotal": {
                                "type": "integer",
                                "description": "Loyer total TTC annuel"
                            },
                            "loyerTTCMensTotal": {
                                "type": "integer",
                                "description": "Loyer total TTC mensuel"
                            },
                            "rentabilite": {
                                "type": "integer",
                                "description": "Rentabilité de l'opération"
                            },
                            "treso_dateRecalage": {
                                "type": "string",
                                "format": "date",
                                "description": "Date dernier recalage trésorerie"
                            },
                            "treso_soldRecDepcum": {
                                "type": "integer",
                                "description": "Solde recettes dépenses cumulées (mois courant)"
                            },
                            "treso_mntTVAresid": {
                                "type": "integer",
                                "description": "TVA résiduelle"
                            },
                            "treso_mntTVApaye": {
                                "type": "integer",
                                "description": "TVA payée réelle"
                            },
                            "treso_mntTVAencaisse": {
                                "type": "integer",
                                "description": "TVA encaissée réelle"
                            },
                            "treso_soldapTVAcum": {
                                "type": "integer",
                                "description": "Trésorerie après TVA en cumul (mois courant)"
                            },
                            "treso_totalFPprev": {
                                "type": "integer",
                                "description": "Fonds prores prévisionnels"
                            },
                            "treso_totalFPreel": {
                                "type": "integer",
                                "description": "Fonds propres apportés réels"
                            },
                            "treso_totalFPreelrest": {
                                "type": "integer",
                                "description": "Fonds propres restitués réels"
                            },
                            "treso_soldapFPcum": {
                                "type": "integer",
                                "description": "Trésorerie après fonds propres en cumul (mois courant)"
                            },
                            "treso_totalEmpPrev": {
                                "type": "integer",
                                "description": "Emprunts prévisionnels"
                            },
                            "treso_totalEmpReel": {
                                "type": "integer",
                                "description": "Déblocage emprunts réels"
                            },
                            "treso_totalEmpReelremb": {
                                "type": "integer",
                                "description": "Remboursement emprunts réels"
                            },
                            "treso_soldapEmpcum": {
                                "type": "integer",
                                "description": "Trésorerie après emprunt en cumul (mois courant)"
                            },
                            "treso_pic": {
                                "type": "integer",
                                "description": "Pic de trésorerie"
                            },
                            "treso_datepic": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de pic de trésorerie"
                            },
                            "treso_totalAutdecouv": {
                                "type": "integer",
                                "description": "Total autorisation de découvert"
                            },
                            "treso_decouvMois": {
                                "type": "integer",
                                "description": "Autorisation de découvert mois courant"
                            },
                            "treso_utDecouvMois": {
                                "type": "integer",
                                "description": "Utilisation de découvert mois courant"
                            },
                            "treso_soldExDef": {
                                "type": "integer",
                                "description": "Trésorerie excédentaire ou déficitaire (mois courant)"
                            },
                            "treso_totalDistriMargereel": {
                                "type": "integer",
                                "description": "Distribution de la marge réelle"
                            },
                            "treso_soldTresoFinal": {
                                "type": "integer",
                                "description": "Solde de trésorerie final (mois courant)"
                            },
                            "treso_TRI": {
                                "type": "number",
                                "format": "rate",
                                "description": "TRI"
                            },
                            "treso_tauxFP": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de rémunération des fonds propres"
                            },
                            "treso_tauxEmp": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux d'intérêt sur emprunts"
                            },
                            "treso_tauxComEngag": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux d'intérêt sur commission d'engagement"
                            },
                            "treso_tauxUtDecouv": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux d'intérêt sur utilisation de découvert (agios)"
                            },
                            "treso_tauxNonUtDecouv": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux d'intérêt sur non utilisation de découvert (agios)"
                            },
                            "lotP_nb": {
                                "type": "integer",
                                "description": "nombre total de lots principaux"
                            },
                            "lotS_nb": {
                                "type": "integer",
                                "description": "nombre total de lots secondaires"
                            },
                            "lotP_prixBudHT": {
                                "type": "integer",
                                "description": "prix budget HT des lots principaux"
                            },
                            "lotP_prixBudTTC": {
                                "type": "integer",
                                "description": "prix budget TTC des lots principaux"
                            },
                            "lotS_prixBudHT": {
                                "type": "integer",
                                "description": "prix budget HT des lots secondaires"
                            },
                            "lotS_prixBudTTC": {
                                "type": "integer",
                                "description": "prix budget TTC des lots secondaires"
                            },
                            "prixBudHT": {
                                "type": "integer",
                                "description": "prix budget HT"
                            },
                            "prixBudTTC": {
                                "type": "integer",
                                "description": "prix budget TTC"
                            },
                            "rendement": {
                                "type": "number",
                                "format": "money",
                                "description": "Rendement"
                            },
                            "marge": {
                                "type": "integer",
                                "description": "Marge en HT"
                            },
                            "recette": {
                                "type": "integer",
                                "description": "Recette en HT"
                            },
                            "depense": {
                                "type": "integer",
                                "description": "Dépense en HT"
                            },
                            "surfTerrain": {
                                "type": "integer",
                                "description": "surface terrain"
                            },
                            "stock_nb": {
                                "type": "integer",
                                "description": "Nombre total de lots en stock"
                            },
                            "stock_nbLotP": {
                                "type": "integer",
                                "description": "Nombre total de lots principaux en stock"
                            },
                            "stock_nbLotS": {
                                "type": "integer",
                                "description": "Nombre total de lots secondaires en stock"
                            },
                            "stock_caHT": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots en stock"
                            },
                            "stock_caTTC": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots en stock"
                            },
                            "stock_caHTLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots principaux en stock"
                            },
                            "stock_caTTCLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots principaux en stock"
                            },
                            "stock_caHTLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots secondaires en stock"
                            },
                            "stock_caTTCLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots secondaires en stock"
                            },
                            "preReserve_nb": {
                                "type": "integer",
                                "description": "Nombre total de lots préréservés"
                            },
                            "preReserve_nbLotP": {
                                "type": "integer",
                                "description": "Nombre total de lots principaux préréservés"
                            },
                            "preReserve_nbLotS": {
                                "type": "integer",
                                "description": "Nombre total de lots secondaires préréservés"
                            },
                            "preReserve_caHT": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots préréservés"
                            },
                            "preReserve_caTTC": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots préréservés"
                            },
                            "preReserve_caHTLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots principaux préréservés"
                            },
                            "preReserve_caTTCLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots principaux préréservés"
                            },
                            "preReserve_caHTLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots secondaires préréservés"
                            },
                            "preReserve_caTTCLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots secondaires préréservés"
                            },
                            "reserve_nb": {
                                "type": "integer",
                                "description": "Nombre total de lots réservés"
                            },
                            "reserve_nbLotP": {
                                "type": "integer",
                                "description": "Nombre total de lots principaux réservés"
                            },
                            "reserve_nbLotS": {
                                "type": "integer",
                                "description": "Nombre total de lots secondaires réservés"
                            },
                            "reserve_caHT": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots réservés"
                            },
                            "reserve_caTTC": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots réservés"
                            },
                            "reserve_caHTLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots principaux réservés"
                            },
                            "reserve_caTTCLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots principaux réservés"
                            },
                            "reserve_caHTLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots secondaires réservés"
                            },
                            "reserve_caTTCLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots secondaires réservés"
                            },
                            "vendu_nb": {
                                "type": "integer",
                                "description": "Nombre total de lots vendus"
                            },
                            "vendu_nbLotP": {
                                "type": "integer",
                                "description": "Nombre total de lots principaux vendus"
                            },
                            "vendu_nbLotS": {
                                "type": "integer",
                                "description": "Nombre total de lots secondaires vendus"
                            },
                            "vendu_caHT": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots vendus"
                            },
                            "vendu_caTTC": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots vendus"
                            },
                            "vendu_caHTLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots principaux vendus"
                            },
                            "vendu_caTTCLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots principaux vendus"
                            },
                            "vendu_caHTLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots secondaires vendus"
                            },
                            "vendu_caTTCLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots secondaires vendus"
                            },
                            "livre_nb": {
                                "type": "integer",
                                "description": "Nombre total de lots livrés"
                            },
                            "livre_nbLotP": {
                                "type": "integer",
                                "description": "Nombre total de lots principaux livrés"
                            },
                            "livre_nbLotS": {
                                "type": "integer",
                                "description": "Nombre total de lots secondaires livrés"
                            },
                            "livre_caHT": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots livrés"
                            },
                            "livre_caTTC": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots livrés"
                            },
                            "livre_caHTLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots principaux livrés"
                            },
                            "livre_caTTCLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots principaux livrés"
                            },
                            "livre_caHTLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots secondaires livrés"
                            },
                            "livre_caTTCLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots secondaires livrés"
                            },
                            "loue_nb": {
                                "type": "integer",
                                "description": "Nombre total de lots loués"
                            },
                            "loue_nbLotP": {
                                "type": "integer",
                                "description": "Nombre total de lots principaux loués"
                            },
                            "loue_nbLotS": {
                                "type": "integer",
                                "description": "Nombre total de lots secondaires loués"
                            },
                            "loue_caHT": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots loués"
                            },
                            "loue_caTTC": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots loués"
                            },
                            "loue_caHTLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots principaux loués"
                            },
                            "loue_caTTCLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots principaux loués"
                            },
                            "loue_caHTLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots secondaires loués"
                            },
                            "loue_caTTCLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots secondaires loués"
                            },
                            "acte_nb": {
                                "type": "integer",
                                "description": "Nombre total de lots actés"
                            },
                            "acte_nbLotP": {
                                "type": "integer",
                                "description": "Nombre total de lots principaux actés"
                            },
                            "acte_nbLotS": {
                                "type": "integer",
                                "description": "Nombre total de lots secondaires actés"
                            },
                            "acte_caHT": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots actés"
                            },
                            "acte_caTTC": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots actés"
                            },
                            "acte_caHTLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots principaux actés"
                            },
                            "acte_caTTCLotP": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots principaux actés"
                            },
                            "acte_caHTLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires HT de lots secondaires actés"
                            },
                            "acte_caTTCLotS": {
                                "type": "integer",
                                "description": "Chiffre d'affaires TTC de lots secondaires actés"
                            },
                            "engage_depenseHT": {
                                "type": "integer",
                                "description": "Montant HT engagé dépenses"
                            },
                            "engage_depenseTTC": {
                                "type": "integer",
                                "description": "Montant TTC engagé dépenses"
                            },
                            "engage_recetteHT": {
                                "type": "integer",
                                "description": "Montant HT engagé recettes"
                            },
                            "engage_recetteTTC": {
                                "type": "integer",
                                "description": "Montant TTC engagé recettes"
                            },
                            "facture_depenseHT": {
                                "type": "integer",
                                "description": "Montant HT facturé dépenses"
                            },
                            "facture_depenseTTC": {
                                "type": "integer",
                                "description": "Montant TTC facturé dépenses"
                            },
                            "facture_recetteHT": {
                                "type": "integer",
                                "description": "Montant HT facturé recettes"
                            },
                            "facture_recetteTTC": {
                                "type": "integer",
                                "description": "Montant TTC facturé recettes"
                            },
                            "paye_depenseHT": {
                                "type": "integer",
                                "description": "Montant HT payé dépenses"
                            },
                            "paye_depenseTTC": {
                                "type": "integer",
                                "description": "Montant TTC payé dépenses"
                            },
                            "paye_recetteHT": {
                                "type": "integer",
                                "description": "Montant HT payé recettes"
                            },
                            "paye_recetteTTC": {
                                "type": "integer",
                                "description": "Montant TTC payé recettes"
                            },
                            "poste_recette1": {
                                "type": "integer",
                                "description": "Poste recette 1 en HT"
                            },
                            "poste_recette2": {
                                "type": "integer",
                                "description": "Poste recette 2 en HT"
                            },
                            "poste_recette3": {
                                "type": "integer",
                                "description": "Poste recette 3 en HT"
                            },
                            "poste_recette4": {
                                "type": "integer",
                                "description": "Poste recette 4 en HT"
                            },
                            "poste_recette5": {
                                "type": "integer",
                                "description": "Poste recette 5 en HT"
                            },
                            "poste_recette6": {
                                "type": "integer",
                                "description": "Poste recette 6 en HT"
                            },
                            "poste_recette7": {
                                "type": "integer",
                                "description": "Poste recette 7 en HT"
                            },
                            "poste_recette8": {
                                "type": "integer",
                                "description": "Poste recette 8 en HT"
                            },
                            "poste_recette9": {
                                "type": "integer",
                                "description": "Poste recette 9  en HT"
                            },
                            "poste_recette10": {
                                "type": "integer",
                                "description": "Poste recette 10  en HT"
                            },
                            "poste_depense1": {
                                "type": "integer",
                                "description": "Poste dépense 1  en HT"
                            },
                            "poste_depense2": {
                                "type": "integer",
                                "description": "Poste dépense 2  en HT"
                            },
                            "poste_depense3": {
                                "type": "integer",
                                "description": "Poste dépense 3  en HT"
                            },
                            "poste_depense4": {
                                "type": "integer",
                                "description": "Poste dépense 4  en HT"
                            },
                            "poste_depense5": {
                                "type": "integer",
                                "description": "Poste dépense 5  en HT"
                            },
                            "poste_depense6": {
                                "type": "integer",
                                "description": "Poste dépense 6  en HT"
                            },
                            "poste_depense7": {
                                "type": "integer",
                                "description": "Poste dépense 7  en HT"
                            },
                            "poste_depense8": {
                                "type": "integer",
                                "description": "Poste dépense 8 en HT"
                            },
                            "poste_depense9": {
                                "type": "integer",
                                "description": "Poste dépense 9 en HT"
                            },
                            "poste_depense10": {
                                "type": "integer",
                                "description": "Poste dépense 10 en HT"
                            },
                            "poste_info1": {
                                "type": "integer",
                                "description": "Poste information 1 en HT"
                            },
                            "poste_info2": {
                                "type": "integer",
                                "description": "Poste information 2 en HT"
                            },
                            "poste_info3": {
                                "type": "integer",
                                "description": "Poste information 3 en HT"
                            },
                            "poste_info4": {
                                "type": "integer",
                                "description": "Poste information 4 en HT"
                            },
                            "poste_info5": {
                                "type": "integer",
                                "description": "Poste information 5 en HT"
                            },
                            "poste_info6": {
                                "type": "integer",
                                "description": "Poste information 6 en HT"
                            },
                            "poste_info7": {
                                "type": "integer",
                                "description": "Poste information 7 en HT"
                            },
                            "poste_info8": {
                                "type": "integer",
                                "description": "Poste information 8 en HT"
                            },
                            "poste_info9": {
                                "type": "integer",
                                "description": "Poste information 9 en HT"
                            },
                            "poste_info10": {
                                "type": "integer",
                                "description": "Poste information 10 en HT"
                            },
                            "societe_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant1",
                                "version": "18.0"
                            },
                            "societe_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant2",
                                "version": "18.0"
                            },
                            "societe_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant3",
                                "version": "18.0"
                            },
                            "societe_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant4",
                                "version": "18.0"
                            },
                            "societe_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant5",
                                "version": "18.0"
                            },
                            "societe_montant6": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant6",
                                "version": "18.0"
                            },
                            "societe_montant7": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant7",
                                "version": "18.0"
                            },
                            "societe_montant8": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant8",
                                "version": "18.0"
                            },
                            "societe_montant9": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant9",
                                "version": "18.0"
                            },
                            "societe_montant10": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société montant10",
                                "version": "18.0"
                            },
                            "societe_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal1",
                                "version": "18.0"
                            },
                            "societe_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal2",
                                "version": "18.0"
                            },
                            "societe_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal3",
                                "version": "18.0"
                            },
                            "societe_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal4",
                                "version": "18.0"
                            },
                            "societe_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal5",
                                "version": "18.0"
                            },
                            "societe_decimal6": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal6",
                                "version": "18.0"
                            },
                            "societe_decimal7": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal7",
                                "version": "18.0"
                            },
                            "societe_decimal8": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal8",
                                "version": "18.0"
                            },
                            "societe_decimal9": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal9",
                                "version": "18.0"
                            },
                            "societe_decimal10": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur société decimal10",
                                "version": "18.0"
                            },
                            "societe_entier1": {
                                "type": "number",
                                "description": "Valeur société entier1",
                                "version": "18.0"
                            },
                            "societe_entier2": {
                                "type": "number",
                                "description": "Valeur société entier2",
                                "version": "18.0"
                            },
                            "societe_entier3": {
                                "type": "number",
                                "description": "Valeur société entier3",
                                "version": "18.0"
                            },
                            "societe_entier4": {
                                "type": "number",
                                "description": "Valeur société entier4",
                                "version": "18.0"
                            },
                            "societe_entier5": {
                                "type": "number",
                                "description": "Valeur société entier5",
                                "version": "18.0"
                            },
                            "societe_entier6": {
                                "type": "number",
                                "description": "Valeur société entier6",
                                "version": "18.0"
                            },
                            "societe_entier7": {
                                "type": "number",
                                "description": "Valeur société entier7",
                                "version": "18.0"
                            },
                            "societe_entier8": {
                                "type": "number",
                                "description": "Valeur société entier8",
                                "version": "18.0"
                            },
                            "societe_entier9": {
                                "type": "number",
                                "description": "Valeur société entier9",
                                "version": "18.0"
                            },
                            "societe_entier10": {
                                "type": "number",
                                "description": "Valeur société entier10",
                                "version": "18.0"
                            },
                            "societe_flag1": {
                                "type": "boolean",
                                "description": "Valeur société flag1",
                                "version": "18.0"
                            },
                            "societe_flag2": {
                                "type": "boolean",
                                "description": "Valeur société flag2",
                                "version": "18.0"
                            },
                            "societe_flag3": {
                                "type": "boolean",
                                "description": "Valeur société flag3",
                                "version": "18.0"
                            },
                            "societe_flag4": {
                                "type": "boolean",
                                "description": "Valeur société flag4",
                                "version": "18.0"
                            },
                            "societe_flag5": {
                                "type": "boolean",
                                "description": "Valeur société flag5",
                                "version": "18.0"
                            },
                            "societe_flag6": {
                                "type": "boolean",
                                "description": "Valeur société flag6",
                                "version": "18.0"
                            },
                            "societe_flag7": {
                                "type": "boolean",
                                "description": "Valeur société flag7",
                                "version": "18.0"
                            },
                            "societe_flag8": {
                                "type": "boolean",
                                "description": "Valeur société flag8",
                                "version": "18.0"
                            },
                            "societe_flag9": {
                                "type": "boolean",
                                "description": "Valeur société flag9",
                                "version": "18.0"
                            },
                            "societe_flag10": {
                                "type": "boolean",
                                "description": "Valeur société flag10",
                                "version": "18.0"
                            },
                            "societe_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date1",
                                "version": "18.0"
                            },
                            "societe_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date2",
                                "version": "18.0"
                            },
                            "societe_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date3",
                                "version": "18.0"
                            },
                            "societe_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date4",
                                "version": "18.0"
                            },
                            "societe_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date5",
                                "version": "18.0"
                            },
                            "societe_date6": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date6",
                                "version": "18.0"
                            },
                            "societe_date7": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date7",
                                "version": "18.0"
                            },
                            "societe_date8": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date8",
                                "version": "18.0"
                            },
                            "societe_date9": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date9",
                                "version": "18.0"
                            },
                            "societe_date10": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur société date10",
                                "version": "18.0"
                            },
                            "societe_texte1": {
                                "type": "string",
                                "description": "Valeur société texte1",
                                "version": "18.0"
                            },
                            "societe_texte2": {
                                "type": "string",
                                "description": "Valeur société texte2",
                                "version": "18.0"
                            },
                            "societe_texte3": {
                                "type": "string",
                                "description": "Valeur société texte3",
                                "version": "18.0"
                            },
                            "societe_texte4": {
                                "type": "string",
                                "description": "Valeur société texte4",
                                "version": "18.0"
                            },
                            "societe_texte5": {
                                "type": "string",
                                "description": "Valeur société texte5",
                                "version": "18.0"
                            },
                            "societe_texte6": {
                                "type": "string",
                                "description": "Valeur société texte6",
                                "version": "18.0"
                            },
                            "societe_texte7": {
                                "type": "string",
                                "description": "Valeur société texte7",
                                "version": "18.0"
                            },
                            "societe_texte8": {
                                "type": "string",
                                "description": "Valeur société texte8",
                                "version": "18.0"
                            },
                            "societe_texte9": {
                                "type": "string",
                                "description": "Valeur société texte9",
                                "version": "18.0"
                            },
                            "societe_texte10": {
                                "type": "string",
                                "description": "Valeur société texte10",
                                "version": "18.0"
                            },
                            "societe_codif1": {
                                "type": "string",
                                "description": "Valeur société codif1",
                                "codif": "OPSociete_codif1",
                                "version": "18.0"
                            },
                            "societe_codif2": {
                                "type": "string",
                                "description": "Valeur société codif2",
                                "codif": "OPSociete_codif2",
                                "version": "18.0"
                            },
                            "societe_codif3": {
                                "type": "string",
                                "description": "Valeur société codif3",
                                "codif": "OPSociete_codif3",
                                "version": "18.0"
                            },
                            "societe_codif4": {
                                "type": "string",
                                "description": "Valeur société codif4",
                                "codif": "OPSociete_codif4",
                                "version": "18.0"
                            },
                            "societe_codif5": {
                                "type": "string",
                                "description": "Valeur société codif5",
                                "codif": "OPSociete_codif5",
                                "version": "18.0"
                            },
                            "societe_codif6": {
                                "type": "string",
                                "description": "Valeur société codif6",
                                "codif": "OPSociete_codif6",
                                "version": "18.0"
                            },
                            "societe_codif7": {
                                "type": "string",
                                "description": "Valeur société codif7",
                                "codif": "OPSociete_codif7",
                                "version": "18.0"
                            },
                            "societe_codif8": {
                                "type": "string",
                                "description": "Valeur société codif8",
                                "codif": "OPSociete_codif8",
                                "version": "18.0"
                            },
                            "societe_codif9": {
                                "type": "string",
                                "description": "Valeur société codif9",
                                "codif": "OPSociete_codif9",
                                "version": "18.0"
                            },
                            "societe_codif10": {
                                "type": "string",
                                "description": "Valeur société codif10",
                                "codif": "OPSociete_codif10",
                                "version": "18.0"
                            },
                            "budget_montants": {
                                "type": "array",
                                "description": "Les montants du budget",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "bud_poste": {
                                            "type": "string",
                                            "description": "Poste Budgétaire"
                                        },
                                        "bud_mntHT": {
                                            "type": "integer",
                                            "description": "Montant HT"
                                        },
                                        "bud_mntTTC": {
                                            "type": "integer",
                                            "description": "Montant TTC"
                                        },
                                        "bud_mntTVA": {
                                            "type": "integer",
                                            "description": "Montant TVA"
                                        },
                                        "bud_mntAutoHT": {
                                            "type": "integer",
                                            "description": "Autorisation HT"
                                        },
                                        "bud_niveau": {
                                            "type": "integer",
                                            "description": "Niveau du poste"
                                        },
                                        "bud_typePoste": {
                                            "type": "string",
                                            "description": "Type du poste"
                                        },
                                        "bud_ordre": {
                                            "type": "string",
                                            "description": "Ordre du poste"
                                        },
                                        "bud_mntHTComp": {
                                            "type": "integer",
                                            "description": "Montant HT des postes de la version comparée"
                                        },
                                        "bud_revient": {
                                            "type": "integer",
                                            "description": "Prix de revient (Bailleurs)"
                                        },
                                        "bud_revientComp": {
                                            "type": "integer",
                                            "description": "Prix de revient de la version comparée (Bailleurs)"
                                        },
                                        "bud_preHT": {
                                            "type": "integer",
                                            "description": "Pré-engagé HT"
                                        },
                                        "bud_preTTC": {
                                            "type": "integer",
                                            "description": "Pré-engagé TTC"
                                        },
                                        "bud_engageHT": {
                                            "type": "integer",
                                            "description": "Engagé HT"
                                        },
                                        "bud_engageTTC": {
                                            "type": "integer",
                                            "description": "Engagé TTC"
                                        },
                                        "bud_factureHT": {
                                            "type": "integer",
                                            "description": "Facturé HT"
                                        },
                                        "bud_factureTTC": {
                                            "type": "integer",
                                            "description": "Facturé TTC"
                                        },
                                        "bud_regleHT": {
                                            "type": "integer",
                                            "description": "Payé HT"
                                        },
                                        "bud_regleTTC": {
                                            "type": "integer",
                                            "description": "Payé TTC"
                                        },
                                        "bud_valeur_taux": {
                                            "type": "string",
                                            "description": "Valeur / Taux"
                                        },
                                        "bud_formule": {
                                            "type": "string",
                                            "description": "Formule"
                                        },
                                        "bud_assiette": {
                                            "type": "string",
                                            "description": "Assiette"
                                        },
                                        "bud_commentaire": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        },
                                        "bud_commentaireComp": {
                                            "type": "string",
                                            "description": "Commentaire version comparée"
                                        },
                                        "bud_repartition": {
                                            "type": "string",
                                            "description": "Répartition au niveau Opération (clé n°1)"
                                        }
                                    }
                                }
                            },
                            "budget_TC_montants": {
                                "type": "array",
                                "description": "Les montants du budget par tranche commerciale",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tc_bud_codeTT": {
                                            "type": "string",
                                            "description": "Code tranche travaux"
                                        },
                                        "tc_bud_libTT": {
                                            "type": "string",
                                            "description": "libellé tranche travaux"
                                        },
                                        "tc_bud_codeTC": {
                                            "type": "string",
                                            "description": "Code tranche commerciale"
                                        },
                                        "tc_bud_libTC": {
                                            "type": "string",
                                            "description": "libellé tranche commerciale"
                                        },
                                        "tc_bud_poste": {
                                            "type": "string",
                                            "description": "Poste Budgétaire"
                                        },
                                        "tc_bud_mntHT": {
                                            "type": "integer",
                                            "description": "Montant HT"
                                        },
                                        "tc_bud_mntTTC": {
                                            "type": "integer",
                                            "description": "Montant TTC"
                                        },
                                        "tc_bud_mntTTCComp": {
                                            "type": "integer",
                                            "description": "Montant TTC de la version comparée"
                                        },
                                        "tc_bud_mntTVA": {
                                            "type": "integer",
                                            "description": "Montant TVA"
                                        },
                                        "tc_bud_niveau": {
                                            "type": "integer",
                                            "description": "Niveau du poste"
                                        },
                                        "tc_bud_typePoste": {
                                            "type": "string",
                                            "description": "Type du poste"
                                        },
                                        "tc_bud_ordre": {
                                            "type": "string",
                                            "description": "Ordre du poste"
                                        },
                                        "tc_bud_mntHTComp": {
                                            "type": "integer",
                                            "description": "Montant HT des postes de la version comparée"
                                        },
                                        "tc_bud_revient": {
                                            "type": "integer",
                                            "description": "Prix de revient (Bailleurs)"
                                        },
                                        "tc_bud_revientComp": {
                                            "type": "integer",
                                            "description": "Prix de revient de la version comparée  (Bailleurs)"
                                        },
                                        "tc_bud_valeur_taux": {
                                            "type": "string",
                                            "description": "Valeur / Taux"
                                        },
                                        "tc_bud_formule": {
                                            "type": "string",
                                            "description": "Formule"
                                        },
                                        "tc_bud_assiette": {
                                            "type": "string",
                                            "description": "Assiette"
                                        },
                                        "tc_bud_commentaire": {
                                            "type": "string",
                                            "description": "Commentaire"
                                        },
                                        "tc_bud_commentaireComp": {
                                            "type": "string",
                                            "description": "Commentaire version comparée"
                                        }
                                    }
                                }
                            },
                            "tranches_travaux": {
                                "type": "array",
                                "description": "Liste des tranches travaux",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tt_dateOs": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date OS de la tranche travaux"
                                        },
                                        "tt_dateLivraison": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date livraison de la tranche travaux"
                                        },
                                        "tt_dureeTravaux": {
                                            "type": "integer",
                                            "description": "Durée travaux en mois de la tranche travaux"
                                        },
                                        "tt_code": {
                                            "type": "string",
                                            "description": "Code tranche travaux"
                                        },
                                        "tt_lib": {
                                            "type": "string",
                                            "description": "libellé tranche travaux"
                                        },
                                        "tt_texte1": {
                                            "type": "string",
                                            "description": "Valeur tranche travaux texte1"
                                        },
                                        "tt_codif1": {
                                            "type": "string",
                                            "description": "Valeur tranche travaux codif1",
                                            "codif": "OPTrancheTravaux_codif1"
                                        },
                                        "tt_entier1": {
                                            "type": "integer",
                                            "description": "Valeur tranche travaux entier1"
                                        },
                                        "tt_date1": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche travaux date1"
                                        },
                                        "tt_flag1": {
                                            "type": "boolean",
                                            "description": "Valeur tranche travaux flag1"
                                        },
                                        "tt_decimal1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche travaux decimal1"
                                        },
                                        "tt_montant1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur  tranche travaux montant1"
                                        }
                                    }
                                }
                            },
                            "tranches_commerciales": {
                                "type": "array",
                                "description": "Liste des tranches commerciales",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tc_code": {
                                            "type": "string",
                                            "description": "code tranche commerciale"
                                        },
                                        "tc_lib": {
                                            "type": "string",
                                            "description": "libellé tranche commerciale"
                                        },
                                        "tc_nomCom": {
                                            "type": "string",
                                            "description": "nom commercial tranche commerciale"
                                        },
                                        "tc_adr_remise": {
                                            "type": "string",
                                            "description": "adresse nom remisé tranche commerciale"
                                        },
                                        "tc_adr_voie": {
                                            "type": "string",
                                            "description": "adresse nom voie tranche commerciale"
                                        },
                                        "tc_adr_complement": {
                                            "type": "string",
                                            "description": "adresse complement tranche commerciale"
                                        },
                                        "tc_adr_cp": {
                                            "type": "string",
                                            "description": "adresse code postal tranche commerciale"
                                        },
                                        "tc_adr_localite": {
                                            "type": "string",
                                            "description": "adresse localité tranche commerciale"
                                        },
                                        "tc_analytique": {
                                            "type": "string",
                                            "description": "code analytique tranche commerciale"
                                        },
                                        "tc_typeOuvrage": {
                                            "type": "string",
                                            "description": "type ouvrage tranche commerciale"
                                        },
                                        "tc_typeCom": {
                                            "type": "string",
                                            "description": "type commercialisation tranche commerciale",
                                            "codif": "TypeComm"
                                        },
                                        "tc_regimeFiscal": {
                                            "type": "string",
                                            "description": "régime fiscal tranche commerciale"
                                        },
                                        "tc_tva": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "taux de TVA tranche commerciale"
                                        },
                                        "tc_avancementCom": {
                                            "type": "string",
                                            "description": "avancement commercial tranche commerciale",
                                            "codif": "StatutTrancheC"
                                        },
                                        "tc_posteBudgVente": {
                                            "type": "string",
                                            "description": "poste budgétaire vente tranche commerciale"
                                        },
                                        "tc_tvaMarge": {
                                            "type": "boolean",
                                            "description": "TVA sur marge tranche commerciale (oui/non)"
                                        },
                                        "tc_typeSurfBase": {
                                            "type": "string",
                                            "description": "type surface de base tranche commerciale",
                                            "enumId": "OPNatureTravaux.typeSurfBase"
                                        },
                                        "tc_valSurfBase": {
                                            "type": "integer",
                                            "description": "valeur de la surface de base tranche commerciale"
                                        },
                                        "tc_typeSurfVendre": {
                                            "type": "string",
                                            "description": "type surface à vendre",
                                            "codif": "TypeSurf"
                                        },
                                        "tc_valSurfVendre": {
                                            "type": "integer",
                                            "description": "valeur surface à vendre"
                                        },
                                        "tc_clerepart": {
                                            "type": "integer",
                                            "description": "clé personnelle de répartition"
                                        },
                                        "tc_typeSurfVendu": {
                                            "type": "string",
                                            "description": "type surface vendue",
                                            "codif": "TypeSurf"
                                        },
                                        "tc_valSurfVendu": {
                                            "type": "integer",
                                            "description": "valeur surface vendue"
                                        },
                                        "tc_surfTerrain": {
                                            "type": "integer",
                                            "description": "surface de terrain en m2 de la tranche"
                                        },
                                        "tc_nbLotP": {
                                            "type": "integer",
                                            "description": "Nombre total de lots principaux de la tranche"
                                        },
                                        "tc_nbLotS": {
                                            "type": "integer",
                                            "description": "Nombre total de lots secondaires de la tranche"
                                        },
                                        "tc_lotP_prixBudHT": {
                                            "type": "integer",
                                            "description": "prix budget HT des lots principaux de la tranche"
                                        },
                                        "tc_lotP_prixBudTTC": {
                                            "type": "integer",
                                            "description": "prix budget TTC des lots principaux de la tranche"
                                        },
                                        "tc_lotS_prixBudHT": {
                                            "type": "integer",
                                            "description": "prix budget HT des lots secondaires de la tranche"
                                        },
                                        "tc_lotS_prixBudTTC": {
                                            "type": "integer",
                                            "description": "prix budget TTC des lots secondaires de la tranche"
                                        },
                                        "tc_prixBudHT": {
                                            "type": "integer",
                                            "description": "prix budget HT de la tranche"
                                        },
                                        "tc_prixBudTTC": {
                                            "type": "integer",
                                            "description": "prix budget TTC de la tranche"
                                        },
                                        "tc_rendement": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Rendement de la tranche"
                                        },
                                        "tc_date1erResa": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date premier réservation de la tranche commerciale"
                                        },
                                        "tc_date1erVente": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date premier vente de la tranche commerciale"
                                        },
                                        "tc_dateLivraison": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date livraison de la tranche commerciale"
                                        },
                                        "tt_dateOs": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date OS de la tranche travaux"
                                        },
                                        "tt_dateLivraison": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date livraison de la tranche travaux"
                                        },
                                        "tt_dureeTravaux": {
                                            "type": "integer",
                                            "description": "Durée travaux en mois de la tranche travaux"
                                        },
                                        "tt_code": {
                                            "type": "string",
                                            "description": "Code tranche travaux"
                                        },
                                        "tt_lib": {
                                            "type": "string",
                                            "description": "libellé tranche travaux"
                                        },
                                        "tc_marge": {
                                            "type": "integer",
                                            "description": "Marge de la tranche en HT"
                                        },
                                        "tc_recette": {
                                            "type": "integer",
                                            "description": "Recette en HT"
                                        },
                                        "tc_depense": {
                                            "type": "integer",
                                            "description": "Dépense en HT"
                                        },
                                        "poste_recette1": {
                                            "type": "integer",
                                            "description": "Poste recette 1 en HT"
                                        },
                                        "poste_recette2": {
                                            "type": "integer",
                                            "description": "Poste recette 2 en HT"
                                        },
                                        "poste_recette3": {
                                            "type": "integer",
                                            "description": "Poste recette 3 en HT"
                                        },
                                        "poste_recette4": {
                                            "type": "integer",
                                            "description": "Poste recette 4 en HT"
                                        },
                                        "poste_recette5": {
                                            "type": "integer",
                                            "description": "Poste recette 5 en HT"
                                        },
                                        "poste_recette6": {
                                            "type": "integer",
                                            "description": "Poste recette 6 en HT"
                                        },
                                        "poste_recette7": {
                                            "type": "integer",
                                            "description": "Poste recette 7 en HT"
                                        },
                                        "poste_recette8": {
                                            "type": "integer",
                                            "description": "Poste recette 8 en HT"
                                        },
                                        "poste_recette9": {
                                            "type": "integer",
                                            "description": "Poste recette 9  en HT"
                                        },
                                        "poste_recette10": {
                                            "type": "integer",
                                            "description": "Poste recette 10  en HT"
                                        },
                                        "poste_depense1": {
                                            "type": "integer",
                                            "description": "Poste dépense 1  en HT"
                                        },
                                        "poste_depense2": {
                                            "type": "integer",
                                            "description": "Poste dépense 2  en HT"
                                        },
                                        "poste_depense3": {
                                            "type": "integer",
                                            "description": "Poste dépense 3  en HT"
                                        },
                                        "poste_depense4": {
                                            "type": "integer",
                                            "description": "Poste dépense 4  en HT"
                                        },
                                        "poste_depense5": {
                                            "type": "integer",
                                            "description": "Poste dépense 5  en HT"
                                        },
                                        "poste_depense6": {
                                            "type": "integer",
                                            "description": "Poste dépense 6  en HT"
                                        },
                                        "poste_depense7": {
                                            "type": "integer",
                                            "description": "Poste dépense 7  en HT"
                                        },
                                        "poste_depense8": {
                                            "type": "integer",
                                            "description": "Poste dépense 8 en HT"
                                        },
                                        "poste_depense9": {
                                            "type": "integer",
                                            "description": "Poste dépense 9 en HT"
                                        },
                                        "poste_depense10": {
                                            "type": "integer",
                                            "description": "Poste dépense 10 en HT"
                                        },
                                        "poste_info1": {
                                            "type": "integer",
                                            "description": "Poste information 1 en HT"
                                        },
                                        "poste_info2": {
                                            "type": "integer",
                                            "description": "Poste information 2 en HT"
                                        },
                                        "poste_info3": {
                                            "type": "integer",
                                            "description": "Poste information 3 en HT"
                                        },
                                        "poste_info4": {
                                            "type": "integer",
                                            "description": "Poste information 4 en HT"
                                        },
                                        "poste_info5": {
                                            "type": "integer",
                                            "description": "Poste information 5 en HT"
                                        },
                                        "poste_info6": {
                                            "type": "integer",
                                            "description": "Poste information 6 en HT"
                                        },
                                        "poste_info7": {
                                            "type": "integer",
                                            "description": "Poste information 7 en HT"
                                        },
                                        "poste_info8": {
                                            "type": "integer",
                                            "description": "Poste information 8 en HT"
                                        },
                                        "poste_info9": {
                                            "type": "integer",
                                            "description": "Poste information 9 en HT"
                                        },
                                        "poste_info10": {
                                            "type": "integer",
                                            "description": "Poste information 10 en HT"
                                        },
                                        "loyerHTAnn": {
                                            "type": "integer",
                                            "description": "Loyer HT annuel / m²"
                                        },
                                        "loyerHTMens": {
                                            "type": "integer",
                                            "description": "Loyer HT mensuel / m²"
                                        },
                                        "loyerTTCAnn": {
                                            "type": "integer",
                                            "description": "Loyer TTC annuel / m²"
                                        },
                                        "loyerTTCMens": {
                                            "type": "integer",
                                            "description": "Loyer TTC mensuel / m²"
                                        },
                                        "loyerHTAnnTotal": {
                                            "type": "integer",
                                            "description": "Loyer total HT annuel"
                                        },
                                        "loyerHTMensTotal": {
                                            "type": "integer",
                                            "description": "Loyer total HT mensuel"
                                        },
                                        "loyerTTCAnnTotal": {
                                            "type": "integer",
                                            "description": "Loyer total TTC annuel"
                                        },
                                        "loyerTTCMensTotal": {
                                            "type": "integer",
                                            "description": "Loyer total TTC mensuel"
                                        },
                                        "rentabilite": {
                                            "type": "integer",
                                            "description": "Rentabilité de la tranche"
                                        },
                                        "tc_montant1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant1"
                                        },
                                        "tc_montant2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant2"
                                        },
                                        "tc_montant3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant3"
                                        },
                                        "tc_montant4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant4"
                                        },
                                        "tc_montant5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant5"
                                        },
                                        "tc_montant6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant6",
                                            "version": "18.0"
                                        },
                                        "tc_montant7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant7",
                                            "version": "18.0"
                                        },
                                        "tc_montant8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant8",
                                            "version": "18.0"
                                        },
                                        "tc_montant9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant9",
                                            "version": "18.0"
                                        },
                                        "tc_montant10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale montant10",
                                            "version": "18.0"
                                        },
                                        "tc_decimal1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal1"
                                        },
                                        "tc_decimal2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal2"
                                        },
                                        "tc_decimal3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal3"
                                        },
                                        "tc_decimal4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal4"
                                        },
                                        "tc_decimal5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal5"
                                        },
                                        "tc_decimal6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal6",
                                            "version": "18.0"
                                        },
                                        "tc_decimal7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal7",
                                            "version": "18.0"
                                        },
                                        "tc_decimal8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal8",
                                            "version": "18.0"
                                        },
                                        "tc_decimal9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal9",
                                            "version": "18.0"
                                        },
                                        "tc_decimal10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur tranche commerciale decimal10",
                                            "version": "18.0"
                                        },
                                        "tc_entier1": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier1"
                                        },
                                        "tc_entier2": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier2"
                                        },
                                        "tc_entier3": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier3"
                                        },
                                        "tc_entier4": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier4"
                                        },
                                        "tc_entier5": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier5"
                                        },
                                        "tc_entier6": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier6",
                                            "version": "18.0"
                                        },
                                        "tc_entier7": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier7",
                                            "version": "18.0"
                                        },
                                        "tc_entier8": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier8",
                                            "version": "18.0"
                                        },
                                        "tc_entier9": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier9",
                                            "version": "18.0"
                                        },
                                        "tc_entier10": {
                                            "type": "number",
                                            "description": "Valeur tranche commerciale entier10",
                                            "version": "18.0"
                                        },
                                        "tc_flag1": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag1"
                                        },
                                        "tc_flag2": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag2"
                                        },
                                        "tc_flag3": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag3"
                                        },
                                        "tc_flag4": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag4"
                                        },
                                        "tc_flag5": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag5"
                                        },
                                        "tc_flag6": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag6",
                                            "version": "18.0"
                                        },
                                        "tc_flag7": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag7",
                                            "version": "18.0"
                                        },
                                        "tc_flag8": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag8",
                                            "version": "18.0"
                                        },
                                        "tc_flag9": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag9",
                                            "version": "18.0"
                                        },
                                        "tc_flag10": {
                                            "type": "boolean",
                                            "description": "Valeur tranche commerciale flag10",
                                            "version": "18.0"
                                        },
                                        "tc_date1": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date1"
                                        },
                                        "tc_date2": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date2"
                                        },
                                        "tc_date3": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date3"
                                        },
                                        "tc_date4": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date4"
                                        },
                                        "tc_date5": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date5"
                                        },
                                        "tc_date6": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date6",
                                            "version": "18.0"
                                        },
                                        "tc_date7": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date7",
                                            "version": "18.0"
                                        },
                                        "tc_date8": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date8",
                                            "version": "18.0"
                                        },
                                        "tc_date9": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date9",
                                            "version": "18.0"
                                        },
                                        "tc_date10": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur tranche commerciale date10",
                                            "version": "18.0"
                                        },
                                        "tc_texte1": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte1"
                                        },
                                        "tc_texte2": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte2"
                                        },
                                        "tc_texte3": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte3"
                                        },
                                        "tc_texte4": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte4"
                                        },
                                        "tc_texte5": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte5"
                                        },
                                        "tc_texte6": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte6",
                                            "version": "18.0"
                                        },
                                        "tc_texte7": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte7",
                                            "version": "18.0"
                                        },
                                        "tc_texte8": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte8",
                                            "version": "18.0"
                                        },
                                        "tc_texte9": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte9",
                                            "version": "18.0"
                                        },
                                        "tc_texte10": {
                                            "type": "string",
                                            "description": "Valeur  tranche commerciale texte10",
                                            "version": "18.0"
                                        },
                                        "tc_codif1": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif1",
                                            "codif": "OpTCExt_codif1"
                                        },
                                        "tc_codif2": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif2",
                                            "codif": "OpTCExt_codif2"
                                        },
                                        "tc_codif3": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif3",
                                            "codif": "OpTCExt_codif3"
                                        },
                                        "tc_codif4": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif4",
                                            "codif": "OpTCExt_codif4"
                                        },
                                        "tc_codif5": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif5",
                                            "codif": "OpTCExt_codif5"
                                        },
                                        "tc_codif6": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif6",
                                            "codif": "OpTCExt_codif6",
                                            "version": "18.0"
                                        },
                                        "tc_codif7": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif7",
                                            "codif": "OpTCExt_codif7",
                                            "version": "18.0"
                                        },
                                        "tc_codif8": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif8",
                                            "codif": "OpTCExt_codif8",
                                            "version": "18.0"
                                        },
                                        "tc_codif9": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif9",
                                            "codif": "OpTCExt_codif9",
                                            "version": "18.0"
                                        },
                                        "tc_codif10": {
                                            "type": "string",
                                            "description": "Valeur tranche commerciale codif10",
                                            "codif": "OpTCExt_codif10",
                                            "version": "18.0"
                                        }
                                    }
                                }
                            },
                            "statuts_commerciaux": {
                                "type": "array",
                                "description": "Liste des statuts commerciaux",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tc_code": {
                                            "type": "string",
                                            "description": "Code tranche commerciale"
                                        },
                                        "tc_lib": {
                                            "type": "string",
                                            "description": "Libellé tranche commerciale"
                                        },
                                        "tt_code": {
                                            "type": "string",
                                            "description": "Code tranche travaux"
                                        },
                                        "tt_lib": {
                                            "type": "string",
                                            "description": "Libellé tranche travaux"
                                        },
                                        "sc_statut": {
                                            "type": "string",
                                            "description": "Statut commercial",
                                            "enumId": "RVLotImmo.statut"
                                        },
                                        "sc_type": {
                                            "type": "string",
                                            "description": "Type de lots"
                                        },
                                        "sc_typeLot": {
                                            "type": "string",
                                            "description": "Typologie du lot",
                                            "codif": "TYPELOT"
                                        },
                                        "sc_nb": {
                                            "type": "integer",
                                            "description": "Nombre total de lots"
                                        },
                                        "sc_caHT": {
                                            "type": "integer",
                                            "description": "Chiffre d'affaires HT"
                                        },
                                        "sc_caTTC": {
                                            "type": "integer",
                                            "description": "Chiffre d'affaires TTC"
                                        },
                                        "sc_surf": {
                                            "type": "integer",
                                            "description": "Total surfaces en m2"
                                        }
                                    }
                                }
                            },
                            "typologies": {
                                "type": "array",
                                "description": "Liste des typologies",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tc_code": {
                                            "type": "string",
                                            "description": "Code tranche commerciale"
                                        },
                                        "tc_lib": {
                                            "type": "string",
                                            "description": "Libellé tranche commerciale"
                                        },
                                        "tt_code": {
                                            "type": "string",
                                            "description": "Code tranche travaux"
                                        },
                                        "tt_lib": {
                                            "type": "string",
                                            "description": "Libellé tranche travaux"
                                        },
                                        "typo_type": {
                                            "type": "string",
                                            "description": "Type de lots"
                                        },
                                        "typo_typeLot": {
                                            "type": "string",
                                            "description": "Typologie du lot",
                                            "codif": "TYPELOT"
                                        },
                                        "typo_nature": {
                                            "type": "string",
                                            "description": "Nature du lot"
                                        },
                                        "typo_nb": {
                                            "type": "integer",
                                            "description": "Nombre total de lots"
                                        },
                                        "typo_caHT": {
                                            "type": "integer",
                                            "description": "Chiffre d'affaires HT"
                                        },
                                        "typo_caTTC": {
                                            "type": "integer",
                                            "description": "Chiffre d'affaires TTC"
                                        },
                                        "typo_surf": {
                                            "type": "integer",
                                            "description": "Total surfaces en m2"
                                        },
                                        "typo_loyerAnnHT": {
                                            "type": "integer",
                                            "description": "Loyer HT annuel / m2"
                                        },
                                        "typo_loyerMensTTC": {
                                            "type": "integer",
                                            "description": "Loyer TTC mensuel / m2"
                                        },
                                        "typo_unique": {
                                            "type": "boolean",
                                            "description": "Lot unique"
                                        },
                                        "typo_dation": {
                                            "type": "boolean",
                                            "description": "Dation"
                                        },
                                        "typo_mntDationHT": {
                                            "type": "integer",
                                            "description": "Montant dation HT"
                                        },
                                        "typo_mntDationTTC": {
                                            "type": "integer",
                                            "description": "Montant dation TTC"
                                        },
                                        "typo_rentabilite": {
                                            "type": "integer",
                                            "description": "Rentabilité"
                                        },
                                        "typo_tantieme": {
                                            "type": "string",
                                            "description": "Tantième"
                                        }
                                    }
                                }
                            },
                            "lots": {
                                "type": "array",
                                "description": "Liste des lots de la grille de prix de vente",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tc_code": {
                                            "type": "string",
                                            "description": "Code tranche commerciale"
                                        },
                                        "tc_lib": {
                                            "type": "string",
                                            "description": "Libellé tranche commerciale"
                                        },
                                        "tt_code": {
                                            "type": "string",
                                            "description": "Code tranche travaux"
                                        },
                                        "tt_lib": {
                                            "type": "string",
                                            "description": "Libellé tranche travaux"
                                        },
                                        "gpv_numero": {
                                            "type": "string",
                                            "description": "Numéro du lot"
                                        },
                                        "gpv_numeroConso": {
                                            "type": "string",
                                            "description": "Numéro lot consolidé"
                                        },
                                        "gpv_type": {
                                            "type": "string",
                                            "description": "Type de lots"
                                        },
                                        "gpv_typeLot": {
                                            "type": "string",
                                            "description": "Typologie du lot",
                                            "codif": "TYPELOT"
                                        },
                                        "gpv_nature": {
                                            "type": "string",
                                            "description": "Nature du lot"
                                        },
                                        "gpv_surface": {
                                            "type": "integer",
                                            "description": "Surface"
                                        },
                                        "gpv_typeSurface": {
                                            "type": "string",
                                            "description": "Type de surface"
                                        },
                                        "gpv_etage": {
                                            "type": "string",
                                            "description": "Etage"
                                        },
                                        "gpv_batiment": {
                                            "type": "string",
                                            "description": "Bâtiment"
                                        },
                                        "gpv_escalier": {
                                            "type": "string",
                                            "description": "Escalier"
                                        },
                                        "gpv_expoPrincipale": {
                                            "type": "string",
                                            "description": "Exposition principale"
                                        },
                                        "gpv_expoSecondaire": {
                                            "type": "string",
                                            "description": "Exposition secondaire"
                                        },
                                        "gpv_numeroCopro": {
                                            "type": "string",
                                            "description": "Numéro de copropriété"
                                        },
                                        "gpv_tantieme": {
                                            "type": "integer",
                                            "description": "Tantièmes"
                                        },
                                        "gpv_prixBudgetHT": {
                                            "type": "integer",
                                            "description": "Prix budget HT"
                                        },
                                        "gpv_prixBudgetTTC": {
                                            "type": "integer",
                                            "description": "Prix budget TTC"
                                        },
                                        "gpv_tauxTVA": {
                                            "type": "integer",
                                            "description": "Taux de TVA"
                                        },
                                        "gpv_prixCommercialHT": {
                                            "type": "integer",
                                            "description": "Prix commercial HT"
                                        },
                                        "gpv_prixCommercialTTC": {
                                            "type": "integer",
                                            "description": "Prix commercial TTC"
                                        },
                                        "gpv_statut": {
                                            "type": "string",
                                            "description": "Statut du lot",
                                            "enumId": "RVLotImmo.statut"
                                        },
                                        "gpv_libDossier": {
                                            "type": "string",
                                            "description": "Libellé dossier client"
                                        },
                                        "gpv_origineContact": {
                                            "type": "string",
                                            "description": "Origine contact"
                                        },
                                        "gpv_qualiteClient": {
                                            "type": "string",
                                            "description": "Qualité du client"
                                        },
                                        "gpv_dateReservation": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date réservation"
                                        },
                                        "gpv_dateVente": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date vente"
                                        },
                                        "gpv_dateLivraison": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de livraison"
                                        },
                                        "gpv_dation": {
                                            "type": "boolean",
                                            "description": "Dation"
                                        }
                                    }
                                }
                            },
                            "vendeurs": {
                                "type": "array",
                                "description": "Vendeurs",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "gpv_codedossier": {
                                            "type": "string",
                                            "description": "Code dossier client"
                                        },
                                        "gpv_libelleDossier": {
                                            "type": "string",
                                            "description": "Libellé dossier client"
                                        },
                                        "gpv_vendeur": {
                                            "type": "string",
                                            "description": "Vendeur"
                                        },
                                        "gpv_represVendeur": {
                                            "type": "string",
                                            "description": "Représentant du vendeur"
                                        },
                                        "gpv_typeVendeur": {
                                            "type": "string",
                                            "description": "Type vendeur",
                                            "codif": "TypeVendeur"
                                        },
                                        "gpv_baseComVendeur": {
                                            "type": "string",
                                            "description": "Base commission vendeur"
                                        },
                                        "gpv_baseComVendeurTTC": {
                                            "type": "string",
                                            "description": "Base commission TTC"
                                        },
                                        "gpv_tauxComVendeur": {
                                            "type": "string",
                                            "description": "Taux de commission vendeur"
                                        },
                                        "gpv_comVendeurHT": {
                                            "type": "string",
                                            "description": "Commission vendeur HT"
                                        },
                                        "gpv_comVendeurTTC": {
                                            "type": "string",
                                            "description": "Commission vendeur TTC"
                                        },
                                        "gpv_vendeurCommentaire": {
                                            "type": "string",
                                            "description": "Commentaire vendeur"
                                        },
                                        "vend_statutDossier": {
                                            "type": "string",
                                            "enumId": "RVDossier.statut",
                                            "description": "Statut du dossier"
                                        }
                                    }
                                }
                            },
                            "tranches_locatives": {
                                "type": "array",
                                "description": "Liste des tranches locatives",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tl_code": {
                                            "type": "string",
                                            "description": "Code tranche locative"
                                        },
                                        "tl_lib": {
                                            "type": "string",
                                            "description": "Libellé tranche locative"
                                        },
                                        "tl_natureTravaux": {
                                            "type": "string",
                                            "description": "nature travaux tranche locative"
                                        },
                                        "tl_typeOuvrage": {
                                            "type": "string",
                                            "description": "Type ouvrage tranche locative"
                                        },
                                        "tl_financement": {
                                            "type": "string",
                                            "description": "Financement tranche locative",
                                            "codif": "OpTypeFin"
                                        },
                                        "tl_typeProgramme": {
                                            "type": "string",
                                            "description": "Type programme tranche locative"
                                        },
                                        "tl_activite": {
                                            "type": "string",
                                            "description": "Activité tranche locative",
                                            "codif": "OpActivite"
                                        }
                                    }
                                }
                            },
                            "associes": {
                                "type": "array",
                                "description": "liste des associés",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "assoc_libelle": {
                                            "type": "string",
                                            "description": "nom associé"
                                        },
                                        "assoc_nbPart": {
                                            "type": "number",
                                            "description": "nombre de parts de l'associé"
                                        },
                                        "assoc_mnt": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "montant des parts de l'associé"
                                        },
                                        "assoc_prct": {
                                            "type": "number",
                                            "description": "pourcentage capital de l'associé",
                                            "decimals": 5,
                                            "precision": 9
                                        },
                                        "assoc_partSurMarge": {
                                            "type": "number",
                                            "decimals": 5,
                                            "precision": 9,
                                            "description": "pourcentage marge de l'associé"
                                        },
                                        "assoc_partCptCourant": {
                                            "type": "number",
                                            "decimals": 5,
                                            "precision": 9,
                                            "description": "pourcentage compte courant de l'associé"
                                        },
                                        "assoc_appGroupe": {
                                            "type": "boolean",
                                            "description": "Appartient au groupe"
                                        }
                                    }
                                }
                            },
                            "intervenants": {
                                "type": "array",
                                "description": "Liste des intervenants",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "int_acteur": {
                                            "type": "string",
                                            "description": "acteur"
                                        },
                                        "int_type": {
                                            "type": "string",
                                            "description": "type"
                                        },
                                        "int_intervenant": {
                                            "type": "string",
                                            "description": "intervenant"
                                        },
                                        "int_lotMarche": {
                                            "type": "string",
                                            "description": "lot marché"
                                        }
                                    }
                                }
                            },
                            "dates": {
                                "type": "array",
                                "description": "Liste des dates",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "dop_etape": {
                                            "type": "string",
                                            "description": "étape"
                                        },
                                        "dop_action": {
                                            "type": "string",
                                            "description": "action"
                                        },
                                        "dop_actionComp": {
                                            "type": "string",
                                            "description": "libellé action de la version comparée"
                                        },
                                        "dop_codeEtape": {
                                            "type": "string",
                                            "description": "code étape"
                                        },
                                        "dop_codeAction": {
                                            "type": "string",
                                            "description": "code action"
                                        },
                                        "dop_datePrev": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date prévue action"
                                        },
                                        "dop_datePrevComp": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date prévue action de la version comparée"
                                        },
                                        "dop_dateReal": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date réalisée action"
                                        },
                                        "dop_dateRealComp": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date réalisée action de la version comparée"
                                        },
                                        "dop_planning": {
                                            "type": "boolean",
                                            "description": "planning"
                                        },
                                        "dop_planningComp": {
                                            "type": "boolean",
                                            "description": "planning de la version comparée"
                                        },
                                        "dop_treso": {
                                            "type": "boolean",
                                            "description": "trésorerie"
                                        },
                                        "dop_recette": {
                                            "type": "boolean",
                                            "description": "recette"
                                        },
                                        "dop_refAdmin": {
                                            "type": "string",
                                            "description": "référence administrative"
                                        }
                                    }
                                }
                            },
                            "reservataires": {
                                "type": "array",
                                "description": "Liste des réservataires par tranche locative",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "tl_code": {
                                            "type": "string",
                                            "description": "Code tranche locative"
                                        },
                                        "tl_lib": {
                                            "type": "string",
                                            "description": "Libellé tranche locative"
                                        },
                                        "res_nomReservataire": {
                                            "type": "string",
                                            "description": "Nom du réservataire",
                                            "codif": "OpTypeReserv"
                                        },
                                        "res_nbLoge": {
                                            "type": "integer",
                                            "description": "Nombre de logements du réservataire"
                                        }
                                    }
                                }
                            },
                            "foncier": {
                                "type": "array",
                                "description": "",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "foncier_code": {
                                            "type": "string",
                                            "description": "Code foncier"
                                        },
                                        "foncier_lib": {
                                            "type": "string",
                                            "description": "Libellé foncier"
                                        },
                                        "foncier_statut": {
                                            "type": "string",
                                            "description": "Statut foncier",
                                            "enumId": "Foncier.statut"
                                        },
                                        "foncier_surf": {
                                            "type": "integer",
                                            "description": "Surface totale des parcelles"
                                        },
                                        "foncier_texte1": {
                                            "type": "string",
                                            "description": "Valeur foncier texte1"
                                        },
                                        "foncier_texte2": {
                                            "type": "string",
                                            "description": "Valeur foncier texte2"
                                        },
                                        "foncier_texte3": {
                                            "type": "string",
                                            "description": "Valeur foncier texte3"
                                        },
                                        "foncier_texte4": {
                                            "type": "string",
                                            "description": "Valeur foncier texte4"
                                        },
                                        "foncier_texte5": {
                                            "type": "string",
                                            "description": "Valeur foncier texte5"
                                        },
                                        "foncier_codif1": {
                                            "type": "string",
                                            "description": "Valeur foncier codif1",
                                            "codif": "Foncier_codif1"
                                        },
                                        "foncier_codif2": {
                                            "type": "string",
                                            "description": "Valeur foncier codif2",
                                            "codif": "Foncier_codif2"
                                        },
                                        "foncier_codif3": {
                                            "type": "string",
                                            "description": "Valeur foncier codif3",
                                            "codif": "Foncier_codif3"
                                        },
                                        "foncier_codif4": {
                                            "type": "string",
                                            "description": "Valeur foncier codif4",
                                            "codif": "Foncier_codif4"
                                        },
                                        "foncier_codif5": {
                                            "type": "string",
                                            "description": "Valeur foncier codif5",
                                            "codif": "Foncier_codif5"
                                        }
                                    }
                                }
                            },
                            "parcelles": {
                                "type": "array",
                                "description": "Liste des parcelles",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "foncier_code": {
                                            "type": "string",
                                            "description": "Code foncier"
                                        },
                                        "foncier_lib": {
                                            "type": "string",
                                            "description": "Libellé foncier"
                                        },
                                        "foncier_statut": {
                                            "type": "string",
                                            "description": "Statut foncier",
                                            "enumId": "Foncier.statut"
                                        },
                                        "foncier_surf": {
                                            "type": "integer",
                                            "description": "Surface totale des parcelles"
                                        },
                                        "parcelle_num": {
                                            "type": "string",
                                            "description": "Numéro"
                                        },
                                        "parcelle_lib": {
                                            "type": "string",
                                            "description": "Libellé"
                                        },
                                        "parcelle_statut": {
                                            "type": "string",
                                            "description": "Statut",
                                            "enumId": "FonParcelle.statut"
                                        },
                                        "parcelle_prefixe": {
                                            "type": "string",
                                            "description": "Préfixe"
                                        },
                                        "parcelle_section": {
                                            "type": "string",
                                            "description": "Section"
                                        },
                                        "parcelle_adr_voie": {
                                            "type": "string",
                                            "description": "adresse rue"
                                        },
                                        "parcelle_adr_cp": {
                                            "type": "string",
                                            "description": "adresse code postal"
                                        },
                                        "parcelle_adr_localite": {
                                            "type": "string",
                                            "description": "adresse localité"
                                        },
                                        "parcelle_zonage": {
                                            "type": "string",
                                            "description": "Zonage"
                                        },
                                        "parcelle_surf": {
                                            "type": "integer",
                                            "description": "Surface"
                                        },
                                        "parcelle_surfDemol": {
                                            "type": "integer",
                                            "description": "Surface à démolir"
                                        },
                                        "parcelle_surfBati": {
                                            "type": "integer",
                                            "description": "Surface bâtie"
                                        },
                                        "parcelle_hauteur": {
                                            "type": "integer",
                                            "description": "Hauteur des constructions"
                                        },
                                        "parcelle_empSol": {
                                            "type": "integer",
                                            "description": "Emprise au sol du bâti"
                                        },
                                        "dosFoncier_lib": {
                                            "type": "string",
                                            "description": "Propriétaire"
                                        },
                                        "dosFoncier_dateActe": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date acté"
                                        },
                                        "dosFoncier_mntHT": {
                                            "type": "integer",
                                            "description": "Montant HT"
                                        },
                                        "dosFoncier_mntTTC": {
                                            "type": "integer",
                                            "description": "Montant TTC"
                                        },
                                        "dosFoncier_mntDation": {
                                            "type": "integer",
                                            "description": "Montant TTC dation"
                                        },
                                        "dosFoncier_mntSoulte": {
                                            "type": "integer",
                                            "description": "Montant TTC Soulte"
                                        },
                                        "parcelle_surface1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface1"
                                        },
                                        "parcelle_surface2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface2"
                                        },
                                        "parcelle_surface3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface3"
                                        },
                                        "parcelle_surface4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface4"
                                        },
                                        "parcelle_surface5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface5"
                                        },
                                        "parcelle_surface6": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface6"
                                        },
                                        "parcelle_surface7": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface7"
                                        },
                                        "parcelle_surface8": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface8"
                                        },
                                        "parcelle_surface9": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface9"
                                        },
                                        "parcelle_surface10": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur parcelle surface10"
                                        },
                                        "parcelle_date1": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date1"
                                        },
                                        "parcelle_date2": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date2"
                                        },
                                        "parcelle_date3": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date3"
                                        },
                                        "parcelle_date4": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date4"
                                        },
                                        "parcelle_date5": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur parcelle date5"
                                        },
                                        "parcelle_texte1": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte1"
                                        },
                                        "parcelle_texte2": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte2"
                                        },
                                        "parcelle_texte3": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte3"
                                        },
                                        "parcelle_texte4": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte4"
                                        },
                                        "parcelle_texte5": {
                                            "type": "string",
                                            "description": "Valeur parcelle texte5"
                                        },
                                        "parcelle_codif1": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif1",
                                            "codif": "FonParcelle_codif1"
                                        },
                                        "parcelle_codif2": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif2",
                                            "codif": "FonParcelle_codif2"
                                        },
                                        "parcelle_codif3": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif3",
                                            "codif": "FonParcelle_codif3"
                                        },
                                        "parcelle_codif4": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif4",
                                            "codif": "FonParcelle_codif4"
                                        },
                                        "parcelle_codif5": {
                                            "type": "string",
                                            "description": "Valeur parcelle codif5",
                                            "codif": "FonParcelle_codif5"
                                        }
                                    }
                                }
                            },
                            "dosFoncier": {
                                "type": "array",
                                "description": "",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "dosFoncier_lib": {
                                            "type": "string",
                                            "description": "Dossier propriétaire"
                                        },
                                        "dosFoncier_statut": {
                                            "type": "string",
                                            "enumId": "FonDossier.statut",
                                            "description": "Statut dossier"
                                        },
                                        "dosFoncier_natureOffre": {
                                            "type": "string",
                                            "codif": "FonNatOffre",
                                            "description": "Nature offre"
                                        },
                                        "dosFoncier_dtOffre": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date offre"
                                        },
                                        "dosFoncier_dtOffreSigne": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date offre contresignée"
                                        },
                                        "dosFoncier_dtEnreg": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date enregistrement"
                                        },
                                        "dosFoncier_dtLeveeOption": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date levée option"
                                        },
                                        "dosFoncier_dtEch": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date échéance"
                                        },
                                        "dosFoncier_dateActe": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date acté"
                                        },
                                        "dosFoncier_mntHT": {
                                            "type": "integer",
                                            "description": "Montant HT"
                                        },
                                        "dosFoncier_mntTTC": {
                                            "type": "integer",
                                            "description": "Montant TTC"
                                        },
                                        "dosFoncier_mntDation": {
                                            "type": "integer",
                                            "description": "Montant TTC dation"
                                        },
                                        "dosFoncier_mntSoulte": {
                                            "type": "integer",
                                            "description": "Montant TTC Soulte"
                                        },
                                        "dosFoncier_montant1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire montant1"
                                        },
                                        "dosFoncier_montant2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire montant2"
                                        },
                                        "dosFoncier_montant3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire montant3"
                                        },
                                        "dosFoncier_montant4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire montant4"
                                        },
                                        "dosFoncier_montant5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire montant5"
                                        },
                                        "dosFoncier_decimal1": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire decimal1"
                                        },
                                        "dosFoncier_decimal2": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire decimal2"
                                        },
                                        "dosFoncier_decimal3": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire decimal3"
                                        },
                                        "dosFoncier_decimal4": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire decimal4"
                                        },
                                        "dosFoncier_decimal5": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Valeur proprietaire decimal5"
                                        },
                                        "dosFoncier_entier1": {
                                            "type": "number",
                                            "description": "Valeur proprietaire entier1"
                                        },
                                        "dosFoncier_entier2": {
                                            "type": "number",
                                            "description": "Valeur proprietaire entier2"
                                        },
                                        "dosFoncier_entier3": {
                                            "type": "number",
                                            "description": "Valeur proprietaire entier3"
                                        },
                                        "dosFoncier_entier4": {
                                            "type": "number",
                                            "description": "Valeur proprietaire entier4"
                                        },
                                        "dosFoncier_entier5": {
                                            "type": "number",
                                            "description": "Valeur proprietaire entier5"
                                        },
                                        "dosFoncier_flag1": {
                                            "type": "boolean",
                                            "description": "Valeur proprietaire flag1"
                                        },
                                        "dosFoncier_flag2": {
                                            "type": "boolean",
                                            "description": "Valeur proprietaire flag2"
                                        },
                                        "dosFoncier_flag3": {
                                            "type": "boolean",
                                            "description": "Valeur proprietaire flag3"
                                        },
                                        "dosFoncier_flag4": {
                                            "type": "boolean",
                                            "description": "Valeur proprietaire flag4"
                                        },
                                        "dosFoncier_flag5": {
                                            "type": "boolean",
                                            "description": "Valeur proprietaire flag5"
                                        },
                                        "dosFoncier_date1": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur proprietaire date1"
                                        },
                                        "dosFoncier_date2": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur proprietaire date2"
                                        },
                                        "dosFoncier_date3": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur proprietaire date3"
                                        },
                                        "dosFoncier_date4": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur proprietaire date4"
                                        },
                                        "dosFoncier_date5": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Valeur proprietaire date5"
                                        },
                                        "dosFoncier_texte1": {
                                            "type": "string",
                                            "description": "Valeur proprietaire texte1"
                                        },
                                        "dosFoncier_texte2": {
                                            "type": "string",
                                            "description": "Valeur proprietaire texte2"
                                        },
                                        "dosFoncier_texte3": {
                                            "type": "string",
                                            "description": "Valeur proprietaire texte3"
                                        },
                                        "dosFoncier_texte4": {
                                            "type": "string",
                                            "description": "Valeur proprietaire texte4"
                                        },
                                        "dosFoncier_texte5": {
                                            "type": "string",
                                            "description": "Valeur proprietaire texte5"
                                        },
                                        "dosFoncier_codif1": {
                                            "type": "string",
                                            "description": "Valeur proprietaire codif1",
                                            "codif": "FonDossier_codif1"
                                        },
                                        "dosFoncier_codif2": {
                                            "type": "string",
                                            "description": "Valeur proprietaire codif2",
                                            "codif": "FonDossier_codif2"
                                        },
                                        "dosFoncier_codif3": {
                                            "type": "string",
                                            "description": "Valeur proprietaire codif3",
                                            "codif": "FonDossier_codif3"
                                        },
                                        "dosFoncier_codif4": {
                                            "type": "string",
                                            "description": "Valeur proprietaire codif4",
                                            "codif": "FonDossier_codif4"
                                        },
                                        "dosFoncier_codif5": {
                                            "type": "string",
                                            "description": "Valeur proprietaire codif5",
                                            "codif": "FonDossier_codif5"
                                        }
                                    }
                                }
                            },
                            "commercialisation": {
                                "type": "array",
                                "description": "",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "comm_codeTC": {
                                            "type": "string",
                                            "description": "Code tranche commerciale"
                                        },
                                        "comm_libTC": {
                                            "type": "string",
                                            "description": "Libellé tranche commerciale"
                                        },
                                        "comm_codeTT": {
                                            "type": "string",
                                            "description": "Code tranche travaux"
                                        },
                                        "comm_libTT": {
                                            "type": "string",
                                            "description": "Libellé tranche travaux"
                                        },
                                        "comm_typeVal": {
                                            "type": "string",
                                            "description": "type valeur",
                                            "enumId": "RVCommValeur.typeVal"
                                        },
                                        "comm_niveau": {
                                            "type": "string",
                                            "description": "Détail",
                                            "enumId": "RVCommValeur.niveauCumul"
                                        },
                                        "comm_categorie": {
                                            "type": "string",
                                            "description": "Catégorie",
                                            "enumId": "RVCommValeur.etape"
                                        },
                                        "comm_lotSec": {
                                            "type": "boolean",
                                            "description": "lot secondaire exclusif"
                                        },
                                        "comm_dtCalcul": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date actualisation"
                                        },
                                        "comm_dtVal": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "date valeur"
                                        },
                                        "comm_quantite": {
                                            "type": "number",
                                            "description": "Quantité"
                                        },
                                        "comm_surface": {
                                            "type": "number",
                                            "description": "Surface"
                                        },
                                        "comm_mntHT": {
                                            "type": "number",
                                            "description": "Montant HT"
                                        },
                                        "comm_mntTTC": {
                                            "type": "number",
                                            "description": "Montant TTC"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "Tiers": {
        "schemas": {
            "type": "object",
            "properties": {
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "Tiers",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "code tiers"
                            },
                            "libelle": {
                                "type": "string",
                                "description": "libellé tiers"
                            },
                            "type_tiers": {
                                "type": "string",
                                "description": "type de tiers",
                                "enumId": "SpoTiers.typeTiers"
                            },
                            "statut": {
                                "type": "string",
                                "description": "statut (actif/non actif)"
                            },
                            "mail": {
                                "type": "string",
                                "description": "mail"
                            },
                            "site_web": {
                                "type": "string",
                                "description": "site internet"
                            },
                            "phone": {
                                "type": "string",
                                "description": "téléphone"
                            },
                            "adrPays": {
                                "type": "string",
                                "description": "adrPays"
                            },
                            "adrNomVoie": {
                                "type": "string",
                                "description": "adrNomVoie"
                            },
                            "adrNomRemise": {
                                "type": "string",
                                "description": "adrNomRemise"
                            },
                            "adrComplement": {
                                "type": "string",
                                "description": "adrComplement"
                            },
                            "adrCP": {
                                "type": "string",
                                "description": "adrCP"
                            },
                            "adrLocalite": {
                                "type": "string",
                                "description": "adrLocalite"
                            },
                            "commentaire": {
                                "type": "string",
                                "description": "observations (commentaire)"
                            },
                            "siret": {
                                "type": "string",
                                "description": "siret"
                            },
                            "tvaIntraUE": {
                                "type": "string",
                                "description": "n° TVA intracom"
                            },
                            "raison_sociale": {
                                "type": "string",
                                "description": "raison sociale"
                            },
                            "nom_commercial": {
                                "type": "string",
                                "description": "nom commercial"
                            },
                            "ape": {
                                "type": "string",
                                "description": "code NAF/APE"
                            },
                            "forme_juridique": {
                                "type": "string",
                                "description": "formeJuridique",
                                "codif": "FormeJuridique"
                            },
                            "%societe_image_270x180": {
                                "type": "string",
                                "description": "logo"
                            },
                            "appGroupe": {
                                "type": "boolean",
                                "description": "appartient au groupe"
                            },
                            "ref_comptable": {
                                "type": "string",
                                "description": "référence comptable"
                            },
                            "ref_externe": {
                                "type": "string",
                                "description": "référence externe"
                            },
                            "compte_credit": {
                                "type": "string",
                                "description": "compte créditeur"
                            },
                            "compte_debit": {
                                "type": "string",
                                "description": "compte débiteur"
                            },
                            "role": {
                                "type": "string",
                                "description": "role"
                            },
                            "repres_civ": {
                                "type": "string",
                                "description": "civilité du Représentant principal titulaire",
                                "codif": "Civilite"
                            },
                            "repres_prenom": {
                                "type": "string",
                                "description": "prénom du Représentant principal titulaire"
                            },
                            "repres_nom": {
                                "type": "string",
                                "description": "nom du Représentant principal titulaire"
                            },
                            "repres_service": {
                                "type": "string",
                                "description": "service Représentant principal titulaire"
                            },
                            "repres_fonction": {
                                "type": "string",
                                "description": "fonction Représentant principal titulaire"
                            },
                            "repres_mail": {
                                "type": "string",
                                "description": "mail Représentant principal titulaire"
                            },
                            "repres_phoneMobile": {
                                "type": "string",
                                "description": "portable Représentant principal titulaire"
                            },
                            "repres_statut": {
                                "type": "string",
                                "description": "statut Représentant (actif/non actif)"
                            },
                            "repres_adrPays": {
                                "type": "string",
                                "description": "adrPays du Représentant principal titulaire"
                            },
                            "repres_adrNomVoie": {
                                "type": "string",
                                "description": "adrNomVoie du Représentant principal titulaire"
                            },
                            "repres_adrNomRemise": {
                                "type": "string",
                                "description": "adrNomRemise du Représentant principal titulaire"
                            },
                            "repres_adrComplement": {
                                "type": "string",
                                "description": "adrComplement du Représentant principal titulaire"
                            },
                            "repres_adrCP": {
                                "type": "string",
                                "description": "adrCP du Représentant principal titulaire"
                            },
                            "repres_adrLocalite": {
                                "type": "string",
                                "description": "adrLocalite du Représentant principal titulaire"
                            },
                            "capital": {
                                "type": "number",
                                "format": "money",
                                "description": "capital social du tiers personne morale"
                            },
                            "objet_entreprise": {
                                "type": "string",
                                "description": "objet de l'entreprise"
                            },
                            "date_activite": {
                                "type": "string",
                                "format": "date",
                                "description": "date début d'activité"
                            },
                            "date_fermeture": {
                                "type": "string",
                                "format": "date",
                                "description": "date de fermeture"
                            },
                            "tribunal_comm": {
                                "type": "string",
                                "description": "tribunal de commerce"
                            },
                            "rcs": {
                                "type": "string",
                                "description": "numéro RCS"
                            },
                            "bdc_delai": {
                                "type": "number",
                                "description": "factures directes et BDC délai"
                            },
                            "bdc_base": {
                                "type": "string",
                                "description": "factures directes et BDC base",
                                "enumId": "SpoTiers.facCondPaie"
                            },
                            "bdc_exig": {
                                "type": "number",
                                "description": "factures directes et BDC exigibilité"
                            },
                            "bdc_mode_paiement": {
                                "type": "string",
                                "description": "factures directes et BDC mode de paiement"
                            },
                            "marche_delai": {
                                "type": "number",
                                "description": "marchés délai"
                            },
                            "marche_base": {
                                "type": "string",
                                "description": "marché base",
                                "enumId": "SpoTiers.marCondPaie"
                            },
                            "marche_exig": {
                                "type": "number",
                                "description": "marchés exigibilité"
                            },
                            "marche_mode_paiement": {
                                "type": "string",
                                "description": "marchés mode de paiement"
                            },
                            "civilite": {
                                "type": "string",
                                "description": "civilité",
                                "codif": "Civilite"
                            },
                            "nom": {
                                "type": "string",
                                "description": "nom"
                            },
                            "nom_naissance": {
                                "type": "string",
                                "description": "nom de naissance"
                            },
                            "prenom": {
                                "type": "string",
                                "description": "prénom"
                            },
                            "date_naissance": {
                                "type": "string",
                                "format": "date",
                                "description": "date de naissance"
                            },
                            "lieu_naissance": {
                                "type": "string",
                                "description": "lieu de naissance"
                            },
                            "nationalite": {
                                "type": "string",
                                "description": "nationalité"
                            },
                            "situ_famille": {
                                "type": "string",
                                "description": "situation familiale",
                                "codif": "SituFamille"
                            },
                            "profession": {
                                "type": "string",
                                "description": "profession"
                            },
                            "employeur": {
                                "type": "string",
                                "description": "employeur"
                            },
                            "phone_mobile": {
                                "type": "string",
                                "description": "portable"
                            },
                            "acces_rectif": {
                                "type": "boolean",
                                "description": "option droit d'accès et de rectification"
                            },
                            "perso_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "montant1"
                            },
                            "perso_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "montant2"
                            },
                            "perso_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "montant3"
                            },
                            "perso_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "montant4"
                            },
                            "perso_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "montant5"
                            },
                            "perso_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "decimal1"
                            },
                            "perso_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "decimal2"
                            },
                            "perso_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "decimal3"
                            },
                            "perso_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "decimal4"
                            },
                            "perso_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "decimal5"
                            },
                            "perso_entier1": {
                                "type": "number",
                                "description": "entier1"
                            },
                            "perso_entier2": {
                                "type": "number",
                                "description": "entier2"
                            },
                            "perso_entier3": {
                                "type": "number",
                                "description": "entier3"
                            },
                            "perso_entier4": {
                                "type": "number",
                                "description": "entier4"
                            },
                            "perso_entier5": {
                                "type": "number",
                                "description": "entier5"
                            },
                            "perso_flag1": {
                                "type": "boolean",
                                "description": "flag1"
                            },
                            "perso_flag2": {
                                "type": "boolean",
                                "description": "flag2"
                            },
                            "perso_flag3": {
                                "type": "boolean",
                                "description": "flag3"
                            },
                            "perso_flag4": {
                                "type": "boolean",
                                "description": "flag4"
                            },
                            "perso_flag5": {
                                "type": "boolean",
                                "description": "flag5"
                            },
                            "perso_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "date1"
                            },
                            "perso_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "date2"
                            },
                            "perso_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "date3"
                            },
                            "perso_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "date4"
                            },
                            "perso_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "date5"
                            },
                            "perso_texte1": {
                                "type": "string",
                                "description": "texte1"
                            },
                            "perso_texte2": {
                                "type": "string",
                                "description": "texte2"
                            },
                            "perso_texte3": {
                                "type": "string",
                                "description": "texte3"
                            },
                            "perso_texte4": {
                                "type": "string",
                                "description": "texte4"
                            },
                            "perso_texte5": {
                                "type": "string",
                                "description": "texte5"
                            },
                            "perso_codif1": {
                                "type": "string",
                                "description": "codif1",
                                "codif": "SpoTiers_codif1"
                            },
                            "perso_codif2": {
                                "type": "string",
                                "description": "codif2",
                                "codif": "SpoTiers_codif2"
                            },
                            "perso_codif3": {
                                "type": "string",
                                "description": "codif3",
                                "codif": "SpoTiers_codif3"
                            },
                            "perso_codif4": {
                                "type": "string",
                                "description": "codif4",
                                "codif": "SpoTiers_codif4"
                            },
                            "perso_codif5": {
                                "type": "string",
                                "description": "codif5",
                                "codif": "SpoTiers_codif5"
                            },
                            "couple1_civilite": {
                                "type": "string",
                                "description": "civilité1",
                                "codif": "Civilite"
                            },
                            "couple1_nom": {
                                "type": "string",
                                "description": "nom1"
                            },
                            "couple1_nomNaissance": {
                                "type": "string",
                                "description": "nom de naissance1"
                            },
                            "couple1_prenom": {
                                "type": "string",
                                "description": "prénom1"
                            },
                            "couple1_date_naissance": {
                                "type": "string",
                                "format": "date",
                                "description": "date de naissance1"
                            },
                            "couple1_lieu_naissance": {
                                "type": "string",
                                "description": "lieu de naissance1"
                            },
                            "couple1_nationalite": {
                                "type": "string",
                                "description": "nationalité1"
                            },
                            "couple1_situ_famille": {
                                "type": "string",
                                "description": "situation familiale1",
                                "codif": "SituFamille"
                            },
                            "couple1_profession": {
                                "type": "string",
                                "description": "profession1"
                            },
                            "couple1_employeur": {
                                "type": "string",
                                "description": "employeur1"
                            },
                            "couple1_phoneMobile": {
                                "type": "string",
                                "description": "portable1"
                            },
                            "couple1_phone": {
                                "type": "string",
                                "description": "téléphone1"
                            },
                            "couple1_mail": {
                                "type": "string",
                                "description": "mail1"
                            },
                            "couple1_adrPays": {
                                "type": "string",
                                "description": "adrPays1"
                            },
                            "couple1_adrNomVoie": {
                                "type": "string",
                                "description": "adrNomVoie1"
                            },
                            "couple1_adrNomRemise": {
                                "type": "string",
                                "description": "adrNomRemise1"
                            },
                            "couple1_adrComplement": {
                                "type": "string",
                                "description": "adrComplement1"
                            },
                            "couple1_adrCP": {
                                "type": "string",
                                "description": "adrCP1"
                            },
                            "couple1_adrLocalite": {
                                "type": "string",
                                "description": "adrLocalite1"
                            },
                            "couple2_civilite": {
                                "type": "string",
                                "description": "civilité2",
                                "codif": "Civilite"
                            },
                            "couple2_nom": {
                                "type": "string",
                                "description": "nom2"
                            },
                            "couple2_nomNaissance": {
                                "type": "string",
                                "description": "nom de naissance2"
                            },
                            "couple2_prenom": {
                                "type": "string",
                                "description": "prénom2"
                            },
                            "couple2_date_naissance": {
                                "type": "string",
                                "format": "date",
                                "description": "date de naissance2"
                            },
                            "couple2_lieu_naissance": {
                                "type": "string",
                                "description": "lieu de naissance2"
                            },
                            "couple2_nationalite": {
                                "type": "string",
                                "description": "nationalité2"
                            },
                            "couple2_situ_famille": {
                                "type": "string",
                                "description": "situation familiale2",
                                "codif": "SituFamille"
                            },
                            "couple2_profession": {
                                "type": "string",
                                "description": "profession2"
                            },
                            "couple2_employeur": {
                                "type": "string",
                                "description": "employeur2"
                            },
                            "couple2_phoneMobile": {
                                "type": "string",
                                "description": "portable2"
                            },
                            "couple2_phone": {
                                "type": "string",
                                "description": "téléphone2"
                            },
                            "couple2_mail": {
                                "type": "string",
                                "description": "mail2"
                            },
                            "couple2_adrPays": {
                                "type": "string",
                                "description": "adrPays2"
                            },
                            "couple2_adrNomVoie": {
                                "type": "string",
                                "description": "adrNomVoie2"
                            },
                            "couple2_adrNomRemise": {
                                "type": "string",
                                "description": "adrNomRemise2"
                            },
                            "couple2_adrComplement": {
                                "type": "string",
                                "description": "adrComplement2"
                            },
                            "couple2_adrCP": {
                                "type": "string",
                                "description": "adrCP2"
                            },
                            "couple2_adrLocalite": {
                                "type": "string",
                                "description": "adrLocalité2"
                            }
                        }
                    }
                }
            }
        }
    },
    "TMA": {
        "schemas": {
            "type": "object",
            "properties": {
                "operation_code": {
                    "type": "string",
                    "description": "Code de l'operation"
                },
                "operation_statut": {
                    "type": "string",
                    "description": "Statut de l'operation",
                    "enumId": "OPOperation.statut"
                },
                "operation_lib": {
                    "type": "string",
                    "description": "Libellé de l'operation"
                },
                "operation_nomCommerciale": {
                    "type": "string",
                    "description": "Nom commerciale de l’opération"
                },
                "operation_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie de l'opération"
                },
                "operation_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise de l'opération"
                },
                "operation_adr_complement": {
                    "type": "string",
                    "description": "adrComplement de l'opération"
                },
                "operation_adr_cp": {
                    "type": "string",
                    "description": "adrCP de l'opération"
                },
                "operation_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite de l'opération"
                },
                "operation_adr_pays": {
                    "type": "string",
                    "description": "adrPays de l'opération"
                },
                "ope_ville": {
                    "type": "string",
                    "description": "ville de l'opération"
                },
                "operation_refCompta": {
                    "type": "string",
                    "description": "référence comptable opération"
                },
                "operation_adrRecepFE": {
                    "type": "string",
                    "description": "adresse de réception des factures électroniques de l'opération"
                },
                "banque_lib": {
                    "type": "string",
                    "description": "intitulé du compte de la banque par défaut de l'opération"
                },
                "banque_bic": {
                    "type": "string",
                    "description": "BIC du compte de la banque par défaut de l'opération"
                },
                "banque_iban": {
                    "type": "string",
                    "description": "iban du compte de la banque par défaut de l'opération"
                },
                "respo_libelle": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Responsable de programme"
                },
                "respo_fonction": {
                    "type": "string",
                    "description": "Acteur : Fonction du Responsable de programme"
                },
                "respo_phone": {
                    "type": "string",
                    "description": "Acteur : téléphone du tiers Responsable de programme"
                },
                "respo_email": {
                    "type": "string",
                    "description": "Acteur : email du tiers Responsable de programme"
                },
                "operation_montant1": {
                    "type": "string",
                    "description": "operation montant1"
                },
                "operation_montant2": {
                    "type": "string",
                    "description": "operation montant2"
                },
                "operation_montant3": {
                    "type": "string",
                    "description": "operation montant3"
                },
                "operation_montant4": {
                    "type": "string",
                    "description": "operation montant4"
                },
                "operation_montant5": {
                    "type": "string",
                    "description": "operation montant5"
                },
                "operation_montant6": {
                    "type": "string",
                    "description": "operation montant6",
                    "version": "18.0"
                },
                "operation_montant7": {
                    "type": "string",
                    "description": "operation montant7",
                    "version": "18.0"
                },
                "operation_montant8": {
                    "type": "string",
                    "description": "operation montant8",
                    "version": "18.0"
                },
                "operation_montant9": {
                    "type": "string",
                    "description": "operation montant9",
                    "version": "18.0"
                },
                "operation_montant10": {
                    "type": "string",
                    "description": "operation montant10",
                    "version": "18.0"
                },
                "operation_decimal1": {
                    "type": "string",
                    "description": "operation decimal1"
                },
                "operation_decimal2": {
                    "type": "string",
                    "description": "operation decimal2"
                },
                "operation_decimal3": {
                    "type": "string",
                    "description": "operation decimal3"
                },
                "operation_decimal4": {
                    "type": "string",
                    "description": "operation decimal4"
                },
                "operation_decimal5": {
                    "type": "string",
                    "description": "operation decimal5"
                },
                "operation_decimal6": {
                    "type": "string",
                    "description": "operation decimal6",
                    "version": "18.0"
                },
                "operation_decimal7": {
                    "type": "string",
                    "description": "operation decimal7",
                    "version": "18.0"
                },
                "operation_decimal8": {
                    "type": "string",
                    "description": "operation decimal8",
                    "version": "18.0"
                },
                "operation_decimal9": {
                    "type": "string",
                    "description": "operation decimal9",
                    "version": "18.0"
                },
                "operation_decimal10": {
                    "type": "string",
                    "description": "operation decimal10",
                    "version": "18.0"
                },
                "operation_entier1": {
                    "type": "string",
                    "description": "operation entier1"
                },
                "operation_entier2": {
                    "type": "string",
                    "description": "operation entier2"
                },
                "operation_entier3": {
                    "type": "string",
                    "description": "operation entier3"
                },
                "operation_entier4": {
                    "type": "string",
                    "description": "operation entier4"
                },
                "operation_entier5": {
                    "type": "string",
                    "description": "operation entier5"
                },
                "operation_entier6": {
                    "type": "string",
                    "description": "operation entier6",
                    "version": "18.0"
                },
                "operation_entier7": {
                    "type": "string",
                    "description": "operation entier7",
                    "version": "18.0"
                },
                "operation_entier8": {
                    "type": "string",
                    "description": "operation entier8",
                    "version": "18.0"
                },
                "operation_entier9": {
                    "type": "string",
                    "description": "operation entier9",
                    "version": "18.0"
                },
                "operation_entier10": {
                    "type": "string",
                    "description": "operation entier10",
                    "version": "18.0"
                },
                "operation_flag1": {
                    "type": "string",
                    "description": "operation flag1"
                },
                "operation_flag2": {
                    "type": "string",
                    "description": "operation flag2"
                },
                "operation_flag3": {
                    "type": "string",
                    "description": "operation flag3"
                },
                "operation_flag4": {
                    "type": "string",
                    "description": "operation flag4"
                },
                "operation_flag5": {
                    "type": "string",
                    "description": "operation flag5"
                },
                "operation_flag6": {
                    "type": "string",
                    "description": "operation flag6",
                    "version": "18.0"
                },
                "operation_flag7": {
                    "type": "string",
                    "description": "operation flag7",
                    "version": "18.0"
                },
                "operation_flag8": {
                    "type": "string",
                    "description": "operation flag8",
                    "version": "18.0"
                },
                "operation_flag9": {
                    "type": "string",
                    "description": "operation flag9",
                    "version": "18.0"
                },
                "operation_flag10": {
                    "type": "string",
                    "description": "operation flag10",
                    "version": "18.0"
                },
                "operation_date1": {
                    "type": "string",
                    "description": "operation date1"
                },
                "operation_date2": {
                    "type": "string",
                    "description": "operation date2"
                },
                "operation_date3": {
                    "type": "string",
                    "description": "operation date3"
                },
                "operation_date4": {
                    "type": "string",
                    "description": "operation date4"
                },
                "operation_date5": {
                    "type": "string",
                    "description": "operation date5"
                },
                "operation_date6": {
                    "type": "string",
                    "description": "operation date6",
                    "version": "18.0"
                },
                "operation_date7": {
                    "type": "string",
                    "description": "operation date7",
                    "version": "18.0"
                },
                "operation_date8": {
                    "type": "string",
                    "description": "operation date8",
                    "version": "18.0"
                },
                "operation_date9": {
                    "type": "string",
                    "description": "operation date9",
                    "version": "18.0"
                },
                "operation_date10": {
                    "type": "string",
                    "description": "operation date10",
                    "version": "18.0"
                },
                "operation_texte1": {
                    "type": "string",
                    "description": "operation texte1"
                },
                "operation_texte2": {
                    "type": "string",
                    "description": "operation texte2"
                },
                "operation_texte3": {
                    "type": "string",
                    "description": "operation texte3"
                },
                "operation_texte4": {
                    "type": "string",
                    "description": "operation texte4"
                },
                "operation_texte5": {
                    "type": "string",
                    "description": "operation texte5"
                },
                "operation_texte6": {
                    "type": "string",
                    "description": "operation texte6",
                    "version": "18.0"
                },
                "operation_texte7": {
                    "type": "string",
                    "description": "operation texte7",
                    "version": "18.0"
                },
                "operation_texte8": {
                    "type": "string",
                    "description": "operation texte8",
                    "version": "18.0"
                },
                "operation_texte9": {
                    "type": "string",
                    "description": "operation texte9",
                    "version": "18.0"
                },
                "operation_texte10": {
                    "type": "string",
                    "description": "operation texte10",
                    "version": "18.0"
                },
                "operation_codif1": {
                    "type": "string",
                    "description": "operation codif1",
                    "codif": "OpExt_codif1"
                },
                "operation_codif2": {
                    "type": "string",
                    "description": "operation codif2",
                    "codif": "OpExt_codif2"
                },
                "operation_codif3": {
                    "type": "string",
                    "description": "operation codif3",
                    "codif": "OpExt_codif3"
                },
                "operation_codif4": {
                    "type": "string",
                    "description": "operation codif4",
                    "codif": "OpExt_codif4"
                },
                "operation_codif5": {
                    "type": "string",
                    "description": "operation codif5",
                    "codif": "OpExt_codif5"
                },
                "operation_codif6": {
                    "type": "string",
                    "description": "operation codif6",
                    "codif": "OpExt_codif6"
                },
                "operation_codif7": {
                    "type": "string",
                    "description": "operation codif7",
                    "codif": "OpExt_codif7"
                },
                "operation_codif8": {
                    "type": "string",
                    "description": "operation codif8",
                    "codif": "OpExt_codif8"
                },
                "operation_codif9": {
                    "type": "string",
                    "description": "operation codif9",
                    "codif": "OpExt_codif9"
                },
                "operation_codif10": {
                    "type": "string",
                    "description": "operation codif10",
                    "codif": "OpExt_codif10"
                },
                "moe_lib": {
                    "type": "string",
                    "description": "Acteur : libellé du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_voie": {
                    "type": "string",
                    "description": "Acteur : adrNomVoie du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_remise": {
                    "type": "string",
                    "description": "Acteur : adrNomRemise du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_complement": {
                    "type": "string",
                    "description": "Acteur : adrComplement du tiers Maître d'Œuvre d'exécution "
                },
                "moe_adr_codePostal": {
                    "type": "string",
                    "description": "Acteur : adrCP du tiers Maître d'Œuvre d'exécution"
                },
                "moe_adr_localite": {
                    "type": "string",
                    "description": "Acteur : adrLocalite du tiers Maître d'Œuvre d'exécution"
                },
                "moe_formeJuridique": {
                    "type": "string",
                    "description": "Acteur : formeJuridique du tiers Maître d'Œuvre d'exécution"
                },
                "moe_siret": {
                    "type": "string",
                    "description": "Acteur : siret du tiers Maître d'Œuvre d'exécution"
                },
                "%societe_image_270x180": {
                    "type": "string",
                    "description": "Logo du tiers lié à la société comptable de l'opération"
                },
                "tiers_code": {
                    "type": "string",
                    "description": "Code du tiers lié à la société comptable de l'opération"
                },
                "societe_code": {
                    "type": "string",
                    "description": "Code de la société"
                },
                "societe_lib": {
                    "type": "string",
                    "description": "libellé de la société"
                },
                "societe_refExterne": {
                    "type": "string",
                    "description": "référence externe société"
                },
                "societe_modefin": {
                    "type": "string",
                    "description": "Mode de financement"
                },
                "societe_tiers_lib": {
                    "type": "string",
                    "description": "libellé du tiers lié à la société"
                },
                "societe_adr_voie": {
                    "type": "string",
                    "description": "adrNomVoie du tiers lié à la société"
                },
                "societe_adr_remise": {
                    "type": "string",
                    "description": "adrNomRemise du tiers lié à la société"
                },
                "societe_adr_complement": {
                    "type": "string",
                    "description": "adrComplement du tiers lié à la société"
                },
                "societe_adr_cp": {
                    "type": "string",
                    "description": "adrCP du tiers lié à la société"
                },
                "societe_adr_localite": {
                    "type": "string",
                    "description": "adrLocalite du tiers lié à la société"
                },
                "societe_adr_pays": {
                    "type": "string",
                    "description": "adrPays du tiers lié à la société"
                },
                "societe_formeJuridique": {
                    "type": "string",
                    "description": "Forme Juridique du tiers lié à la société"
                },
                "societe_capital": {
                    "type": "number",
                    "format": "money",
                    "description": "Capital de la société"
                },
                "societe_RCS": {
                    "type": "string",
                    "description": "RCS du tiers lié à la société"
                },
                "societe_APE": {
                    "type": "string",
                    "description": "Code NAF/APE du tiers lié à la société comptable de l'opération"
                },
                "societe_siret": {
                    "type": "string",
                    "description": "Siret  du tiers lié à la société comptable de l'opération"
                },
                "societe_tvaIntraUE": {
                    "type": "string",
                    "description": "Numéro TVA intracommunautaire  du tiers lié à la société comptable de l'opération"
                },
                "societe_mail": {
                    "type": "string",
                    "description": "mail  du tiers lié à la société comptable de l'opération"
                },
                "societe_phone": {
                    "type": "string",
                    "description": "téléphone  du tiers lié à la société comptable de l'opération"
                },
                "societe_phonemobile": {
                    "type": "string",
                    "description": "téléphone mobile du tiers lié à la société comptable de l'opération"
                },
                "societe_tribunalComm": {
                    "type": "string",
                    "description": "Tribunal de commerce du tiers lié à la société"
                },
                "societe_tiers_commentaire": {
                    "type": "string",
                    "description": "Commentaire du tiers lié à la société"
                },
                "_date_jour": {
                    "type": "string",
                    "description": "date du courrier"
                },
                "_datelongue_jour": {
                    "type": "string",
                    "description": "date longue du courrier"
                },
                "lib_user": {
                    "type": "string",
                    "description": "Nom et prénom utilisateur connecté"
                },
                "fonction_user": {
                    "type": "string",
                    "description": "fonction utilisateur connecté"
                },
                "email_user": {
                    "type": "string",
                    "description": "email utilisateur connecté"
                },
                "phone_user": {
                    "type": "string",
                    "description": "téléphone utilisateur connecté"
                },
                "lib_doss_flag1": {
                    "type": "string",
                    "description": "dossier flag1"
                },
                "lib_doss_flag2": {
                    "type": "string",
                    "description": "dossier flag2"
                },
                "lib_doss_flag3": {
                    "type": "string",
                    "description": "dossier flag3"
                },
                "lib_doss_flag4": {
                    "type": "string",
                    "description": "dossier flag4"
                },
                "lib_doss_flag5": {
                    "type": "string",
                    "description": "dossier flag5"
                },
                "lib_doss_flag6": {
                    "type": "string",
                    "description": "dossier flag6",
                    "version": "18.0"
                },
                "lib_doss_flag7": {
                    "type": "string",
                    "description": "dossier flag7",
                    "version": "18.0"
                },
                "lib_doss_flag8": {
                    "type": "string",
                    "description": "dossier flag8",
                    "version": "18.0"
                },
                "lib_doss_flag9": {
                    "type": "string",
                    "description": "dossier flag9",
                    "version": "18.0"
                },
                "lib_doss_flag10": {
                    "type": "string",
                    "description": "dossier flag10",
                    "version": "18.0"
                },
                "lib_doss_date1": {
                    "type": "string",
                    "description": "dossier date1"
                },
                "lib_doss_date2": {
                    "type": "string",
                    "description": "dossier date2"
                },
                "lib_doss_date3": {
                    "type": "string",
                    "description": "dossier date3"
                },
                "lib_doss_date4": {
                    "type": "string",
                    "description": "dossier date4"
                },
                "lib_doss_date5": {
                    "type": "string",
                    "description": "dossier date5"
                },
                "lib_doss_date6": {
                    "type": "string",
                    "description": "dossier date6"
                },
                "lib_doss_date7": {
                    "type": "string",
                    "description": "dossier date7",
                    "version": "18.0"
                },
                "lib_doss_date8": {
                    "type": "string",
                    "description": "dossier date8",
                    "version": "18.0"
                },
                "lib_doss_date9": {
                    "type": "string",
                    "description": "dossier date9",
                    "version": "18.0"
                },
                "lib_doss_date10": {
                    "type": "string",
                    "description": "dossier date10",
                    "version": "18.0"
                },
                "lib_doss_texte1": {
                    "type": "string",
                    "description": "dossier texte1"
                },
                "lib_doss_texte2": {
                    "type": "string",
                    "description": "dossier texte2"
                },
                "lib_doss_texte3": {
                    "type": "string",
                    "description": "dossier texte3"
                },
                "lib_doss_texte4": {
                    "type": "string",
                    "description": "dossier texte4"
                },
                "lib_doss_texte5": {
                    "type": "string",
                    "description": "dossier texte5"
                },
                "lib_doss_texte6": {
                    "type": "string",
                    "description": "dossier texte6",
                    "version": "18.0"
                },
                "lib_doss_texte7": {
                    "type": "string",
                    "description": "dossier texte7",
                    "version": "18.0"
                },
                "lib_doss_texte8": {
                    "type": "string",
                    "description": "dossier texte8",
                    "version": "18.0"
                },
                "lib_doss_texte9": {
                    "type": "string",
                    "description": "dossier texte9",
                    "version": "18.0"
                },
                "lib_doss_texte10": {
                    "type": "string",
                    "description": "dossier texte10",
                    "version": "18.0"
                },
                "lib_doss_codif1": {
                    "type": "string",
                    "description": "dossier codif1"
                },
                "lib_doss_codif2": {
                    "type": "string",
                    "description": "dossier codif2"
                },
                "lib_doss_codif3": {
                    "type": "string",
                    "description": "dossier codif3"
                },
                "lib_doss_codif4": {
                    "type": "string",
                    "description": "dossier codif4"
                },
                "lib_doss_codif5": {
                    "type": "string",
                    "description": "dossier codif5"
                },
                "lib_doss_codif6": {
                    "type": "string",
                    "description": "dossier codif6",
                    "version": "18.0"
                },
                "lib_doss_codif7": {
                    "type": "string",
                    "description": "dossier codif7",
                    "version": "18.0"
                },
                "lib_doss_codif8": {
                    "type": "string",
                    "description": "dossier codif8",
                    "version": "18.0"
                },
                "lib_doss_codif9": {
                    "type": "string",
                    "description": "dossier codif9",
                    "version": "18.0"
                },
                "lib_doss_codif10": {
                    "type": "string",
                    "description": "dossier codif10",
                    "version": "18.0"
                },
                "lib_lot_flag1": {
                    "type": "string",
                    "description": "lot flag1"
                },
                "lib_lot_flag2": {
                    "type": "string",
                    "description": "lot flag2"
                },
                "lib_lot_flag3": {
                    "type": "string",
                    "description": "lot flag3"
                },
                "lib_lot_flag4": {
                    "type": "string",
                    "description": "lot flag4"
                },
                "lib_lot_flag5": {
                    "type": "string",
                    "description": "lot flag5"
                },
                "lib_lot_flag6": {
                    "type": "string",
                    "description": "lot flag6",
                    "version": "18.0"
                },
                "lib_lot_flag7": {
                    "type": "string",
                    "description": "lot flag7",
                    "version": "18.0"
                },
                "lib_lot_flag8": {
                    "type": "string",
                    "description": "lot flag8",
                    "version": "18.0"
                },
                "lib_lot_flag9": {
                    "type": "string",
                    "description": "lot flag9",
                    "version": "18.0"
                },
                "lib_lot_flag10": {
                    "type": "string",
                    "description": "lot flag10",
                    "version": "18.0"
                },
                "lib_lot_date1": {
                    "type": "string",
                    "description": "lot date1"
                },
                "lib_lot_date2": {
                    "type": "string",
                    "description": "lot date2"
                },
                "lib_lot_date3": {
                    "type": "string",
                    "description": "lot date3"
                },
                "lib_lot_date4": {
                    "type": "string",
                    "description": "lot date4"
                },
                "lib_lot_date5": {
                    "type": "string",
                    "description": "lot date5"
                },
                "lib_lot_date6": {
                    "type": "string",
                    "description": "lot date6"
                },
                "lib_lot_date7": {
                    "type": "string",
                    "description": "lot date7"
                },
                "lib_lot_date8": {
                    "type": "string",
                    "description": "lot date 8"
                },
                "lib_lot_date9": {
                    "type": "string",
                    "description": "lot date 9"
                },
                "lib_lot_date10": {
                    "type": "string",
                    "description": "lot date 10"
                },
                "lib_lot_montant1": {
                    "type": "string",
                    "description": "lot montant1"
                },
                "lib_lot_montant2": {
                    "type": "string",
                    "description": "lot montant 2"
                },
                "lib_lot_montant3": {
                    "type": "string",
                    "description": "lot montant 3"
                },
                "lib_lot_montant4": {
                    "type": "string",
                    "description": "lot montant 4"
                },
                "lib_lot_montant5": {
                    "type": "string",
                    "description": "lot montant 5"
                },
                "lib_lot_montant6": {
                    "type": "string",
                    "description": "lot montant 6"
                },
                "lib_lot_montant7": {
                    "type": "string",
                    "description": "lot montant 7"
                },
                "lib_lot_montant8": {
                    "type": "string",
                    "description": "lot montant 8"
                },
                "lib_lot_montant9": {
                    "type": "string",
                    "description": "lot montant 9"
                },
                "lib_lot_montant10": {
                    "type": "string",
                    "description": "lot montant 10"
                },
                "lib_lot_surface1": {
                    "type": "string",
                    "description": "lot surface1"
                },
                "lib_lot_surface2": {
                    "type": "string",
                    "description": "lot surface 2"
                },
                "lib_lot_surface3": {
                    "type": "string",
                    "description": "lot surface 3"
                },
                "lib_lot_surface4": {
                    "type": "string",
                    "description": "lot surface 4"
                },
                "lib_lot_surface5": {
                    "type": "string",
                    "description": "lot surface 5"
                },
                "lib_lot_surface6": {
                    "type": "string",
                    "description": "lot surface 6"
                },
                "lib_lot_surface7": {
                    "type": "string",
                    "description": "lot surface 7"
                },
                "lib_lot_surface8": {
                    "type": "string",
                    "description": "lot surface 8"
                },
                "lib_lot_surface9": {
                    "type": "string",
                    "description": "lot surface 9"
                },
                "lib_lot_surface10": {
                    "type": "string",
                    "description": "lot surface 10"
                },
                "lib_lot_surfAnnexe1": {
                    "type": "string",
                    "description": "lot surfAnnexe1"
                },
                "lib_lot_surfAnnexe2": {
                    "type": "string",
                    "description": "lot surfAnnexe 2"
                },
                "lib_lot_surfAnnexe3": {
                    "type": "string",
                    "description": "lot surfAnnexe 3"
                },
                "lib_lot_surfAnnexe4": {
                    "type": "string",
                    "description": "lot surfAnnexe 4"
                },
                "lib_lot_surfAnnexe5": {
                    "type": "string",
                    "description": "lot surfAnnexe 5"
                },
                "lib_lot_surfAnnexe6": {
                    "type": "string",
                    "description": "lot surfAnnexe 6"
                },
                "lib_lot_surfAnnexe7": {
                    "type": "string",
                    "description": "lot surfAnnexe 7"
                },
                "lib_lot_surfAnnexe8": {
                    "type": "string",
                    "description": "lot surfAnnexe 8"
                },
                "lib_lot_surfAnnexe9": {
                    "type": "string",
                    "description": "lot surfAnnexe 9"
                },
                "lib_lot_surfAnnexe10": {
                    "type": "string",
                    "description": "lot surfAnnexe 10"
                },
                "lib_lot_texte1": {
                    "type": "string",
                    "description": "lot texte1"
                },
                "lib_lot_texte2": {
                    "type": "string",
                    "description": "lot texte2"
                },
                "lib_lot_texte3": {
                    "type": "string",
                    "description": "lot texte3"
                },
                "lib_lot_texte4": {
                    "type": "string",
                    "description": "lot texte4"
                },
                "lib_lot_texte5": {
                    "type": "string",
                    "description": "lot texte5"
                },
                "lib_lot_texte6": {
                    "type": "string",
                    "description": "lot texte6",
                    "version": "18.0"
                },
                "lib_lot_texte7": {
                    "type": "string",
                    "description": "lot texte7",
                    "version": "18.0"
                },
                "lib_lot_texte8": {
                    "type": "string",
                    "description": "lot texte8",
                    "version": "18.0"
                },
                "lib_lot_texte9": {
                    "type": "string",
                    "description": "lot texte9",
                    "version": "18.0"
                },
                "lib_lot_texte10": {
                    "type": "string",
                    "description": "lot texte10",
                    "version": "18.0"
                },
                "lib_lot_codif1": {
                    "type": "string",
                    "description": "lot codif1"
                },
                "lib_lot_codif2": {
                    "type": "string",
                    "description": "lot codif2"
                },
                "lib_lot_codif3": {
                    "type": "string",
                    "description": "lot codif3"
                },
                "lib_lot_codif4": {
                    "type": "string",
                    "description": "lot codif4"
                },
                "lib_lot_codif5": {
                    "type": "string",
                    "description": "lot codif5"
                },
                "lib_lot_codif6": {
                    "type": "string",
                    "description": "lot codif6",
                    "version": "18.0"
                },
                "lib_lot_codif7": {
                    "type": "string",
                    "description": "lot codif7",
                    "version": "18.0"
                },
                "lib_lot_codif8": {
                    "type": "string",
                    "description": "lot codif8",
                    "version": "18.0"
                },
                "lib_lot_codif9": {
                    "type": "string",
                    "description": "lot codif9",
                    "version": "18.0"
                },
                "lib_lot_codif10": {
                    "type": "string",
                    "description": "lot codif10",
                    "version": "18.0"
                },
                "lib_tma_flag1": {
                    "type": "string",
                    "description": "tma flag1"
                },
                "lib_tma_flag2": {
                    "type": "string",
                    "description": "tma flag2"
                },
                "lib_tma_flag3": {
                    "type": "string",
                    "description": "tma flag3"
                },
                "lib_tma_flag4": {
                    "type": "string",
                    "description": "tma flag4"
                },
                "lib_tma_flag5": {
                    "type": "string",
                    "description": "tma flag5"
                },
                "lib_tma_montant1": {
                    "type": "string",
                    "description": "tma montant1"
                },
                "lib_tma_montant2": {
                    "type": "string",
                    "description": "tma montant2"
                },
                "lib_tma_montant3": {
                    "type": "string",
                    "description": "tma montant3"
                },
                "lib_tma_montant4": {
                    "type": "string",
                    "description": "tma montant4"
                },
                "lib_tma_montant5": {
                    "type": "string",
                    "description": "tma montant5"
                },
                "lib_tma_decimal1": {
                    "type": "string",
                    "description": "tma decimal1"
                },
                "lib_tma_decimal2": {
                    "type": "string",
                    "description": "tma decimal2"
                },
                "lib_tma_decimal3": {
                    "type": "string",
                    "description": "tma decimal3"
                },
                "lib_tma_decimal4": {
                    "type": "string",
                    "description": "tma decimal4"
                },
                "lib_tma_decimal5": {
                    "type": "string",
                    "description": "tma decimal5"
                },
                "lib_tma_date1": {
                    "type": "string",
                    "description": "tma date1"
                },
                "lib_tma_date2": {
                    "type": "string",
                    "description": "tma date2"
                },
                "lib_tma_date3": {
                    "type": "string",
                    "description": "tma date3"
                },
                "lib_tma_date4": {
                    "type": "string",
                    "description": "tma date4"
                },
                "lib_tma_date5": {
                    "type": "string",
                    "description": "tma date5"
                },
                "lib_tma_texte1": {
                    "type": "string",
                    "description": "tma texte1"
                },
                "lib_tma_texte2": {
                    "type": "string",
                    "description": "tma texte2"
                },
                "lib_tma_texte3": {
                    "type": "string",
                    "description": "tma texte3"
                },
                "lib_tma_texte4": {
                    "type": "string",
                    "description": "tma texte4"
                },
                "lib_tma_texte5": {
                    "type": "string",
                    "description": "tma texte5"
                },
                "lib_tma_codif1": {
                    "type": "string",
                    "description": "tma codif1"
                },
                "lib_tma_codif2": {
                    "type": "string",
                    "description": "tma codif2"
                },
                "lib_tma_codif3": {
                    "type": "string",
                    "description": "tma codif3"
                },
                "lib_tma_codif4": {
                    "type": "string",
                    "description": "tma codif4"
                },
                "lib_tma_codif5": {
                    "type": "string",
                    "description": "tma codif5"
                },
                "lib_tiers_montant1": {
                    "type": "string",
                    "description": "tiers montant1"
                },
                "lib_tiers_montant2": {
                    "type": "string",
                    "description": "tiers montant2"
                },
                "lib_tiers_montant3": {
                    "type": "string",
                    "description": "tiers montant3"
                },
                "lib_tiers_montant4": {
                    "type": "string",
                    "description": "tiers montant4"
                },
                "lib_tiers_montant5": {
                    "type": "string",
                    "description": "tiers montant5"
                },
                "lib_tiers_decimal1": {
                    "type": "string",
                    "description": "tiers decimal1"
                },
                "lib_tiers_decimal2": {
                    "type": "string",
                    "description": "tiers decimal2"
                },
                "lib_tiers_decimal3": {
                    "type": "string",
                    "description": "tiers decimal3"
                },
                "lib_tiers_decimal4": {
                    "type": "string",
                    "description": "tiers decimal4"
                },
                "lib_tiers_decimal5": {
                    "type": "string",
                    "description": "tiers decimal5"
                },
                "lib_tiers_entier1": {
                    "type": "string",
                    "description": "tiers entier1"
                },
                "lib_tiers_entier2": {
                    "type": "string",
                    "description": "tiers entier2"
                },
                "lib_tiers_entier3": {
                    "type": "string",
                    "description": "tiers entier3"
                },
                "lib_tiers_entier4": {
                    "type": "string",
                    "description": "tiers entier4"
                },
                "lib_tiers_entier5": {
                    "type": "string",
                    "description": "tiers entier5"
                },
                "lib_tiers_flag1": {
                    "type": "string",
                    "description": "tiers flag1"
                },
                "lib_tiers_flag2": {
                    "type": "string",
                    "description": "tiers flag2"
                },
                "lib_tiers_flag3": {
                    "type": "string",
                    "description": "tiers flag3"
                },
                "lib_tiers_flag4": {
                    "type": "string",
                    "description": "tiers flag4"
                },
                "lib_tiers_flag5": {
                    "type": "string",
                    "description": "tiers flag5"
                },
                "lib_tiers_date1": {
                    "type": "string",
                    "description": "tiers date1"
                },
                "lib_tiers_date2": {
                    "type": "string",
                    "description": "tiers date2"
                },
                "lib_tiers_date3": {
                    "type": "string",
                    "description": "tiers date3"
                },
                "lib_tiers_date4": {
                    "type": "string",
                    "description": "tiers date4"
                },
                "lib_tiers_date5": {
                    "type": "string",
                    "description": "tiers date5"
                },
                "lib_tiers_texte1": {
                    "type": "string",
                    "description": "tiers texte1"
                },
                "lib_tiers_texte2": {
                    "type": "string",
                    "description": "tiers texte2"
                },
                "lib_tiers_texte3": {
                    "type": "string",
                    "description": "tiers texte3"
                },
                "lib_tiers_texte4": {
                    "type": "string",
                    "description": "tiers texte4"
                },
                "lib_tiers_texte5": {
                    "type": "string",
                    "description": "tiers texte5"
                },
                "lib_tiers_codif1": {
                    "type": "string",
                    "description": "tiers codif1"
                },
                "lib_tiers_codif2": {
                    "type": "string",
                    "description": "tiers codif2"
                },
                "lib_tiers_codif3": {
                    "type": "string",
                    "description": "tiers codif3"
                },
                "lib_tiers_codif4": {
                    "type": "string",
                    "description": "tiers codif4"
                },
                "lib_tiers_codif5": {
                    "type": "string",
                    "description": "tiers codif5"
                },
                "lib_doss_origineContactClient": {
                    "type": "string",
                    "description": "origine contact client"
                },
                "lib_doss_qualiteClient": {
                    "type": "string",
                    "description": "qualité client"
                },
                "lib_psla_date1": {
                    "type": "string",
                    "description": "psla date1"
                },
                "lib_psla_date2": {
                    "type": "string",
                    "description": "psla date2"
                },
                "lib_psla_date3": {
                    "type": "string",
                    "description": "psla date3"
                },
                "lib_psla_date4": {
                    "type": "string",
                    "description": "psla date4"
                },
                "lib_psla_date5": {
                    "type": "string",
                    "description": "psla date5"
                },
                "lib_psla_date6": {
                    "type": "string",
                    "description": "psla date6"
                },
                "lib_foncier_texte1": {
                    "type": "string",
                    "description": "foncier texte1"
                },
                "lib_foncier_texte2": {
                    "type": "string",
                    "description": "foncier texte2"
                },
                "lib_foncier_texte3": {
                    "type": "string",
                    "description": "foncier texte3"
                },
                "lib_foncier_texte4": {
                    "type": "string",
                    "description": "foncier texte4"
                },
                "lib_foncier_texte5": {
                    "type": "string",
                    "description": "foncier texte5"
                },
                "lib_foncier_codif1": {
                    "type": "string",
                    "description": "foncier codif1"
                },
                "lib_foncier_codif2": {
                    "type": "string",
                    "description": "foncier codif2"
                },
                "lib_foncier_codif3": {
                    "type": "string",
                    "description": "foncier codif3"
                },
                "lib_foncier_codif4": {
                    "type": "string",
                    "description": "foncier codif4"
                },
                "lib_foncier_codif5": {
                    "type": "string",
                    "description": "foncier codif5"
                },
                "lib_foncier_flag1": {
                    "type": "string",
                    "description": "foncier flag1"
                },
                "lib_foncier_flag2": {
                    "type": "string",
                    "description": "foncier flag2"
                },
                "lib_foncier_flag3": {
                    "type": "string",
                    "description": "foncier flag3"
                },
                "lib_foncier_flag4": {
                    "type": "string",
                    "description": "foncier flag4"
                },
                "lib_foncier_flag5": {
                    "type": "string",
                    "description": "foncier flag5"
                },
                "lib_foncier_flag6": {
                    "type": "string",
                    "description": "foncier flag6"
                },
                "lib_foncier_flag7": {
                    "type": "string",
                    "description": "foncier flag7"
                },
                "lib_foncier_flag8": {
                    "type": "string",
                    "description": "foncier flag8"
                },
                "lib_foncier_flag9": {
                    "type": "string",
                    "description": "foncier flag9"
                },
                "lib_foncier_flag10": {
                    "type": "string",
                    "description": "foncier flag10"
                },
                "lib_foncier_flag11": {
                    "type": "string",
                    "description": "foncier flag11"
                },
                "lib_foncier_flag12": {
                    "type": "string",
                    "description": "foncier flag12"
                },
                "lib_foncier_flag13": {
                    "type": "string",
                    "description": "foncier flag13"
                },
                "lib_foncier_flag14": {
                    "type": "string",
                    "description": "foncier flag14"
                },
                "lib_foncier_flag15": {
                    "type": "string",
                    "description": "foncier flag15"
                },
                "lib_foncier_flag16": {
                    "type": "string",
                    "description": "foncier flag16"
                },
                "lib_foncier_flag17": {
                    "type": "string",
                    "description": "foncier flag17"
                },
                "lib_foncier_flag18": {
                    "type": "string",
                    "description": "foncier flag18"
                },
                "lib_foncier_flag19": {
                    "type": "string",
                    "description": "foncier flag19"
                },
                "lib_foncier_flag20": {
                    "type": "string",
                    "description": "foncier flag20"
                },
                "lib_foncier_flag21": {
                    "type": "string",
                    "description": "foncier flag21"
                },
                "lib_foncier_flag22": {
                    "type": "string",
                    "description": "foncier flag22"
                },
                "lib_foncier_flag23": {
                    "type": "string",
                    "description": "foncier flag23"
                },
                "lib_foncier_flag24": {
                    "type": "string",
                    "description": "foncier flag24"
                },
                "lib_foncier_flag25": {
                    "type": "string",
                    "description": "foncier flag25"
                },
                "lib_dossFoncier_montant1": {
                    "type": "string",
                    "description": "dossfoncier montant1"
                },
                "lib_dossFoncier_montant2": {
                    "type": "string",
                    "description": "dossfoncier montant2"
                },
                "lib_dossFoncier_montant3": {
                    "type": "string",
                    "description": "dossfoncier montant3"
                },
                "lib_dossFoncier_montant4": {
                    "type": "string",
                    "description": "dossfoncier montant4"
                },
                "lib_dossFoncier_montant5": {
                    "type": "string",
                    "description": "dossfoncier montant5"
                },
                "lib_dossFoncier_decimal1": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_decimal2": {
                    "type": "string",
                    "description": "dossfoncier decimal2"
                },
                "lib_dossFoncier_decimal3": {
                    "type": "string",
                    "description": "dossfoncier decimal3"
                },
                "lib_dossFoncier_decimal4": {
                    "type": "string",
                    "description": "dossfoncier decimal4"
                },
                "lib_dossFoncier_decimal5": {
                    "type": "string",
                    "description": "dossfoncier decimal5"
                },
                "lib_dossFoncier_entier1": {
                    "type": "string",
                    "description": "dossfoncier entier1"
                },
                "lib_dossFoncier_entier2": {
                    "type": "string",
                    "description": "dossfoncier entier2"
                },
                "lib_dossFoncier_entier3": {
                    "type": "string",
                    "description": "dossfoncier entier3"
                },
                "lib_dossFoncier_entier4": {
                    "type": "string",
                    "description": "dossfoncier entier4"
                },
                "lib_dossFoncier_entier5": {
                    "type": "string",
                    "description": "dossfoncier entier5"
                },
                "lib_dossFoncier_flag1": {
                    "type": "string",
                    "description": "dossfoncier flag1"
                },
                "lib_dossFoncier_flag2": {
                    "type": "string",
                    "description": "dossfoncier flag2"
                },
                "lib_dossFoncier_flag3": {
                    "type": "string",
                    "description": "dossfoncier flag3"
                },
                "lib_dossFoncier_flag4": {
                    "type": "string",
                    "description": "dossfoncier flag4"
                },
                "lib_dossFoncier_flag5": {
                    "type": "string",
                    "description": "dossfoncier flag5"
                },
                "lib_dossFoncier_date1": {
                    "type": "string",
                    "description": "dossfoncier date1"
                },
                "lib_dossFoncier_date2": {
                    "type": "string",
                    "description": "dossfoncier date2"
                },
                "lib_dossFoncier_date3": {
                    "type": "string",
                    "description": "dossfoncier date3"
                },
                "lib_dossFoncier_date4": {
                    "type": "string",
                    "description": "dossfoncier date4"
                },
                "lib_dossFoncier_date5": {
                    "type": "string",
                    "description": "dossfoncier date5"
                },
                "lib_dossFoncier_texte1": {
                    "type": "string",
                    "description": "dossfoncier texte1"
                },
                "lib_dossFoncier_texte2": {
                    "type": "string",
                    "description": "dossfoncier texte2"
                },
                "lib_dossFoncier_texte3": {
                    "type": "string",
                    "description": "dossfoncier texte3"
                },
                "lib_dossFoncier_texte4": {
                    "type": "string",
                    "description": "dossfoncier texte4"
                },
                "lib_dossFoncier_texte5": {
                    "type": "string",
                    "description": "dossfoncier texte5"
                },
                "lib_dossFoncier_codif1": {
                    "type": "string",
                    "description": "dossfoncier codif1"
                },
                "lib_dossFoncier_codif2": {
                    "type": "string",
                    "description": "dossfoncier codif2"
                },
                "lib_dossFoncier_codif3": {
                    "type": "string",
                    "description": "dossfoncier codif3"
                },
                "lib_dossFoncier_codif4": {
                    "type": "string",
                    "description": "dossfoncier codif4"
                },
                "lib_dossFoncier_codif5": {
                    "type": "string",
                    "description": "dossfoncier codif5"
                },
                "lib_operation_montant1": {
                    "type": "string",
                    "description": "Libellé operation montant1"
                },
                "lib_operation_montant2": {
                    "type": "string",
                    "description": "Libellé operation montant2"
                },
                "lib_operation_montant3": {
                    "type": "string",
                    "description": "Libellé operation montant3"
                },
                "lib_operation_montant4": {
                    "type": "string",
                    "description": "Libellé operation montant4"
                },
                "lib_operation_montant5": {
                    "type": "string",
                    "description": "Libellé operation montant5"
                },
                "lib_operation_montant6": {
                    "type": "string",
                    "description": "Libellé operation montant6",
                    "version": "18.0"
                },
                "lib_operation_montant7": {
                    "type": "string",
                    "description": "Libellé operation montant7",
                    "version": "18.0"
                },
                "lib_operation_montant8": {
                    "type": "string",
                    "description": "Libellé operation montant8",
                    "version": "18.0"
                },
                "lib_operation_montant9": {
                    "type": "string",
                    "description": "Libellé operation montant9",
                    "version": "18.0"
                },
                "lib_operation_montant10": {
                    "type": "string",
                    "description": "Libellé operation montant10",
                    "version": "18.0"
                },
                "lib_operation_decimal1": {
                    "type": "string",
                    "description": "Libellé operation decimal1"
                },
                "lib_operation_decimal2": {
                    "type": "string",
                    "description": "Libellé operation decimal2"
                },
                "lib_operation_decimal3": {
                    "type": "string",
                    "description": "Libellé operation decimal3"
                },
                "lib_operation_decimal4": {
                    "type": "string",
                    "description": "Libellé operation decimal4"
                },
                "lib_operation_decimal5": {
                    "type": "string",
                    "description": "Libellé operation decimal5"
                },
                "lib_operation_decimal6": {
                    "type": "string",
                    "description": "Libellé operation decimal6",
                    "version": "18.0"
                },
                "lib_operation_decimal7": {
                    "type": "string",
                    "description": "Libellé operation decimal7",
                    "version": "18.0"
                },
                "lib_operation_decimal8": {
                    "type": "string",
                    "description": "Libellé operation decimal8",
                    "version": "18.0"
                },
                "lib_operation_decimal9": {
                    "type": "string",
                    "description": "Libellé operation decimal9",
                    "version": "18.0"
                },
                "lib_operation_decimal10": {
                    "type": "string",
                    "description": "Libellé operation decimal10",
                    "version": "18.0"
                },
                "lib_operation_entier1": {
                    "type": "string",
                    "description": "Libellé operation entier1"
                },
                "lib_operation_entier2": {
                    "type": "string",
                    "description": "Libellé operation entier2"
                },
                "lib_operation_entier3": {
                    "type": "string",
                    "description": "Libellé operation entier3"
                },
                "lib_operation_entier4": {
                    "type": "string",
                    "description": "Libellé operation entier4"
                },
                "lib_operation_entier5": {
                    "type": "string",
                    "description": "Libellé operation entier5"
                },
                "lib_operation_entier6": {
                    "type": "string",
                    "description": "Libellé operation entier6",
                    "version": "18.0"
                },
                "lib_operation_entier7": {
                    "type": "string",
                    "description": "Libellé operation entier7",
                    "version": "18.0"
                },
                "lib_operation_entier8": {
                    "type": "string",
                    "description": "Libellé operation entier8",
                    "version": "18.0"
                },
                "lib_operation_entier9": {
                    "type": "string",
                    "description": "Libellé operation entier9",
                    "version": "18.0"
                },
                "lib_operation_entier10": {
                    "type": "string",
                    "description": "Libellé operation entier10",
                    "version": "18.0"
                },
                "lib_operation_flag1": {
                    "type": "string",
                    "description": "Libellé operation flag1"
                },
                "lib_operation_flag2": {
                    "type": "string",
                    "description": "Libellé operation flag2"
                },
                "lib_operation_flag3": {
                    "type": "string",
                    "description": "Libellé operation flag3"
                },
                "lib_operation_flag4": {
                    "type": "string",
                    "description": "Libellé operation flag4"
                },
                "lib_operation_flag5": {
                    "type": "string",
                    "description": "Libellé operation flag5"
                },
                "lib_operation_flag6": {
                    "type": "string",
                    "description": "Libellé operation flag6",
                    "version": "18.0"
                },
                "lib_operation_flag7": {
                    "type": "string",
                    "description": "Libellé operation flag7",
                    "version": "18.0"
                },
                "lib_operation_flag8": {
                    "type": "string",
                    "description": "Libellé operation flag8",
                    "version": "18.0"
                },
                "lib_operation_flag9": {
                    "type": "string",
                    "description": "Libellé operation flag9",
                    "version": "18.0"
                },
                "lib_operation_flag10": {
                    "type": "string",
                    "description": "Libellé operation flag10",
                    "version": "18.0"
                },
                "lib_operation_date1": {
                    "type": "string",
                    "description": "Libellé operation date1"
                },
                "lib_operation_date2": {
                    "type": "string",
                    "description": "Libellé operation date2"
                },
                "lib_operation_date3": {
                    "type": "string",
                    "description": "Libellé operation date3"
                },
                "lib_operation_date4": {
                    "type": "string",
                    "description": "Libellé operation date4"
                },
                "lib_operation_date5": {
                    "type": "string",
                    "description": "Libellé operation date5"
                },
                "lib_operation_date6": {
                    "type": "string",
                    "description": "Libellé operation date6",
                    "version": "18.0"
                },
                "lib_operation_date7": {
                    "type": "string",
                    "description": "Libellé operation date7",
                    "version": "18.0"
                },
                "lib_operation_date8": {
                    "type": "string",
                    "description": "Libellé operation date8",
                    "version": "18.0"
                },
                "lib_operation_date9": {
                    "type": "string",
                    "description": "Libellé operation date9",
                    "version": "18.0"
                },
                "lib_operation_date10": {
                    "type": "string",
                    "description": "Libellé operation date10",
                    "version": "18.0"
                },
                "lib_operation_texte1": {
                    "type": "string",
                    "description": "Libellé operation texte1"
                },
                "lib_operation_texte2": {
                    "type": "string",
                    "description": "Libellé operation texte2"
                },
                "lib_operation_texte3": {
                    "type": "string",
                    "description": "Libellé operation texte3"
                },
                "lib_operation_texte4": {
                    "type": "string",
                    "description": "Libellé operation texte4"
                },
                "lib_operation_texte5": {
                    "type": "string",
                    "description": "Libellé operation texte5"
                },
                "lib_operation_texte6": {
                    "type": "string",
                    "description": "Libellé operation texte6",
                    "version": "18.0"
                },
                "lib_operation_texte7": {
                    "type": "string",
                    "description": "Libellé operation texte7",
                    "version": "18.0"
                },
                "lib_operation_texte8": {
                    "type": "string",
                    "description": "Libellé operation texte8",
                    "version": "18.0"
                },
                "lib_operation_texte9": {
                    "type": "string",
                    "description": "Libellé operation texte9",
                    "version": "18.0"
                },
                "lib_operation_texte10": {
                    "type": "string",
                    "description": "Libellé operation texte10",
                    "version": "18.0"
                },
                "lib_operation_codif1": {
                    "type": "string",
                    "description": "Libellé operation codif1"
                },
                "lib_operation_codif2": {
                    "type": "string",
                    "description": "Libellé operation codif2"
                },
                "lib_operation_codif3": {
                    "type": "string",
                    "description": "Libellé operation codif3"
                },
                "lib_operation_codif4": {
                    "type": "string",
                    "description": "Libellé operation codif4"
                },
                "lib_operation_codif5": {
                    "type": "string",
                    "description": "Libellé operation codif5"
                },
                "lib_operation_codif6": {
                    "type": "string",
                    "description": "Libellé operation codif6"
                },
                "lib_operation_codif7": {
                    "type": "string",
                    "description": "Libellé operation codif7"
                },
                "lib_operation_codif8": {
                    "type": "string",
                    "description": "Libellé operation codif8"
                },
                "lib_operation_codif9": {
                    "type": "string",
                    "description": "Libellé operation codif9"
                },
                "lib_operation_codif10": {
                    "type": "string",
                    "description": "Libellé operation codif10"
                },
                "lib_facture_montant1": {
                    "type": "string",
                    "description": "Libellé facture montant1"
                },
                "lib_facture_montant2": {
                    "type": "string",
                    "description": "Libellé facture montant2"
                },
                "lib_facture_montant3": {
                    "type": "string",
                    "description": "Libellé facture montant3"
                },
                "lib_facture_montant4": {
                    "type": "string",
                    "description": "Libellé facture montant4"
                },
                "lib_facture_montant5": {
                    "type": "string",
                    "description": "Libellé facture montant5"
                },
                "lib_facture_decimal1": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_decimal2": {
                    "type": "string",
                    "description": "Libellé facture decimal2"
                },
                "lib_facture_decimal3": {
                    "type": "string",
                    "description": "Libellé facture decimal3"
                },
                "lib_facture_decimal4": {
                    "type": "string",
                    "description": "Libellé facture decimal4"
                },
                "lib_facture_decimal5": {
                    "type": "string",
                    "description": "Libellé facture decimal5"
                },
                "lib_facture_entier1": {
                    "type": "string",
                    "description": "Libellé facture entier1"
                },
                "lib_facture_entier2": {
                    "type": "string",
                    "description": "Libellé facture entier2"
                },
                "lib_facture_entier3": {
                    "type": "string",
                    "description": "Libellé facture entier3"
                },
                "lib_facture_entier4": {
                    "type": "string",
                    "description": "Libellé facture entier4"
                },
                "lib_facture_entier5": {
                    "type": "string",
                    "description": "Libellé facture entier5"
                },
                "lib_facture_flag1": {
                    "type": "string",
                    "description": "Libellé facture flag1"
                },
                "lib_facture_flag2": {
                    "type": "string",
                    "description": "Libellé facture flag2"
                },
                "lib_facture_flag3": {
                    "type": "string",
                    "description": "Libellé facture flag3"
                },
                "lib_facture_flag4": {
                    "type": "string",
                    "description": "Libellé facture flag4"
                },
                "lib_facture_flag5": {
                    "type": "string",
                    "description": "Libellé facture flag5"
                },
                "lib_facture_date1": {
                    "type": "string",
                    "description": "Libellé facture date1"
                },
                "lib_facture_date2": {
                    "type": "string",
                    "description": "Libellé facture date2"
                },
                "lib_facture_date3": {
                    "type": "string",
                    "description": "Libellé facture date3"
                },
                "lib_facture_date4": {
                    "type": "string",
                    "description": "Libellé facture date4"
                },
                "lib_facture_date5": {
                    "type": "string",
                    "description": "Libellé facture date5"
                },
                "lib_facture_texte1": {
                    "type": "string",
                    "description": "Libellé facture texte1"
                },
                "lib_facture_texte2": {
                    "type": "string",
                    "description": "Libellé facture texte2"
                },
                "lib_facture_texte3": {
                    "type": "string",
                    "description": "Libellé facture texte3"
                },
                "lib_facture_texte4": {
                    "type": "string",
                    "description": "Libellé facture texte4"
                },
                "lib_facture_texte5": {
                    "type": "string",
                    "description": "Libellé facture texte5"
                },
                "lib_facture_codif1": {
                    "type": "string",
                    "description": "Libellé facture codif1"
                },
                "lib_facture_codif2": {
                    "type": "string",
                    "description": "Libellé facture codif2"
                },
                "lib_facture_codif3": {
                    "type": "string",
                    "description": "Libellé facture codif3"
                },
                "lib_facture_codif4": {
                    "type": "string",
                    "description": "Libellé facture codif4"
                },
                "lib_facture_codif5": {
                    "type": "string",
                    "description": "Libellé facture codif5"
                },
                "lib_tc_montant1": {
                    "type": "string",
                    "description": "tc montant1",
                    "version": "18.0"
                },
                "lib_tc_montant2": {
                    "type": "string",
                    "description": "tc montant 2",
                    "version": "18.0"
                },
                "lib_tc_montant3": {
                    "type": "string",
                    "description": "tc montant 3",
                    "version": "18.0"
                },
                "lib_tc_montant4": {
                    "type": "string",
                    "description": "tc montant 4",
                    "version": "18.0"
                },
                "lib_tc_montant5": {
                    "type": "string",
                    "description": "tc montant 5",
                    "version": "18.0"
                },
                "lib_tc_montant6": {
                    "type": "string",
                    "description": "tc montant 6",
                    "version": "18.0"
                },
                "lib_tc_montant7": {
                    "type": "string",
                    "description": "tc montant 7",
                    "version": "18.0"
                },
                "lib_tc_montant8": {
                    "type": "string",
                    "description": "tc montant 8",
                    "version": "18.0"
                },
                "lib_tc_montant9": {
                    "type": "string",
                    "description": "tc montant 9",
                    "version": "18.0"
                },
                "lib_tc_montant10": {
                    "type": "string",
                    "description": "tc montant 10",
                    "version": "18.0"
                },
                "lib_tc_flag1": {
                    "type": "string",
                    "description": "tc flag1",
                    "version": "18.0"
                },
                "lib_tc_flag2": {
                    "type": "string",
                    "description": "tc flag2",
                    "version": "18.0"
                },
                "lib_tc_flag3": {
                    "type": "string",
                    "description": "tc flag3",
                    "version": "18.0"
                },
                "lib_tc_flag4": {
                    "type": "string",
                    "description": "tc flag4",
                    "version": "18.0"
                },
                "lib_tc_flag5": {
                    "type": "string",
                    "description": "tc flag5",
                    "version": "18.0"
                },
                "lib_tc_flag6": {
                    "type": "string",
                    "description": "tc flag6",
                    "version": "18.0"
                },
                "lib_tc_flag7": {
                    "type": "string",
                    "description": "tc flag7",
                    "version": "18.0"
                },
                "lib_tc_flag8": {
                    "type": "string",
                    "description": "tc flag8",
                    "version": "18.0"
                },
                "lib_tc_flag9": {
                    "type": "string",
                    "description": "tc flag9",
                    "version": "18.0"
                },
                "lib_tc_flag10": {
                    "type": "string",
                    "description": "tc flag10",
                    "version": "18.0"
                },
                "lib_tc_date1": {
                    "type": "string",
                    "description": "tc date1",
                    "version": "18.0"
                },
                "lib_tc_date2": {
                    "type": "string",
                    "description": "tc date2",
                    "version": "18.0"
                },
                "lib_tc_date3": {
                    "type": "string",
                    "description": "tc date3",
                    "version": "18.0"
                },
                "lib_tc_date4": {
                    "type": "string",
                    "description": "tc date4",
                    "version": "18.0"
                },
                "lib_tc_date5": {
                    "type": "string",
                    "description": "tc date5",
                    "version": "18.0"
                },
                "lib_tc_date6": {
                    "type": "string",
                    "description": "tc date6",
                    "version": "18.0"
                },
                "lib_tc_date7": {
                    "type": "string",
                    "description": "tc date7",
                    "version": "18.0"
                },
                "lib_tc_date8": {
                    "type": "string",
                    "description": "tc date 8",
                    "version": "18.0"
                },
                "lib_tc_date9": {
                    "type": "string",
                    "description": "tc date 9",
                    "version": "18.0"
                },
                "lib_tc_date10": {
                    "type": "string",
                    "description": "tc date 10",
                    "version": "18.0"
                },
                "lib_tc_texte1": {
                    "type": "string",
                    "description": "tc texte1",
                    "version": "18.0"
                },
                "lib_tc_texte2": {
                    "type": "string",
                    "description": "tc texte2",
                    "version": "18.0"
                },
                "lib_tc_texte3": {
                    "type": "string",
                    "description": "tc texte3",
                    "version": "18.0"
                },
                "lib_tc_texte4": {
                    "type": "string",
                    "description": "tc texte4",
                    "version": "18.0"
                },
                "lib_tc_texte5": {
                    "type": "string",
                    "description": "tc texte5",
                    "version": "18.0"
                },
                "lib_tc_texte6": {
                    "type": "string",
                    "description": "tc texte6",
                    "version": "18.0"
                },
                "lib_tc_texte7": {
                    "type": "string",
                    "description": "tc texte7",
                    "version": "18.0"
                },
                "lib_tc_texte8": {
                    "type": "string",
                    "description": "tc texte8",
                    "version": "18.0"
                },
                "lib_tc_texte9": {
                    "type": "string",
                    "description": "tc texte9",
                    "version": "18.0"
                },
                "lib_tc_texte10": {
                    "type": "string",
                    "description": "tc texte10",
                    "version": "18.0"
                },
                "lib_tc_codif1": {
                    "type": "string",
                    "description": "tc codif1",
                    "version": "18.0"
                },
                "lib_tc_codif2": {
                    "type": "string",
                    "description": "tc codif2",
                    "version": "18.0"
                },
                "lib_tc_codif3": {
                    "type": "string",
                    "description": "tc codif3",
                    "version": "18.0"
                },
                "lib_tc_codif4": {
                    "type": "string",
                    "description": "tc codif4",
                    "version": "18.0"
                },
                "lib_tc_codif5": {
                    "type": "string",
                    "description": "tc codif5",
                    "version": "18.0"
                },
                "lib_tc_codif6": {
                    "type": "string",
                    "description": "tc codif6",
                    "version": "18.0"
                },
                "lib_tc_codif7": {
                    "type": "string",
                    "description": "tc codif7",
                    "version": "18.0"
                },
                "lib_tc_codif8": {
                    "type": "string",
                    "description": "tc codif8",
                    "version": "18.0"
                },
                "lib_tc_codif9": {
                    "type": "string",
                    "description": "tc codif9",
                    "version": "18.0"
                },
                "lib_tc_codif10": {
                    "type": "string",
                    "description": "tc codif10",
                    "version": "18.0"
                },
                "lib_tc_decimal1": {
                    "type": "string",
                    "description": "Libellé tc decimal1",
                    "version": "18.0"
                },
                "lib_tc_decimal2": {
                    "type": "string",
                    "description": "Libellé tc decimal2",
                    "version": "18.0"
                },
                "lib_tc_decimal3": {
                    "type": "string",
                    "description": "Libellé tc decimal3",
                    "version": "18.0"
                },
                "lib_tc_decimal4": {
                    "type": "string",
                    "description": "Libellé tc decimal4",
                    "version": "18.0"
                },
                "lib_tc_decimal5": {
                    "type": "string",
                    "description": "Libellé tc decimal5",
                    "version": "18.0"
                },
                "lib_tc_decimal6": {
                    "type": "string",
                    "description": "Libellé tc decimal6",
                    "version": "18.0"
                },
                "lib_tc_decimal7": {
                    "type": "string",
                    "description": "Libellé tc decimal7",
                    "version": "18.0"
                },
                "lib_tc_decimal8": {
                    "type": "string",
                    "description": "Libellé tc decimal8",
                    "version": "18.0"
                },
                "lib_tc_decimal9": {
                    "type": "string",
                    "description": "Libellé tc decimal9",
                    "version": "18.0"
                },
                "lib_tc_decimal10": {
                    "type": "string",
                    "description": "Libellé tc decimal10",
                    "version": "18.0"
                },
                "lib_tc_entier1": {
                    "type": "string",
                    "description": "Libellé tc entier1",
                    "version": "18.0"
                },
                "lib_tc_entier2": {
                    "type": "string",
                    "description": "Libellé tc entier2",
                    "version": "18.0"
                },
                "lib_tc_entier3": {
                    "type": "string",
                    "description": "Libellé tc entier3",
                    "version": "18.0"
                },
                "lib_tc_entier4": {
                    "type": "string",
                    "description": "Libellé tc entier4",
                    "version": "18.0"
                },
                "lib_tc_entier5": {
                    "type": "string",
                    "description": "Libellé tc entier5",
                    "version": "18.0"
                },
                "lib_tc_entier6": {
                    "type": "string",
                    "description": "Libellé tc entier6",
                    "version": "18.0"
                },
                "lib_tc_entier7": {
                    "type": "string",
                    "description": "Libellé tc entier7",
                    "version": "18.0"
                },
                "lib_tc_entier8": {
                    "type": "string",
                    "description": "Libellé tc entier8",
                    "version": "18.0"
                },
                "lib_tc_entier9": {
                    "type": "string",
                    "description": "Libellé tc entier9",
                    "version": "18.0"
                },
                "lib_tc_entier10": {
                    "type": "string",
                    "description": "Libellé tc entier10",
                    "version": "18.0"
                },
                "lib_soc_montant1": {
                    "type": "string",
                    "description": "société montant1",
                    "version": "18.0"
                },
                "lib_soc_montant2": {
                    "type": "string",
                    "description": "société montant 2",
                    "version": "18.0"
                },
                "lib_soc_montant3": {
                    "type": "string",
                    "description": "société montant 3",
                    "version": "18.0"
                },
                "lib_soc_montant4": {
                    "type": "string",
                    "description": "société montant 4",
                    "version": "18.0"
                },
                "lib_soc_montant5": {
                    "type": "string",
                    "description": "société montant 5",
                    "version": "18.0"
                },
                "lib_soc_montant6": {
                    "type": "string",
                    "description": "société montant 6",
                    "version": "18.0"
                },
                "lib_soc_montant7": {
                    "type": "string",
                    "description": "société montant 7",
                    "version": "18.0"
                },
                "lib_soc_montant8": {
                    "type": "string",
                    "description": "société montant 8",
                    "version": "18.0"
                },
                "lib_soc_montant9": {
                    "type": "string",
                    "description": "société montant 9",
                    "version": "18.0"
                },
                "lib_soc_montant10": {
                    "type": "string",
                    "description": "société montant 10",
                    "version": "18.0"
                },
                "lib_soc_decimal1": {
                    "type": "string",
                    "description": "Libellé société decimal1",
                    "version": "18.0"
                },
                "lib_soc_decimal2": {
                    "type": "string",
                    "description": "Libellé société decimal2",
                    "version": "18.0"
                },
                "lib_soc_decimal3": {
                    "type": "string",
                    "description": "Libellé société decimal3",
                    "version": "18.0"
                },
                "lib_soc_decimal4": {
                    "type": "string",
                    "description": "Libellé société decimal4",
                    "version": "18.0"
                },
                "lib_soc_decimal5": {
                    "type": "string",
                    "description": "Libellé société decimal5",
                    "version": "18.0"
                },
                "lib_soc_decimal6": {
                    "type": "string",
                    "description": "Libellé société decimal6",
                    "version": "18.0"
                },
                "lib_soc_decimal7": {
                    "type": "string",
                    "description": "Libellé société decimal7",
                    "version": "18.0"
                },
                "lib_soc_decimal8": {
                    "type": "string",
                    "description": "Libellé société decimal8",
                    "version": "18.0"
                },
                "lib_soc_decimal9": {
                    "type": "string",
                    "description": "Libellé société decimal9",
                    "version": "18.0"
                },
                "lib_soc_decimal10": {
                    "type": "string",
                    "description": "Libellé société decimal10",
                    "version": "18.0"
                },
                "lib_soc_entier1": {
                    "type": "string",
                    "description": "Libellé société entier1",
                    "version": "18.0"
                },
                "lib_soc_entier2": {
                    "type": "string",
                    "description": "Libellé société entier2",
                    "version": "18.0"
                },
                "lib_soc_entier3": {
                    "type": "string",
                    "description": "Libellé société entier3",
                    "version": "18.0"
                },
                "lib_soc_entier4": {
                    "type": "string",
                    "description": "Libellé société entier4",
                    "version": "18.0"
                },
                "lib_soc_entier5": {
                    "type": "string",
                    "description": "Libellé société entier5",
                    "version": "18.0"
                },
                "lib_soc_entier6": {
                    "type": "string",
                    "description": "Libellé société entier6",
                    "version": "18.0"
                },
                "lib_soc_entier7": {
                    "type": "string",
                    "description": "Libellé société entier7",
                    "version": "18.0"
                },
                "lib_soc_entier8": {
                    "type": "string",
                    "description": "Libellé société entier8",
                    "version": "18.0"
                },
                "lib_soc_entier9": {
                    "type": "string",
                    "description": "Libellé société entier9",
                    "version": "18.0"
                },
                "lib_soc_entier10": {
                    "type": "string",
                    "description": "Libellé société entier10",
                    "version": "18.0"
                },
                "lib_soc_flag1": {
                    "type": "string",
                    "description": "société flag1",
                    "version": "18.0"
                },
                "lib_soc_flag2": {
                    "type": "string",
                    "description": "société flag2",
                    "version": "18.0"
                },
                "lib_soc_flag3": {
                    "type": "string",
                    "description": "société flag3",
                    "version": "18.0"
                },
                "lib_soc_flag4": {
                    "type": "string",
                    "description": "société flag4",
                    "version": "18.0"
                },
                "lib_soc_flag5": {
                    "type": "string",
                    "description": "société flag5",
                    "version": "18.0"
                },
                "lib_soc_flag6": {
                    "type": "string",
                    "description": "société flag6",
                    "version": "18.0"
                },
                "lib_soc_flag7": {
                    "type": "string",
                    "description": "société flag7",
                    "version": "18.0"
                },
                "lib_soc_flag8": {
                    "type": "string",
                    "description": "société flag8",
                    "version": "18.0"
                },
                "lib_soc_flag9": {
                    "type": "string",
                    "description": "société flag9",
                    "version": "18.0"
                },
                "lib_soc_flag10": {
                    "type": "string",
                    "description": "société flag10",
                    "version": "18.0"
                },
                "lib_soc_date1": {
                    "type": "string",
                    "description": "société date1",
                    "version": "18.0"
                },
                "lib_soc_date2": {
                    "type": "string",
                    "description": "société date2",
                    "version": "18.0"
                },
                "lib_soc_date3": {
                    "type": "string",
                    "description": "société date3",
                    "version": "18.0"
                },
                "lib_soc_date4": {
                    "type": "string",
                    "description": "société date4",
                    "version": "18.0"
                },
                "lib_soc_date5": {
                    "type": "string",
                    "description": "société date5",
                    "version": "18.0"
                },
                "lib_soc_date6": {
                    "type": "string",
                    "description": "société date6",
                    "version": "18.0"
                },
                "lib_soc_date7": {
                    "type": "string",
                    "description": "société date7",
                    "version": "18.0"
                },
                "lib_soc_date8": {
                    "type": "string",
                    "description": "société date8",
                    "version": "18.0"
                },
                "lib_soc_date9": {
                    "type": "string",
                    "description": "société date9",
                    "version": "18.0"
                },
                "lib_soc_date10": {
                    "type": "string",
                    "description": "société date10",
                    "version": "18.0"
                },
                "lib_soc_texte1": {
                    "type": "string",
                    "description": "société texte1",
                    "version": "18.0"
                },
                "lib_soc_texte2": {
                    "type": "string",
                    "description": "société texte2",
                    "version": "18.0"
                },
                "lib_soc_texte3": {
                    "type": "string",
                    "description": "société texte3",
                    "version": "18.0"
                },
                "lib_soc_texte4": {
                    "type": "string",
                    "description": "société texte4",
                    "version": "18.0"
                },
                "lib_soc_texte5": {
                    "type": "string",
                    "description": "société texte5",
                    "version": "18.0"
                },
                "lib_soc_texte6": {
                    "type": "string",
                    "description": "société texte6",
                    "version": "18.0"
                },
                "lib_soc_texte7": {
                    "type": "string",
                    "description": "société texte7",
                    "version": "18.0"
                },
                "lib_soc_texte8": {
                    "type": "string",
                    "description": "société texte8",
                    "version": "18.0"
                },
                "lib_soc_texte9": {
                    "type": "string",
                    "description": "société texte9",
                    "version": "18.0"
                },
                "lib_soc_texte10": {
                    "type": "string",
                    "description": "société texte10",
                    "version": "18.0"
                },
                "lib_soc_codif1": {
                    "type": "string",
                    "description": "société codif1",
                    "version": "18.0"
                },
                "lib_soc_codif2": {
                    "type": "string",
                    "description": "société codif2",
                    "version": "18.0"
                },
                "lib_soc_codif3": {
                    "type": "string",
                    "description": "société codif3",
                    "version": "18.0"
                },
                "lib_soc_codif4": {
                    "type": "string",
                    "description": "société codif4",
                    "version": "18.0"
                },
                "lib_soc_codif5": {
                    "type": "string",
                    "description": "société codif5",
                    "version": "18.0"
                },
                "lib_soc_codif6": {
                    "type": "string",
                    "description": "société codif6",
                    "version": "18.0"
                },
                "lib_soc_codif7": {
                    "type": "string",
                    "description": "société codif7",
                    "version": "18.0"
                },
                "lib_soc_codif8": {
                    "type": "string",
                    "description": "société codif8",
                    "version": "18.0"
                },
                "lib_soc_codif9": {
                    "type": "string",
                    "description": "société codif9",
                    "version": "18.0"
                },
                "lib_soc_codif10": {
                    "type": "string",
                    "description": "société codif10",
                    "version": "18.0"
                },
                "liste": {
                    "type": "array",
                    "description": "TMA Devis Et Facture",
                    "items": {
                        "type": "object",
                        "properties": {
                            "code": {
                                "type": "string",
                                "description": "Code appel de fonds"
                            },
                            "tranche_libelle": {
                                "type": "string",
                                "description": "Libellé tranche commerciale de l’opération"
                            },
                            "tma_ref": {
                                "type": "string",
                                "description": "Numéro référence"
                            },
                            "tma_dateFinDevis": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de fin de validité du devis"
                            },
                            "tma_lib": {
                                "type": "string",
                                "description": "Libellé du TMA"
                            },
                            "tma_mntEncaisse": {
                                "type": "number",
                                "format": "money",
                                "description": "Montant encaissé du TMA"
                            },
                            "tma_solde": {
                                "type": "number",
                                "format": "money",
                                "description": "Solde du TMA"
                            },
                            "tma_lots": {
                                "type": "string",
                                "description": "Liste des lots concernés par le TMA"
                            },
                            "tma_description": {
                                "type": "string",
                                "description": "Description du TMA"
                            },
                            "tma_commentaire": {
                                "type": "string",
                                "description": "Commentaire"
                            },
                            "client_civPreNom": {
                                "type": "string",
                                "description": "civilité + prenom + nom du client"
                            },
                            "client_civNom": {
                                "type": "string",
                                "description": "civilité + nom du client"
                            },
                            "client_civ": {
                                "type": "string",
                                "description": "civilité du client",
                                "codif": "Civilite"
                            },
                            "client_lib": {
                                "type": "string",
                                "description": "Nom du client"
                            },
                            "client_adr1": {
                                "type": "string",
                                "description": "adrPointRemise du client"
                            },
                            "client_adr2": {
                                "type": "string",
                                "description": "adrNomVoie du client"
                            },
                            "client_adrComplement": {
                                "type": "string",
                                "description": "adrComplement de l'acquéreur"
                            },
                            "client_adrPointDistrib": {
                                "type": "string",
                                "description": "adrPointDistrib de l'acquéreur"
                            },
                            "client_cp": {
                                "type": "string",
                                "description": "adrCP du client"
                            },
                            "client_localite": {
                                "type": "string",
                                "description": "adrLocalite du client"
                            },
                            "client_pays": {
                                "type": "string",
                                "description": "adrPays du client"
                            },
                            "client_mail": {
                                "type": "string",
                                "description": "Courriel du client"
                            },
                            "destinataire_courrier": {
                                "type": "string",
                                "description": "destinataire du courrier"
                            },
                            "devis_ref": {
                                "type": "string",
                                "description": "RefDevis du TMA"
                            },
                            "devis_date": {
                                "type": "string",
                                "format": "date",
                                "description": "dateDevis du TMA"
                            },
                            "signe_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de la signature du devis"
                            },
                            "vente_date": {
                                "type": "string",
                                "format": "date",
                                "description": "Date de la vente"
                            },
                            "reglement_mode": {
                                "type": "string",
                                "description": "Mode de règlement",
                                "enumId": "RVDossierTma.modeRegle"
                            },
                            "details_solde_ht": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants HT du details"
                            },
                            "details_solde_ttc": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TTC du details"
                            },
                            "details_solde_tva": {
                                "type": "number",
                                "format": "money",
                                "description": "somme des montants TVA du details"
                            },
                            "taux_tva": {
                                "type": "number",
                                "format": "rate",
                                "description": "Taux de TVA du TMA"
                            },
                            "facture_num": {
                                "type": "string",
                                "description": "numéro de la facture"
                            },
                            "perso_flag1": {
                                "type": "boolean",
                                "description": "flag1"
                            },
                            "perso_flag2": {
                                "type": "boolean",
                                "description": "flag2"
                            },
                            "perso_flag3": {
                                "type": "boolean",
                                "description": "flag3"
                            },
                            "perso_flag4": {
                                "type": "boolean",
                                "description": "flag4"
                            },
                            "perso_flag5": {
                                "type": "boolean",
                                "description": "flag5"
                            },
                            "perso_montant1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant1"
                            },
                            "perso_montant2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant2"
                            },
                            "perso_montant3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant3"
                            },
                            "perso_montant4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant4"
                            },
                            "perso_montant5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur montant5"
                            },
                            "perso_decimal1": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal1"
                            },
                            "perso_decimal2": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal2"
                            },
                            "perso_decimal3": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal3"
                            },
                            "perso_decimal4": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal4"
                            },
                            "perso_decimal5": {
                                "type": "number",
                                "format": "money",
                                "description": "Valeur decimal5"
                            },
                            "perso_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date1"
                            },
                            "perso_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date2"
                            },
                            "perso_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date3"
                            },
                            "perso_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date4"
                            },
                            "perso_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur date5"
                            },
                            "perso_texte1": {
                                "type": "string",
                                "description": "Valeur texte1"
                            },
                            "perso_texte2": {
                                "type": "string",
                                "description": "Valeur texte2"
                            },
                            "perso_texte3": {
                                "type": "string",
                                "description": "Valeur texte3"
                            },
                            "perso_texte4": {
                                "type": "string",
                                "description": "Valeur texte4"
                            },
                            "perso_texte5": {
                                "type": "string",
                                "description": "Valeur texte5"
                            },
                            "perso_codif1": {
                                "type": "string",
                                "description": "Valeur codif1",
                                "codif": "RVDossierTma_codif1"
                            },
                            "perso_codif2": {
                                "type": "string",
                                "description": "Valeur codif2",
                                "codif": "RVDossierTma_codif2"
                            },
                            "perso_codif3": {
                                "type": "string",
                                "description": "Valeur codif3",
                                "codif": "RVDossierTma_codif3"
                            },
                            "perso_codif4": {
                                "type": "string",
                                "description": "Valeur codif4",
                                "codif": "RVDossierTma_codif4"
                            },
                            "perso_codif5": {
                                "type": "string",
                                "description": "Valeur codif5",
                                "codif": "RVDossierTma_codif5"
                            },
                            "perso_psla_date1": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date1"
                            },
                            "perso_psla_date2": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date2"
                            },
                            "perso_psla_date3": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date3"
                            },
                            "perso_psla_date4": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date4"
                            },
                            "perso_psla_date5": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date5"
                            },
                            "perso_psla_date6": {
                                "type": "string",
                                "format": "date",
                                "description": "Valeur psla date6"
                            },
                            "details": {
                                "type": "array",
                                "description": "Détails du TMA",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "lib": {
                                            "type": "string",
                                            "description": "Libellé du détail"
                                        },
                                        "piece": {
                                            "type": "string",
                                            "description": "emplacement du détail du TMA"
                                        },
                                        "quantite": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "quantité du détail du TMA"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT du détail du TMA"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC du détail du TMA"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA du détail du TMA"
                                        },
                                        "unite": {
                                            "type": "string",
                                            "description": "Unité",
                                            "enumId": "RVDossierTmaDetail.unite"
                                        },
                                        "prix_vente_unit_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de vente unitaire HT"
                                        },
                                        "prix_vente_unit_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de vente unitaire TTC"
                                        },
                                        "prix_vente_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de vente HT (avant remise)"
                                        },
                                        "prix_vente_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de vente TTC (avant remise)"
                                        },
                                        "prix_revient_unit_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de revient unitaire HT"
                                        },
                                        "prix_revient_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de revient HT"
                                        },
                                        "prix_revient_unit_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de revient unitaire TTC"
                                        },
                                        "prix_revient_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Prix de revient TTC"
                                        },
                                        "coef": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Coef"
                                        },
                                        "offert": {
                                            "type": "boolean",
                                            "description": "Offert"
                                        },
                                        "desc_detail": {
                                            "type": "string",
                                            "description": "Descriptif détaillé"
                                        }
                                    }
                                }
                            },
                            "echeances": {
                                "type": "array",
                                "description": "Échéances du TMA",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "lib": {
                                            "type": "string",
                                            "description": "Libellé de l'échéance"
                                        },
                                        "date": {
                                            "type": "string",
                                            "format": "date",
                                            "description": "Date de l'échéance"
                                        },
                                        "mnt_ht": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant HT de l'échéance"
                                        },
                                        "mnt_ttc": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TTC de l'échéance"
                                        },
                                        "mnt_tva": {
                                            "type": "number",
                                            "format": "money",
                                            "description": "Montant TVA de l'échéance"
                                        },
                                        "ech_prctAppel": {
                                            "type": "number",
                                            "format": "rate",
                                            "description": "Pourcentage d'appel sur l'échéancier TMA"
                                        }
                                    }
                                }
                            },
                            "clients": {
                                "type": "array",
                                "description": "Clients",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "libelle": {
                                            "type": "string",
                                            "description": "Libelle du client"
                                        },
                                        "civilite": {
                                            "type": "string",
                                            "description": "civilité du client",
                                            "codif": "Civilite"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};